/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Madlen API
 * This API exposes endpoints to manage madlen.
 * OpenAPI spec version: 1.27.76
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  ActivateCodeParams,
  ActivateInternalCodeParams,
  ActiveStudentMetrics,
  AddApiKeyRequestDto,
  AddRemoveStudentsToFromClassroomRequestBodyDto,
  AddStudentsToClassroomInOrganizationAdminController200,
  AddTagRequestDto,
  AiAssessmentScaleCreateRequestDto,
  AiAssessmentScaleResponseDto,
  AiAssessmentScaleUpdateRequestDto,
  AiAssessmentScaleWebhookRequestDto,
  AiAssignmentCreateRequestDto,
  AiAssignmentResponseDto,
  AiAssignmentUpdateRequestDto,
  AiAssignmentWebhookRequestDto,
  AiResistantHomeworkCreateRequestDto,
  AiResistantHomeworkResponseDto,
  AiResistantHomeworkUpdateRequestDto,
  AiResistantHomeworkWebhookRequestDto,
  AiSupportedTasksCreateRequestDto,
  AiSupportedTasksResponseDto,
  AiSupportedTasksUpdateRequestDto,
  AiSupportedTasksWebhookRequestDto,
  AnonymousResponseDto,
  ApiKeyEntity,
  ApplyQuestionRegenRequestDto,
  ArticleGeneratorCreateRequestDto,
  ArticleGeneratorCreateTemplateRequestDto,
  ArticleGeneratorResponseDto,
  ArticleGeneratorUpdateRequestDto,
  ArticleGeneratorWebhookRequestDto,
  AssignAssignmentRequestBodyNew,
  AssignInteractiveMaterialRequestDto,
  AssignPodcastRequestDto,
  AssignStudentsRequestDto,
  AssignmentAnalyticsResponseDto,
  AssignmentCountByCourseTypeAndGrade,
  AssignmentDuringQuizStudentPerspectiveResponseDto,
  AssignmentGenerationImageUpdateDto,
  AssignmentGenerationTitleUpdateDto,
  AssignmentStatisticsResponseDto,
  AuthFirebaseLoginRequestBodyDto,
  AutoGenerateRequestDto,
  AverageMessageCountPerChat,
  BaseAssignmentResponseDto,
  BaseChatDto,
  BaseChatMessageDto,
  BaseErrorResponseDto,
  BaseFileNodeDto,
  BaseOrganizationDTO,
  BaseStaticQuestionAnswerResponseDto,
  BaseSuccessResponseDto,
  BaseTranslationDto,
  BlogPostResponseDto,
  BlogQuizFinishRequestDto,
  BloomsTaxonomyActivitiesCreateRequestDto,
  BloomsTaxonomyActivitiesResponseDto,
  BloomsTaxonomyActivitiesUpdateRequestDto,
  BloomsTaxonomyActivitiesWebhookRequestDto,
  BoardResponseDto,
  BulkGradeUpdateRequestDto,
  CanDoEventParams,
  CanDoParams,
  ChatAnalysisSuccessRequestDto,
  ChatFileNodeDto,
  ChatsCourseGradeDistributionDto,
  ChoiceBoardCreateRequestDto,
  ChoiceBoardResponseDto,
  ChoiceBoardUpdateRequestDto,
  ChoiceBoardWebhookRequestDto,
  CircleWebhookRequestObject,
  ClassroomAnalyticsResponseDto,
  ClassroomAssignmentStatisticsResponseDto,
  ClassroomDashboardResponseDto,
  ClassroomForAssignViewResponseDto,
  ClassroomManagementCreateRequestDto,
  ClassroomManagementResponseDto,
  ClassroomManagementUpdateRequestDto,
  ClassroomManagementWebhookRequestDto,
  ClassroomResponseDto,
  ClassroomStudentStatisticsResponseDto,
  ClassroomWithStudentDetailResponseDto,
  ClassroomWithoutStudentDetailResponseDto,
  CloneClassroomRequestDto,
  CloneSharedTool200,
  CollaborativeGroupWorkCreateRequestDto,
  CollaborativeGroupWorkResponseDto,
  CollaborativeGroupWorkUpdateRequestDto,
  CollaborativeGroupWorkWebhookRequestDto,
  ColumnResponseDto,
  CommonMisconceptionCreateRequestDto,
  CommonMisconceptionResponseDto,
  CommonMisconceptionUpdateRequestDto,
  CommonMisconceptionWebhookRequestDto,
  CompleteQuestionGenerationRequestDto,
  ConceptualUnderstandingCreateRequestDto,
  ConceptualUnderstandingResponseDto,
  ConceptualUnderstandingUpdateRequestDto,
  ConceptualUnderstandingWebhookRequestDto,
  CountChatsWithMessagesGreaterThanNParams,
  CreateAuditRequestBodyDto,
  CreateAuditResponseDto,
  CreateBlogRequestBodyDto,
  CreateBoardRequestDto,
  CreateChatMessageRequestBodyDto,
  CreateChatMessageResponseDto,
  CreateChatMessageSuggestionRequestBodyDto,
  CreateChatMessageSuggestionResponseDto,
  CreateChatResponseDto,
  CreateChatStudentRequestBodyDto,
  CreateClassroomRequestBodyDto,
  CreateColumnRequestDto,
  CreateDidacticChatStudentRequestBodyDto,
  CreateEssayAssignmentRequestDto,
  CreateEssayGraderChatMessageRequestBodyDto,
  CreateExplanationStudentChatRequestBodyDto,
  CreateExtraCardRequestDto,
  CreateForumCommentRequestDto,
  CreateForumPostRequestDto,
  CreateHomeworkAssignmentRequestBody,
  CreateInteractiveMaterialRequest,
  CreateLessonPlannerV2RequestDto,
  CreateOrganizationResponseDto,
  CreatePodcastFromReferenceRequestDto,
  CreatePodcastRequestDto,
  CreatePostRequestDto,
  CreatePronunciationAssignmentRequestDto,
  CreatePublicSessionRequestDto,
  CreatePublicSessionResponseDto,
  CreateQuestionAnswerRequestBodyDto,
  CreateQuestionRegenRequestDto,
  CreateQuizAssignmentRequestBody,
  CreateSlideGeneratorOutlineRequestDto,
  CreateSlideGeneratorSlidesRequestDto,
  CreateSpecialHomeworkAssignmentRequestBody,
  CreateStudentRequestBodyDto,
  CreateTeacherChatRequestDto,
  CreateTeacherDocumentResponseDto,
  CreateTeacherRequestBodyDto,
  CreateTeacherToolChatRequestDto,
  CreateUbdExpertPlannerRequestDto,
  DailyActiveTeacherDto,
  DailyAssignmentFinishRequestDto,
  DailyAssignmentsResponseDto,
  DailyStreak,
  DailyStreakResponseDto,
  DashboardDto,
  DidacticTopicResponseDto,
  DocumentExtractorResponse,
  EditAssignAssignmentRequestBody,
  EditAssignmentRequestBody,
  EditInteractiveMaterialSpecsRequest,
  EditQuestionRequestBody,
  EditStudentRequestBodyDto,
  EditTeacherRequestBodyDto,
  EditUbdMaarifPlannerRequestDto,
  EdlinkAssignmentPublishRequestDto,
  EdlinkBulkUserImportRequestDto,
  EdlinkClassroomCloneRequestDto,
  EdlinkClassroomResponseDto,
  EnrollClassroomWithCodeRequestBodyDto,
  EssayAssignmentResponseDto,
  EssayGraderRubricAnalyzerResult,
  EssayGradingRequestBodyDto,
  EssayGradingResultDto,
  EssayGradingSubSingleResultDto,
  EssentialQuestionsCreateRequestDto,
  EssentialQuestionsResponseDto,
  EssentialQuestionsUpdateRequestDto,
  EssentialQuestionsWebhookRequestDto,
  ExitTicketGeneratorCreateRequestDto,
  ExitTicketGeneratorResponseDto,
  ExitTicketGeneratorUpdateRequestDto,
  ExitTicketWebhookRequestDto,
  ExportQuestionSolverV2Params,
  ExtendQuizAssignmentRequestBody,
  FailedQuestionGenerationRequestDto,
  FeedbackRequestDto,
  FileNodeCreateDto,
  FilterResponseDto,
  FinishStudentPodcastRequestDto,
  FirebaseLoginResponseDto,
  FormativeAssessmentCreateRequestDto,
  FormativeAssessmentResponseDto,
  FormativeAssessmentUpdateRequestDto,
  FormativeAssessmentWebhookRequestDto,
  ForumCommentDto,
  ForumPostDto,
  GeneratePresignedUrlOnlyParams,
  GeneratePresignedUrlParams,
  GenerateToolFromNodeRequestDto,
  GenerateUbdGoalsRequestDto,
  GenerateUbdGoalsSubstepRequestDto,
  GenerateUbdGoalsSubstepWithAiRequestDto,
  GenericDataDto,
  GetActiveUserMetricsParams,
  GetAdminAppFiltersParams,
  GetAllChatsParams,
  GetAllChatsWithFileSystemParams,
  GetAllInteractiveMaterialsParams,
  GetAllSuperToolsParams,
  GetAnswerFeedback1200,
  GetAnswerFeedback200,
  GetApiKeysParams,
  GetAssignmentAsJSONParams,
  GetAssignmentAsPdfParams,
  GetAssignmentCountByCourseTypeAndGradeParams,
  GetAssignmentFromStudentsParams,
  GetAssignmentStatisticsParams,
  GetAssignmentsFromTeacherParams,
  GetAssignmentsOfStudentFromOrganizationAdminParams,
  GetAssignmentsOfStudentFromStudentParams,
  GetAssignmentsOfStudentFromTeacherParams,
  GetAssignmentsOfStudentParams,
  GetAssignmentsOfTeacherParams,
  GetAssignmentsParams,
  GetAuditsAdminParams,
  GetAuditsParams,
  GetAvailableCourses200Item,
  GetAvailableRubricsParams,
  GetBlogsParams,
  GetChatMessageSuggestionsParams,
  GetChatParams,
  GetChatResponseDto,
  GetChatsAdminParams,
  GetChatsParams,
  GetClassroomAssignmentsStatisticsParams,
  GetClassroomDashboard1Params,
  GetClassroomDashboardParams,
  GetClassroomStudentsStatisticsParams,
  GetClassroomWeeklyAnalysisParams,
  GetClassroomsDetailedAdminParams,
  GetClassroomsDetailedParams,
  GetClassroomsParams,
  GetClassroomsWithFiltersForAdminAppParams,
  GetCourseGradeDistributionOfChatsParams,
  GetCoursesResponseDto,
  GetDailyActiveTeachersParams,
  GetDailyAssignments1Params,
  GetDailyAssignmentsParams,
  GetDashboardDataParams,
  GetDidacticChatParams,
  GetDidacticChatsParams,
  GetDidacticTopicsParams,
  GetDriveFilesParams,
  GetEssayAssignmentsParams,
  GetEssayGradersAdminParams,
  GetEssayGradersParams,
  GetFavouriteChatMessagesParams,
  GetFavouriteChatsParams,
  GetFilesParams,
  GetGoogleDrivePickerTokenResponseDto,
  GetGoogleScopesResponseDto,
  GetInteractiveMaterialsParams,
  GetLearningOutcomesParams,
  GetLessonPlannersAdminParams,
  GetLessonPlannersV2Params,
  GetMaarifLearningOutcomesParams,
  GetMessageCountPerChatParams,
  GetMessageCountPerChatPerCourseParams,
  GetMessagesAdminParams,
  GetMessagesAveragesParams,
  GetMessagesOfDidacticParams,
  GetMessagesParams,
  GetMostSeenBlogsParams,
  GetMyAssignmentsParams,
  GetMySubmissionsParams,
  GetNotificationsParams,
  GetOrganizationAdminsParams,
  GetQuestionHelpersParams,
  GetQuestionSolverChatsParams,
  GetQuestionSolverCourseDistributionParams,
  GetQuestionSolverResponseDtoV2,
  GetQuestionSolverResponsesV2Params,
  GetQuestionsWithFileSystemV2Params,
  GetRecentAiAssessmentScalesParams,
  GetRecentAiAssignmentsParams,
  GetRecentAiResistantHomeworkParams,
  GetRecentAiSupportedTasksParams,
  GetRecentArticleGeneratorsParams,
  GetRecentBloomsTaxonomyActivitiesParams,
  GetRecentChoiceBoardsParams,
  GetRecentClassroomManagementsParams,
  GetRecentCollaborativeGroupWorksParams,
  GetRecentCommonMisconceptionsParams,
  GetRecentConceptualUnderstandingsParams,
  GetRecentEssentialQuestionsParams,
  GetRecentExitTicketGeneratorsParams,
  GetRecentFormativeAssessmentsParams,
  GetRecentHomeworkIdeasParams,
  GetRecentImageGeneratorsParams,
  GetRecentLessonHooksParams,
  GetRecentMindmapGeneratorsParams,
  GetRecentPerformanceTasksParams,
  GetRecentPodcastsParams,
  GetRecentProjectBasedLearningsParams,
  GetRecentRealWorldConnectionsParams,
  GetRecentRubricGeneratorsParams,
  GetRecentSummarizersParams,
  GetRecentTextLevelersParams,
  GetRecentTransferActivitiesParams,
  GetRecentUdlChoiceBoardsParams,
  GetRecentVideoAvatarsParams,
  GetRecentVocabularyListsParams,
  GetSharedTool200,
  GetSketchGenerator1Params,
  GetSketchGeneratorsParams,
  GetStudentAssignmentDetailResponseDto,
  GetStudentDetailParams,
  GetStudentWeeklyAnalysisParams,
  GetStudentsFilteredForAdminAppParams,
  GetStudentsGenericFilteredAdminParams,
  GetStudentsGenericFilteredParams,
  GetStudentsParams,
  GetStudentsResponseDto,
  GetStudentsWithIdsParams,
  GetSubmissionsForAssignmentParams,
  GetTeacherActivityLogParams,
  GetTeacherActivitySummaryParams,
  GetTeacherAssignedInteractiveMaterialsParams,
  GetTeacherChatsParams,
  GetTeacherDetailParams,
  GetTeacherProfileParams,
  GetTeacherToolChatsParams,
  GetTeacherToolsStatisticsParams,
  GetTeachers1Params,
  GetTeachersParams,
  GetTeachersWithFiltersForAdminAppParams,
  GetTedLessonPlannersAdminParams,
  GetTedLessonPlannersParams,
  GetTedYearlyLessonPlannersAdminParams,
  GetTedYearlyLessonPlannersParams,
  GetTextEmbeddingParams,
  GetTokenUsageAveragesParams,
  GetTokenUsagesParams,
  GetTokenUsagesPerUserParams,
  GetToolCountPerGradeParams,
  GetToolCountPerTypeParams,
  GetToolCountPerUserCountParams,
  GetToolUsageCountsForSpecificUsersParams,
  GetTopAiAssessmentScalesParams,
  GetTopAiAssignmentsParams,
  GetTopAiResistantHomeworkParams,
  GetTopAiSupportedTasksParams,
  GetTopArticleGeneratorsParams,
  GetTopBloomsTaxonomyActivitiesParams,
  GetTopChoiceBoardsParams,
  GetTopClassroomManagementsParams,
  GetTopCollaborativeGroupWorksParams,
  GetTopCommonMisconceptionsParams,
  GetTopConceptualUnderstandingsParams,
  GetTopEssentialQuestionsParams,
  GetTopExitTicketGeneratorsParams,
  GetTopFormativeAssessmentsParams,
  GetTopHomeworkIdeasParams,
  GetTopImageGeneratorsParams,
  GetTopLessonHooksParams,
  GetTopMindmapGeneratorsParams,
  GetTopPerformanceTasksParams,
  GetTopPodcastsParams,
  GetTopProjectBasedLearningsParams,
  GetTopRealWorldConnectionsParams,
  GetTopRubricGeneratorsParams,
  GetTopSketchGeneratorParams,
  GetTopSummarizersParams,
  GetTopTextLevelersParams,
  GetTopTransferActivitiesParams,
  GetTopUdlChoiceBoardsParams,
  GetTopVideoAvatarsParams,
  GetTopVocabularyListsParams,
  GetTopicsParams,
  GetTopicsResponseDto,
  GetUnifiedTasksParams,
  GetUnreadNotificationsParams,
  GetUserAiAssessmentScalesParams,
  GetUserAiAssignmentsParams,
  GetUserAiResistantHomeworkParams,
  GetUserAiSupportedTasksParams,
  GetUserArticleGeneratorsParams,
  GetUserBloomsTaxonomyActivitiesParams,
  GetUserChoiceBoardsParams,
  GetUserClassroomManagementsParams,
  GetUserCollaborativeGroupWorksParams,
  GetUserCommonMisconceptionsParams,
  GetUserConceptualUnderstandingsParams,
  GetUserEssentialQuestionsParams,
  GetUserExitTicketGeneratorsParams,
  GetUserFormativeAssessmentsParams,
  GetUserGradeDistributionParams,
  GetUserHomeworkIdeasParams,
  GetUserImageGeneratorsParams,
  GetUserLessonHooksParams,
  GetUserMindmapGeneratorsParams,
  GetUserPerformanceTasksParams,
  GetUserPodcastsParams,
  GetUserProjectBasedLearningsParams,
  GetUserRealWorldConnectionsParams,
  GetUserRubricGeneratorsParams,
  GetUserSummarizersParams,
  GetUserTextLevelersParams,
  GetUserTop4GradesParams,
  GetUserTransferActivitiesParams,
  GetUserUdlChoiceBoardsParams,
  GetUserVideoAvatarsParams,
  GetUserVocabularyListsParams,
  GetVideosAndPdfFromGoogleDriveParams,
  GetVideosFromGoogleDriveParams,
  GetVisualMatchingListParams,
  GoogleLoginRequestDto,
  GoogleLoginResponseDto,
  GradeFinishedStudentsOpenEndedAnswersRequestBody,
  GradeQuestionAnswerRequestBodyDto,
  GroupedUnifiedTaskResponseDto,
  H5pExportResponseDto,
  HandleCallbackParams,
  HandleFirebaseActionParams,
  HandleNewEmailBody,
  HandleTokenRequest200,
  HandleTokenRequestParams,
  HandleUserInfoRequest200,
  HomeworkAssignmentPdfCreateRequestItem,
  HomeworkIdeaCreateRequestDto,
  HomeworkIdeaResponseDto,
  HomeworkIdeaUpdateRequestDto,
  HomeworkIdeaWebhookRequestDto,
  ImageGeneratorCreateRequestDto,
  ImageGeneratorResponseDto,
  ImageGeneratorWebhookRequestDto,
  IndividualStepRequestDto,
  InteractiveMaterialResponseDto,
  InteractiveMaterialVideoContentExtractionData,
  InteractiveMaterialWebhookRequest,
  InteractiveMaterialWebhookRequestAdvancedEdit,
  InteractiveMaterialsCaptureStudentEventRequestDto,
  JsonNode,
  LambdaAlertEntity,
  LeaderboardDTO,
  LeaderboardV2DTO,
  LearningOutcomesPerOutcomePerExplanationResponseDto,
  LessonHookCreateRequestDto,
  LessonHookResponseDto,
  LessonHookUpdateRequestDto,
  LessonHookWebhookRequestDto,
  LessonPlannerV2ResponseDto,
  LessonPlannerWebhookV2RequestBodyDto,
  LikeOrDislikeMessageRequestBodyDto,
  ListAiAssessmentScaleResponseDto,
  ListAiAssignmentResponseDto,
  ListAiResistantHomeworkResponseDto,
  ListAiSupportedTasksResponseDto,
  ListArticleGeneratorResponseDto,
  ListAuditResponseDto,
  ListBlogPostResponseDto,
  ListBloomsTaxonomyActivitiesResponseDto,
  ListBoardsResponseDto,
  ListChatMessageSuggestionsResponseDto,
  ListChatMessagesResponseDto,
  ListChatResponseDto,
  ListChoiceBoardResponseDto,
  ListClassroomManagementResponseDto,
  ListCollaborativeGroupWorkResponseDto,
  ListCommonMisconceptionResponseDto,
  ListConceptualUnderstandingResponseDto,
  ListEssayAssignmentResponseDto,
  ListEssayGradingResultDto,
  ListEssayGradingSubSingleResultDto,
  ListEssentialQuestionsResponseDto,
  ListExitTicketGeneratorResponseDto,
  ListFilesParams,
  ListFormativeAssessmentResponseDto,
  ListHomeworkIdeaResponseDto,
  ListImageGeneratorResponseDto,
  ListInteractiveMaterialResponseDto,
  ListLessonHookResponseDto,
  ListLessonPlannerV2ResponseDto,
  ListMadlenBoardUserBoardsParams,
  ListMindmapGeneratorResponseDto,
  ListNotificationsResponseDto,
  ListPerformanceTaskResponseDto,
  ListPodcastResponseDto,
  ListProjectBasedLearningResponseDto,
  ListPronunciationAssignmentResponseDto,
  ListQuestionSolverV2ResponseDto,
  ListRealWorldConnectionResponseDto,
  ListRubricGeneratorResponseDto,
  ListSketchGeneratorResponseDto,
  ListSpokenDialogueResponseDto,
  ListSpokenDialoguesParams,
  ListStudentAssignmentViewDto,
  ListStudentAssignmentsResponseDto,
  ListStudentEssaySubmissionResponseDto,
  ListSummarizerResponseDto,
  ListSuperToolResponseDto,
  ListTeacherChatResponseDto,
  ListTeacherDocumentResponseDto,
  ListTeacherToolChatResponseDto,
  ListTextLevelerResponseDto,
  ListTokenUsageDetailedResponseDto,
  ListTokenUsagePerUserResponseDto,
  ListTransferActivityResponseDto,
  ListUbdExpertPlannerResponseDto,
  ListUbdExpertPlannerServicesParams,
  ListUdlChoiceBoardResponseDto,
  ListVideoAvatarResponseDto,
  ListVisualMatchingResponseDto,
  ListVocabularyListResponseDto,
  LivekitEventsRequestDto,
  LoginWithNameRequestDto,
  MaarifLearningOutcomesPerOutcomePerExplanationResponseDto,
  MadlenAdminResponseDto,
  MergeAnonymousUserToStudentBodyDto,
  MessageCountDistributionOfChats,
  MessageCountDistributionOfChatsPerCourse,
  MindmapGeneratorCreateRequestDto,
  MindmapGeneratorResponseDto,
  MindmapGeneratorUpdateRequestDto,
  MindmapGeneratorWebhookRequestDto,
  MinutesSavedResponseDto,
  MoveNodesDto,
  MovePostRequestDto,
  NewEssayEvaluationResult,
  Oauth2callbackParams,
  OrganizationAdminResponseDto,
  OrganizationCreateRequestBodyDto,
  PageStudentResponseDto,
  PageStudentTableRowDto,
  PageTeacherTableRowDto,
  PaginatedBaseAssignmentsResponseDto,
  PaginatedClassroomResponseDto,
  PaginatedDriveFilesResponseDto,
  PaginatedOrganizationAdminResponseDto,
  PaginatedTeacherResponseDto,
  PartialAssignmentGenerationSingleBody,
  PdfStatusResponseItem,
  PerformanceTaskCreateRequestDto,
  PerformanceTaskResponseDto,
  PerformanceTaskUpdateRequestDto,
  PerformanceTaskWebhookRequestDto,
  PodcastResponseDto,
  PodcastUpdateRequestDto,
  PodcastWebhookRequestDto,
  PostFilesMetadataResponseDto,
  PostResponseDto,
  PresignedUrlResponseDto,
  ProjectBasedLearningCreateRequestDto,
  ProjectBasedLearningResponseDto,
  ProjectBasedLearningUpdateRequestDto,
  ProjectBasedLearningWebhookRequestDto,
  PromptEnhancerCreateRequestDto,
  PromptEnhancerResponseDto,
  PromptRequestDto,
  PromptResponseDto,
  PronunciationAssignmentResponseDto,
  PublicAssignmentViewDto,
  PublicSubmissionResponseDto,
  PublicSubmitRequestDto,
  PublishAssignmentRequestDto,
  QuestionExplanationSuccessRequestDto,
  QuestionFileNodeDtoV2,
  QuestionHelperCreateRequestDto,
  QuestionHelperListResponseDto,
  QuestionHelperResponseDto,
  QuestionHelperTagsResponseDto,
  QuestionHelperUpdateRequestDto,
  QuestionHelperWebhookRequestDto,
  QuestionRegenResponseDto,
  QuestionSolverCourseDistributionDto,
  QuestionSolverCreateRequestDto,
  QuestionSolverUpdateRequestDto,
  QuestionSolverWebhookRequestBodyDto,
  RealWorldConnectionCreateRequestDto,
  RealWorldConnectionResponseDto,
  RealWorldConnectionUpdateRequestDto,
  RealWorldConnectionWebhookRequestDto,
  RefineGenericRequestDto,
  RefineStep1RequestDto,
  RegenQuestionSolverV2Params,
  RegenSlideGeneratorOutlineRequestDto,
  RegenTeacherToolRequestBody,
  RegisterStudentRequestBodyDto,
  RegisterStudentResponseDto,
  ReleaseGradesRequestDto,
  RemoveStudentsFromClassroomInOrganizationAdminController200,
  RemoveStudentsFromClassroomInTeacherController200,
  RenameChatRequestBodyDto,
  RequestDemoEmailItem,
  ResponseBodyEmitter,
  RubricGeneratorCreateRequestDto,
  RubricGeneratorResponseDto,
  RubricGeneratorUpdateRequestDto,
  RubricGeneratorWebhookRequestDto,
  SaveFirebaseDeviceInfoRequestBodyDto,
  SaveLessonPlannerResultRequestDto,
  SaveYoutubeVimeoUrlAsTeacherDocumentParams,
  SearchNodesParams,
  SearchRequest,
  SearchResult,
  ServerSentEventString,
  SetGoogleDrivePickerTokenRequestDto,
  SetGoogleDrivePickerTokenResponseDto,
  ShareTool200,
  SketchGeneratorCreateRequestDto,
  SketchGeneratorResponseDto,
  SketchGeneratorWebhookRequestDto,
  SlideGeneratorOutlineWebhookRequestBodyDto,
  SlideGeneratorResponseDto,
  SlideGeneratorSlidesWebhookRequestBodyDto,
  SpokenDialogueCreateRequestDto,
  SpokenDialogueResponseDto,
  SpokenDialogueWebhookRequestDto,
  StartQuizAssignmentRequestBody,
  StudentAssignmentDetailStudentPerspectiveResponseDto,
  StudentAssignmentDetailTeacherPerspectiveResponseDto,
  StudentAssignmentStatisticsResponseDto,
  StudentAssignmentSummaryDto,
  StudentAssignmentViewDto,
  StudentDetailResponseDto,
  StudentDetailsDto,
  StudentEssaySubmissionResponseDto,
  StudentInteractiveMaterialDetailResponseDto,
  StudentInteractiveMaterialResponseDto,
  StudentPodcastResponseDto,
  StudentResponseDto,
  SubmitEssayRequestDto,
  SubscribeEmailItem,
  SubscriptionCodeCreateRequestDto,
  SummarizerCreateRequestDto,
  SummarizerResponseDto,
  SummarizerUpdateRequestDto,
  SummarizerWebhookRequestDto,
  SuperToolCreateRequestDto,
  SuperToolResponseDto,
  SyncClassroomRequestDto,
  SynthesizeChirpRequestBody,
  SynthesizeRequestBody,
  SynthesizeTextOpenai1Params,
  TeacherActivityLogDto,
  TeacherActivitySummaryDto,
  TeacherChatAnalysisSuccessRequestDto,
  TeacherChatResponseDto,
  TeacherChatSendMessageRequestDto,
  TeacherChatSendMessageWebhookRequestDto,
  TeacherChatUpdateTitleWebhookRequestDto,
  TeacherDetailResponseDto,
  TeacherDetailsDto,
  TeacherDocumentResponseDto,
  TeacherProfileResponseDto,
  TeacherResponseDto,
  TeacherReviewPageDto,
  TeacherToolChatResponseDto,
  TeacherToolChatSendMessageRequestDto,
  TeacherToolChatSendMessageWebhookRequestDto,
  TeacherToolPerGradeMetrics,
  TeacherToolPerToolTypeMetrics,
  TeacherToolsStatisticsResponseDto,
  TedLessonPlannerCreateRequestDto,
  TedLessonPlannerResponseDto,
  TedLessonPlannerUpdateRequestDto,
  TedLessonPlannerWebhookRequestDto,
  TedYearlyLessonPlannerCreateRequestDto,
  TedYearlyLessonPlannerResponseDto,
  TedYearlyLessonPlannerUpdateRequestDto,
  TedYearlyLessonPlannerWebhookRequestDto,
  TemplateGenerateResponseDto,
  TextLevelerCreateRequestDto,
  TextLevelerResponseDto,
  TextLevelerUpdateRequestDto,
  TextLevelerWebhookRequestDto,
  TokenUsageAverage,
  ToolUsageByCourseDto,
  ToolUsageMetric,
  TopicListResponseDto,
  TopicMergerSuccessRequestDto,
  TransferActivityCreateRequestDto,
  TransferActivityResponseDto,
  TransferActivityUpdateRequestDto,
  TransferActivityWebhookRequestDto,
  TriggerChatAnalysisRequestDto,
  TriggerTeacherChatAnalysisRequestDto,
  TriggerWeeklyAnalysisRequestDto,
  UbdExpertPlannerResponseDto,
  UbdExpertWebhookRequestDto,
  UbdMaarifPlannerResponseDto,
  UbdMaarifWebhookRequestDto,
  UdlChoiceBoardCreateRequestDto,
  UdlChoiceBoardResponseDto,
  UdlChoiceBoardUpdateRequestDto,
  UdlChoiceBoardWebhookRequestDto,
  UpdateAnonymousUserMeBodyDto,
  UpdateBlogRequestBodyDto,
  UpdateBoardRequestDto,
  UpdateChatHistoryRequestBodyDto,
  UpdateChatMessageRequestBodyDto,
  UpdateChatMessageSuggestionRequestBodyDto,
  UpdateChatMessageSuggestionResponseDto,
  UpdateColumnOrderRequestDto,
  UpdateColumnOrderResponseDto,
  UpdateColumnRequestDto,
  UpdateDidacticChatConfigStudentParams,
  UpdateEssayAssignmentRequestDto,
  UpdateGradeRequestDto,
  UpdateImageGeneratorRequestDto,
  UpdateItemsRequestDto,
  UpdateLessonPlannerV2RequestDto,
  UpdatePostContentRequestDto,
  UpdateQuestionRegenRequestDto,
  UpdateSketchGeneratorRequestDto,
  UpdateSlideGeneratorRequestDto,
  UpdateSubmissionRequestDto,
  UpdateTeacherChatRequestDto,
  UploadGoogleDriveFilesToTeacherDocumentsRequestDto,
  UploadGoogleDriveFilesToTeacherDocumentsResponseDto,
  UserGradeDistributionDto,
  UserTeacherToolUsageMetrics,
  UserTopGradeDto,
  VideoAvatarAvailableFacesResponseDto,
  VideoAvatarCreateRequestDto,
  VideoAvatarResponseDto,
  VideoAvatarUpdateRequestDto,
  VideoAvatarWebhookRequestDto,
  VisualMatchingCreateRequestDto,
  VisualMatchingResponseDto,
  VisualMatchingUpdateRequestDto,
  VisualMatchingWebhookRequestDto,
  VocabularyListCreateRequestDto,
  VocabularyListResponseDto,
  VocabularyListUpdateRequestDto,
  VocabularyListWebhookRequestDto,
  WeeklyAnalysisResponseDto,
  WeeklyAnalysisSuccessRequestDto,
} from "./madlenAPI.schemas";
import { configureAxios } from "../../axiosConfig";
import type { ErrorType, BodyType } from "../../axiosConfig";

export const weeklyAnalysisSuccess = (
  weeklyAnalysisSuccessRequestDto: BodyType<WeeklyAnalysisSuccessRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/weekly-analysis-success`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: weeklyAnalysisSuccessRequestDto,
  });
};

export const getWeeklyAnalysisSuccessMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weeklyAnalysisSuccess>>,
    TError,
    { data: BodyType<WeeklyAnalysisSuccessRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weeklyAnalysisSuccess>>,
  TError,
  { data: BodyType<WeeklyAnalysisSuccessRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weeklyAnalysisSuccess>>,
    { data: BodyType<WeeklyAnalysisSuccessRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return weeklyAnalysisSuccess(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeeklyAnalysisSuccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof weeklyAnalysisSuccess>>
>;
export type WeeklyAnalysisSuccessMutationBody =
  BodyType<WeeklyAnalysisSuccessRequestDto>;
export type WeeklyAnalysisSuccessMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useWeeklyAnalysisSuccess = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weeklyAnalysisSuccess>>,
    TError,
    { data: BodyType<WeeklyAnalysisSuccessRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof weeklyAnalysisSuccess>>,
  TError,
  { data: BodyType<WeeklyAnalysisSuccessRequestDto> },
  TContext
> => {
  const mutationOptions = getWeeklyAnalysisSuccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleVocabularyListWebhook = (
  id: number,
  vocabularyListWebhookRequestDto: BodyType<VocabularyListWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/vocab-list/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: vocabularyListWebhookRequestDto,
  });
};

export const getHandleVocabularyListWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleVocabularyListWebhook>>,
    TError,
    { id: number; data: BodyType<VocabularyListWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleVocabularyListWebhook>>,
  TError,
  { id: number; data: BodyType<VocabularyListWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleVocabularyListWebhook>>,
    { id: number; data: BodyType<VocabularyListWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleVocabularyListWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleVocabularyListWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleVocabularyListWebhook>>
>;
export type HandleVocabularyListWebhookMutationBody =
  BodyType<VocabularyListWebhookRequestDto>;
export type HandleVocabularyListWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleVocabularyListWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleVocabularyListWebhook>>,
    TError,
    { id: number; data: BodyType<VocabularyListWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleVocabularyListWebhook>>,
  TError,
  { id: number; data: BodyType<VocabularyListWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleVocabularyListWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTeacherDocumentVimeoWebhook = (
  id: number,
  documentExtractorResponse: BodyType<DocumentExtractorResponse>,
) => {
  return configureAxios<void>({
    url: `/webhooks/vimeo-transcript-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: documentExtractorResponse,
  });
};

export const getHandleTeacherDocumentVimeoWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTeacherDocumentVimeoWebhook>>,
    TError,
    { id: number; data: BodyType<DocumentExtractorResponse> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTeacherDocumentVimeoWebhook>>,
  TError,
  { id: number; data: BodyType<DocumentExtractorResponse> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTeacherDocumentVimeoWebhook>>,
    { id: number; data: BodyType<DocumentExtractorResponse> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleTeacherDocumentVimeoWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTeacherDocumentVimeoWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTeacherDocumentVimeoWebhook>>
>;
export type HandleTeacherDocumentVimeoWebhookMutationBody =
  BodyType<DocumentExtractorResponse>;
export type HandleTeacherDocumentVimeoWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleTeacherDocumentVimeoWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTeacherDocumentVimeoWebhook>>,
    TError,
    { id: number; data: BodyType<DocumentExtractorResponse> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTeacherDocumentVimeoWebhook>>,
  TError,
  { id: number; data: BodyType<DocumentExtractorResponse> },
  TContext
> => {
  const mutationOptions =
    getHandleTeacherDocumentVimeoWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTeacherDocumentVideoOrAudioWebhook = (
  id: number,
  documentExtractorResponse: BodyType<DocumentExtractorResponse>,
) => {
  return configureAxios<void>({
    url: `/webhooks/video-or-audio-transcript-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: documentExtractorResponse,
  });
};

export const getHandleTeacherDocumentVideoOrAudioWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTeacherDocumentVideoOrAudioWebhook>>,
    TError,
    { id: number; data: BodyType<DocumentExtractorResponse> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTeacherDocumentVideoOrAudioWebhook>>,
  TError,
  { id: number; data: BodyType<DocumentExtractorResponse> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTeacherDocumentVideoOrAudioWebhook>>,
    { id: number; data: BodyType<DocumentExtractorResponse> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleTeacherDocumentVideoOrAudioWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTeacherDocumentVideoOrAudioWebhookMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof handleTeacherDocumentVideoOrAudioWebhook>>
  >;
export type HandleTeacherDocumentVideoOrAudioWebhookMutationBody =
  BodyType<DocumentExtractorResponse>;
export type HandleTeacherDocumentVideoOrAudioWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleTeacherDocumentVideoOrAudioWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTeacherDocumentVideoOrAudioWebhook>>,
    TError,
    { id: number; data: BodyType<DocumentExtractorResponse> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTeacherDocumentVideoOrAudioWebhook>>,
  TError,
  { id: number; data: BodyType<DocumentExtractorResponse> },
  TContext
> => {
  const mutationOptions =
    getHandleTeacherDocumentVideoOrAudioWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleUdlChoiceBoardWebhook = (
  id: number,
  udlChoiceBoardWebhookRequestDto: BodyType<UdlChoiceBoardWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/udl-choice-board/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: udlChoiceBoardWebhookRequestDto,
  });
};

export const getHandleUdlChoiceBoardWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUdlChoiceBoardWebhook>>,
    TError,
    { id: number; data: BodyType<UdlChoiceBoardWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleUdlChoiceBoardWebhook>>,
  TError,
  { id: number; data: BodyType<UdlChoiceBoardWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleUdlChoiceBoardWebhook>>,
    { id: number; data: BodyType<UdlChoiceBoardWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleUdlChoiceBoardWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleUdlChoiceBoardWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleUdlChoiceBoardWebhook>>
>;
export type HandleUdlChoiceBoardWebhookMutationBody =
  BodyType<UdlChoiceBoardWebhookRequestDto>;
export type HandleUdlChoiceBoardWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleUdlChoiceBoardWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUdlChoiceBoardWebhook>>,
    TError,
    { id: number; data: BodyType<UdlChoiceBoardWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleUdlChoiceBoardWebhook>>,
  TError,
  { id: number; data: BodyType<UdlChoiceBoardWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleUdlChoiceBoardWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleUbdPlannerWebhook = (
  id: number,
  ubdMaarifWebhookRequestDto: BodyType<UbdMaarifWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ubd-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: ubdMaarifWebhookRequestDto,
  });
};

export const getHandleUbdPlannerWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUbdPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleUbdPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleUbdPlannerWebhook>>,
    { id: number; data: BodyType<UbdMaarifWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleUbdPlannerWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleUbdPlannerWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleUbdPlannerWebhook>>
>;
export type HandleUbdPlannerWebhookMutationBody =
  BodyType<UbdMaarifWebhookRequestDto>;
export type HandleUbdPlannerWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleUbdPlannerWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUbdPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleUbdPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleUbdPlannerWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleUbdMaarifWebhook = (
  id: number,
  ubdMaarifWebhookRequestDto: BodyType<UbdMaarifWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ubd-maarif-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: ubdMaarifWebhookRequestDto,
  });
};

export const getHandleUbdMaarifWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUbdMaarifWebhook>>,
    TError,
    { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleUbdMaarifWebhook>>,
  TError,
  { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleUbdMaarifWebhook>>,
    { id: number; data: BodyType<UbdMaarifWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleUbdMaarifWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleUbdMaarifWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleUbdMaarifWebhook>>
>;
export type HandleUbdMaarifWebhookMutationBody =
  BodyType<UbdMaarifWebhookRequestDto>;
export type HandleUbdMaarifWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleUbdMaarifWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUbdMaarifWebhook>>,
    TError,
    { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleUbdMaarifWebhook>>,
  TError,
  { id: number; data: BodyType<UbdMaarifWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleUbdMaarifWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleUbdExpertWebhook = (
  id: number,
  ubdExpertWebhookRequestDto: BodyType<UbdExpertWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ubd-expert-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: ubdExpertWebhookRequestDto,
  });
};

export const getHandleUbdExpertWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUbdExpertWebhook>>,
    TError,
    { id: number; data: BodyType<UbdExpertWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleUbdExpertWebhook>>,
  TError,
  { id: number; data: BodyType<UbdExpertWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleUbdExpertWebhook>>,
    { id: number; data: BodyType<UbdExpertWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleUbdExpertWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleUbdExpertWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleUbdExpertWebhook>>
>;
export type HandleUbdExpertWebhookMutationBody =
  BodyType<UbdExpertWebhookRequestDto>;
export type HandleUbdExpertWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleUbdExpertWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleUbdExpertWebhook>>,
    TError,
    { id: number; data: BodyType<UbdExpertWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleUbdExpertWebhook>>,
  TError,
  { id: number; data: BodyType<UbdExpertWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleUbdExpertWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTransferActivityWebhook = (
  id: number,
  transferActivityWebhookRequestDto: BodyType<TransferActivityWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/transfer-activity/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: transferActivityWebhookRequestDto,
  });
};

export const getHandleTransferActivityWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTransferActivityWebhook>>,
    TError,
    { id: number; data: BodyType<TransferActivityWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTransferActivityWebhook>>,
  TError,
  { id: number; data: BodyType<TransferActivityWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTransferActivityWebhook>>,
    { id: number; data: BodyType<TransferActivityWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleTransferActivityWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTransferActivityWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTransferActivityWebhook>>
>;
export type HandleTransferActivityWebhookMutationBody =
  BodyType<TransferActivityWebhookRequestDto>;
export type HandleTransferActivityWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleTransferActivityWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTransferActivityWebhook>>,
    TError,
    { id: number; data: BodyType<TransferActivityWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTransferActivityWebhook>>,
  TError,
  { id: number; data: BodyType<TransferActivityWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleTransferActivityWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const topicMergerSuccess = (
  topicMergerSuccessRequestDto: BodyType<TopicMergerSuccessRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/topic-merger-success`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: topicMergerSuccessRequestDto,
  });
};

export const getTopicMergerSuccessMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof topicMergerSuccess>>,
    TError,
    { data: BodyType<TopicMergerSuccessRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof topicMergerSuccess>>,
  TError,
  { data: BodyType<TopicMergerSuccessRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof topicMergerSuccess>>,
    { data: BodyType<TopicMergerSuccessRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return topicMergerSuccess(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TopicMergerSuccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof topicMergerSuccess>>
>;
export type TopicMergerSuccessMutationBody =
  BodyType<TopicMergerSuccessRequestDto>;
export type TopicMergerSuccessMutationError = ErrorType<BaseErrorResponseDto>;

export const useTopicMergerSuccess = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof topicMergerSuccess>>,
    TError,
    { data: BodyType<TopicMergerSuccessRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof topicMergerSuccess>>,
  TError,
  { data: BodyType<TopicMergerSuccessRequestDto> },
  TContext
> => {
  const mutationOptions = getTopicMergerSuccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleArticleGeneratorWebhook = (
  id: number,
  articleGeneratorWebhookRequestDto: BodyType<ArticleGeneratorWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/text2chart/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: articleGeneratorWebhookRequestDto,
  });
};

export const getHandleArticleGeneratorWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleArticleGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<ArticleGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleArticleGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<ArticleGeneratorWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleArticleGeneratorWebhook>>,
    { id: number; data: BodyType<ArticleGeneratorWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleArticleGeneratorWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleArticleGeneratorWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleArticleGeneratorWebhook>>
>;
export type HandleArticleGeneratorWebhookMutationBody =
  BodyType<ArticleGeneratorWebhookRequestDto>;
export type HandleArticleGeneratorWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleArticleGeneratorWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleArticleGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<ArticleGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleArticleGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<ArticleGeneratorWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleArticleGeneratorWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTextLevelerWebhook = (
  id: number,
  textLevelerWebhookRequestDto: BodyType<TextLevelerWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/text-leveler/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: textLevelerWebhookRequestDto,
  });
};

export const getHandleTextLevelerWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTextLevelerWebhook>>,
    TError,
    { id: number; data: BodyType<TextLevelerWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTextLevelerWebhook>>,
  TError,
  { id: number; data: BodyType<TextLevelerWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTextLevelerWebhook>>,
    { id: number; data: BodyType<TextLevelerWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleTextLevelerWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTextLevelerWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTextLevelerWebhook>>
>;
export type HandleTextLevelerWebhookMutationBody =
  BodyType<TextLevelerWebhookRequestDto>;
export type HandleTextLevelerWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleTextLevelerWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTextLevelerWebhook>>,
    TError,
    { id: number; data: BodyType<TextLevelerWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTextLevelerWebhook>>,
  TError,
  { id: number; data: BodyType<TextLevelerWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleTextLevelerWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTedLessonPlannerWebhook = (
  id: number,
  tedLessonPlannerWebhookRequestDto: BodyType<TedLessonPlannerWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ted-lesson-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: tedLessonPlannerWebhookRequestDto,
  });
};

export const getHandleTedLessonPlannerWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTedLessonPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTedLessonPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTedLessonPlannerWebhook>>,
    { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleTedLessonPlannerWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTedLessonPlannerWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTedLessonPlannerWebhook>>
>;
export type HandleTedLessonPlannerWebhookMutationBody =
  BodyType<TedLessonPlannerWebhookRequestDto>;
export type HandleTedLessonPlannerWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleTedLessonPlannerWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTedLessonPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTedLessonPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleTedLessonPlannerWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const teacherChatAnalysisSuccess = (
  teacherChatAnalysisSuccessRequestDto: BodyType<TeacherChatAnalysisSuccessRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/teacher-chat-analysis-success`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: teacherChatAnalysisSuccessRequestDto,
  });
};

export const getTeacherChatAnalysisSuccessMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof teacherChatAnalysisSuccess>>,
    TError,
    { data: BodyType<TeacherChatAnalysisSuccessRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof teacherChatAnalysisSuccess>>,
  TError,
  { data: BodyType<TeacherChatAnalysisSuccessRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof teacherChatAnalysisSuccess>>,
    { data: BodyType<TeacherChatAnalysisSuccessRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return teacherChatAnalysisSuccess(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TeacherChatAnalysisSuccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof teacherChatAnalysisSuccess>>
>;
export type TeacherChatAnalysisSuccessMutationBody =
  BodyType<TeacherChatAnalysisSuccessRequestDto>;
export type TeacherChatAnalysisSuccessMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useTeacherChatAnalysisSuccess = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof teacherChatAnalysisSuccess>>,
    TError,
    { data: BodyType<TeacherChatAnalysisSuccessRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof teacherChatAnalysisSuccess>>,
  TError,
  { data: BodyType<TeacherChatAnalysisSuccessRequestDto> },
  TContext
> => {
  const mutationOptions = getTeacherChatAnalysisSuccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleSummarizerWebhook = (
  id: number,
  summarizerWebhookRequestDto: BodyType<SummarizerWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/summarizer/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: summarizerWebhookRequestDto,
  });
};

export const getHandleSummarizerWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSummarizerWebhook>>,
    TError,
    { id: number; data: BodyType<SummarizerWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleSummarizerWebhook>>,
  TError,
  { id: number; data: BodyType<SummarizerWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleSummarizerWebhook>>,
    { id: number; data: BodyType<SummarizerWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleSummarizerWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleSummarizerWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleSummarizerWebhook>>
>;
export type HandleSummarizerWebhookMutationBody =
  BodyType<SummarizerWebhookRequestDto>;
export type HandleSummarizerWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleSummarizerWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSummarizerWebhook>>,
    TError,
    { id: number; data: BodyType<SummarizerWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleSummarizerWebhook>>,
  TError,
  { id: number; data: BodyType<SummarizerWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleSummarizerWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleSlideGeneratorSlidesWebhook = (
  id: number,
  slideGeneratorSlidesWebhookRequestBodyDto: BodyType<SlideGeneratorSlidesWebhookRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/slide-generator/slides/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: slideGeneratorSlidesWebhookRequestBodyDto,
  });
};

export const getHandleSlideGeneratorSlidesWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSlideGeneratorSlidesWebhook>>,
    TError,
    { id: number; data: BodyType<SlideGeneratorSlidesWebhookRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleSlideGeneratorSlidesWebhook>>,
  TError,
  { id: number; data: BodyType<SlideGeneratorSlidesWebhookRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleSlideGeneratorSlidesWebhook>>,
    { id: number; data: BodyType<SlideGeneratorSlidesWebhookRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleSlideGeneratorSlidesWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleSlideGeneratorSlidesWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleSlideGeneratorSlidesWebhook>>
>;
export type HandleSlideGeneratorSlidesWebhookMutationBody =
  BodyType<SlideGeneratorSlidesWebhookRequestBodyDto>;
export type HandleSlideGeneratorSlidesWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleSlideGeneratorSlidesWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSlideGeneratorSlidesWebhook>>,
    TError,
    { id: number; data: BodyType<SlideGeneratorSlidesWebhookRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleSlideGeneratorSlidesWebhook>>,
  TError,
  { id: number; data: BodyType<SlideGeneratorSlidesWebhookRequestBodyDto> },
  TContext
> => {
  const mutationOptions =
    getHandleSlideGeneratorSlidesWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleSlideGeneratorOutlineWebhook = (
  id: number,
  slideGeneratorOutlineWebhookRequestBodyDto: BodyType<SlideGeneratorOutlineWebhookRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/slide-generator/outline/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: slideGeneratorOutlineWebhookRequestBodyDto,
  });
};

export const getHandleSlideGeneratorOutlineWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSlideGeneratorOutlineWebhook>>,
    TError,
    { id: number; data: BodyType<SlideGeneratorOutlineWebhookRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleSlideGeneratorOutlineWebhook>>,
  TError,
  { id: number; data: BodyType<SlideGeneratorOutlineWebhookRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleSlideGeneratorOutlineWebhook>>,
    { id: number; data: BodyType<SlideGeneratorOutlineWebhookRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleSlideGeneratorOutlineWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleSlideGeneratorOutlineWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleSlideGeneratorOutlineWebhook>>
>;
export type HandleSlideGeneratorOutlineWebhookMutationBody =
  BodyType<SlideGeneratorOutlineWebhookRequestBodyDto>;
export type HandleSlideGeneratorOutlineWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleSlideGeneratorOutlineWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSlideGeneratorOutlineWebhook>>,
    TError,
    { id: number; data: BodyType<SlideGeneratorOutlineWebhookRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleSlideGeneratorOutlineWebhook>>,
  TError,
  { id: number; data: BodyType<SlideGeneratorOutlineWebhookRequestBodyDto> },
  TContext
> => {
  const mutationOptions =
    getHandleSlideGeneratorOutlineWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleVideoGeneratorWebhook = (
  id: number,
  sketchGeneratorWebhookRequestDto: BodyType<SketchGeneratorWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/sketch-video-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: sketchGeneratorWebhookRequestDto,
  });
};

export const getHandleVideoGeneratorWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleVideoGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<SketchGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleVideoGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<SketchGeneratorWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleVideoGeneratorWebhook>>,
    { id: number; data: BodyType<SketchGeneratorWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleVideoGeneratorWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleVideoGeneratorWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleVideoGeneratorWebhook>>
>;
export type HandleVideoGeneratorWebhookMutationBody =
  BodyType<SketchGeneratorWebhookRequestDto>;
export type HandleVideoGeneratorWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleVideoGeneratorWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleVideoGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<SketchGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleVideoGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<SketchGeneratorWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleVideoGeneratorWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleRubricGeneratorWebhook = (
  id: number,
  rubricGeneratorWebhookRequestDto: BodyType<RubricGeneratorWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/rubric-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: rubricGeneratorWebhookRequestDto,
  });
};

export const getHandleRubricGeneratorWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleRubricGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<RubricGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleRubricGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<RubricGeneratorWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleRubricGeneratorWebhook>>,
    { id: number; data: BodyType<RubricGeneratorWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleRubricGeneratorWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleRubricGeneratorWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleRubricGeneratorWebhook>>
>;
export type HandleRubricGeneratorWebhookMutationBody =
  BodyType<RubricGeneratorWebhookRequestDto>;
export type HandleRubricGeneratorWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleRubricGeneratorWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleRubricGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<RubricGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleRubricGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<RubricGeneratorWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleRubricGeneratorWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const essayGraderRubricAnalyzer = (
  id: number,
  essayGraderRubricAnalyzerResult: BodyType<EssayGraderRubricAnalyzerResult>,
) => {
  return configureAxios<void>({
    url: `/webhooks/rubric-analyzer/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: essayGraderRubricAnalyzerResult,
  });
};

export const getEssayGraderRubricAnalyzerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayGraderRubricAnalyzer>>,
    TError,
    { id: number; data: BodyType<EssayGraderRubricAnalyzerResult> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof essayGraderRubricAnalyzer>>,
  TError,
  { id: number; data: BodyType<EssayGraderRubricAnalyzerResult> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof essayGraderRubricAnalyzer>>,
    { id: number; data: BodyType<EssayGraderRubricAnalyzerResult> }
  > = (props) => {
    const { id, data } = props ?? {};

    return essayGraderRubricAnalyzer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EssayGraderRubricAnalyzerMutationResult = NonNullable<
  Awaited<ReturnType<typeof essayGraderRubricAnalyzer>>
>;
export type EssayGraderRubricAnalyzerMutationBody =
  BodyType<EssayGraderRubricAnalyzerResult>;
export type EssayGraderRubricAnalyzerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEssayGraderRubricAnalyzer = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayGraderRubricAnalyzer>>,
    TError,
    { id: number; data: BodyType<EssayGraderRubricAnalyzerResult> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof essayGraderRubricAnalyzer>>,
  TError,
  { id: number; data: BodyType<EssayGraderRubricAnalyzerResult> },
  TContext
> => {
  const mutationOptions = getEssayGraderRubricAnalyzerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleRealWorldConnectionWebhook = (
  id: number,
  realWorldConnectionWebhookRequestDto: BodyType<RealWorldConnectionWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/real-world-connections/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: realWorldConnectionWebhookRequestDto,
  });
};

export const getHandleRealWorldConnectionWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleRealWorldConnectionWebhook>>,
    TError,
    { id: number; data: BodyType<RealWorldConnectionWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleRealWorldConnectionWebhook>>,
  TError,
  { id: number; data: BodyType<RealWorldConnectionWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleRealWorldConnectionWebhook>>,
    { id: number; data: BodyType<RealWorldConnectionWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleRealWorldConnectionWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleRealWorldConnectionWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleRealWorldConnectionWebhook>>
>;
export type HandleRealWorldConnectionWebhookMutationBody =
  BodyType<RealWorldConnectionWebhookRequestDto>;
export type HandleRealWorldConnectionWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleRealWorldConnectionWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleRealWorldConnectionWebhook>>,
    TError,
    { id: number; data: BodyType<RealWorldConnectionWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleRealWorldConnectionWebhook>>,
  TError,
  { id: number; data: BodyType<RealWorldConnectionWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleRealWorldConnectionWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const questionSolverWebhook = (
  id: number,
  questionSolverWebhookRequestBodyDto: BodyType<QuestionSolverWebhookRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/question_solver/v2/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: questionSolverWebhookRequestBodyDto,
  });
};

export const getQuestionSolverWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questionSolverWebhook>>,
    TError,
    { id: number; data: BodyType<QuestionSolverWebhookRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof questionSolverWebhook>>,
  TError,
  { id: number; data: BodyType<QuestionSolverWebhookRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof questionSolverWebhook>>,
    { id: number; data: BodyType<QuestionSolverWebhookRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return questionSolverWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuestionSolverWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof questionSolverWebhook>>
>;
export type QuestionSolverWebhookMutationBody =
  BodyType<QuestionSolverWebhookRequestBodyDto>;
export type QuestionSolverWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useQuestionSolverWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questionSolverWebhook>>,
    TError,
    { id: number; data: BodyType<QuestionSolverWebhookRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof questionSolverWebhook>>,
  TError,
  { id: number; data: BodyType<QuestionSolverWebhookRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getQuestionSolverWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleQuestionRegenWebhook = (
  id: number,
  updateQuestionRegenRequestDto: BodyType<UpdateQuestionRegenRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/question-regen/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateQuestionRegenRequestDto,
  });
};

export const getHandleQuestionRegenWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleQuestionRegenWebhook>>,
    TError,
    { id: number; data: BodyType<UpdateQuestionRegenRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleQuestionRegenWebhook>>,
  TError,
  { id: number; data: BodyType<UpdateQuestionRegenRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleQuestionRegenWebhook>>,
    { id: number; data: BodyType<UpdateQuestionRegenRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleQuestionRegenWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleQuestionRegenWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleQuestionRegenWebhook>>
>;
export type HandleQuestionRegenWebhookMutationBody =
  BodyType<UpdateQuestionRegenRequestDto>;
export type HandleQuestionRegenWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleQuestionRegenWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleQuestionRegenWebhook>>,
    TError,
    { id: number; data: BodyType<UpdateQuestionRegenRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleQuestionRegenWebhook>>,
  TError,
  { id: number; data: BodyType<UpdateQuestionRegenRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleQuestionRegenWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const questionExplanation = (
  questionExplanationSuccessRequestDto: BodyType<QuestionExplanationSuccessRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/question-explanation-success`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: questionExplanationSuccessRequestDto,
  });
};

export const getQuestionExplanationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questionExplanation>>,
    TError,
    { data: BodyType<QuestionExplanationSuccessRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof questionExplanation>>,
  TError,
  { data: BodyType<QuestionExplanationSuccessRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof questionExplanation>>,
    { data: BodyType<QuestionExplanationSuccessRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return questionExplanation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuestionExplanationMutationResult = NonNullable<
  Awaited<ReturnType<typeof questionExplanation>>
>;
export type QuestionExplanationMutationBody =
  BodyType<QuestionExplanationSuccessRequestDto>;
export type QuestionExplanationMutationError = ErrorType<BaseErrorResponseDto>;

export const useQuestionExplanation = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questionExplanation>>,
    TError,
    { data: BodyType<QuestionExplanationSuccessRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof questionExplanation>>,
  TError,
  { data: BodyType<QuestionExplanationSuccessRequestDto> },
  TContext
> => {
  const mutationOptions = getQuestionExplanationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handlePronunciationWebhook = (
  id: number,
  updateItemsRequestDto: BodyType<UpdateItemsRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/pronunciation/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateItemsRequestDto,
  });
};

export const getHandlePronunciationWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePronunciationWebhook>>,
    TError,
    { id: number; data: BodyType<UpdateItemsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handlePronunciationWebhook>>,
  TError,
  { id: number; data: BodyType<UpdateItemsRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handlePronunciationWebhook>>,
    { id: number; data: BodyType<UpdateItemsRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handlePronunciationWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandlePronunciationWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handlePronunciationWebhook>>
>;
export type HandlePronunciationWebhookMutationBody =
  BodyType<UpdateItemsRequestDto>;
export type HandlePronunciationWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandlePronunciationWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePronunciationWebhook>>,
    TError,
    { id: number; data: BodyType<UpdateItemsRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handlePronunciationWebhook>>,
  TError,
  { id: number; data: BodyType<UpdateItemsRequestDto> },
  TContext
> => {
  const mutationOptions = getHandlePronunciationWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handlePronunciationImageWebhook = (
  id: number,
  updateItemsRequestDto: BodyType<UpdateItemsRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/pronunciation-items-images/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateItemsRequestDto,
  });
};

export const getHandlePronunciationImageWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePronunciationImageWebhook>>,
    TError,
    { id: number; data: BodyType<UpdateItemsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handlePronunciationImageWebhook>>,
  TError,
  { id: number; data: BodyType<UpdateItemsRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handlePronunciationImageWebhook>>,
    { id: number; data: BodyType<UpdateItemsRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handlePronunciationImageWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandlePronunciationImageWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handlePronunciationImageWebhook>>
>;
export type HandlePronunciationImageWebhookMutationBody =
  BodyType<UpdateItemsRequestDto>;
export type HandlePronunciationImageWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandlePronunciationImageWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePronunciationImageWebhook>>,
    TError,
    { id: number; data: BodyType<UpdateItemsRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handlePronunciationImageWebhook>>,
  TError,
  { id: number; data: BodyType<UpdateItemsRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandlePronunciationImageWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleProjectBasedLearningWebhook = (
  id: number,
  projectBasedLearningWebhookRequestDto: BodyType<ProjectBasedLearningWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/project-based-learning/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: projectBasedLearningWebhookRequestDto,
  });
};

export const getHandleProjectBasedLearningWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleProjectBasedLearningWebhook>>,
    TError,
    { id: number; data: BodyType<ProjectBasedLearningWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleProjectBasedLearningWebhook>>,
  TError,
  { id: number; data: BodyType<ProjectBasedLearningWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleProjectBasedLearningWebhook>>,
    { id: number; data: BodyType<ProjectBasedLearningWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleProjectBasedLearningWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleProjectBasedLearningWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleProjectBasedLearningWebhook>>
>;
export type HandleProjectBasedLearningWebhookMutationBody =
  BodyType<ProjectBasedLearningWebhookRequestDto>;
export type HandleProjectBasedLearningWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleProjectBasedLearningWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleProjectBasedLearningWebhook>>,
    TError,
    { id: number; data: BodyType<ProjectBasedLearningWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleProjectBasedLearningWebhook>>,
  TError,
  { id: number; data: BodyType<ProjectBasedLearningWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleProjectBasedLearningWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handlePodcastWebhook = (
  id: number,
  podcastWebhookRequestDto: BodyType<PodcastWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/podcast/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: podcastWebhookRequestDto,
  });
};

export const getHandlePodcastWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePodcastWebhook>>,
    TError,
    { id: number; data: BodyType<PodcastWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handlePodcastWebhook>>,
  TError,
  { id: number; data: BodyType<PodcastWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handlePodcastWebhook>>,
    { id: number; data: BodyType<PodcastWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handlePodcastWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandlePodcastWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handlePodcastWebhook>>
>;
export type HandlePodcastWebhookMutationBody =
  BodyType<PodcastWebhookRequestDto>;
export type HandlePodcastWebhookMutationError = ErrorType<BaseErrorResponseDto>;

export const useHandlePodcastWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePodcastWebhook>>,
    TError,
    { id: number; data: BodyType<PodcastWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handlePodcastWebhook>>,
  TError,
  { id: number; data: BodyType<PodcastWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandlePodcastWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handlePerformanceTaskWebhook = (
  id: number,
  performanceTaskWebhookRequestDto: BodyType<PerformanceTaskWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/performance-task/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: performanceTaskWebhookRequestDto,
  });
};

export const getHandlePerformanceTaskWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePerformanceTaskWebhook>>,
    TError,
    { id: number; data: BodyType<PerformanceTaskWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handlePerformanceTaskWebhook>>,
  TError,
  { id: number; data: BodyType<PerformanceTaskWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handlePerformanceTaskWebhook>>,
    { id: number; data: BodyType<PerformanceTaskWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handlePerformanceTaskWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandlePerformanceTaskWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handlePerformanceTaskWebhook>>
>;
export type HandlePerformanceTaskWebhookMutationBody =
  BodyType<PerformanceTaskWebhookRequestDto>;
export type HandlePerformanceTaskWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandlePerformanceTaskWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handlePerformanceTaskWebhook>>,
    TError,
    { id: number; data: BodyType<PerformanceTaskWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handlePerformanceTaskWebhook>>,
  TError,
  { id: number; data: BodyType<PerformanceTaskWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandlePerformanceTaskWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleMindmapGeneratorWebhook = (
  id: number,
  mindmapGeneratorWebhookRequestDto: BodyType<MindmapGeneratorWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/mindmap-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: mindmapGeneratorWebhookRequestDto,
  });
};

export const getHandleMindmapGeneratorWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleMindmapGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<MindmapGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleMindmapGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<MindmapGeneratorWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleMindmapGeneratorWebhook>>,
    { id: number; data: BodyType<MindmapGeneratorWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleMindmapGeneratorWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleMindmapGeneratorWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleMindmapGeneratorWebhook>>
>;
export type HandleMindmapGeneratorWebhookMutationBody =
  BodyType<MindmapGeneratorWebhookRequestDto>;
export type HandleMindmapGeneratorWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleMindmapGeneratorWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleMindmapGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<MindmapGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleMindmapGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<MindmapGeneratorWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleMindmapGeneratorWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleLessonPlannerWebhook = (
  id: number,
  lessonPlannerWebhookV2RequestBodyDto: BodyType<LessonPlannerWebhookV2RequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/lesson-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: lessonPlannerWebhookV2RequestBodyDto,
  });
};

export const getHandleLessonPlannerWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleLessonPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<LessonPlannerWebhookV2RequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleLessonPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<LessonPlannerWebhookV2RequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleLessonPlannerWebhook>>,
    { id: number; data: BodyType<LessonPlannerWebhookV2RequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleLessonPlannerWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleLessonPlannerWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleLessonPlannerWebhook>>
>;
export type HandleLessonPlannerWebhookMutationBody =
  BodyType<LessonPlannerWebhookV2RequestBodyDto>;
export type HandleLessonPlannerWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleLessonPlannerWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleLessonPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<LessonPlannerWebhookV2RequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleLessonPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<LessonPlannerWebhookV2RequestBodyDto> },
  TContext
> => {
  const mutationOptions = getHandleLessonPlannerWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleLessonHookWebhook = (
  id: number,
  lessonHookWebhookRequestDto: BodyType<LessonHookWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/lesson-hook/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: lessonHookWebhookRequestDto,
  });
};

export const getHandleLessonHookWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleLessonHookWebhook>>,
    TError,
    { id: number; data: BodyType<LessonHookWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleLessonHookWebhook>>,
  TError,
  { id: number; data: BodyType<LessonHookWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleLessonHookWebhook>>,
    { id: number; data: BodyType<LessonHookWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleLessonHookWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleLessonHookWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleLessonHookWebhook>>
>;
export type HandleLessonHookWebhookMutationBody =
  BodyType<LessonHookWebhookRequestDto>;
export type HandleLessonHookWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleLessonHookWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleLessonHookWebhook>>,
    TError,
    { id: number; data: BodyType<LessonHookWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleLessonHookWebhook>>,
  TError,
  { id: number; data: BodyType<LessonHookWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleLessonHookWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleInteractiveMaterialGeneratorWebhook = (
  id: number,
  interactiveMaterialWebhookRequest: BodyType<InteractiveMaterialWebhookRequest>,
) => {
  return configureAxios<void>({
    url: `/webhooks/interactive-material-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: interactiveMaterialWebhookRequest,
  });
};

export const getHandleInteractiveMaterialGeneratorWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleInteractiveMaterialGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleInteractiveMaterialGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleInteractiveMaterialGeneratorWebhook>>,
    { id: number; data: BodyType<InteractiveMaterialWebhookRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleInteractiveMaterialGeneratorWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleInteractiveMaterialGeneratorWebhookMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof handleInteractiveMaterialGeneratorWebhook>>
  >;
export type HandleInteractiveMaterialGeneratorWebhookMutationBody =
  BodyType<InteractiveMaterialWebhookRequest>;
export type HandleInteractiveMaterialGeneratorWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleInteractiveMaterialGeneratorWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleInteractiveMaterialGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleInteractiveMaterialGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
  TContext
> => {
  const mutationOptions =
    getHandleInteractiveMaterialGeneratorWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleInteractiveMaterialGeneratorTranscriptWebhook = (
  id: number,
  interactiveMaterialVideoContentExtractionData: BodyType<InteractiveMaterialVideoContentExtractionData>,
) => {
  return configureAxios<void>({
    url: `/webhooks/interactive-material-generator/transcript/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: interactiveMaterialVideoContentExtractionData,
  });
};

export const getHandleInteractiveMaterialGeneratorTranscriptWebhookMutationOptions =
  <TError = ErrorType<BaseErrorResponseDto>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof handleInteractiveMaterialGeneratorTranscriptWebhook>
      >,
      TError,
      {
        id: number;
        data: BodyType<InteractiveMaterialVideoContentExtractionData>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof handleInteractiveMaterialGeneratorTranscriptWebhook>
    >,
    TError,
    {
      id: number;
      data: BodyType<InteractiveMaterialVideoContentExtractionData>;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof handleInteractiveMaterialGeneratorTranscriptWebhook>
      >,
      {
        id: number;
        data: BodyType<InteractiveMaterialVideoContentExtractionData>;
      }
    > = (props) => {
      const { id, data } = props ?? {};

      return handleInteractiveMaterialGeneratorTranscriptWebhook(id, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type HandleInteractiveMaterialGeneratorTranscriptWebhookMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof handleInteractiveMaterialGeneratorTranscriptWebhook>
    >
  >;
export type HandleInteractiveMaterialGeneratorTranscriptWebhookMutationBody =
  BodyType<InteractiveMaterialVideoContentExtractionData>;
export type HandleInteractiveMaterialGeneratorTranscriptWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleInteractiveMaterialGeneratorTranscriptWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof handleInteractiveMaterialGeneratorTranscriptWebhook>
    >,
    TError,
    {
      id: number;
      data: BodyType<InteractiveMaterialVideoContentExtractionData>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof handleInteractiveMaterialGeneratorTranscriptWebhook>
  >,
  TError,
  { id: number; data: BodyType<InteractiveMaterialVideoContentExtractionData> },
  TContext
> => {
  const mutationOptions =
    getHandleInteractiveMaterialGeneratorTranscriptWebhookMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

export const handleImageGeneratorWebhook = (
  id: number,
  imageGeneratorWebhookRequestDto: BodyType<ImageGeneratorWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/image-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: imageGeneratorWebhookRequestDto,
  });
};

export const getHandleImageGeneratorWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleImageGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<ImageGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleImageGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<ImageGeneratorWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleImageGeneratorWebhook>>,
    { id: number; data: BodyType<ImageGeneratorWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleImageGeneratorWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleImageGeneratorWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleImageGeneratorWebhook>>
>;
export type HandleImageGeneratorWebhookMutationBody =
  BodyType<ImageGeneratorWebhookRequestDto>;
export type HandleImageGeneratorWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleImageGeneratorWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleImageGeneratorWebhook>>,
    TError,
    { id: number; data: BodyType<ImageGeneratorWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleImageGeneratorWebhook>>,
  TError,
  { id: number; data: BodyType<ImageGeneratorWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleImageGeneratorWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleHomeworkIdeaWebhook = (
  id: number,
  homeworkIdeaWebhookRequestDto: BodyType<HomeworkIdeaWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/homework-idea/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: homeworkIdeaWebhookRequestDto,
  });
};

export const getHandleHomeworkIdeaWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleHomeworkIdeaWebhook>>,
    TError,
    { id: number; data: BodyType<HomeworkIdeaWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleHomeworkIdeaWebhook>>,
  TError,
  { id: number; data: BodyType<HomeworkIdeaWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleHomeworkIdeaWebhook>>,
    { id: number; data: BodyType<HomeworkIdeaWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleHomeworkIdeaWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleHomeworkIdeaWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleHomeworkIdeaWebhook>>
>;
export type HandleHomeworkIdeaWebhookMutationBody =
  BodyType<HomeworkIdeaWebhookRequestDto>;
export type HandleHomeworkIdeaWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleHomeworkIdeaWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleHomeworkIdeaWebhook>>,
    TError,
    { id: number; data: BodyType<HomeworkIdeaWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleHomeworkIdeaWebhook>>,
  TError,
  { id: number; data: BodyType<HomeworkIdeaWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleHomeworkIdeaWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleHeygenVideoAvatarWebhook = (
  id: number,
  videoAvatarWebhookRequestDto: BodyType<VideoAvatarWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/heygen_video_avatar/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: videoAvatarWebhookRequestDto,
  });
};

export const getHandleHeygenVideoAvatarWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleHeygenVideoAvatarWebhook>>,
    TError,
    { id: number; data: BodyType<VideoAvatarWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleHeygenVideoAvatarWebhook>>,
  TError,
  { id: number; data: BodyType<VideoAvatarWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleHeygenVideoAvatarWebhook>>,
    { id: number; data: BodyType<VideoAvatarWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleHeygenVideoAvatarWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleHeygenVideoAvatarWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleHeygenVideoAvatarWebhook>>
>;
export type HandleHeygenVideoAvatarWebhookMutationBody =
  BodyType<VideoAvatarWebhookRequestDto>;
export type HandleHeygenVideoAvatarWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleHeygenVideoAvatarWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleHeygenVideoAvatarWebhook>>,
    TError,
    { id: number; data: BodyType<VideoAvatarWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleHeygenVideoAvatarWebhook>>,
  TError,
  { id: number; data: BodyType<VideoAvatarWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleHeygenVideoAvatarWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleH5pUpdateWebhook = (
  id: number,
  interactiveMaterialWebhookRequestAdvancedEdit: BodyType<InteractiveMaterialWebhookRequestAdvancedEdit>,
) => {
  return configureAxios<void>({
    url: `/webhooks/h5p-update/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: interactiveMaterialWebhookRequestAdvancedEdit,
  });
};

export const getHandleH5pUpdateWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleH5pUpdateWebhook>>,
    TError,
    {
      id: number;
      data: BodyType<InteractiveMaterialWebhookRequestAdvancedEdit>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleH5pUpdateWebhook>>,
  TError,
  { id: number; data: BodyType<InteractiveMaterialWebhookRequestAdvancedEdit> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleH5pUpdateWebhook>>,
    {
      id: number;
      data: BodyType<InteractiveMaterialWebhookRequestAdvancedEdit>;
    }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleH5pUpdateWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleH5pUpdateWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleH5pUpdateWebhook>>
>;
export type HandleH5pUpdateWebhookMutationBody =
  BodyType<InteractiveMaterialWebhookRequestAdvancedEdit>;
export type HandleH5pUpdateWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleH5pUpdateWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleH5pUpdateWebhook>>,
    TError,
    {
      id: number;
      data: BodyType<InteractiveMaterialWebhookRequestAdvancedEdit>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleH5pUpdateWebhook>>,
  TError,
  { id: number; data: BodyType<InteractiveMaterialWebhookRequestAdvancedEdit> },
  TContext
> => {
  const mutationOptions = getHandleH5pUpdateWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleFormativeAssessmentWebhook = (
  id: number,
  formativeAssessmentWebhookRequestDto: BodyType<FormativeAssessmentWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/formative-assessment/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: formativeAssessmentWebhookRequestDto,
  });
};

export const getHandleFormativeAssessmentWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleFormativeAssessmentWebhook>>,
    TError,
    { id: number; data: BodyType<FormativeAssessmentWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleFormativeAssessmentWebhook>>,
  TError,
  { id: number; data: BodyType<FormativeAssessmentWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleFormativeAssessmentWebhook>>,
    { id: number; data: BodyType<FormativeAssessmentWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleFormativeAssessmentWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleFormativeAssessmentWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleFormativeAssessmentWebhook>>
>;
export type HandleFormativeAssessmentWebhookMutationBody =
  BodyType<FormativeAssessmentWebhookRequestDto>;
export type HandleFormativeAssessmentWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleFormativeAssessmentWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleFormativeAssessmentWebhook>>,
    TError,
    { id: number; data: BodyType<FormativeAssessmentWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleFormativeAssessmentWebhook>>,
  TError,
  { id: number; data: BodyType<FormativeAssessmentWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleFormativeAssessmentWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleExitTicketWebhook = (
  id: number,
  exitTicketWebhookRequestDto: BodyType<ExitTicketWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/exit-ticket/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: exitTicketWebhookRequestDto,
  });
};

export const getHandleExitTicketWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleExitTicketWebhook>>,
    TError,
    { id: number; data: BodyType<ExitTicketWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleExitTicketWebhook>>,
  TError,
  { id: number; data: BodyType<ExitTicketWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleExitTicketWebhook>>,
    { id: number; data: BodyType<ExitTicketWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleExitTicketWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleExitTicketWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleExitTicketWebhook>>
>;
export type HandleExitTicketWebhookMutationBody =
  BodyType<ExitTicketWebhookRequestDto>;
export type HandleExitTicketWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleExitTicketWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleExitTicketWebhook>>,
    TError,
    { id: number; data: BodyType<ExitTicketWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleExitTicketWebhook>>,
  TError,
  { id: number; data: BodyType<ExitTicketWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleExitTicketWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleEssentialQuestionsWebhook = (
  id: number,
  essentialQuestionsWebhookRequestDto: BodyType<EssentialQuestionsWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/essential-questions/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: essentialQuestionsWebhookRequestDto,
  });
};

export const getHandleEssentialQuestionsWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleEssentialQuestionsWebhook>>,
    TError,
    { id: number; data: BodyType<EssentialQuestionsWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleEssentialQuestionsWebhook>>,
  TError,
  { id: number; data: BodyType<EssentialQuestionsWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleEssentialQuestionsWebhook>>,
    { id: number; data: BodyType<EssentialQuestionsWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleEssentialQuestionsWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleEssentialQuestionsWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleEssentialQuestionsWebhook>>
>;
export type HandleEssentialQuestionsWebhookMutationBody =
  BodyType<EssentialQuestionsWebhookRequestDto>;
export type HandleEssentialQuestionsWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleEssentialQuestionsWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleEssentialQuestionsWebhook>>,
    TError,
    { id: number; data: BodyType<EssentialQuestionsWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleEssentialQuestionsWebhook>>,
  TError,
  { id: number; data: BodyType<EssentialQuestionsWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleEssentialQuestionsWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const essayGraderSuccess = (
  id: number,
  newEssayEvaluationResult: BodyType<NewEssayEvaluationResult>,
) => {
  return configureAxios<void>({
    url: `/webhooks/essay-grader-success/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: newEssayEvaluationResult,
  });
};

export const getEssayGraderSuccessMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayGraderSuccess>>,
    TError,
    { id: number; data: BodyType<NewEssayEvaluationResult> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof essayGraderSuccess>>,
  TError,
  { id: number; data: BodyType<NewEssayEvaluationResult> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof essayGraderSuccess>>,
    { id: number; data: BodyType<NewEssayEvaluationResult> }
  > = (props) => {
    const { id, data } = props ?? {};

    return essayGraderSuccess(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EssayGraderSuccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof essayGraderSuccess>>
>;
export type EssayGraderSuccessMutationBody = BodyType<NewEssayEvaluationResult>;
export type EssayGraderSuccessMutationError = ErrorType<BaseErrorResponseDto>;

export const useEssayGraderSuccess = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayGraderSuccess>>,
    TError,
    { id: number; data: BodyType<NewEssayEvaluationResult> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof essayGraderSuccess>>,
  TError,
  { id: number; data: BodyType<NewEssayEvaluationResult> },
  TContext
> => {
  const mutationOptions = getEssayGraderSuccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const essayAssignmentSuccess = (
  id: number,
  newEssayEvaluationResult: BodyType<NewEssayEvaluationResult>,
) => {
  return configureAxios<void>({
    url: `/webhooks/essay-assignment-success/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: newEssayEvaluationResult,
  });
};

export const getEssayAssignmentSuccessMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayAssignmentSuccess>>,
    TError,
    { id: number; data: BodyType<NewEssayEvaluationResult> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof essayAssignmentSuccess>>,
  TError,
  { id: number; data: BodyType<NewEssayEvaluationResult> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof essayAssignmentSuccess>>,
    { id: number; data: BodyType<NewEssayEvaluationResult> }
  > = (props) => {
    const { id, data } = props ?? {};

    return essayAssignmentSuccess(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EssayAssignmentSuccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof essayAssignmentSuccess>>
>;
export type EssayAssignmentSuccessMutationBody =
  BodyType<NewEssayEvaluationResult>;
export type EssayAssignmentSuccessMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEssayAssignmentSuccess = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayAssignmentSuccess>>,
    TError,
    { id: number; data: BodyType<NewEssayEvaluationResult> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof essayAssignmentSuccess>>,
  TError,
  { id: number; data: BodyType<NewEssayEvaluationResult> },
  TContext
> => {
  const mutationOptions = getEssayAssignmentSuccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleConceptualUnderstandingWebhook = (
  id: number,
  conceptualUnderstandingWebhookRequestDto: BodyType<ConceptualUnderstandingWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/conceptual-understanding/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: conceptualUnderstandingWebhookRequestDto,
  });
};

export const getHandleConceptualUnderstandingWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleConceptualUnderstandingWebhook>>,
    TError,
    { id: number; data: BodyType<ConceptualUnderstandingWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleConceptualUnderstandingWebhook>>,
  TError,
  { id: number; data: BodyType<ConceptualUnderstandingWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleConceptualUnderstandingWebhook>>,
    { id: number; data: BodyType<ConceptualUnderstandingWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleConceptualUnderstandingWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleConceptualUnderstandingWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleConceptualUnderstandingWebhook>>
>;
export type HandleConceptualUnderstandingWebhookMutationBody =
  BodyType<ConceptualUnderstandingWebhookRequestDto>;
export type HandleConceptualUnderstandingWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleConceptualUnderstandingWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleConceptualUnderstandingWebhook>>,
    TError,
    { id: number; data: BodyType<ConceptualUnderstandingWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleConceptualUnderstandingWebhook>>,
  TError,
  { id: number; data: BodyType<ConceptualUnderstandingWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleConceptualUnderstandingWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleCommonMisconceptionWebhook = (
  id: number,
  commonMisconceptionWebhookRequestDto: BodyType<CommonMisconceptionWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/common-misconceptions/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: commonMisconceptionWebhookRequestDto,
  });
};

export const getHandleCommonMisconceptionWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleCommonMisconceptionWebhook>>,
    TError,
    { id: number; data: BodyType<CommonMisconceptionWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleCommonMisconceptionWebhook>>,
  TError,
  { id: number; data: BodyType<CommonMisconceptionWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleCommonMisconceptionWebhook>>,
    { id: number; data: BodyType<CommonMisconceptionWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleCommonMisconceptionWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleCommonMisconceptionWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleCommonMisconceptionWebhook>>
>;
export type HandleCommonMisconceptionWebhookMutationBody =
  BodyType<CommonMisconceptionWebhookRequestDto>;
export type HandleCommonMisconceptionWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleCommonMisconceptionWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleCommonMisconceptionWebhook>>,
    TError,
    { id: number; data: BodyType<CommonMisconceptionWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleCommonMisconceptionWebhook>>,
  TError,
  { id: number; data: BodyType<CommonMisconceptionWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleCommonMisconceptionWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleCollaborativeGroupWorkWebhook = (
  id: number,
  collaborativeGroupWorkWebhookRequestDto: BodyType<CollaborativeGroupWorkWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/collaborative-group-work/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: collaborativeGroupWorkWebhookRequestDto,
  });
};

export const getHandleCollaborativeGroupWorkWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleCollaborativeGroupWorkWebhook>>,
    TError,
    { id: number; data: BodyType<CollaborativeGroupWorkWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleCollaborativeGroupWorkWebhook>>,
  TError,
  { id: number; data: BodyType<CollaborativeGroupWorkWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleCollaborativeGroupWorkWebhook>>,
    { id: number; data: BodyType<CollaborativeGroupWorkWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleCollaborativeGroupWorkWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleCollaborativeGroupWorkWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleCollaborativeGroupWorkWebhook>>
>;
export type HandleCollaborativeGroupWorkWebhookMutationBody =
  BodyType<CollaborativeGroupWorkWebhookRequestDto>;
export type HandleCollaborativeGroupWorkWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleCollaborativeGroupWorkWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleCollaborativeGroupWorkWebhook>>,
    TError,
    { id: number; data: BodyType<CollaborativeGroupWorkWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleCollaborativeGroupWorkWebhook>>,
  TError,
  { id: number; data: BodyType<CollaborativeGroupWorkWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleCollaborativeGroupWorkWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleClassroomManagementWebhook = (
  id: number,
  classroomManagementWebhookRequestDto: BodyType<ClassroomManagementWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/classroom-management/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: classroomManagementWebhookRequestDto,
  });
};

export const getHandleClassroomManagementWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleClassroomManagementWebhook>>,
    TError,
    { id: number; data: BodyType<ClassroomManagementWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleClassroomManagementWebhook>>,
  TError,
  { id: number; data: BodyType<ClassroomManagementWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleClassroomManagementWebhook>>,
    { id: number; data: BodyType<ClassroomManagementWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleClassroomManagementWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleClassroomManagementWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleClassroomManagementWebhook>>
>;
export type HandleClassroomManagementWebhookMutationBody =
  BodyType<ClassroomManagementWebhookRequestDto>;
export type HandleClassroomManagementWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleClassroomManagementWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleClassroomManagementWebhook>>,
    TError,
    { id: number; data: BodyType<ClassroomManagementWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleClassroomManagementWebhook>>,
  TError,
  { id: number; data: BodyType<ClassroomManagementWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleClassroomManagementWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleChoiceBoardWebhook = (
  id: number,
  choiceBoardWebhookRequestDto: BodyType<ChoiceBoardWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/choice-board/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: choiceBoardWebhookRequestDto,
  });
};

export const getHandleChoiceBoardWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleChoiceBoardWebhook>>,
    TError,
    { id: number; data: BodyType<ChoiceBoardWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleChoiceBoardWebhook>>,
  TError,
  { id: number; data: BodyType<ChoiceBoardWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleChoiceBoardWebhook>>,
    { id: number; data: BodyType<ChoiceBoardWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleChoiceBoardWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleChoiceBoardWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleChoiceBoardWebhook>>
>;
export type HandleChoiceBoardWebhookMutationBody =
  BodyType<ChoiceBoardWebhookRequestDto>;
export type HandleChoiceBoardWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleChoiceBoardWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleChoiceBoardWebhook>>,
    TError,
    { id: number; data: BodyType<ChoiceBoardWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleChoiceBoardWebhook>>,
  TError,
  { id: number; data: BodyType<ChoiceBoardWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleChoiceBoardWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const chatAnalysisSuccess = (
  chatAnalysisSuccessRequestDto: BodyType<ChatAnalysisSuccessRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/chat-analysis-success`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: chatAnalysisSuccessRequestDto,
  });
};

export const getChatAnalysisSuccessMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatAnalysisSuccess>>,
    TError,
    { data: BodyType<ChatAnalysisSuccessRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatAnalysisSuccess>>,
  TError,
  { data: BodyType<ChatAnalysisSuccessRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatAnalysisSuccess>>,
    { data: BodyType<ChatAnalysisSuccessRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return chatAnalysisSuccess(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatAnalysisSuccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatAnalysisSuccess>>
>;
export type ChatAnalysisSuccessMutationBody =
  BodyType<ChatAnalysisSuccessRequestDto>;
export type ChatAnalysisSuccessMutationError = ErrorType<BaseErrorResponseDto>;

export const useChatAnalysisSuccess = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatAnalysisSuccess>>,
    TError,
    { data: BodyType<ChatAnalysisSuccessRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof chatAnalysisSuccess>>,
  TError,
  { data: BodyType<ChatAnalysisSuccessRequestDto> },
  TContext
> => {
  const mutationOptions = getChatAnalysisSuccessMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleBloomsTaxonomyActivitiesWebhook = (
  id: number,
  bloomsTaxonomyActivitiesWebhookRequestDto: BodyType<BloomsTaxonomyActivitiesWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/blooms-taxonomy-activities/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bloomsTaxonomyActivitiesWebhookRequestDto,
  });
};

export const getHandleBloomsTaxonomyActivitiesWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleBloomsTaxonomyActivitiesWebhook>>,
    TError,
    { id: number; data: BodyType<BloomsTaxonomyActivitiesWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleBloomsTaxonomyActivitiesWebhook>>,
  TError,
  { id: number; data: BodyType<BloomsTaxonomyActivitiesWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleBloomsTaxonomyActivitiesWebhook>>,
    { id: number; data: BodyType<BloomsTaxonomyActivitiesWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleBloomsTaxonomyActivitiesWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleBloomsTaxonomyActivitiesWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleBloomsTaxonomyActivitiesWebhook>>
>;
export type HandleBloomsTaxonomyActivitiesWebhookMutationBody =
  BodyType<BloomsTaxonomyActivitiesWebhookRequestDto>;
export type HandleBloomsTaxonomyActivitiesWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleBloomsTaxonomyActivitiesWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleBloomsTaxonomyActivitiesWebhook>>,
    TError,
    { id: number; data: BodyType<BloomsTaxonomyActivitiesWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleBloomsTaxonomyActivitiesWebhook>>,
  TError,
  { id: number; data: BodyType<BloomsTaxonomyActivitiesWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleBloomsTaxonomyActivitiesWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const assignmentGenerationTitleUpdate = (
  assignmentId: number,
  assignmentGenerationTitleUpdateDto: BodyType<AssignmentGenerationTitleUpdateDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/assignments/${assignmentId}/question-generation-title`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: assignmentGenerationTitleUpdateDto,
  });
};

export const getAssignmentGenerationTitleUpdateMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignmentGenerationTitleUpdate>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<AssignmentGenerationTitleUpdateDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignmentGenerationTitleUpdate>>,
  TError,
  { assignmentId: number; data: BodyType<AssignmentGenerationTitleUpdateDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignmentGenerationTitleUpdate>>,
    { assignmentId: number; data: BodyType<AssignmentGenerationTitleUpdateDto> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return assignmentGenerationTitleUpdate(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGenerationTitleUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignmentGenerationTitleUpdate>>
>;
export type AssignmentGenerationTitleUpdateMutationBody =
  BodyType<AssignmentGenerationTitleUpdateDto>;
export type AssignmentGenerationTitleUpdateMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAssignmentGenerationTitleUpdate = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignmentGenerationTitleUpdate>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<AssignmentGenerationTitleUpdateDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignmentGenerationTitleUpdate>>,
  TError,
  { assignmentId: number; data: BodyType<AssignmentGenerationTitleUpdateDto> },
  TContext
> => {
  const mutationOptions =
    getAssignmentGenerationTitleUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const partialAssignmentGenerationSingle = (
  assignmentId: number,
  partialAssignmentGenerationSingleBody: BodyType<PartialAssignmentGenerationSingleBody>,
) => {
  return configureAxios<number>({
    url: `/webhooks/assignments/${assignmentId}/question-generation-single`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: partialAssignmentGenerationSingleBody,
  });
};

export const getPartialAssignmentGenerationSingleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partialAssignmentGenerationSingle>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<PartialAssignmentGenerationSingleBody>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof partialAssignmentGenerationSingle>>,
  TError,
  {
    assignmentId: number;
    data: BodyType<PartialAssignmentGenerationSingleBody>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof partialAssignmentGenerationSingle>>,
    {
      assignmentId: number;
      data: BodyType<PartialAssignmentGenerationSingleBody>;
    }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return partialAssignmentGenerationSingle(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PartialAssignmentGenerationSingleMutationResult = NonNullable<
  Awaited<ReturnType<typeof partialAssignmentGenerationSingle>>
>;
export type PartialAssignmentGenerationSingleMutationBody =
  BodyType<PartialAssignmentGenerationSingleBody>;
export type PartialAssignmentGenerationSingleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const usePartialAssignmentGenerationSingle = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partialAssignmentGenerationSingle>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<PartialAssignmentGenerationSingleBody>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof partialAssignmentGenerationSingle>>,
  TError,
  {
    assignmentId: number;
    data: BodyType<PartialAssignmentGenerationSingleBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPartialAssignmentGenerationSingleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const assignmentGenerationImageUpdate = (
  assignmentId: number,
  assignmentGenerationImageUpdateDto: BodyType<AssignmentGenerationImageUpdateDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/assignments/${assignmentId}/question-generation-image`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: assignmentGenerationImageUpdateDto,
  });
};

export const getAssignmentGenerationImageUpdateMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignmentGenerationImageUpdate>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<AssignmentGenerationImageUpdateDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignmentGenerationImageUpdate>>,
  TError,
  { assignmentId: number; data: BodyType<AssignmentGenerationImageUpdateDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignmentGenerationImageUpdate>>,
    { assignmentId: number; data: BodyType<AssignmentGenerationImageUpdateDto> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return assignmentGenerationImageUpdate(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGenerationImageUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignmentGenerationImageUpdate>>
>;
export type AssignmentGenerationImageUpdateMutationBody =
  BodyType<AssignmentGenerationImageUpdateDto>;
export type AssignmentGenerationImageUpdateMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAssignmentGenerationImageUpdate = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignmentGenerationImageUpdate>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<AssignmentGenerationImageUpdateDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignmentGenerationImageUpdate>>,
  TError,
  { assignmentId: number; data: BodyType<AssignmentGenerationImageUpdateDto> },
  TContext
> => {
  const mutationOptions =
    getAssignmentGenerationImageUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const partialAssignmentGenerationFinalize = (
  assignmentId: number,
  completeQuestionGenerationRequestDto: BodyType<CompleteQuestionGenerationRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/assignments/${assignmentId}/question-generation-finalize`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: completeQuestionGenerationRequestDto,
  });
};

export const getPartialAssignmentGenerationFinalizeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partialAssignmentGenerationFinalize>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<CompleteQuestionGenerationRequestDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof partialAssignmentGenerationFinalize>>,
  TError,
  {
    assignmentId: number;
    data: BodyType<CompleteQuestionGenerationRequestDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof partialAssignmentGenerationFinalize>>,
    {
      assignmentId: number;
      data: BodyType<CompleteQuestionGenerationRequestDto>;
    }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return partialAssignmentGenerationFinalize(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PartialAssignmentGenerationFinalizeMutationResult = NonNullable<
  Awaited<ReturnType<typeof partialAssignmentGenerationFinalize>>
>;
export type PartialAssignmentGenerationFinalizeMutationBody =
  BodyType<CompleteQuestionGenerationRequestDto>;
export type PartialAssignmentGenerationFinalizeMutationError =
  ErrorType<BaseErrorResponseDto>;

export const usePartialAssignmentGenerationFinalize = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partialAssignmentGenerationFinalize>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<CompleteQuestionGenerationRequestDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof partialAssignmentGenerationFinalize>>,
  TError,
  {
    assignmentId: number;
    data: BodyType<CompleteQuestionGenerationRequestDto>;
  },
  TContext
> => {
  const mutationOptions =
    getPartialAssignmentGenerationFinalizeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const assignmentGenerationFailure = (
  assignmentId: number,
  failedQuestionGenerationRequestDto: BodyType<FailedQuestionGenerationRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/assignments/${assignmentId}/question-generation-failed`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: failedQuestionGenerationRequestDto,
  });
};

export const getAssignmentGenerationFailureMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignmentGenerationFailure>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<FailedQuestionGenerationRequestDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignmentGenerationFailure>>,
  TError,
  { assignmentId: number; data: BodyType<FailedQuestionGenerationRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignmentGenerationFailure>>,
    { assignmentId: number; data: BodyType<FailedQuestionGenerationRequestDto> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return assignmentGenerationFailure(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGenerationFailureMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignmentGenerationFailure>>
>;
export type AssignmentGenerationFailureMutationBody =
  BodyType<FailedQuestionGenerationRequestDto>;
export type AssignmentGenerationFailureMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAssignmentGenerationFailure = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignmentGenerationFailure>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<FailedQuestionGenerationRequestDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignmentGenerationFailure>>,
  TError,
  { assignmentId: number; data: BodyType<FailedQuestionGenerationRequestDto> },
  TContext
> => {
  const mutationOptions =
    getAssignmentGenerationFailureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleAiSupportedTasksWebhook = (
  id: number,
  aiSupportedTasksWebhookRequestDto: BodyType<AiSupportedTasksWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ai-supported-tasks/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiSupportedTasksWebhookRequestDto,
  });
};

export const getHandleAiSupportedTasksWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiSupportedTasksWebhook>>,
    TError,
    { id: number; data: BodyType<AiSupportedTasksWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleAiSupportedTasksWebhook>>,
  TError,
  { id: number; data: BodyType<AiSupportedTasksWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleAiSupportedTasksWebhook>>,
    { id: number; data: BodyType<AiSupportedTasksWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleAiSupportedTasksWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleAiSupportedTasksWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleAiSupportedTasksWebhook>>
>;
export type HandleAiSupportedTasksWebhookMutationBody =
  BodyType<AiSupportedTasksWebhookRequestDto>;
export type HandleAiSupportedTasksWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleAiSupportedTasksWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiSupportedTasksWebhook>>,
    TError,
    { id: number; data: BodyType<AiSupportedTasksWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleAiSupportedTasksWebhook>>,
  TError,
  { id: number; data: BodyType<AiSupportedTasksWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleAiSupportedTasksWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleAiResistantHomeworkWebhook = (
  id: number,
  aiResistantHomeworkWebhookRequestDto: BodyType<AiResistantHomeworkWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ai-resistant-homework/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiResistantHomeworkWebhookRequestDto,
  });
};

export const getHandleAiResistantHomeworkWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiResistantHomeworkWebhook>>,
    TError,
    { id: number; data: BodyType<AiResistantHomeworkWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleAiResistantHomeworkWebhook>>,
  TError,
  { id: number; data: BodyType<AiResistantHomeworkWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleAiResistantHomeworkWebhook>>,
    { id: number; data: BodyType<AiResistantHomeworkWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleAiResistantHomeworkWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleAiResistantHomeworkWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleAiResistantHomeworkWebhook>>
>;
export type HandleAiResistantHomeworkWebhookMutationBody =
  BodyType<AiResistantHomeworkWebhookRequestDto>;
export type HandleAiResistantHomeworkWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleAiResistantHomeworkWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiResistantHomeworkWebhook>>,
    TError,
    { id: number; data: BodyType<AiResistantHomeworkWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleAiResistantHomeworkWebhook>>,
  TError,
  { id: number; data: BodyType<AiResistantHomeworkWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleAiResistantHomeworkWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleAiAssignmentDesignerWebhook = (
  id: number,
  aiAssignmentWebhookRequestDto: BodyType<AiAssignmentWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ai-assignment-designer/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiAssignmentWebhookRequestDto,
  });
};

export const getHandleAiAssignmentDesignerWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiAssignmentDesignerWebhook>>,
    TError,
    { id: number; data: BodyType<AiAssignmentWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleAiAssignmentDesignerWebhook>>,
  TError,
  { id: number; data: BodyType<AiAssignmentWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleAiAssignmentDesignerWebhook>>,
    { id: number; data: BodyType<AiAssignmentWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleAiAssignmentDesignerWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleAiAssignmentDesignerWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleAiAssignmentDesignerWebhook>>
>;
export type HandleAiAssignmentDesignerWebhookMutationBody =
  BodyType<AiAssignmentWebhookRequestDto>;
export type HandleAiAssignmentDesignerWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleAiAssignmentDesignerWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiAssignmentDesignerWebhook>>,
    TError,
    { id: number; data: BodyType<AiAssignmentWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleAiAssignmentDesignerWebhook>>,
  TError,
  { id: number; data: BodyType<AiAssignmentWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleAiAssignmentDesignerWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleAiAssessmentScaleWebhook = (
  id: number,
  aiAssessmentScaleWebhookRequestDto: BodyType<AiAssessmentScaleWebhookRequestDto>,
) => {
  return configureAxios<void>({
    url: `/webhooks/ai-assessment-scale/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiAssessmentScaleWebhookRequestDto,
  });
};

export const getHandleAiAssessmentScaleWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiAssessmentScaleWebhook>>,
    TError,
    { id: number; data: BodyType<AiAssessmentScaleWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleAiAssessmentScaleWebhook>>,
  TError,
  { id: number; data: BodyType<AiAssessmentScaleWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleAiAssessmentScaleWebhook>>,
    { id: number; data: BodyType<AiAssessmentScaleWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleAiAssessmentScaleWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleAiAssessmentScaleWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleAiAssessmentScaleWebhook>>
>;
export type HandleAiAssessmentScaleWebhookMutationBody =
  BodyType<AiAssessmentScaleWebhookRequestDto>;
export type HandleAiAssessmentScaleWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleAiAssessmentScaleWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAiAssessmentScaleWebhook>>,
    TError,
    { id: number; data: BodyType<AiAssessmentScaleWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleAiAssessmentScaleWebhook>>,
  TError,
  { id: number; data: BodyType<AiAssessmentScaleWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleAiAssessmentScaleWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getVocabularyList = (id: number, signal?: AbortSignal) => {
  return configureAxios<VocabularyListResponseDto>({
    url: `/vocabulary-lists/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetVocabularyListQueryKey = (id: number) => {
  return [`/vocabulary-lists/${id}`] as const;
};

export const getGetVocabularyListQueryOptions = <
  TData = Awaited<ReturnType<typeof getVocabularyList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVocabularyList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVocabularyListQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVocabularyList>>
  > = ({ signal }) => getVocabularyList(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVocabularyList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVocabularyListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVocabularyList>>
>;
export type GetVocabularyListQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetVocabularyList<
  TData = Awaited<ReturnType<typeof getVocabularyList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVocabularyList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVocabularyList>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVocabularyList<
  TData = Awaited<ReturnType<typeof getVocabularyList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVocabularyList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVocabularyList>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVocabularyList<
  TData = Awaited<ReturnType<typeof getVocabularyList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVocabularyList>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetVocabularyList<
  TData = Awaited<ReturnType<typeof getVocabularyList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVocabularyList>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVocabularyListQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateVocabularyList = (
  id: number,
  vocabularyListUpdateRequestDto: BodyType<VocabularyListUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/vocabulary-lists/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: vocabularyListUpdateRequestDto,
  });
};

export const getUpdateVocabularyListMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVocabularyList>>,
    TError,
    { id: number; data: BodyType<VocabularyListUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVocabularyList>>,
  TError,
  { id: number; data: BodyType<VocabularyListUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVocabularyList>>,
    { id: number; data: BodyType<VocabularyListUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVocabularyList(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVocabularyListMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVocabularyList>>
>;
export type UpdateVocabularyListMutationBody =
  BodyType<VocabularyListUpdateRequestDto>;
export type UpdateVocabularyListMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateVocabularyList = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVocabularyList>>,
    TError,
    { id: number; data: BodyType<VocabularyListUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVocabularyList>>,
  TError,
  { id: number; data: BodyType<VocabularyListUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateVocabularyListMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteVocabularyList = (id: number) => {
  return configureAxios<void>({
    url: `/vocabulary-lists/${id}`,
    method: "DELETE",
  });
};

export const getDeleteVocabularyListMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVocabularyList>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVocabularyList>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVocabularyList>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVocabularyList(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVocabularyListMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVocabularyList>>
>;

export type DeleteVocabularyListMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteVocabularyList = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVocabularyList>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVocabularyList>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteVocabularyListMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getVideoAvatar = (id: number, signal?: AbortSignal) => {
  return configureAxios<VideoAvatarResponseDto>({
    url: `/video-avatar/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetVideoAvatarQueryKey = (id: number) => {
  return [`/video-avatar/${id}`] as const;
};

export const getGetVideoAvatarQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideoAvatar>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVideoAvatar>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVideoAvatarQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVideoAvatar>>> = ({
    signal,
  }) => getVideoAvatar(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideoAvatar>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVideoAvatarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVideoAvatar>>
>;
export type GetVideoAvatarQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetVideoAvatar<
  TData = Awaited<ReturnType<typeof getVideoAvatar>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVideoAvatar>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoAvatar>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVideoAvatar<
  TData = Awaited<ReturnType<typeof getVideoAvatar>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVideoAvatar>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoAvatar>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVideoAvatar<
  TData = Awaited<ReturnType<typeof getVideoAvatar>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVideoAvatar>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetVideoAvatar<
  TData = Awaited<ReturnType<typeof getVideoAvatar>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVideoAvatar>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVideoAvatarQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateVideoAvatar = (
  id: number,
  videoAvatarUpdateRequestDto: BodyType<VideoAvatarUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/video-avatar/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: videoAvatarUpdateRequestDto,
  });
};

export const getUpdateVideoAvatarMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVideoAvatar>>,
    TError,
    { id: number; data: BodyType<VideoAvatarUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVideoAvatar>>,
  TError,
  { id: number; data: BodyType<VideoAvatarUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVideoAvatar>>,
    { id: number; data: BodyType<VideoAvatarUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVideoAvatar(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVideoAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVideoAvatar>>
>;
export type UpdateVideoAvatarMutationBody =
  BodyType<VideoAvatarUpdateRequestDto>;
export type UpdateVideoAvatarMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateVideoAvatar = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVideoAvatar>>,
    TError,
    { id: number; data: BodyType<VideoAvatarUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVideoAvatar>>,
  TError,
  { id: number; data: BodyType<VideoAvatarUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateVideoAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteVideoAvatar = (id: number) => {
  return configureAxios<void>({ url: `/video-avatar/${id}`, method: "DELETE" });
};

export const getDeleteVideoAvatarMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVideoAvatar>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVideoAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVideoAvatar>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVideoAvatar(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVideoAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVideoAvatar>>
>;

export type DeleteVideoAvatarMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteVideoAvatar = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVideoAvatar>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVideoAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteVideoAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const saveFirebaseDeviceInfo = (
  saveFirebaseDeviceInfoRequestBodyDto: BodyType<SaveFirebaseDeviceInfoRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/users/firebase-device-info`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: saveFirebaseDeviceInfoRequestBodyDto,
  });
};

export const getSaveFirebaseDeviceInfoMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveFirebaseDeviceInfo>>,
    TError,
    { data: BodyType<SaveFirebaseDeviceInfoRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveFirebaseDeviceInfo>>,
  TError,
  { data: BodyType<SaveFirebaseDeviceInfoRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveFirebaseDeviceInfo>>,
    { data: BodyType<SaveFirebaseDeviceInfoRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return saveFirebaseDeviceInfo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveFirebaseDeviceInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveFirebaseDeviceInfo>>
>;
export type SaveFirebaseDeviceInfoMutationBody =
  BodyType<SaveFirebaseDeviceInfoRequestBodyDto>;
export type SaveFirebaseDeviceInfoMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSaveFirebaseDeviceInfo = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveFirebaseDeviceInfo>>,
    TError,
    { data: BodyType<SaveFirebaseDeviceInfoRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveFirebaseDeviceInfo>>,
  TError,
  { data: BodyType<SaveFirebaseDeviceInfoRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getSaveFirebaseDeviceInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUdlChoiceBoard = (id: number, signal?: AbortSignal) => {
  return configureAxios<UdlChoiceBoardResponseDto>({
    url: `/udl-choice-board/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetUdlChoiceBoardQueryKey = (id: number) => {
  return [`/udl-choice-board/${id}`] as const;
};

export const getGetUdlChoiceBoardQueryOptions = <
  TData = Awaited<ReturnType<typeof getUdlChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUdlChoiceBoard>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUdlChoiceBoardQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUdlChoiceBoard>>
  > = ({ signal }) => getUdlChoiceBoard(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUdlChoiceBoard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUdlChoiceBoardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUdlChoiceBoard>>
>;
export type GetUdlChoiceBoardQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUdlChoiceBoard<
  TData = Awaited<ReturnType<typeof getUdlChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUdlChoiceBoard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUdlChoiceBoard>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUdlChoiceBoard<
  TData = Awaited<ReturnType<typeof getUdlChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUdlChoiceBoard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUdlChoiceBoard>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUdlChoiceBoard<
  TData = Awaited<ReturnType<typeof getUdlChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUdlChoiceBoard>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUdlChoiceBoard<
  TData = Awaited<ReturnType<typeof getUdlChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUdlChoiceBoard>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUdlChoiceBoardQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateUdlChoiceBoard = (
  id: number,
  udlChoiceBoardUpdateRequestDto: BodyType<UdlChoiceBoardUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/udl-choice-board/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: udlChoiceBoardUpdateRequestDto,
  });
};

export const getUpdateUdlChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUdlChoiceBoard>>,
    TError,
    { id: number; data: BodyType<UdlChoiceBoardUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUdlChoiceBoard>>,
  TError,
  { id: number; data: BodyType<UdlChoiceBoardUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUdlChoiceBoard>>,
    { id: number; data: BodyType<UdlChoiceBoardUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUdlChoiceBoard(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUdlChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUdlChoiceBoard>>
>;
export type UpdateUdlChoiceBoardMutationBody =
  BodyType<UdlChoiceBoardUpdateRequestDto>;
export type UpdateUdlChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateUdlChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUdlChoiceBoard>>,
    TError,
    { id: number; data: BodyType<UdlChoiceBoardUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUdlChoiceBoard>>,
  TError,
  { id: number; data: BodyType<UdlChoiceBoardUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateUdlChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteUdlChoiceBoard = (id: number) => {
  return configureAxios<void>({
    url: `/udl-choice-board/${id}`,
    method: "DELETE",
  });
};

export const getDeleteUdlChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUdlChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUdlChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUdlChoiceBoard>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteUdlChoiceBoard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUdlChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUdlChoiceBoard>>
>;

export type DeleteUdlChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteUdlChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUdlChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUdlChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteUdlChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUbdPlanner = (id: number, signal?: AbortSignal) => {
  return configureAxios<UbdMaarifPlannerResponseDto>({
    url: `/ubd-planner/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetUbdPlannerQueryKey = (id: number) => {
  return [`/ubd-planner/${id}`] as const;
};

export const getGetUbdPlannerQueryOptions = <
  TData = Awaited<ReturnType<typeof getUbdPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanner>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUbdPlannerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUbdPlanner>>> = ({
    signal,
  }) => getUbdPlanner(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUbdPlanner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUbdPlannerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUbdPlanner>>
>;
export type GetUbdPlannerQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUbdPlanner<
  TData = Awaited<ReturnType<typeof getUbdPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanner>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUbdPlanner>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUbdPlanner<
  TData = Awaited<ReturnType<typeof getUbdPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanner>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUbdPlanner>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUbdPlanner<
  TData = Awaited<ReturnType<typeof getUbdPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanner>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUbdPlanner<
  TData = Awaited<ReturnType<typeof getUbdPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanner>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUbdPlannerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const editUbdMaarifPlanner = (
  id: number,
  editUbdMaarifPlannerRequestDto: BodyType<EditUbdMaarifPlannerRequestDto>,
) => {
  return configureAxios<UbdMaarifPlannerResponseDto>({
    url: `/ubd-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: editUbdMaarifPlannerRequestDto,
  });
};

export const getEditUbdMaarifPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editUbdMaarifPlanner>>,
    TError,
    { id: number; data: BodyType<EditUbdMaarifPlannerRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editUbdMaarifPlanner>>,
  TError,
  { id: number; data: BodyType<EditUbdMaarifPlannerRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editUbdMaarifPlanner>>,
    { id: number; data: BodyType<EditUbdMaarifPlannerRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return editUbdMaarifPlanner(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditUbdMaarifPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof editUbdMaarifPlanner>>
>;
export type EditUbdMaarifPlannerMutationBody =
  BodyType<EditUbdMaarifPlannerRequestDto>;
export type EditUbdMaarifPlannerMutationError = ErrorType<BaseErrorResponseDto>;

export const useEditUbdMaarifPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editUbdMaarifPlanner>>,
    TError,
    { id: number; data: BodyType<EditUbdMaarifPlannerRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editUbdMaarifPlanner>>,
  TError,
  { id: number; data: BodyType<EditUbdMaarifPlannerRequestDto> },
  TContext
> => {
  const mutationOptions = getEditUbdMaarifPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteUbdPlanner = (id: number) => {
  return configureAxios<void>({ url: `/ubd-planner/${id}`, method: "DELETE" });
};

export const getDeleteUbdPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUbdPlanner>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUbdPlanner>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUbdPlanner>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteUbdPlanner(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUbdPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUbdPlanner>>
>;

export type DeleteUbdPlannerMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteUbdPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUbdPlanner>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUbdPlanner>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteUbdPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createUbdMaarifLessonPlannerSubsteps = (
  id: number,
  generateUbdGoalsSubstepRequestDto: BodyType<GenerateUbdGoalsSubstepRequestDto>,
) => {
  return configureAxios<UbdMaarifPlannerResponseDto>({
    url: `/ubd-planner/${id}/sub-steps`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: generateUbdGoalsSubstepRequestDto,
  });
};

export const getCreateUbdMaarifLessonPlannerSubstepsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubsteps>>,
    TError,
    { id: number; data: BodyType<GenerateUbdGoalsSubstepRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubsteps>>,
  TError,
  { id: number; data: BodyType<GenerateUbdGoalsSubstepRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubsteps>>,
    { id: number; data: BodyType<GenerateUbdGoalsSubstepRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createUbdMaarifLessonPlannerSubsteps(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUbdMaarifLessonPlannerSubstepsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubsteps>>
>;
export type CreateUbdMaarifLessonPlannerSubstepsMutationBody =
  BodyType<GenerateUbdGoalsSubstepRequestDto>;
export type CreateUbdMaarifLessonPlannerSubstepsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateUbdMaarifLessonPlannerSubsteps = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubsteps>>,
    TError,
    { id: number; data: BodyType<GenerateUbdGoalsSubstepRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubsteps>>,
  TError,
  { id: number; data: BodyType<GenerateUbdGoalsSubstepRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateUbdMaarifLessonPlannerSubstepsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createUbdMaarifLessonPlannerSubstepsWithAi = (
  id: number,
  generateUbdGoalsSubstepWithAiRequestDto: BodyType<GenerateUbdGoalsSubstepWithAiRequestDto>,
) => {
  return configureAxios<UbdMaarifPlannerResponseDto>({
    url: `/ubd-planner/${id}/sub-steps-ai`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: generateUbdGoalsSubstepWithAiRequestDto,
  });
};

export const getCreateUbdMaarifLessonPlannerSubstepsWithAiMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubstepsWithAi>>,
    TError,
    { id: number; data: BodyType<GenerateUbdGoalsSubstepWithAiRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubstepsWithAi>>,
  TError,
  { id: number; data: BodyType<GenerateUbdGoalsSubstepWithAiRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubstepsWithAi>>,
    { id: number; data: BodyType<GenerateUbdGoalsSubstepWithAiRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createUbdMaarifLessonPlannerSubstepsWithAi(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUbdMaarifLessonPlannerSubstepsWithAiMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubstepsWithAi>>
  >;
export type CreateUbdMaarifLessonPlannerSubstepsWithAiMutationBody =
  BodyType<GenerateUbdGoalsSubstepWithAiRequestDto>;
export type CreateUbdMaarifLessonPlannerSubstepsWithAiMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateUbdMaarifLessonPlannerSubstepsWithAi = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubstepsWithAi>>,
    TError,
    { id: number; data: BodyType<GenerateUbdGoalsSubstepWithAiRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlannerSubstepsWithAi>>,
  TError,
  { id: number; data: BodyType<GenerateUbdGoalsSubstepWithAiRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateUbdMaarifLessonPlannerSubstepsWithAiMutationOptions(options);

  return useMutation(mutationOptions);
};

export const finalizeUbdMaarifLessonFlow = (id: number) => {
  return configureAxios<UbdMaarifPlannerResponseDto>({
    url: `/ubd-planner/${id}/finalize`,
    method: "PUT",
  });
};

export const getFinalizeUbdMaarifLessonFlowMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeUbdMaarifLessonFlow>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeUbdMaarifLessonFlow>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeUbdMaarifLessonFlow>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return finalizeUbdMaarifLessonFlow(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeUbdMaarifLessonFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeUbdMaarifLessonFlow>>
>;

export type FinalizeUbdMaarifLessonFlowMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useFinalizeUbdMaarifLessonFlow = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeUbdMaarifLessonFlow>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof finalizeUbdMaarifLessonFlow>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getFinalizeUbdMaarifLessonFlowMutationOptions(options);

  return useMutation(mutationOptions);
};

export const runIndividualStepUbdExpertPlannerService = (
  id: number,
  individualStepRequestDto: BodyType<IndividualStepRequestDto>,
) => {
  return configureAxios<UbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner/${id}/run-step`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: individualStepRequestDto,
  });
};

export const getRunIndividualStepUbdExpertPlannerServiceMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runIndividualStepUbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<IndividualStepRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runIndividualStepUbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<IndividualStepRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runIndividualStepUbdExpertPlannerService>>,
    { id: number; data: BodyType<IndividualStepRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return runIndividualStepUbdExpertPlannerService(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunIndividualStepUbdExpertPlannerServiceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof runIndividualStepUbdExpertPlannerService>>
  >;
export type RunIndividualStepUbdExpertPlannerServiceMutationBody =
  BodyType<IndividualStepRequestDto>;
export type RunIndividualStepUbdExpertPlannerServiceMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRunIndividualStepUbdExpertPlannerService = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runIndividualStepUbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<IndividualStepRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof runIndividualStepUbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<IndividualStepRequestDto> },
  TContext
> => {
  const mutationOptions =
    getRunIndividualStepUbdExpertPlannerServiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const refineGenericUbdExpertPlannerService = (
  id: number,
  refineGenericRequestDto: BodyType<RefineGenericRequestDto>,
) => {
  return configureAxios<UbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner/${id}/refine-step`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: refineGenericRequestDto,
  });
};

export const getRefineGenericUbdExpertPlannerServiceMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refineGenericUbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<RefineGenericRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refineGenericUbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<RefineGenericRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refineGenericUbdExpertPlannerService>>,
    { id: number; data: BodyType<RefineGenericRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return refineGenericUbdExpertPlannerService(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefineGenericUbdExpertPlannerServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof refineGenericUbdExpertPlannerService>>
>;
export type RefineGenericUbdExpertPlannerServiceMutationBody =
  BodyType<RefineGenericRequestDto>;
export type RefineGenericUbdExpertPlannerServiceMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRefineGenericUbdExpertPlannerService = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refineGenericUbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<RefineGenericRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof refineGenericUbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<RefineGenericRequestDto> },
  TContext
> => {
  const mutationOptions =
    getRefineGenericUbdExpertPlannerServiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const refineStep1UbdExpertPlannerService = (
  id: number,
  refineStep1RequestDto: BodyType<RefineStep1RequestDto>,
) => {
  return configureAxios<UbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner/${id}/refine-step1`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: refineStep1RequestDto,
  });
};

export const getRefineStep1UbdExpertPlannerServiceMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refineStep1UbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<RefineStep1RequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refineStep1UbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<RefineStep1RequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refineStep1UbdExpertPlannerService>>,
    { id: number; data: BodyType<RefineStep1RequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return refineStep1UbdExpertPlannerService(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefineStep1UbdExpertPlannerServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof refineStep1UbdExpertPlannerService>>
>;
export type RefineStep1UbdExpertPlannerServiceMutationBody =
  BodyType<RefineStep1RequestDto>;
export type RefineStep1UbdExpertPlannerServiceMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRefineStep1UbdExpertPlannerService = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refineStep1UbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<RefineStep1RequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof refineStep1UbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<RefineStep1RequestDto> },
  TContext
> => {
  const mutationOptions =
    getRefineStep1UbdExpertPlannerServiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const autoStage2UbdExpertPlannerService = (
  id: number,
  autoGenerateRequestDto: BodyType<AutoGenerateRequestDto>,
) => {
  return configureAxios<UbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner/${id}/auto-stage2`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: autoGenerateRequestDto,
  });
};

export const getAutoStage2UbdExpertPlannerServiceMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autoStage2UbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<AutoGenerateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof autoStage2UbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<AutoGenerateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof autoStage2UbdExpertPlannerService>>,
    { id: number; data: BodyType<AutoGenerateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return autoStage2UbdExpertPlannerService(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AutoStage2UbdExpertPlannerServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof autoStage2UbdExpertPlannerService>>
>;
export type AutoStage2UbdExpertPlannerServiceMutationBody =
  BodyType<AutoGenerateRequestDto>;
export type AutoStage2UbdExpertPlannerServiceMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAutoStage2UbdExpertPlannerService = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autoStage2UbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<AutoGenerateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof autoStage2UbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<AutoGenerateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getAutoStage2UbdExpertPlannerServiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const autoStage1UbdExpertPlannerService = (
  id: number,
  autoGenerateRequestDto: BodyType<AutoGenerateRequestDto>,
) => {
  return configureAxios<UbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner/${id}/auto-stage1`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: autoGenerateRequestDto,
  });
};

export const getAutoStage1UbdExpertPlannerServiceMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autoStage1UbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<AutoGenerateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof autoStage1UbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<AutoGenerateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof autoStage1UbdExpertPlannerService>>,
    { id: number; data: BodyType<AutoGenerateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return autoStage1UbdExpertPlannerService(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AutoStage1UbdExpertPlannerServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof autoStage1UbdExpertPlannerService>>
>;
export type AutoStage1UbdExpertPlannerServiceMutationBody =
  BodyType<AutoGenerateRequestDto>;
export type AutoStage1UbdExpertPlannerServiceMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAutoStage1UbdExpertPlannerService = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autoStage1UbdExpertPlannerService>>,
    TError,
    { id: number; data: BodyType<AutoGenerateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof autoStage1UbdExpertPlannerService>>,
  TError,
  { id: number; data: BodyType<AutoGenerateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getAutoStage1UbdExpertPlannerServiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTransferActivity = (id: number, signal?: AbortSignal) => {
  return configureAxios<TransferActivityResponseDto>({
    url: `/transfer-activity/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTransferActivityQueryKey = (id: number) => {
  return [`/transfer-activity/${id}`] as const;
};

export const getGetTransferActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransferActivity>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferActivity>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransferActivityQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTransferActivity>>
  > = ({ signal }) => getTransferActivity(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransferActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTransferActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransferActivity>>
>;
export type GetTransferActivityQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTransferActivity<
  TData = Awaited<ReturnType<typeof getTransferActivity>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransferActivity>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTransferActivity<
  TData = Awaited<ReturnType<typeof getTransferActivity>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransferActivity>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTransferActivity<
  TData = Awaited<ReturnType<typeof getTransferActivity>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferActivity>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTransferActivity<
  TData = Awaited<ReturnType<typeof getTransferActivity>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferActivity>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTransferActivityQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTransferActivity = (
  id: number,
  transferActivityUpdateRequestDto: BodyType<TransferActivityUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/transfer-activity/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: transferActivityUpdateRequestDto,
  });
};

export const getUpdateTransferActivityMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTransferActivity>>,
    TError,
    { id: number; data: BodyType<TransferActivityUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTransferActivity>>,
  TError,
  { id: number; data: BodyType<TransferActivityUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTransferActivity>>,
    { id: number; data: BodyType<TransferActivityUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTransferActivity(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTransferActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTransferActivity>>
>;
export type UpdateTransferActivityMutationBody =
  BodyType<TransferActivityUpdateRequestDto>;
export type UpdateTransferActivityMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateTransferActivity = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTransferActivity>>,
    TError,
    { id: number; data: BodyType<TransferActivityUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTransferActivity>>,
  TError,
  { id: number; data: BodyType<TransferActivityUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateTransferActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTransferActivity = (id: number) => {
  return configureAxios<void>({
    url: `/transfer-activity/${id}`,
    method: "DELETE",
  });
};

export const getDeleteTransferActivityMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTransferActivity>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTransferActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTransferActivity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTransferActivity(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTransferActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTransferActivity>>
>;

export type DeleteTransferActivityMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteTransferActivity = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTransferActivity>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTransferActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTransferActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTopicsCache = () => {
  return configureAxios<void>({ url: `/topics/refresh-topics`, method: "PUT" });
};

export const getDeleteTopicsCacheMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTopicsCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTopicsCache>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTopicsCache>>,
    void
  > = () => {
    return deleteTopicsCache();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTopicsCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTopicsCache>>
>;

export type DeleteTopicsCacheMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteTopicsCache = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTopicsCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTopicsCache>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteTopicsCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTextLeveler = (id: number, signal?: AbortSignal) => {
  return configureAxios<TextLevelerResponseDto>({
    url: `/text-levelers/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTextLevelerQueryKey = (id: number) => {
  return [`/text-levelers/${id}`] as const;
};

export const getGetTextLevelerQueryOptions = <
  TData = Awaited<ReturnType<typeof getTextLeveler>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTextLeveler>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTextLevelerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTextLeveler>>> = ({
    signal,
  }) => getTextLeveler(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTextLeveler>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTextLevelerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTextLeveler>>
>;
export type GetTextLevelerQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTextLeveler<
  TData = Awaited<ReturnType<typeof getTextLeveler>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTextLeveler>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTextLeveler>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTextLeveler<
  TData = Awaited<ReturnType<typeof getTextLeveler>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTextLeveler>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTextLeveler>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTextLeveler<
  TData = Awaited<ReturnType<typeof getTextLeveler>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTextLeveler>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTextLeveler<
  TData = Awaited<ReturnType<typeof getTextLeveler>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTextLeveler>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTextLevelerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTextLeveler = (
  id: number,
  textLevelerUpdateRequestDto: BodyType<TextLevelerUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/text-levelers/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: textLevelerUpdateRequestDto,
  });
};

export const getUpdateTextLevelerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTextLeveler>>,
    TError,
    { id: number; data: BodyType<TextLevelerUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTextLeveler>>,
  TError,
  { id: number; data: BodyType<TextLevelerUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTextLeveler>>,
    { id: number; data: BodyType<TextLevelerUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTextLeveler(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTextLevelerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTextLeveler>>
>;
export type UpdateTextLevelerMutationBody =
  BodyType<TextLevelerUpdateRequestDto>;
export type UpdateTextLevelerMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateTextLeveler = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTextLeveler>>,
    TError,
    { id: number; data: BodyType<TextLevelerUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTextLeveler>>,
  TError,
  { id: number; data: BodyType<TextLevelerUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateTextLevelerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTextLeveler = (id: number) => {
  return configureAxios<void>({
    url: `/text-levelers/${id}`,
    method: "DELETE",
  });
};

export const getDeleteTextLevelerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTextLeveler>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTextLeveler>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTextLeveler>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTextLeveler(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTextLevelerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTextLeveler>>
>;

export type DeleteTextLevelerMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteTextLeveler = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTextLeveler>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTextLeveler>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTextLevelerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTedYearlyLessonPlanner = (id: number, signal?: AbortSignal) => {
  return configureAxios<TedYearlyLessonPlannerResponseDto>({
    url: `/ted-yearly-lesson-planner/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTedYearlyLessonPlannerQueryKey = (id: number) => {
  return [`/ted-yearly-lesson-planner/${id}`] as const;
};

export const getGetTedYearlyLessonPlannerQueryOptions = <
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTedYearlyLessonPlannerQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>
  > = ({ signal }) => getTedYearlyLessonPlanner(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTedYearlyLessonPlannerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>
>;
export type GetTedYearlyLessonPlannerQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTedYearlyLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTedYearlyLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTedYearlyLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTedYearlyLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanner>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTedYearlyLessonPlannerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTedYearlyLessonPlanner = (
  id: number,
  tedYearlyLessonPlannerUpdateRequestDto: BodyType<TedYearlyLessonPlannerUpdateRequestDto>,
) => {
  return configureAxios<TedYearlyLessonPlannerResponseDto>({
    url: `/ted-yearly-lesson-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: tedYearlyLessonPlannerUpdateRequestDto,
  });
};

export const getUpdateTedYearlyLessonPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTedYearlyLessonPlanner>>,
    TError,
    { id: number; data: BodyType<TedYearlyLessonPlannerUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTedYearlyLessonPlanner>>,
  TError,
  { id: number; data: BodyType<TedYearlyLessonPlannerUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTedYearlyLessonPlanner>>,
    { id: number; data: BodyType<TedYearlyLessonPlannerUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTedYearlyLessonPlanner(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTedYearlyLessonPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTedYearlyLessonPlanner>>
>;
export type UpdateTedYearlyLessonPlannerMutationBody =
  BodyType<TedYearlyLessonPlannerUpdateRequestDto>;
export type UpdateTedYearlyLessonPlannerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateTedYearlyLessonPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTedYearlyLessonPlanner>>,
    TError,
    { id: number; data: BodyType<TedYearlyLessonPlannerUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTedYearlyLessonPlanner>>,
  TError,
  { id: number; data: BodyType<TedYearlyLessonPlannerUpdateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getUpdateTedYearlyLessonPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTedYearlyLessonPlanner = (id: number) => {
  return configureAxios<void>({
    url: `/ted-yearly-lesson-planner/${id}`,
    method: "DELETE",
  });
};

export const getDeleteTedYearlyLessonPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTedYearlyLessonPlanner>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTedYearlyLessonPlanner>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTedYearlyLessonPlanner>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTedYearlyLessonPlanner(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTedYearlyLessonPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTedYearlyLessonPlanner>>
>;

export type DeleteTedYearlyLessonPlannerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteTedYearlyLessonPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTedYearlyLessonPlanner>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTedYearlyLessonPlanner>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteTedYearlyLessonPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTedLessonPlanner = (id: number, signal?: AbortSignal) => {
  return configureAxios<TedLessonPlannerResponseDto>({
    url: `/ted-lesson-planner/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTedLessonPlannerQueryKey = (id: number) => {
  return [`/ted-lesson-planner/${id}`] as const;
};

export const getGetTedLessonPlannerQueryOptions = <
  TData = Awaited<ReturnType<typeof getTedLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanner>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTedLessonPlannerQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTedLessonPlanner>>
  > = ({ signal }) => getTedLessonPlanner(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTedLessonPlanner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTedLessonPlannerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTedLessonPlanner>>
>;
export type GetTedLessonPlannerQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTedLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanner>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedLessonPlanner>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTedLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanner>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedLessonPlanner>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTedLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanner>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTedLessonPlanner<
  TData = Awaited<ReturnType<typeof getTedLessonPlanner>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanner>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTedLessonPlannerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTedLessonPlanner = (
  id: number,
  tedLessonPlannerUpdateRequestDto: BodyType<TedLessonPlannerUpdateRequestDto>,
) => {
  return configureAxios<TedLessonPlannerResponseDto>({
    url: `/ted-lesson-planner/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: tedLessonPlannerUpdateRequestDto,
  });
};

export const getUpdateTedLessonPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTedLessonPlanner>>,
    TError,
    { id: number; data: BodyType<TedLessonPlannerUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTedLessonPlanner>>,
  TError,
  { id: number; data: BodyType<TedLessonPlannerUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTedLessonPlanner>>,
    { id: number; data: BodyType<TedLessonPlannerUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTedLessonPlanner(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTedLessonPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTedLessonPlanner>>
>;
export type UpdateTedLessonPlannerMutationBody =
  BodyType<TedLessonPlannerUpdateRequestDto>;
export type UpdateTedLessonPlannerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateTedLessonPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTedLessonPlanner>>,
    TError,
    { id: number; data: BodyType<TedLessonPlannerUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTedLessonPlanner>>,
  TError,
  { id: number; data: BodyType<TedLessonPlannerUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateTedLessonPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTedLessonPlanner = (id: number) => {
  return configureAxios<void>({
    url: `/ted-lesson-planner/${id}`,
    method: "DELETE",
  });
};

export const getDeleteTedLessonPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTedLessonPlanner>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTedLessonPlanner>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTedLessonPlanner>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTedLessonPlanner(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTedLessonPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTedLessonPlanner>>
>;

export type DeleteTedLessonPlannerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteTedLessonPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTedLessonPlanner>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTedLessonPlanner>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTedLessonPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editPreferences = (
  editTeacherRequestBodyDto: BodyType<EditTeacherRequestBodyDto>,
) => {
  return configureAxios<TeacherResponseDto>({
    url: `/teachers/preferences`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: editTeacherRequestBodyDto,
  });
};

export const getEditPreferencesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editPreferences>>,
    TError,
    { data: BodyType<EditTeacherRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editPreferences>>,
  TError,
  { data: BodyType<EditTeacherRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editPreferences>>,
    { data: BodyType<EditTeacherRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return editPreferences(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof editPreferences>>
>;
export type EditPreferencesMutationBody = BodyType<EditTeacherRequestBodyDto>;
export type EditPreferencesMutationError = ErrorType<BaseErrorResponseDto>;

export const useEditPreferences = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editPreferences>>,
    TError,
    { data: BodyType<EditTeacherRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editPreferences>>,
  TError,
  { data: BodyType<EditTeacherRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getEditPreferencesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate a presigned URL for uploading a file
 */
export const extractTeacherDocumentContent = (id: number) => {
  return configureAxios<TeacherDocumentResponseDto>({
    url: `/teachers/documents/${id}/extract-content`,
    method: "PUT",
  });
};

export const getExtractTeacherDocumentContentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractTeacherDocumentContent>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractTeacherDocumentContent>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractTeacherDocumentContent>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return extractTeacherDocumentContent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractTeacherDocumentContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractTeacherDocumentContent>>
>;

export type ExtractTeacherDocumentContentMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Generate a presigned URL for uploading a file
 */
export const useExtractTeacherDocumentContent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractTeacherDocumentContent>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof extractTeacherDocumentContent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getExtractTeacherDocumentContentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAssignmentFromTeacher = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/teachers/assignments/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetAssignmentFromTeacherQueryKey = (assignmentId: number) => {
  return [`/teachers/assignments/${assignmentId}`] as const;
};

export const getGetAssignmentFromTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentFromTeacherQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentFromTeacher>>
  > = ({ signal }) => getAssignmentFromTeacher(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentFromTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentFromTeacher>>
>;
export type GetAssignmentFromTeacherQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentFromTeacherQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const editAssignment = (
  assignmentId: number,
  editAssignmentRequestBody: BodyType<EditAssignmentRequestBody>,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: editAssignmentRequestBody,
  });
};

export const getEditAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editAssignment>>,
    TError,
    { assignmentId: number; data: BodyType<EditAssignmentRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editAssignment>>,
  TError,
  { assignmentId: number; data: BodyType<EditAssignmentRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editAssignment>>,
    { assignmentId: number; data: BodyType<EditAssignmentRequestBody> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return editAssignment(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof editAssignment>>
>;
export type EditAssignmentMutationBody = BodyType<EditAssignmentRequestBody>;
export type EditAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useEditAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editAssignment>>,
    TError,
    { assignmentId: number; data: BodyType<EditAssignmentRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editAssignment>>,
  TError,
  { assignmentId: number; data: BodyType<EditAssignmentRequestBody> },
  TContext
> => {
  const mutationOptions = getEditAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAssignmentsFromTeacher = (assignmentId: number) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}`,
    method: "DELETE",
  });
};

export const getDeleteAssignmentsFromTeacherMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssignmentsFromTeacher>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAssignmentsFromTeacher>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAssignmentsFromTeacher>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return deleteAssignmentsFromTeacher(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssignmentsFromTeacherMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssignmentsFromTeacher>>
>;

export type DeleteAssignmentsFromTeacherMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteAssignmentsFromTeacher = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssignmentsFromTeacher>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAssignmentsFromTeacher>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteAssignmentsFromTeacherMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Assign assignment to students
 */
export const editAssignAssignmentToStudents = (
  assignmentId: number,
  editAssignAssignmentRequestBody: BodyType<EditAssignAssignmentRequestBody>,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/students`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: editAssignAssignmentRequestBody,
  });
};

export const getEditAssignAssignmentToStudentsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editAssignAssignmentToStudents>>,
    TError,
    { assignmentId: number; data: BodyType<EditAssignAssignmentRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editAssignAssignmentToStudents>>,
  TError,
  { assignmentId: number; data: BodyType<EditAssignAssignmentRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editAssignAssignmentToStudents>>,
    { assignmentId: number; data: BodyType<EditAssignAssignmentRequestBody> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return editAssignAssignmentToStudents(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditAssignAssignmentToStudentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof editAssignAssignmentToStudents>>
>;
export type EditAssignAssignmentToStudentsMutationBody =
  BodyType<EditAssignAssignmentRequestBody>;
export type EditAssignAssignmentToStudentsMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Assign assignment to students
 */
export const useEditAssignAssignmentToStudents = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editAssignAssignmentToStudents>>,
    TError,
    { assignmentId: number; data: BodyType<EditAssignAssignmentRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editAssignAssignmentToStudents>>,
  TError,
  { assignmentId: number; data: BodyType<EditAssignAssignmentRequestBody> },
  TContext
> => {
  const mutationOptions =
    getEditAssignAssignmentToStudentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editQuestion = (
  assignmentId: number,
  questionId: number,
  editQuestionRequestBody: BodyType<EditQuestionRequestBody>,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/questions/${questionId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: editQuestionRequestBody,
  });
};

export const getEditQuestionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editQuestion>>,
    TError,
    {
      assignmentId: number;
      questionId: number;
      data: BodyType<EditQuestionRequestBody>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editQuestion>>,
  TError,
  {
    assignmentId: number;
    questionId: number;
    data: BodyType<EditQuestionRequestBody>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editQuestion>>,
    {
      assignmentId: number;
      questionId: number;
      data: BodyType<EditQuestionRequestBody>;
    }
  > = (props) => {
    const { assignmentId, questionId, data } = props ?? {};

    return editQuestion(assignmentId, questionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof editQuestion>>
>;
export type EditQuestionMutationBody = BodyType<EditQuestionRequestBody>;
export type EditQuestionMutationError = ErrorType<BaseErrorResponseDto>;

export const useEditQuestion = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editQuestion>>,
    TError,
    {
      assignmentId: number;
      questionId: number;
      data: BodyType<EditQuestionRequestBody>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editQuestion>>,
  TError,
  {
    assignmentId: number;
    questionId: number;
    data: BodyType<EditQuestionRequestBody>;
  },
  TContext
> => {
  const mutationOptions = getEditQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const makeAssignmentVisible = (assignmentId: number) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/makeVisible`,
    method: "PUT",
  });
};

export const getMakeAssignmentVisibleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeAssignmentVisible>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof makeAssignmentVisible>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof makeAssignmentVisible>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return makeAssignmentVisible(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type MakeAssignmentVisibleMutationResult = NonNullable<
  Awaited<ReturnType<typeof makeAssignmentVisible>>
>;

export type MakeAssignmentVisibleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useMakeAssignmentVisible = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeAssignmentVisible>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof makeAssignmentVisible>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions = getMakeAssignmentVisibleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unfreezeAssignment = (assignmentId: number) => {
  return configureAxios<void>({
    url: `/teachers/assignments/quiz/${assignmentId}/unfreeze`,
    method: "PUT",
  });
};

export const getUnfreezeAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unfreezeAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unfreezeAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unfreezeAssignment>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return unfreezeAssignment(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnfreezeAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof unfreezeAssignment>>
>;

export type UnfreezeAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnfreezeAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unfreezeAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unfreezeAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions = getUnfreezeAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const startQuizAssignment = (
  assignmentId: number,
  startQuizAssignmentRequestBody: BodyType<StartQuizAssignmentRequestBody>,
) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/teachers/assignments/quiz/${assignmentId}/start`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: startQuizAssignmentRequestBody,
  });
};

export const getStartQuizAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startQuizAssignment>>,
    TError,
    { assignmentId: number; data: BodyType<StartQuizAssignmentRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startQuizAssignment>>,
  TError,
  { assignmentId: number; data: BodyType<StartQuizAssignmentRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startQuizAssignment>>,
    { assignmentId: number; data: BodyType<StartQuizAssignmentRequestBody> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return startQuizAssignment(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartQuizAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof startQuizAssignment>>
>;
export type StartQuizAssignmentMutationBody =
  BodyType<StartQuizAssignmentRequestBody>;
export type StartQuizAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useStartQuizAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startQuizAssignment>>,
    TError,
    { assignmentId: number; data: BodyType<StartQuizAssignmentRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof startQuizAssignment>>,
  TError,
  { assignmentId: number; data: BodyType<StartQuizAssignmentRequestBody> },
  TContext
> => {
  const mutationOptions = getStartQuizAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const freezeAssignment = (assignmentId: number) => {
  return configureAxios<void>({
    url: `/teachers/assignments/quiz/${assignmentId}/freeze`,
    method: "PUT",
  });
};

export const getFreezeAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof freezeAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof freezeAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof freezeAssignment>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return freezeAssignment(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type FreezeAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof freezeAssignment>>
>;

export type FreezeAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useFreezeAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof freezeAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof freezeAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions = getFreezeAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const extendQuizAssignment = (
  assignmentId: number,
  extendQuizAssignmentRequestBody: BodyType<ExtendQuizAssignmentRequestBody>,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/quiz/${assignmentId}/extend`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: extendQuizAssignmentRequestBody,
  });
};

export const getExtendQuizAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extendQuizAssignment>>,
    TError,
    { assignmentId: number; data: BodyType<ExtendQuizAssignmentRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extendQuizAssignment>>,
  TError,
  { assignmentId: number; data: BodyType<ExtendQuizAssignmentRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extendQuizAssignment>>,
    { assignmentId: number; data: BodyType<ExtendQuizAssignmentRequestBody> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return extendQuizAssignment(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtendQuizAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof extendQuizAssignment>>
>;
export type ExtendQuizAssignmentMutationBody =
  BodyType<ExtendQuizAssignmentRequestBody>;
export type ExtendQuizAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useExtendQuizAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extendQuizAssignment>>,
    TError,
    { assignmentId: number; data: BodyType<ExtendQuizAssignmentRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof extendQuizAssignment>>,
  TError,
  { assignmentId: number; data: BodyType<ExtendQuizAssignmentRequestBody> },
  TContext
> => {
  const mutationOptions = getExtendQuizAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTeacherChat = (id: number, signal?: AbortSignal) => {
  return configureAxios<TeacherChatResponseDto>({
    url: `/teacher-chat/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTeacherChatQueryKey = (id: number) => {
  return [`/teacher-chat/${id}`] as const;
};

export const getGetTeacherChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacherChat>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeacherChatQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeacherChat>>> = ({
    signal,
  }) => getTeacherChat(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherChat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherChat>>
>;
export type GetTeacherChatQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherChat<
  TData = Awaited<ReturnType<typeof getTeacherChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacherChat>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherChat<
  TData = Awaited<ReturnType<typeof getTeacherChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacherChat>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherChat<
  TData = Awaited<ReturnType<typeof getTeacherChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacherChat>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherChat<
  TData = Awaited<ReturnType<typeof getTeacherChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacherChat>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherChatQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTeacherChat = (
  id: number,
  updateTeacherChatRequestDto: BodyType<UpdateTeacherChatRequestDto>,
) => {
  return configureAxios<TeacherChatResponseDto>({
    url: `/teacher-chat/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateTeacherChatRequestDto,
  });
};

export const getUpdateTeacherChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeacherChat>>,
    TError,
    { id: number; data: BodyType<UpdateTeacherChatRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeacherChat>>,
  TError,
  { id: number; data: BodyType<UpdateTeacherChatRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeacherChat>>,
    { id: number; data: BodyType<UpdateTeacherChatRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTeacherChat(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeacherChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTeacherChat>>
>;
export type UpdateTeacherChatMutationBody =
  BodyType<UpdateTeacherChatRequestDto>;
export type UpdateTeacherChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateTeacherChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeacherChat>>,
    TError,
    { id: number; data: BodyType<UpdateTeacherChatRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTeacherChat>>,
  TError,
  { id: number; data: BodyType<UpdateTeacherChatRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateTeacherChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTeacherChat = (id: number) => {
  return configureAxios<void>({ url: `/teacher-chat/${id}`, method: "DELETE" });
};

export const getDeleteTeacherChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeacherChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeacherChat>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeacherChat>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTeacherChat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeacherChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeacherChat>>
>;

export type DeleteTeacherChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteTeacherChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeacherChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTeacherChat>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTeacherChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getVisualMatching = (id: number, signal?: AbortSignal) => {
  return configureAxios<VisualMatchingResponseDto>({
    url: `/swann-visual-matching/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetVisualMatchingQueryKey = (id: number) => {
  return [`/swann-visual-matching/${id}`] as const;
};

export const getGetVisualMatchingQueryOptions = <
  TData = Awaited<ReturnType<typeof getVisualMatching>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatching>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVisualMatchingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVisualMatching>>
  > = ({ signal }) => getVisualMatching(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVisualMatching>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVisualMatchingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVisualMatching>>
>;
export type GetVisualMatchingQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetVisualMatching<
  TData = Awaited<ReturnType<typeof getVisualMatching>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatching>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisualMatching>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVisualMatching<
  TData = Awaited<ReturnType<typeof getVisualMatching>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatching>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisualMatching>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVisualMatching<
  TData = Awaited<ReturnType<typeof getVisualMatching>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatching>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetVisualMatching<
  TData = Awaited<ReturnType<typeof getVisualMatching>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatching>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVisualMatchingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateVisualMatching = (
  id: number,
  visualMatchingUpdateRequestDto: BodyType<VisualMatchingUpdateRequestDto>,
) => {
  return configureAxios<VisualMatchingResponseDto>({
    url: `/swann-visual-matching/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: visualMatchingUpdateRequestDto,
  });
};

export const getUpdateVisualMatchingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVisualMatching>>,
    TError,
    { id: number; data: BodyType<VisualMatchingUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVisualMatching>>,
  TError,
  { id: number; data: BodyType<VisualMatchingUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVisualMatching>>,
    { id: number; data: BodyType<VisualMatchingUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVisualMatching(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVisualMatchingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVisualMatching>>
>;
export type UpdateVisualMatchingMutationBody =
  BodyType<VisualMatchingUpdateRequestDto>;
export type UpdateVisualMatchingMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateVisualMatching = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVisualMatching>>,
    TError,
    { id: number; data: BodyType<VisualMatchingUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVisualMatching>>,
  TError,
  { id: number; data: BodyType<VisualMatchingUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateVisualMatchingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteVisualMatching = (id: number) => {
  return configureAxios<void>({
    url: `/swann-visual-matching/${id}`,
    method: "DELETE",
  });
};

export const getDeleteVisualMatchingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVisualMatching>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVisualMatching>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVisualMatching>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVisualMatching(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVisualMatchingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVisualMatching>>
>;

export type DeleteVisualMatchingMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteVisualMatching = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVisualMatching>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVisualMatching>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteVisualMatchingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateItems = (
  id: number,
  updateItemsRequestDto: BodyType<UpdateItemsRequestDto>,
) => {
  return configureAxios<PronunciationAssignmentResponseDto>({
    url: `/swann-pronunciation/assignments/${id}/items`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateItemsRequestDto,
  });
};

export const getUpdateItemsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItems>>,
    TError,
    { id: number; data: BodyType<UpdateItemsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateItems>>,
  TError,
  { id: number; data: BodyType<UpdateItemsRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateItems>>,
    { id: number; data: BodyType<UpdateItemsRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateItems(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateItems>>
>;
export type UpdateItemsMutationBody = BodyType<UpdateItemsRequestDto>;
export type UpdateItemsMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateItems = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateItems>>,
    TError,
    { id: number; data: BodyType<UpdateItemsRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateItems>>,
  TError,
  { id: number; data: BodyType<UpdateItemsRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateItemsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSummarizer = (id: number, signal?: AbortSignal) => {
  return configureAxios<SummarizerResponseDto>({
    url: `/summarizers/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSummarizerQueryKey = (id: number) => {
  return [`/summarizers/${id}`] as const;
};

export const getGetSummarizerQueryOptions = <
  TData = Awaited<ReturnType<typeof getSummarizer>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummarizer>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSummarizerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummarizer>>> = ({
    signal,
  }) => getSummarizer(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSummarizer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSummarizerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSummarizer>>
>;
export type GetSummarizerQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSummarizer<
  TData = Awaited<ReturnType<typeof getSummarizer>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummarizer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummarizer>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSummarizer<
  TData = Awaited<ReturnType<typeof getSummarizer>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummarizer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummarizer>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSummarizer<
  TData = Awaited<ReturnType<typeof getSummarizer>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummarizer>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSummarizer<
  TData = Awaited<ReturnType<typeof getSummarizer>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummarizer>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSummarizerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateSummarizer = (
  id: number,
  summarizerUpdateRequestDto: BodyType<SummarizerUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/summarizers/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: summarizerUpdateRequestDto,
  });
};

export const getUpdateSummarizerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSummarizer>>,
    TError,
    { id: number; data: BodyType<SummarizerUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSummarizer>>,
  TError,
  { id: number; data: BodyType<SummarizerUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSummarizer>>,
    { id: number; data: BodyType<SummarizerUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSummarizer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSummarizerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSummarizer>>
>;
export type UpdateSummarizerMutationBody = BodyType<SummarizerUpdateRequestDto>;
export type UpdateSummarizerMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateSummarizer = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSummarizer>>,
    TError,
    { id: number; data: BodyType<SummarizerUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSummarizer>>,
  TError,
  { id: number; data: BodyType<SummarizerUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateSummarizerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteSummarizer = (id: number) => {
  return configureAxios<void>({ url: `/summarizers/${id}`, method: "DELETE" });
};

export const getDeleteSummarizerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSummarizer>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSummarizer>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSummarizer>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSummarizer(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSummarizerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSummarizer>>
>;

export type DeleteSummarizerMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteSummarizer = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSummarizer>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSummarizer>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteSummarizerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSlideGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<SlideGeneratorResponseDto>({
    url: `/slide-generator/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSlideGeneratorQueryKey = (id: number) => {
  return [`/slide-generator/${id}`] as const;
};

export const getGetSlideGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlideGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSlideGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSlideGeneratorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSlideGenerator>>
  > = ({ signal }) => getSlideGenerator(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSlideGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSlideGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSlideGenerator>>
>;
export type GetSlideGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSlideGenerator<
  TData = Awaited<ReturnType<typeof getSlideGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSlideGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlideGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSlideGenerator<
  TData = Awaited<ReturnType<typeof getSlideGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSlideGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlideGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSlideGenerator<
  TData = Awaited<ReturnType<typeof getSlideGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSlideGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSlideGenerator<
  TData = Awaited<ReturnType<typeof getSlideGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSlideGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSlideGeneratorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateSlideGenerator = (
  id: number,
  updateSlideGeneratorRequestDto: BodyType<UpdateSlideGeneratorRequestDto>,
) => {
  return configureAxios<SlideGeneratorResponseDto>({
    url: `/slide-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateSlideGeneratorRequestDto,
  });
};

export const getUpdateSlideGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSlideGenerator>>,
    TError,
    { id: number; data: BodyType<UpdateSlideGeneratorRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSlideGenerator>>,
  TError,
  { id: number; data: BodyType<UpdateSlideGeneratorRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSlideGenerator>>,
    { id: number; data: BodyType<UpdateSlideGeneratorRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSlideGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSlideGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSlideGenerator>>
>;
export type UpdateSlideGeneratorMutationBody =
  BodyType<UpdateSlideGeneratorRequestDto>;
export type UpdateSlideGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateSlideGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSlideGenerator>>,
    TError,
    { id: number; data: BodyType<UpdateSlideGeneratorRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSlideGenerator>>,
  TError,
  { id: number; data: BodyType<UpdateSlideGeneratorRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateSlideGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteSlideGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/slide-generator/${id}`,
    method: "DELETE",
  });
};

export const getDeleteSlideGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSlideGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSlideGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSlideGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSlideGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSlideGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSlideGenerator>>
>;

export type DeleteSlideGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteSlideGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSlideGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSlideGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteSlideGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSketchGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<SketchGeneratorResponseDto>({
    url: `/sketch-generator/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSketchGeneratorQueryKey = (id: number) => {
  return [`/sketch-generator/${id}`] as const;
};

export const getGetSketchGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSketchGeneratorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSketchGenerator>>
  > = ({ signal }) => getSketchGenerator(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSketchGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSketchGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSketchGenerator>>
>;
export type GetSketchGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSketchGenerator<
  TData = Awaited<ReturnType<typeof getSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSketchGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSketchGenerator<
  TData = Awaited<ReturnType<typeof getSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSketchGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSketchGenerator<
  TData = Awaited<ReturnType<typeof getSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSketchGenerator<
  TData = Awaited<ReturnType<typeof getSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSketchGeneratorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateSketchGenerator = (
  id: number,
  updateSketchGeneratorRequestDto: BodyType<UpdateSketchGeneratorRequestDto>,
) => {
  return configureAxios<SketchGeneratorResponseDto>({
    url: `/sketch-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateSketchGeneratorRequestDto,
  });
};

export const getUpdateSketchGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSketchGenerator>>,
    TError,
    { id: number; data: BodyType<UpdateSketchGeneratorRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSketchGenerator>>,
  TError,
  { id: number; data: BodyType<UpdateSketchGeneratorRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSketchGenerator>>,
    { id: number; data: BodyType<UpdateSketchGeneratorRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSketchGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSketchGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSketchGenerator>>
>;
export type UpdateSketchGeneratorMutationBody =
  BodyType<UpdateSketchGeneratorRequestDto>;
export type UpdateSketchGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateSketchGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSketchGenerator>>,
    TError,
    { id: number; data: BodyType<UpdateSketchGeneratorRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSketchGenerator>>,
  TError,
  { id: number; data: BodyType<UpdateSketchGeneratorRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateSketchGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteSketchGenerator = (id: number) => {
  return configureAxios<SketchGeneratorResponseDto>({
    url: `/sketch-generator/${id}`,
    method: "DELETE",
  });
};

export const getDeleteSketchGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSketchGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSketchGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSketchGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSketchGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSketchGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSketchGenerator>>
>;

export type DeleteSketchGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteSketchGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSketchGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSketchGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteSketchGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getRubricGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<RubricGeneratorResponseDto>({
    url: `/rubric-generator/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetRubricGeneratorQueryKey = (id: number) => {
  return [`/rubric-generator/${id}`] as const;
};

export const getGetRubricGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getRubricGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRubricGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRubricGeneratorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRubricGenerator>>
  > = ({ signal }) => getRubricGenerator(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRubricGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRubricGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRubricGenerator>>
>;
export type GetRubricGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRubricGenerator<
  TData = Awaited<ReturnType<typeof getRubricGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRubricGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRubricGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRubricGenerator<
  TData = Awaited<ReturnType<typeof getRubricGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRubricGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRubricGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRubricGenerator<
  TData = Awaited<ReturnType<typeof getRubricGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRubricGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRubricGenerator<
  TData = Awaited<ReturnType<typeof getRubricGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRubricGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRubricGeneratorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateRubricGenerator = (
  id: number,
  rubricGeneratorUpdateRequestDto: BodyType<RubricGeneratorUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/rubric-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: rubricGeneratorUpdateRequestDto,
  });
};

export const getUpdateRubricGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRubricGenerator>>,
    TError,
    { id: number; data: BodyType<RubricGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRubricGenerator>>,
  TError,
  { id: number; data: BodyType<RubricGeneratorUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRubricGenerator>>,
    { id: number; data: BodyType<RubricGeneratorUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRubricGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRubricGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRubricGenerator>>
>;
export type UpdateRubricGeneratorMutationBody =
  BodyType<RubricGeneratorUpdateRequestDto>;
export type UpdateRubricGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateRubricGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRubricGenerator>>,
    TError,
    { id: number; data: BodyType<RubricGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRubricGenerator>>,
  TError,
  { id: number; data: BodyType<RubricGeneratorUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateRubricGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteRubricGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/rubric-generator/${id}`,
    method: "DELETE",
  });
};

export const getDeleteRubricGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRubricGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRubricGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRubricGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRubricGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRubricGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRubricGenerator>>
>;

export type DeleteRubricGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteRubricGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRubricGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRubricGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteRubricGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getRealWorldConnection = (id: number, signal?: AbortSignal) => {
  return configureAxios<RealWorldConnectionResponseDto>({
    url: `/real-world-connections/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetRealWorldConnectionQueryKey = (id: number) => {
  return [`/real-world-connections/${id}`] as const;
};

export const getGetRealWorldConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getRealWorldConnection>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRealWorldConnection>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRealWorldConnectionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRealWorldConnection>>
  > = ({ signal }) => getRealWorldConnection(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRealWorldConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRealWorldConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRealWorldConnection>>
>;
export type GetRealWorldConnectionQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRealWorldConnection<
  TData = Awaited<ReturnType<typeof getRealWorldConnection>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRealWorldConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRealWorldConnection>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRealWorldConnection<
  TData = Awaited<ReturnType<typeof getRealWorldConnection>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRealWorldConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRealWorldConnection>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRealWorldConnection<
  TData = Awaited<ReturnType<typeof getRealWorldConnection>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRealWorldConnection>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRealWorldConnection<
  TData = Awaited<ReturnType<typeof getRealWorldConnection>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRealWorldConnection>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRealWorldConnectionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateRealWorldConnection = (
  id: number,
  realWorldConnectionUpdateRequestDto: BodyType<RealWorldConnectionUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/real-world-connections/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: realWorldConnectionUpdateRequestDto,
  });
};

export const getUpdateRealWorldConnectionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRealWorldConnection>>,
    TError,
    { id: number; data: BodyType<RealWorldConnectionUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRealWorldConnection>>,
  TError,
  { id: number; data: BodyType<RealWorldConnectionUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRealWorldConnection>>,
    { id: number; data: BodyType<RealWorldConnectionUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRealWorldConnection(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRealWorldConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRealWorldConnection>>
>;
export type UpdateRealWorldConnectionMutationBody =
  BodyType<RealWorldConnectionUpdateRequestDto>;
export type UpdateRealWorldConnectionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateRealWorldConnection = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRealWorldConnection>>,
    TError,
    { id: number; data: BodyType<RealWorldConnectionUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRealWorldConnection>>,
  TError,
  { id: number; data: BodyType<RealWorldConnectionUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateRealWorldConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteRealWorldConnection = (id: number) => {
  return configureAxios<void>({
    url: `/real-world-connections/${id}`,
    method: "DELETE",
  });
};

export const getDeleteRealWorldConnectionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRealWorldConnection>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRealWorldConnection>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRealWorldConnection>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRealWorldConnection(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRealWorldConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRealWorldConnection>>
>;

export type DeleteRealWorldConnectionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteRealWorldConnection = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRealWorldConnection>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRealWorldConnection>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteRealWorldConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getQuestionSolverResponseV2 = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<GetQuestionSolverResponseDtoV2>({
    url: `/question-solver/v2/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetQuestionSolverResponseV2QueryKey = (id: number) => {
  return [`/question-solver/v2/${id}`] as const;
};

export const getGetQuestionSolverResponseV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionSolverResponseV2QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionSolverResponseV2>>
  > = ({ signal }) => getQuestionSolverResponseV2(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionSolverResponseV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionSolverResponseV2>>
>;
export type GetQuestionSolverResponseV2QueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetQuestionSolverResponseV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionSolverResponseV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionSolverResponseV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionSolverResponseV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponseV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionSolverResponseV2QueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateQuestionSolverV2 = (
  id: number,
  questionSolverUpdateRequestDto: BodyType<QuestionSolverUpdateRequestDto>,
) => {
  return configureAxios<GetQuestionSolverResponseDtoV2>({
    url: `/question-solver/v2/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: questionSolverUpdateRequestDto,
  });
};

export const getUpdateQuestionSolverV2MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuestionSolverV2>>,
    TError,
    { id: number; data: BodyType<QuestionSolverUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateQuestionSolverV2>>,
  TError,
  { id: number; data: BodyType<QuestionSolverUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateQuestionSolverV2>>,
    { id: number; data: BodyType<QuestionSolverUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateQuestionSolverV2(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateQuestionSolverV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateQuestionSolverV2>>
>;
export type UpdateQuestionSolverV2MutationBody =
  BodyType<QuestionSolverUpdateRequestDto>;
export type UpdateQuestionSolverV2MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateQuestionSolverV2 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuestionSolverV2>>,
    TError,
    { id: number; data: BodyType<QuestionSolverUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateQuestionSolverV2>>,
  TError,
  { id: number; data: BodyType<QuestionSolverUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateQuestionSolverV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieve details of a specific question helper including solution steps if available
 * @summary Get a specific question helper by ID
 */
export const getQuestionHelper = (id: number, signal?: AbortSignal) => {
  return configureAxios<QuestionHelperResponseDto>({
    url: `/question-helper/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetQuestionHelperQueryKey = (id: number) => {
  return [`/question-helper/${id}`] as const;
};

export const getGetQuestionHelperQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionHelper>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelper>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuestionHelperQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionHelper>>
  > = ({ signal }) => getQuestionHelper(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionHelper>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionHelperQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionHelper>>
>;
export type GetQuestionHelperQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetQuestionHelper<
  TData = Awaited<ReturnType<typeof getQuestionHelper>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelper>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionHelper>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionHelper<
  TData = Awaited<ReturnType<typeof getQuestionHelper>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelper>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionHelper>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionHelper<
  TData = Awaited<ReturnType<typeof getQuestionHelper>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelper>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a specific question helper by ID
 */

export function useGetQuestionHelper<
  TData = Awaited<ReturnType<typeof getQuestionHelper>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelper>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionHelperQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update title, solution steps, or tags of an existing question helper
 * @summary Update a question helper
 */
export const updateQuestionHelper = (
  id: number,
  questionHelperUpdateRequestDto: BodyType<QuestionHelperUpdateRequestDto>,
) => {
  return configureAxios<QuestionHelperResponseDto>({
    url: `/question-helper/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: questionHelperUpdateRequestDto,
  });
};

export const getUpdateQuestionHelperMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuestionHelper>>,
    TError,
    { id: number; data: BodyType<QuestionHelperUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateQuestionHelper>>,
  TError,
  { id: number; data: BodyType<QuestionHelperUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateQuestionHelper>>,
    { id: number; data: BodyType<QuestionHelperUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateQuestionHelper(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateQuestionHelperMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateQuestionHelper>>
>;
export type UpdateQuestionHelperMutationBody =
  BodyType<QuestionHelperUpdateRequestDto>;
export type UpdateQuestionHelperMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update a question helper
 */
export const useUpdateQuestionHelper = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuestionHelper>>,
    TError,
    { id: number; data: BodyType<QuestionHelperUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateQuestionHelper>>,
  TError,
  { id: number; data: BodyType<QuestionHelperUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateQuestionHelperMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Soft delete a question helper (marks as deleted but keeps data)
 * @summary Delete a question helper
 */
export const deleteQuestionHelper = (id: number) => {
  return configureAxios<void>({
    url: `/question-helper/${id}`,
    method: "DELETE",
  });
};

export const getDeleteQuestionHelperMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuestionHelper>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteQuestionHelper>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteQuestionHelper>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteQuestionHelper(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteQuestionHelperMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteQuestionHelper>>
>;

export type DeleteQuestionHelperMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Delete a question helper
 */
export const useDeleteQuestionHelper = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuestionHelper>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteQuestionHelper>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteQuestionHelperMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getProjectBasedLearning = (id: number, signal?: AbortSignal) => {
  return configureAxios<ProjectBasedLearningResponseDto>({
    url: `/project-based-learning/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetProjectBasedLearningQueryKey = (id: number) => {
  return [`/project-based-learning/${id}`] as const;
};

export const getGetProjectBasedLearningQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectBasedLearning>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectBasedLearning>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProjectBasedLearningQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProjectBasedLearning>>
  > = ({ signal }) => getProjectBasedLearning(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectBasedLearning>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProjectBasedLearningQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectBasedLearning>>
>;
export type GetProjectBasedLearningQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetProjectBasedLearning<
  TData = Awaited<ReturnType<typeof getProjectBasedLearning>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectBasedLearning>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBasedLearning>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProjectBasedLearning<
  TData = Awaited<ReturnType<typeof getProjectBasedLearning>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectBasedLearning>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectBasedLearning>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProjectBasedLearning<
  TData = Awaited<ReturnType<typeof getProjectBasedLearning>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectBasedLearning>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetProjectBasedLearning<
  TData = Awaited<ReturnType<typeof getProjectBasedLearning>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProjectBasedLearning>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProjectBasedLearningQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateProjectBasedLearning = (
  id: number,
  projectBasedLearningUpdateRequestDto: BodyType<ProjectBasedLearningUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/project-based-learning/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: projectBasedLearningUpdateRequestDto,
  });
};

export const getUpdateProjectBasedLearningMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectBasedLearning>>,
    TError,
    { id: number; data: BodyType<ProjectBasedLearningUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectBasedLearning>>,
  TError,
  { id: number; data: BodyType<ProjectBasedLearningUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectBasedLearning>>,
    { id: number; data: BodyType<ProjectBasedLearningUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProjectBasedLearning(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectBasedLearningMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectBasedLearning>>
>;
export type UpdateProjectBasedLearningMutationBody =
  BodyType<ProjectBasedLearningUpdateRequestDto>;
export type UpdateProjectBasedLearningMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateProjectBasedLearning = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectBasedLearning>>,
    TError,
    { id: number; data: BodyType<ProjectBasedLearningUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectBasedLearning>>,
  TError,
  { id: number; data: BodyType<ProjectBasedLearningUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateProjectBasedLearningMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteProjectBasedLearning = (id: number) => {
  return configureAxios<void>({
    url: `/project-based-learning/${id}`,
    method: "DELETE",
  });
};

export const getDeleteProjectBasedLearningMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectBasedLearning>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProjectBasedLearning>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProjectBasedLearning>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProjectBasedLearning(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectBasedLearningMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProjectBasedLearning>>
>;

export type DeleteProjectBasedLearningMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteProjectBasedLearning = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProjectBasedLearning>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProjectBasedLearning>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteProjectBasedLearningMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPodcast = (id: number, signal?: AbortSignal) => {
  return configureAxios<PodcastResponseDto>({
    url: `/podcasts/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPodcastQueryKey = (id: number) => {
  return [`/podcasts/${id}`] as const;
};

export const getGetPodcastQueryOptions = <
  TData = Awaited<ReturnType<typeof getPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPodcast>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPodcastQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPodcast>>> = ({
    signal,
  }) => getPodcast(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPodcast>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPodcastQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPodcast>>
>;
export type GetPodcastQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetPodcast<
  TData = Awaited<ReturnType<typeof getPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPodcast>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPodcast>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPodcast<
  TData = Awaited<ReturnType<typeof getPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPodcast>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPodcast>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPodcast<
  TData = Awaited<ReturnType<typeof getPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPodcast>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPodcast<
  TData = Awaited<ReturnType<typeof getPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPodcast>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPodcastQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updatePodcast = (
  id: number,
  podcastUpdateRequestDto: BodyType<PodcastUpdateRequestDto>,
) => {
  return configureAxios<PodcastResponseDto>({
    url: `/podcasts/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: podcastUpdateRequestDto,
  });
};

export const getUpdatePodcastMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePodcast>>,
    TError,
    { id: number; data: BodyType<PodcastUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePodcast>>,
  TError,
  { id: number; data: BodyType<PodcastUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePodcast>>,
    { id: number; data: BodyType<PodcastUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePodcast(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePodcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePodcast>>
>;
export type UpdatePodcastMutationBody = BodyType<PodcastUpdateRequestDto>;
export type UpdatePodcastMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdatePodcast = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePodcast>>,
    TError,
    { id: number; data: BodyType<PodcastUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePodcast>>,
  TError,
  { id: number; data: BodyType<PodcastUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdatePodcastMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deletePodcast = (id: number) => {
  return configureAxios<void>({ url: `/podcasts/${id}`, method: "DELETE" });
};

export const getDeletePodcastMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePodcast>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePodcast>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePodcast>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePodcast(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePodcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePodcast>>
>;

export type DeletePodcastMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeletePodcast = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePodcast>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePodcast>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeletePodcastMutationOptions(options);

  return useMutation(mutationOptions);
};

export const finishStudentPodcast = (
  id: number,
  finishStudentPodcastRequestDto: BodyType<FinishStudentPodcastRequestDto>,
) => {
  return configureAxios<StudentPodcastResponseDto>({
    url: `/podcasts/students/${id}/finish`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: finishStudentPodcastRequestDto,
  });
};

export const getFinishStudentPodcastMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finishStudentPodcast>>,
    TError,
    { id: number; data: BodyType<FinishStudentPodcastRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finishStudentPodcast>>,
  TError,
  { id: number; data: BodyType<FinishStudentPodcastRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finishStudentPodcast>>,
    { id: number; data: BodyType<FinishStudentPodcastRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return finishStudentPodcast(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinishStudentPodcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof finishStudentPodcast>>
>;
export type FinishStudentPodcastMutationBody =
  BodyType<FinishStudentPodcastRequestDto>;
export type FinishStudentPodcastMutationError = ErrorType<BaseErrorResponseDto>;

export const useFinishStudentPodcast = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finishStudentPodcast>>,
    TError,
    { id: number; data: BodyType<FinishStudentPodcastRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof finishStudentPodcast>>,
  TError,
  { id: number; data: BodyType<FinishStudentPodcastRequestDto> },
  TContext
> => {
  const mutationOptions = getFinishStudentPodcastMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPerformanceTask = (id: number, signal?: AbortSignal) => {
  return configureAxios<PerformanceTaskResponseDto>({
    url: `/performance-task/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPerformanceTaskQueryKey = (id: number) => {
  return [`/performance-task/${id}`] as const;
};

export const getGetPerformanceTaskQueryOptions = <
  TData = Awaited<ReturnType<typeof getPerformanceTask>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPerformanceTask>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPerformanceTaskQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPerformanceTask>>
  > = ({ signal }) => getPerformanceTask(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPerformanceTask>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPerformanceTaskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPerformanceTask>>
>;
export type GetPerformanceTaskQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetPerformanceTask<
  TData = Awaited<ReturnType<typeof getPerformanceTask>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPerformanceTask>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceTask>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPerformanceTask<
  TData = Awaited<ReturnType<typeof getPerformanceTask>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPerformanceTask>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceTask>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPerformanceTask<
  TData = Awaited<ReturnType<typeof getPerformanceTask>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPerformanceTask>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPerformanceTask<
  TData = Awaited<ReturnType<typeof getPerformanceTask>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPerformanceTask>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPerformanceTaskQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updatePerformanceTask = (
  id: number,
  performanceTaskUpdateRequestDto: BodyType<PerformanceTaskUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/performance-task/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: performanceTaskUpdateRequestDto,
  });
};

export const getUpdatePerformanceTaskMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePerformanceTask>>,
    TError,
    { id: number; data: BodyType<PerformanceTaskUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePerformanceTask>>,
  TError,
  { id: number; data: BodyType<PerformanceTaskUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePerformanceTask>>,
    { id: number; data: BodyType<PerformanceTaskUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePerformanceTask(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePerformanceTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePerformanceTask>>
>;
export type UpdatePerformanceTaskMutationBody =
  BodyType<PerformanceTaskUpdateRequestDto>;
export type UpdatePerformanceTaskMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdatePerformanceTask = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePerformanceTask>>,
    TError,
    { id: number; data: BodyType<PerformanceTaskUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePerformanceTask>>,
  TError,
  { id: number; data: BodyType<PerformanceTaskUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdatePerformanceTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deletePerformanceTask = (id: number) => {
  return configureAxios<void>({
    url: `/performance-task/${id}`,
    method: "DELETE",
  });
};

export const getDeletePerformanceTaskMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePerformanceTask>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePerformanceTask>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePerformanceTask>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePerformanceTask(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePerformanceTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePerformanceTask>>
>;

export type DeletePerformanceTaskMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeletePerformanceTask = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePerformanceTask>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePerformanceTask>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeletePerformanceTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Read a notification
 * @summary Read Notification
 */
export const editNotification = (id: number) => {
  return configureAxios<void>({ url: `/notifications/${id}`, method: "PUT" });
};

export const getEditNotificationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editNotification>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editNotification>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editNotification>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return editNotification(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof editNotification>>
>;

export type EditNotificationMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Read Notification
 */
export const useEditNotification = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editNotification>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editNotification>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getEditNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete a notification
 * @summary Delete Notification
 */
export const deleteNotification = (id: number) => {
  return configureAxios<void>({
    url: `/notifications/${id}`,
    method: "DELETE",
  });
};

export const getDeleteNotificationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotification>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNotification>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNotification>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteNotification(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNotification>>
>;

export type DeleteNotificationMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Delete Notification
 */
export const useDeleteNotification = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotification>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNotification>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMindmapGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<MindmapGeneratorResponseDto>({
    url: `/mindmap-generator/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetMindmapGeneratorQueryKey = (id: number) => {
  return [`/mindmap-generator/${id}`] as const;
};

export const getGetMindmapGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getMindmapGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindmapGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMindmapGeneratorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMindmapGenerator>>
  > = ({ signal }) => getMindmapGenerator(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMindmapGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMindmapGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMindmapGenerator>>
>;
export type GetMindmapGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMindmapGenerator<
  TData = Awaited<ReturnType<typeof getMindmapGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindmapGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMindmapGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMindmapGenerator<
  TData = Awaited<ReturnType<typeof getMindmapGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindmapGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMindmapGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMindmapGenerator<
  TData = Awaited<ReturnType<typeof getMindmapGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindmapGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMindmapGenerator<
  TData = Awaited<ReturnType<typeof getMindmapGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMindmapGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMindmapGeneratorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateMindmapGenerator = (
  id: number,
  mindmapGeneratorUpdateRequestDto: BodyType<MindmapGeneratorUpdateRequestDto>,
) => {
  return configureAxios<MindmapGeneratorResponseDto>({
    url: `/mindmap-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: mindmapGeneratorUpdateRequestDto,
  });
};

export const getUpdateMindmapGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMindmapGenerator>>,
    TError,
    { id: number; data: BodyType<MindmapGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMindmapGenerator>>,
  TError,
  { id: number; data: BodyType<MindmapGeneratorUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMindmapGenerator>>,
    { id: number; data: BodyType<MindmapGeneratorUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMindmapGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMindmapGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMindmapGenerator>>
>;
export type UpdateMindmapGeneratorMutationBody =
  BodyType<MindmapGeneratorUpdateRequestDto>;
export type UpdateMindmapGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateMindmapGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMindmapGenerator>>,
    TError,
    { id: number; data: BodyType<MindmapGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMindmapGenerator>>,
  TError,
  { id: number; data: BodyType<MindmapGeneratorUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateMindmapGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMindmapGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/mindmap-generator/${id}`,
    method: "DELETE",
  });
};

export const getDeleteMindmapGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMindmapGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMindmapGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMindmapGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMindmapGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMindmapGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMindmapGenerator>>
>;

export type DeleteMindmapGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteMindmapGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMindmapGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMindmapGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteMindmapGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const refreshTranslations = () => {
  return configureAxios<void>({
    url: `/madlen-admin/refresh-translations`,
    method: "PUT",
  });
};

export const getRefreshTranslationsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshTranslations>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshTranslations>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshTranslations>>,
    void
  > = () => {
    return refreshTranslations();
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshTranslationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshTranslations>>
>;

export type RefreshTranslationsMutationError = ErrorType<BaseErrorResponseDto>;

export const useRefreshTranslations = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshTranslations>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshTranslations>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRefreshTranslationsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const refreshCms = () => {
  return configureAxios<void>({
    url: `/madlen-admin/refresh-cms`,
    method: "PUT",
  });
};

export const getRefreshCmsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshCms>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshCms>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshCms>>,
    void
  > = () => {
    return refreshCms();
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshCmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshCms>>
>;

export type RefreshCmsMutationError = ErrorType<BaseErrorResponseDto>;

export const useRefreshCms = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshCms>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshCms>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRefreshCmsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteBlogCache = () => {
  return configureAxios<void>({
    url: `/madlen-admin/refresh-blogs`,
    method: "PUT",
  });
};

export const getDeleteBlogCacheMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlogCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBlogCache>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBlogCache>>,
    void
  > = () => {
    return deleteBlogCache();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBlogCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBlogCache>>
>;

export type DeleteBlogCacheMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteBlogCache = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlogCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBlogCache>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteBlogCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const refreshApiKeys = () => {
  return configureAxios<void>({
    url: `/madlen-admin/refresh-api-keys`,
    method: "PUT",
  });
};

export const getRefreshApiKeysMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshApiKeys>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshApiKeys>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshApiKeys>>,
    void
  > = () => {
    return refreshApiKeys();
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshApiKeysMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshApiKeys>>
>;

export type RefreshApiKeysMutationError = ErrorType<BaseErrorResponseDto>;

export const useRefreshApiKeys = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshApiKeys>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshApiKeys>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRefreshApiKeysMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteMaarifCache = () => {
  return configureAxios<void>({
    url: `/maarif-learning-outcomes/refresh-outcomes`,
    method: "PUT",
  });
};

export const getDeleteMaarifCacheMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMaarifCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMaarifCache>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMaarifCache>>,
    void
  > = () => {
    return deleteMaarifCache();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMaarifCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMaarifCache>>
>;

export type DeleteMaarifCacheMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteMaarifCache = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMaarifCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMaarifCache>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteMaarifCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getLessonPlannerV2 = (id: number, signal?: AbortSignal) => {
  return configureAxios<LessonPlannerV2ResponseDto>({
    url: `/lesson-planner/v2/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetLessonPlannerV2QueryKey = (id: number) => {
  return [`/lesson-planner/v2/${id}`] as const;
};

export const getGetLessonPlannerV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getLessonPlannerV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannerV2>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLessonPlannerV2QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLessonPlannerV2>>
  > = ({ signal }) => getLessonPlannerV2(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLessonPlannerV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLessonPlannerV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getLessonPlannerV2>>
>;
export type GetLessonPlannerV2QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLessonPlannerV2<
  TData = Awaited<ReturnType<typeof getLessonPlannerV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannerV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonPlannerV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLessonPlannerV2<
  TData = Awaited<ReturnType<typeof getLessonPlannerV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannerV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonPlannerV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLessonPlannerV2<
  TData = Awaited<ReturnType<typeof getLessonPlannerV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannerV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLessonPlannerV2<
  TData = Awaited<ReturnType<typeof getLessonPlannerV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannerV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLessonPlannerV2QueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateLessonPlannerV2 = (
  id: number,
  updateLessonPlannerV2RequestDto: BodyType<UpdateLessonPlannerV2RequestDto>,
) => {
  return configureAxios<LessonPlannerV2ResponseDto>({
    url: `/lesson-planner/v2/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateLessonPlannerV2RequestDto,
  });
};

export const getUpdateLessonPlannerV2MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLessonPlannerV2>>,
    TError,
    { id: number; data: BodyType<UpdateLessonPlannerV2RequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLessonPlannerV2>>,
  TError,
  { id: number; data: BodyType<UpdateLessonPlannerV2RequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLessonPlannerV2>>,
    { id: number; data: BodyType<UpdateLessonPlannerV2RequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLessonPlannerV2(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLessonPlannerV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLessonPlannerV2>>
>;
export type UpdateLessonPlannerV2MutationBody =
  BodyType<UpdateLessonPlannerV2RequestDto>;
export type UpdateLessonPlannerV2MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateLessonPlannerV2 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLessonPlannerV2>>,
    TError,
    { id: number; data: BodyType<UpdateLessonPlannerV2RequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLessonPlannerV2>>,
  TError,
  { id: number; data: BodyType<UpdateLessonPlannerV2RequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateLessonPlannerV2MutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteLessonPlannerV2 = (id: number) => {
  return configureAxios<void>({
    url: `/lesson-planner/v2/${id}`,
    method: "DELETE",
  });
};

export const getDeleteLessonPlannerV2MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLessonPlannerV2>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLessonPlannerV2>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLessonPlannerV2>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLessonPlannerV2(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLessonPlannerV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLessonPlannerV2>>
>;

export type DeleteLessonPlannerV2MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteLessonPlannerV2 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLessonPlannerV2>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLessonPlannerV2>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteLessonPlannerV2MutationOptions(options);

  return useMutation(mutationOptions);
};

export const saveLessonPlannerResult = (
  id: number,
  saveLessonPlannerResultRequestDto: BodyType<SaveLessonPlannerResultRequestDto>,
) => {
  return configureAxios<LessonPlannerV2ResponseDto>({
    url: `/lesson-planner/v2/${id}/save`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: saveLessonPlannerResultRequestDto,
  });
};

export const getSaveLessonPlannerResultMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveLessonPlannerResult>>,
    TError,
    { id: number; data: BodyType<SaveLessonPlannerResultRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveLessonPlannerResult>>,
  TError,
  { id: number; data: BodyType<SaveLessonPlannerResultRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveLessonPlannerResult>>,
    { id: number; data: BodyType<SaveLessonPlannerResultRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return saveLessonPlannerResult(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveLessonPlannerResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveLessonPlannerResult>>
>;
export type SaveLessonPlannerResultMutationBody =
  BodyType<SaveLessonPlannerResultRequestDto>;
export type SaveLessonPlannerResultMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSaveLessonPlannerResult = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveLessonPlannerResult>>,
    TError,
    { id: number; data: BodyType<SaveLessonPlannerResultRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveLessonPlannerResult>>,
  TError,
  { id: number; data: BodyType<SaveLessonPlannerResultRequestDto> },
  TContext
> => {
  const mutationOptions = getSaveLessonPlannerResultMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getLessonHook = (id: number, signal?: AbortSignal) => {
  return configureAxios<LessonHookResponseDto>({
    url: `/lesson-hooks/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetLessonHookQueryKey = (id: number) => {
  return [`/lesson-hooks/${id}`] as const;
};

export const getGetLessonHookQueryOptions = <
  TData = Awaited<ReturnType<typeof getLessonHook>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLessonHook>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLessonHookQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLessonHook>>> = ({
    signal,
  }) => getLessonHook(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLessonHook>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLessonHookQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLessonHook>>
>;
export type GetLessonHookQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLessonHook<
  TData = Awaited<ReturnType<typeof getLessonHook>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLessonHook>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonHook>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLessonHook<
  TData = Awaited<ReturnType<typeof getLessonHook>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLessonHook>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonHook>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLessonHook<
  TData = Awaited<ReturnType<typeof getLessonHook>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLessonHook>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLessonHook<
  TData = Awaited<ReturnType<typeof getLessonHook>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLessonHook>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLessonHookQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateLessonHook = (
  id: number,
  lessonHookUpdateRequestDto: BodyType<LessonHookUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/lesson-hooks/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: lessonHookUpdateRequestDto,
  });
};

export const getUpdateLessonHookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLessonHook>>,
    TError,
    { id: number; data: BodyType<LessonHookUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLessonHook>>,
  TError,
  { id: number; data: BodyType<LessonHookUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLessonHook>>,
    { id: number; data: BodyType<LessonHookUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLessonHook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLessonHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLessonHook>>
>;
export type UpdateLessonHookMutationBody = BodyType<LessonHookUpdateRequestDto>;
export type UpdateLessonHookMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateLessonHook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLessonHook>>,
    TError,
    { id: number; data: BodyType<LessonHookUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLessonHook>>,
  TError,
  { id: number; data: BodyType<LessonHookUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateLessonHookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteLessonHook = (id: number) => {
  return configureAxios<void>({ url: `/lesson-hooks/${id}`, method: "DELETE" });
};

export const getDeleteLessonHookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLessonHook>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLessonHook>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLessonHook>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLessonHook(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLessonHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLessonHook>>
>;

export type DeleteLessonHookMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteLessonHook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLessonHook>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLessonHook>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteLessonHookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteLearningOutcomeCache = () => {
  return configureAxios<void>({
    url: `/learning-outcomes/refresh-outcomes`,
    method: "PUT",
  });
};

export const getDeleteLearningOutcomeCacheMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLearningOutcomeCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLearningOutcomeCache>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLearningOutcomeCache>>,
    void
  > = () => {
    return deleteLearningOutcomeCache();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLearningOutcomeCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLearningOutcomeCache>>
>;

export type DeleteLearningOutcomeCacheMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteLearningOutcomeCache = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLearningOutcomeCache>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLearningOutcomeCache>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteLearningOutcomeCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getInteractiveMaterial = (id: number, signal?: AbortSignal) => {
  return configureAxios<InteractiveMaterialResponseDto>({
    url: `/interactive-materials/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetInteractiveMaterialQueryKey = (id: number) => {
  return [`/interactive-materials/${id}`] as const;
};

export const getGetInteractiveMaterialQueryOptions = <
  TData = Awaited<ReturnType<typeof getInteractiveMaterial>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInteractiveMaterialQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInteractiveMaterial>>
  > = ({ signal }) => getInteractiveMaterial(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInteractiveMaterial>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetInteractiveMaterialQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInteractiveMaterial>>
>;
export type GetInteractiveMaterialQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetInteractiveMaterial<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInteractiveMaterial>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInteractiveMaterial<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInteractiveMaterial>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInteractiveMaterial<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetInteractiveMaterial<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetInteractiveMaterialQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const editInteractiveMaterial = (
  id: number,
  interactiveMaterialWebhookRequest: BodyType<InteractiveMaterialWebhookRequest>,
) => {
  return configureAxios<void>({
    url: `/interactive-materials/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: interactiveMaterialWebhookRequest,
  });
};

export const getEditInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editInteractiveMaterial>>,
    TError,
    { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editInteractiveMaterial>>,
  TError,
  { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editInteractiveMaterial>>,
    { id: number; data: BodyType<InteractiveMaterialWebhookRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return editInteractiveMaterial(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof editInteractiveMaterial>>
>;
export type EditInteractiveMaterialMutationBody =
  BodyType<InteractiveMaterialWebhookRequest>;
export type EditInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEditInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editInteractiveMaterial>>,
    TError,
    { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editInteractiveMaterial>>,
  TError,
  { id: number; data: BodyType<InteractiveMaterialWebhookRequest> },
  TContext
> => {
  const mutationOptions = getEditInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteInteractiveMaterial = (id: number) => {
  return configureAxios<void>({
    url: `/interactive-materials/${id}`,
    method: "DELETE",
  });
};

export const getDeleteInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInteractiveMaterial>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInteractiveMaterial(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInteractiveMaterial>>
>;

export type DeleteInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editInteractiveMaterialSpecs = (
  id: number,
  editInteractiveMaterialSpecsRequest: BodyType<EditInteractiveMaterialSpecsRequest>,
) => {
  return configureAxios<InteractiveMaterialResponseDto>({
    url: `/interactive-materials/${id}/specs`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: editInteractiveMaterialSpecsRequest,
  });
};

export const getEditInteractiveMaterialSpecsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editInteractiveMaterialSpecs>>,
    TError,
    { id: number; data: BodyType<EditInteractiveMaterialSpecsRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editInteractiveMaterialSpecs>>,
  TError,
  { id: number; data: BodyType<EditInteractiveMaterialSpecsRequest> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editInteractiveMaterialSpecs>>,
    { id: number; data: BodyType<EditInteractiveMaterialSpecsRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return editInteractiveMaterialSpecs(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditInteractiveMaterialSpecsMutationResult = NonNullable<
  Awaited<ReturnType<typeof editInteractiveMaterialSpecs>>
>;
export type EditInteractiveMaterialSpecsMutationBody =
  BodyType<EditInteractiveMaterialSpecsRequest>;
export type EditInteractiveMaterialSpecsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEditInteractiveMaterialSpecs = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editInteractiveMaterialSpecs>>,
    TError,
    { id: number; data: BodyType<EditInteractiveMaterialSpecsRequest> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editInteractiveMaterialSpecs>>,
  TError,
  { id: number; data: BodyType<EditInteractiveMaterialSpecsRequest> },
  TContext
> => {
  const mutationOptions =
    getEditInteractiveMaterialSpecsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getImageGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<ImageGeneratorResponseDto>({
    url: `/image-generators/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetImageGeneratorQueryKey = (id: number) => {
  return [`/image-generators/${id}`] as const;
};

export const getGetImageGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getImageGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImageGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImageGeneratorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getImageGenerator>>
  > = ({ signal }) => getImageGenerator(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getImageGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetImageGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImageGenerator>>
>;
export type GetImageGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetImageGenerator<
  TData = Awaited<ReturnType<typeof getImageGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImageGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetImageGenerator<
  TData = Awaited<ReturnType<typeof getImageGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImageGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetImageGenerator<
  TData = Awaited<ReturnType<typeof getImageGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImageGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetImageGenerator<
  TData = Awaited<ReturnType<typeof getImageGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getImageGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetImageGeneratorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateImageGenerator = (
  id: number,
  updateImageGeneratorRequestDto: BodyType<UpdateImageGeneratorRequestDto>,
) => {
  return configureAxios<void>({
    url: `/image-generators/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateImageGeneratorRequestDto,
  });
};

export const getUpdateImageGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateImageGenerator>>,
    TError,
    { id: number; data: BodyType<UpdateImageGeneratorRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateImageGenerator>>,
  TError,
  { id: number; data: BodyType<UpdateImageGeneratorRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateImageGenerator>>,
    { id: number; data: BodyType<UpdateImageGeneratorRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateImageGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateImageGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateImageGenerator>>
>;
export type UpdateImageGeneratorMutationBody =
  BodyType<UpdateImageGeneratorRequestDto>;
export type UpdateImageGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateImageGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateImageGenerator>>,
    TError,
    { id: number; data: BodyType<UpdateImageGeneratorRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateImageGenerator>>,
  TError,
  { id: number; data: BodyType<UpdateImageGeneratorRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateImageGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteImageGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/image-generators/${id}`,
    method: "DELETE",
  });
};

export const getDeleteImageGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteImageGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteImageGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteImageGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteImageGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteImageGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteImageGenerator>>
>;

export type DeleteImageGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteImageGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteImageGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteImageGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteImageGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateImageGenerator = (
  id: number,
  imageGeneratorCreateRequestDto: BodyType<ImageGeneratorCreateRequestDto>,
) => {
  return configureAxios<ImageGeneratorResponseDto>({
    url: `/image-generators/${id}/regen`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: imageGeneratorCreateRequestDto,
  });
};

export const getRegenerateImageGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateImageGenerator>>,
    TError,
    { id: number; data: BodyType<ImageGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateImageGenerator>>,
  TError,
  { id: number; data: BodyType<ImageGeneratorCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateImageGenerator>>,
    { id: number; data: BodyType<ImageGeneratorCreateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateImageGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateImageGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateImageGenerator>>
>;
export type RegenerateImageGeneratorMutationBody =
  BodyType<ImageGeneratorCreateRequestDto>;
export type RegenerateImageGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateImageGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateImageGenerator>>,
    TError,
    { id: number; data: BodyType<ImageGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateImageGenerator>>,
  TError,
  { id: number; data: BodyType<ImageGeneratorCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getRegenerateImageGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getHomeworkIdea = (id: number, signal?: AbortSignal) => {
  return configureAxios<HomeworkIdeaResponseDto>({
    url: `/homework-ideas/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetHomeworkIdeaQueryKey = (id: number) => {
  return [`/homework-ideas/${id}`] as const;
};

export const getGetHomeworkIdeaQueryOptions = <
  TData = Awaited<ReturnType<typeof getHomeworkIdea>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHomeworkIdea>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHomeworkIdeaQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomeworkIdea>>> = ({
    signal,
  }) => getHomeworkIdea(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHomeworkIdea>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetHomeworkIdeaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHomeworkIdea>>
>;
export type GetHomeworkIdeaQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetHomeworkIdea<
  TData = Awaited<ReturnType<typeof getHomeworkIdea>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHomeworkIdea>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomeworkIdea>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHomeworkIdea<
  TData = Awaited<ReturnType<typeof getHomeworkIdea>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHomeworkIdea>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHomeworkIdea>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHomeworkIdea<
  TData = Awaited<ReturnType<typeof getHomeworkIdea>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHomeworkIdea>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetHomeworkIdea<
  TData = Awaited<ReturnType<typeof getHomeworkIdea>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHomeworkIdea>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetHomeworkIdeaQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateHomeworkIdea = (
  id: number,
  homeworkIdeaUpdateRequestDto: BodyType<HomeworkIdeaUpdateRequestDto>,
) => {
  return configureAxios<HomeworkIdeaResponseDto>({
    url: `/homework-ideas/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: homeworkIdeaUpdateRequestDto,
  });
};

export const getUpdateHomeworkIdeaMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHomeworkIdea>>,
    TError,
    { id: number; data: BodyType<HomeworkIdeaUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHomeworkIdea>>,
  TError,
  { id: number; data: BodyType<HomeworkIdeaUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHomeworkIdea>>,
    { id: number; data: BodyType<HomeworkIdeaUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHomeworkIdea(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHomeworkIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHomeworkIdea>>
>;
export type UpdateHomeworkIdeaMutationBody =
  BodyType<HomeworkIdeaUpdateRequestDto>;
export type UpdateHomeworkIdeaMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateHomeworkIdea = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHomeworkIdea>>,
    TError,
    { id: number; data: BodyType<HomeworkIdeaUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateHomeworkIdea>>,
  TError,
  { id: number; data: BodyType<HomeworkIdeaUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateHomeworkIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteHomeworkIdea = (id: number) => {
  return configureAxios<void>({
    url: `/homework-ideas/${id}`,
    method: "DELETE",
  });
};

export const getDeleteHomeworkIdeaMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHomeworkIdea>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHomeworkIdea>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHomeworkIdea>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteHomeworkIdea(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteHomeworkIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHomeworkIdea>>
>;

export type DeleteHomeworkIdeaMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteHomeworkIdea = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHomeworkIdea>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteHomeworkIdea>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteHomeworkIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPost = (postId: number, signal?: AbortSignal) => {
  return configureAxios<ForumPostDto>({
    url: `/forum-posts/${postId}`,
    method: "GET",
    signal,
  });
};

export const getGetPostQueryKey = (postId: number) => {
  return [`/forum-posts/${postId}`] as const;
};

export const getGetPostQueryOptions = <
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  postId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPostQueryKey(postId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPost>>> = ({
    signal,
  }) => getPost(postId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!postId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetPostQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPost>>
>;
export type GetPostQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetPost<
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  postId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPost>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPost<
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  postId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPost>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPost<
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  postId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPost<
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  postId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPostQueryOptions(postId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updatePost = (
  postId: number,
  createForumPostRequestDto: BodyType<CreateForumPostRequestDto>,
) => {
  return configureAxios<ForumPostDto>({
    url: `/forum-posts/${postId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: createForumPostRequestDto,
  });
};

export const getUpdatePostMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePost>>,
    TError,
    { postId: number; data: BodyType<CreateForumPostRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePost>>,
  TError,
  { postId: number; data: BodyType<CreateForumPostRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePost>>,
    { postId: number; data: BodyType<CreateForumPostRequestDto> }
  > = (props) => {
    const { postId, data } = props ?? {};

    return updatePost(postId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePost>>
>;
export type UpdatePostMutationBody = BodyType<CreateForumPostRequestDto>;
export type UpdatePostMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdatePost = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePost>>,
    TError,
    { postId: number; data: BodyType<CreateForumPostRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePost>>,
  TError,
  { postId: number; data: BodyType<CreateForumPostRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdatePostMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deletePost = (postId: number) => {
  return configureAxios<void>({
    url: `/forum-posts/${postId}`,
    method: "DELETE",
  });
};

export const getDeletePostMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePost>>,
    TError,
    { postId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePost>>,
  TError,
  { postId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePost>>,
    { postId: number }
  > = (props) => {
    const { postId } = props ?? {};

    return deletePost(postId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePost>>
>;

export type DeletePostMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeletePost = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePost>>,
    TError,
    { postId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePost>>,
  TError,
  { postId: number },
  TContext
> => {
  const mutationOptions = getDeletePostMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateComment = (
  commentId: number,
  createForumCommentRequestDto: BodyType<CreateForumCommentRequestDto>,
) => {
  return configureAxios<ForumCommentDto>({
    url: `/forum-posts/${commentId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: createForumCommentRequestDto,
  });
};

export const getUpdateCommentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateComment>>,
    TError,
    { commentId: number; data: BodyType<CreateForumCommentRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateComment>>,
  TError,
  { commentId: number; data: BodyType<CreateForumCommentRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateComment>>,
    { commentId: number; data: BodyType<CreateForumCommentRequestDto> }
  > = (props) => {
    const { commentId, data } = props ?? {};

    return updateComment(commentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateComment>>
>;
export type UpdateCommentMutationBody = BodyType<CreateForumCommentRequestDto>;
export type UpdateCommentMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateComment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateComment>>,
    TError,
    { commentId: number; data: BodyType<CreateForumCommentRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateComment>>,
  TError,
  { commentId: number; data: BodyType<CreateForumCommentRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteComment = (commentId: number) => {
  return configureAxios<void>({
    url: `/forum-posts/${commentId}`,
    method: "DELETE",
  });
};

export const getDeleteCommentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteComment>>,
    TError,
    { commentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { commentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteComment>>,
    { commentId: number }
  > = (props) => {
    const { commentId } = props ?? {};

    return deleteComment(commentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteComment>>
>;

export type DeleteCommentMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteComment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteComment>>,
    TError,
    { commentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { commentId: number },
  TContext
> => {
  const mutationOptions = getDeleteCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFormativeAssessment = (id: number, signal?: AbortSignal) => {
  return configureAxios<FormativeAssessmentResponseDto>({
    url: `/formative-assessment/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetFormativeAssessmentQueryKey = (id: number) => {
  return [`/formative-assessment/${id}`] as const;
};

export const getGetFormativeAssessmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getFormativeAssessment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFormativeAssessment>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFormativeAssessmentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFormativeAssessment>>
  > = ({ signal }) => getFormativeAssessment(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFormativeAssessment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFormativeAssessmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFormativeAssessment>>
>;
export type GetFormativeAssessmentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetFormativeAssessment<
  TData = Awaited<ReturnType<typeof getFormativeAssessment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFormativeAssessment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormativeAssessment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFormativeAssessment<
  TData = Awaited<ReturnType<typeof getFormativeAssessment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFormativeAssessment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFormativeAssessment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFormativeAssessment<
  TData = Awaited<ReturnType<typeof getFormativeAssessment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFormativeAssessment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFormativeAssessment<
  TData = Awaited<ReturnType<typeof getFormativeAssessment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFormativeAssessment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFormativeAssessmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateFormativeAssessment = (
  id: number,
  formativeAssessmentUpdateRequestDto: BodyType<FormativeAssessmentUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/formative-assessment/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: formativeAssessmentUpdateRequestDto,
  });
};

export const getUpdateFormativeAssessmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFormativeAssessment>>,
    TError,
    { id: number; data: BodyType<FormativeAssessmentUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFormativeAssessment>>,
  TError,
  { id: number; data: BodyType<FormativeAssessmentUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFormativeAssessment>>,
    { id: number; data: BodyType<FormativeAssessmentUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFormativeAssessment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFormativeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFormativeAssessment>>
>;
export type UpdateFormativeAssessmentMutationBody =
  BodyType<FormativeAssessmentUpdateRequestDto>;
export type UpdateFormativeAssessmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateFormativeAssessment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFormativeAssessment>>,
    TError,
    { id: number; data: BodyType<FormativeAssessmentUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFormativeAssessment>>,
  TError,
  { id: number; data: BodyType<FormativeAssessmentUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateFormativeAssessmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteFormativeAssessment = (id: number) => {
  return configureAxios<void>({
    url: `/formative-assessment/${id}`,
    method: "DELETE",
  });
};

export const getDeleteFormativeAssessmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFormativeAssessment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFormativeAssessment>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFormativeAssessment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteFormativeAssessment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFormativeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFormativeAssessment>>
>;

export type DeleteFormativeAssessmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteFormativeAssessment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFormativeAssessment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFormativeAssessment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteFormativeAssessmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const moveNode = (moveNodesDto: BodyType<MoveNodesDto>) => {
  return configureAxios<void>({
    url: `/filenodes/move`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: moveNodesDto,
  });
};

export const getMoveNodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveNode>>,
    TError,
    { data: BodyType<MoveNodesDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveNode>>,
  TError,
  { data: BodyType<MoveNodesDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveNode>>,
    { data: BodyType<MoveNodesDto> }
  > = (props) => {
    const { data } = props ?? {};

    return moveNode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveNodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveNode>>
>;
export type MoveNodeMutationBody = BodyType<MoveNodesDto>;
export type MoveNodeMutationError = ErrorType<BaseErrorResponseDto>;

export const useMoveNode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveNode>>,
    TError,
    { data: BodyType<MoveNodesDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof moveNode>>,
  TError,
  { data: BodyType<MoveNodesDto> },
  TContext
> => {
  const mutationOptions = getMoveNodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getExitTicketGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<ExitTicketGeneratorResponseDto>({
    url: `/exit-ticket-generator/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetExitTicketGeneratorQueryKey = (id: number) => {
  return [`/exit-ticket-generator/${id}`] as const;
};

export const getGetExitTicketGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getExitTicketGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExitTicketGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExitTicketGeneratorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExitTicketGenerator>>
  > = ({ signal }) => getExitTicketGenerator(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExitTicketGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetExitTicketGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExitTicketGenerator>>
>;
export type GetExitTicketGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetExitTicketGenerator<
  TData = Awaited<ReturnType<typeof getExitTicketGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExitTicketGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExitTicketGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetExitTicketGenerator<
  TData = Awaited<ReturnType<typeof getExitTicketGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExitTicketGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExitTicketGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetExitTicketGenerator<
  TData = Awaited<ReturnType<typeof getExitTicketGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExitTicketGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetExitTicketGenerator<
  TData = Awaited<ReturnType<typeof getExitTicketGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExitTicketGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetExitTicketGeneratorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateExitTicketGenerator = (
  id: number,
  exitTicketGeneratorUpdateRequestDto: BodyType<ExitTicketGeneratorUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/exit-ticket-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: exitTicketGeneratorUpdateRequestDto,
  });
};

export const getUpdateExitTicketGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExitTicketGenerator>>,
    TError,
    { id: number; data: BodyType<ExitTicketGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExitTicketGenerator>>,
  TError,
  { id: number; data: BodyType<ExitTicketGeneratorUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExitTicketGenerator>>,
    { id: number; data: BodyType<ExitTicketGeneratorUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateExitTicketGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExitTicketGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExitTicketGenerator>>
>;
export type UpdateExitTicketGeneratorMutationBody =
  BodyType<ExitTicketGeneratorUpdateRequestDto>;
export type UpdateExitTicketGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateExitTicketGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExitTicketGenerator>>,
    TError,
    { id: number; data: BodyType<ExitTicketGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateExitTicketGenerator>>,
  TError,
  { id: number; data: BodyType<ExitTicketGeneratorUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateExitTicketGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteExitTicketGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/exit-ticket-generator/${id}`,
    method: "DELETE",
  });
};

export const getDeleteExitTicketGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExitTicketGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteExitTicketGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteExitTicketGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteExitTicketGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteExitTicketGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteExitTicketGenerator>>
>;

export type DeleteExitTicketGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteExitTicketGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExitTicketGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteExitTicketGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteExitTicketGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEssentialQuestions = (id: number, signal?: AbortSignal) => {
  return configureAxios<EssentialQuestionsResponseDto>({
    url: `/essential-questions/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetEssentialQuestionsQueryKey = (id: number) => {
  return [`/essential-questions/${id}`] as const;
};

export const getGetEssentialQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEssentialQuestionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEssentialQuestions>>
  > = ({ signal }) => getEssentialQuestions(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEssentialQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEssentialQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEssentialQuestions>>
>;
export type GetEssentialQuestionsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetEssentialQuestions<
  TData = Awaited<ReturnType<typeof getEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEssentialQuestions<
  TData = Awaited<ReturnType<typeof getEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEssentialQuestions<
  TData = Awaited<ReturnType<typeof getEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetEssentialQuestions<
  TData = Awaited<ReturnType<typeof getEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEssentialQuestionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateEssentialQuestions = (
  id: number,
  essentialQuestionsUpdateRequestDto: BodyType<EssentialQuestionsUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/essential-questions/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: essentialQuestionsUpdateRequestDto,
  });
};

export const getUpdateEssentialQuestionsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEssentialQuestions>>,
    TError,
    { id: number; data: BodyType<EssentialQuestionsUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEssentialQuestions>>,
  TError,
  { id: number; data: BodyType<EssentialQuestionsUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEssentialQuestions>>,
    { id: number; data: BodyType<EssentialQuestionsUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEssentialQuestions(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEssentialQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEssentialQuestions>>
>;
export type UpdateEssentialQuestionsMutationBody =
  BodyType<EssentialQuestionsUpdateRequestDto>;
export type UpdateEssentialQuestionsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateEssentialQuestions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEssentialQuestions>>,
    TError,
    { id: number; data: BodyType<EssentialQuestionsUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEssentialQuestions>>,
  TError,
  { id: number; data: BodyType<EssentialQuestionsUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateEssentialQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteEssentialQuestions = (id: number) => {
  return configureAxios<void>({
    url: `/essential-questions/${id}`,
    method: "DELETE",
  });
};

export const getDeleteEssentialQuestionsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEssentialQuestions>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEssentialQuestions>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEssentialQuestions>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEssentialQuestions(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEssentialQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEssentialQuestions>>
>;

export type DeleteEssentialQuestionsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteEssentialQuestions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEssentialQuestions>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEssentialQuestions>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteEssentialQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update grade for a student submission (Teacher only)
 */
export const updateGrade = (
  submissionId: number,
  updateGradeRequestDto: BodyType<UpdateGradeRequestDto>,
) => {
  return configureAxios<StudentEssaySubmissionResponseDto>({
    url: `/essay-submissions/grade/${submissionId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateGradeRequestDto,
  });
};

export const getUpdateGradeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGrade>>,
    TError,
    { submissionId: number; data: BodyType<UpdateGradeRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGrade>>,
  TError,
  { submissionId: number; data: BodyType<UpdateGradeRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGrade>>,
    { submissionId: number; data: BodyType<UpdateGradeRequestDto> }
  > = (props) => {
    const { submissionId, data } = props ?? {};

    return updateGrade(submissionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGradeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGrade>>
>;
export type UpdateGradeMutationBody = BodyType<UpdateGradeRequestDto>;
export type UpdateGradeMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update grade for a student submission (Teacher only)
 */
export const useUpdateGrade = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGrade>>,
    TError,
    { submissionId: number; data: BodyType<UpdateGradeRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGrade>>,
  TError,
  { submissionId: number; data: BodyType<UpdateGradeRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateGradeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get my submission for assignment
 */
export const getSubmission = (assignmentId: number, signal?: AbortSignal) => {
  return configureAxios<StudentEssaySubmissionResponseDto>({
    url: `/essay-submissions/assignments/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetSubmissionQueryKey = (assignmentId: number) => {
  return [`/essay-submissions/assignments/${assignmentId}`] as const;
};

export const getGetSubmissionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubmission>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSubmissionQueryKey(assignmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubmission>>> = ({
    signal,
  }) => getSubmission(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubmission>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSubmissionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubmission>>
>;
export type GetSubmissionQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSubmission<
  TData = Awaited<ReturnType<typeof getSubmission>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubmission>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSubmission<
  TData = Awaited<ReturnType<typeof getSubmission>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubmission>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSubmission<
  TData = Awaited<ReturnType<typeof getSubmission>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get my submission for assignment
 */

export function useGetSubmission<
  TData = Awaited<ReturnType<typeof getSubmission>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSubmissionQueryOptions(assignmentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update essay submission
 */
export const updateSubmission = (
  assignmentId: number,
  updateSubmissionRequestDto: BodyType<UpdateSubmissionRequestDto>,
) => {
  return configureAxios<StudentEssaySubmissionResponseDto>({
    url: `/essay-submissions/assignments/${assignmentId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateSubmissionRequestDto,
  });
};

export const getUpdateSubmissionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubmission>>,
    TError,
    { assignmentId: number; data: BodyType<UpdateSubmissionRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubmission>>,
  TError,
  { assignmentId: number; data: BodyType<UpdateSubmissionRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubmission>>,
    { assignmentId: number; data: BodyType<UpdateSubmissionRequestDto> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return updateSubmission(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubmission>>
>;
export type UpdateSubmissionMutationBody = BodyType<UpdateSubmissionRequestDto>;
export type UpdateSubmissionMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update essay submission
 */
export const useUpdateSubmission = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubmission>>,
    TError,
    { assignmentId: number; data: BodyType<UpdateSubmissionRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSubmission>>,
  TError,
  { assignmentId: number; data: BodyType<UpdateSubmissionRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk update grades for submissions (Teacher only)
 */
export const bulkUpdateGrades = (
  assignmentId: number,
  bulkGradeUpdateRequestDto: BodyType<BulkGradeUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/essay-submissions/assignments/${assignmentId}/bulk-grade`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bulkGradeUpdateRequestDto,
  });
};

export const getBulkUpdateGradesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateGrades>>,
    TError,
    { assignmentId: number; data: BodyType<BulkGradeUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateGrades>>,
  TError,
  { assignmentId: number; data: BodyType<BulkGradeUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateGrades>>,
    { assignmentId: number; data: BodyType<BulkGradeUpdateRequestDto> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return bulkUpdateGrades(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateGradesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpdateGrades>>
>;
export type BulkUpdateGradesMutationBody = BodyType<BulkGradeUpdateRequestDto>;
export type BulkUpdateGradesMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Bulk update grades for submissions (Teacher only)
 */
export const useBulkUpdateGrades = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateGrades>>,
    TError,
    { assignmentId: number; data: BodyType<BulkGradeUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpdateGrades>>,
  TError,
  { assignmentId: number; data: BodyType<BulkGradeUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getBulkUpdateGradesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get essay assignment by ID
 */
export const getEssayAssignment = (id: number, signal?: AbortSignal) => {
  return configureAxios<EssayAssignmentResponseDto>({
    url: `/essay-assignments/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetEssayAssignmentQueryKey = (id: number) => {
  return [`/essay-assignments/${id}`] as const;
};

export const getGetEssayAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getEssayAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignment>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEssayAssignmentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEssayAssignment>>
  > = ({ signal }) => getEssayAssignment(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEssayAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEssayAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEssayAssignment>>
>;
export type GetEssayAssignmentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetEssayAssignment<
  TData = Awaited<ReturnType<typeof getEssayAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEssayAssignment<
  TData = Awaited<ReturnType<typeof getEssayAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEssayAssignment<
  TData = Awaited<ReturnType<typeof getEssayAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get essay assignment by ID
 */

export function useGetEssayAssignment<
  TData = Awaited<ReturnType<typeof getEssayAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEssayAssignmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update essay assignment
 */
export const updateEssayAssignment = (
  id: number,
  updateEssayAssignmentRequestDto: BodyType<UpdateEssayAssignmentRequestDto>,
) => {
  return configureAxios<EssayAssignmentResponseDto>({
    url: `/essay-assignments/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateEssayAssignmentRequestDto,
  });
};

export const getUpdateEssayAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEssayAssignment>>,
    TError,
    { id: number; data: BodyType<UpdateEssayAssignmentRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEssayAssignment>>,
  TError,
  { id: number; data: BodyType<UpdateEssayAssignmentRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEssayAssignment>>,
    { id: number; data: BodyType<UpdateEssayAssignmentRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEssayAssignment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEssayAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEssayAssignment>>
>;
export type UpdateEssayAssignmentMutationBody =
  BodyType<UpdateEssayAssignmentRequestDto>;
export type UpdateEssayAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update essay assignment
 */
export const useUpdateEssayAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEssayAssignment>>,
    TError,
    { id: number; data: BodyType<UpdateEssayAssignmentRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEssayAssignment>>,
  TError,
  { id: number; data: BodyType<UpdateEssayAssignmentRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateEssayAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete essay assignment
 */
export const deleteEssayAssignment = (id: number) => {
  return configureAxios<string>({
    url: `/essay-assignments/${id}`,
    method: "DELETE",
  });
};

export const getDeleteEssayAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEssayAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEssayAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEssayAssignment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEssayAssignment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEssayAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEssayAssignment>>
>;

export type DeleteEssayAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Delete essay assignment
 */
export const useDeleteEssayAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEssayAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEssayAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteEssayAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getConceptualUnderstanding = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<ConceptualUnderstandingResponseDto>({
    url: `/conceptual-understandings/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetConceptualUnderstandingQueryKey = (id: number) => {
  return [`/conceptual-understandings/${id}`] as const;
};

export const getGetConceptualUnderstandingQueryOptions = <
  TData = Awaited<ReturnType<typeof getConceptualUnderstanding>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConceptualUnderstanding>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConceptualUnderstandingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConceptualUnderstanding>>
  > = ({ signal }) => getConceptualUnderstanding(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConceptualUnderstanding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetConceptualUnderstandingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConceptualUnderstanding>>
>;
export type GetConceptualUnderstandingQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetConceptualUnderstanding<
  TData = Awaited<ReturnType<typeof getConceptualUnderstanding>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConceptualUnderstanding>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConceptualUnderstanding>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetConceptualUnderstanding<
  TData = Awaited<ReturnType<typeof getConceptualUnderstanding>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConceptualUnderstanding>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConceptualUnderstanding>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetConceptualUnderstanding<
  TData = Awaited<ReturnType<typeof getConceptualUnderstanding>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConceptualUnderstanding>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetConceptualUnderstanding<
  TData = Awaited<ReturnType<typeof getConceptualUnderstanding>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConceptualUnderstanding>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetConceptualUnderstandingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateConceptualUnderstanding = (
  id: number,
  conceptualUnderstandingUpdateRequestDto: BodyType<ConceptualUnderstandingUpdateRequestDto>,
) => {
  return configureAxios<ConceptualUnderstandingResponseDto>({
    url: `/conceptual-understandings/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: conceptualUnderstandingUpdateRequestDto,
  });
};

export const getUpdateConceptualUnderstandingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConceptualUnderstanding>>,
    TError,
    { id: number; data: BodyType<ConceptualUnderstandingUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConceptualUnderstanding>>,
  TError,
  { id: number; data: BodyType<ConceptualUnderstandingUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConceptualUnderstanding>>,
    { id: number; data: BodyType<ConceptualUnderstandingUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateConceptualUnderstanding(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConceptualUnderstandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConceptualUnderstanding>>
>;
export type UpdateConceptualUnderstandingMutationBody =
  BodyType<ConceptualUnderstandingUpdateRequestDto>;
export type UpdateConceptualUnderstandingMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateConceptualUnderstanding = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConceptualUnderstanding>>,
    TError,
    { id: number; data: BodyType<ConceptualUnderstandingUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateConceptualUnderstanding>>,
  TError,
  { id: number; data: BodyType<ConceptualUnderstandingUpdateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getUpdateConceptualUnderstandingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteConceptualUnderstanding = (id: number) => {
  return configureAxios<void>({
    url: `/conceptual-understandings/${id}`,
    method: "DELETE",
  });
};

export const getDeleteConceptualUnderstandingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConceptualUnderstanding>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConceptualUnderstanding>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConceptualUnderstanding>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteConceptualUnderstanding(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConceptualUnderstandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConceptualUnderstanding>>
>;

export type DeleteConceptualUnderstandingMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteConceptualUnderstanding = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConceptualUnderstanding>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteConceptualUnderstanding>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteConceptualUnderstandingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCommonMisconception = (id: number, signal?: AbortSignal) => {
  return configureAxios<CommonMisconceptionResponseDto>({
    url: `/common-misconceptions/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetCommonMisconceptionQueryKey = (id: number) => {
  return [`/common-misconceptions/${id}`] as const;
};

export const getGetCommonMisconceptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommonMisconception>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCommonMisconception>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCommonMisconceptionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCommonMisconception>>
  > = ({ signal }) => getCommonMisconception(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommonMisconception>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCommonMisconceptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommonMisconception>>
>;
export type GetCommonMisconceptionQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetCommonMisconception<
  TData = Awaited<ReturnType<typeof getCommonMisconception>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCommonMisconception>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommonMisconception>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCommonMisconception<
  TData = Awaited<ReturnType<typeof getCommonMisconception>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCommonMisconception>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommonMisconception>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCommonMisconception<
  TData = Awaited<ReturnType<typeof getCommonMisconception>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCommonMisconception>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetCommonMisconception<
  TData = Awaited<ReturnType<typeof getCommonMisconception>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCommonMisconception>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCommonMisconceptionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateCommonMisconception = (
  id: number,
  commonMisconceptionUpdateRequestDto: BodyType<CommonMisconceptionUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/common-misconceptions/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: commonMisconceptionUpdateRequestDto,
  });
};

export const getUpdateCommonMisconceptionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommonMisconception>>,
    TError,
    { id: number; data: BodyType<CommonMisconceptionUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommonMisconception>>,
  TError,
  { id: number; data: BodyType<CommonMisconceptionUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommonMisconception>>,
    { id: number; data: BodyType<CommonMisconceptionUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCommonMisconception(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommonMisconceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommonMisconception>>
>;
export type UpdateCommonMisconceptionMutationBody =
  BodyType<CommonMisconceptionUpdateRequestDto>;
export type UpdateCommonMisconceptionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateCommonMisconception = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommonMisconception>>,
    TError,
    { id: number; data: BodyType<CommonMisconceptionUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCommonMisconception>>,
  TError,
  { id: number; data: BodyType<CommonMisconceptionUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateCommonMisconceptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCommonMisconception = (id: number) => {
  return configureAxios<void>({
    url: `/common-misconceptions/${id}`,
    method: "DELETE",
  });
};

export const getDeleteCommonMisconceptionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommonMisconception>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCommonMisconception>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCommonMisconception>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCommonMisconception(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommonMisconceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCommonMisconception>>
>;

export type DeleteCommonMisconceptionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteCommonMisconception = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommonMisconception>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCommonMisconception>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteCommonMisconceptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getCollaborativeGroupWork = (id: number, signal?: AbortSignal) => {
  return configureAxios<CollaborativeGroupWorkResponseDto>({
    url: `/collaborative-group-work/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetCollaborativeGroupWorkQueryKey = (id: number) => {
  return [`/collaborative-group-work/${id}`] as const;
};

export const getGetCollaborativeGroupWorkQueryOptions = <
  TData = Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCollaborativeGroupWorkQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCollaborativeGroupWork>>
  > = ({ signal }) => getCollaborativeGroupWork(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCollaborativeGroupWorkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCollaborativeGroupWork>>
>;
export type GetCollaborativeGroupWorkQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetCollaborativeGroupWork<
  TData = Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCollaborativeGroupWork<
  TData = Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCollaborativeGroupWork<
  TData = Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetCollaborativeGroupWork<
  TData = Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCollaborativeGroupWork>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCollaborativeGroupWorkQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateCollaborativeGroupWork = (
  id: number,
  collaborativeGroupWorkUpdateRequestDto: BodyType<CollaborativeGroupWorkUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/collaborative-group-work/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: collaborativeGroupWorkUpdateRequestDto,
  });
};

export const getUpdateCollaborativeGroupWorkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollaborativeGroupWork>>,
    TError,
    { id: number; data: BodyType<CollaborativeGroupWorkUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCollaborativeGroupWork>>,
  TError,
  { id: number; data: BodyType<CollaborativeGroupWorkUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCollaborativeGroupWork>>,
    { id: number; data: BodyType<CollaborativeGroupWorkUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCollaborativeGroupWork(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCollaborativeGroupWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCollaborativeGroupWork>>
>;
export type UpdateCollaborativeGroupWorkMutationBody =
  BodyType<CollaborativeGroupWorkUpdateRequestDto>;
export type UpdateCollaborativeGroupWorkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateCollaborativeGroupWork = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollaborativeGroupWork>>,
    TError,
    { id: number; data: BodyType<CollaborativeGroupWorkUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCollaborativeGroupWork>>,
  TError,
  { id: number; data: BodyType<CollaborativeGroupWorkUpdateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getUpdateCollaborativeGroupWorkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteCollaborativeGroupWork = (id: number) => {
  return configureAxios<void>({
    url: `/collaborative-group-work/${id}`,
    method: "DELETE",
  });
};

export const getDeleteCollaborativeGroupWorkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollaborativeGroupWork>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCollaborativeGroupWork>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCollaborativeGroupWork>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCollaborativeGroupWork(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCollaborativeGroupWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCollaborativeGroupWork>>
>;

export type DeleteCollaborativeGroupWorkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteCollaborativeGroupWork = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollaborativeGroupWork>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCollaborativeGroupWork>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteCollaborativeGroupWorkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getClassroomManagement = (id: number, signal?: AbortSignal) => {
  return configureAxios<ClassroomManagementResponseDto>({
    url: `/classroom-managements/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomManagementQueryKey = (id: number) => {
  return [`/classroom-managements/${id}`] as const;
};

export const getGetClassroomManagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomManagement>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomManagement>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassroomManagementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomManagement>>
  > = ({ signal }) => getClassroomManagement(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomManagement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomManagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomManagement>>
>;
export type GetClassroomManagementQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassroomManagement<
  TData = Awaited<ReturnType<typeof getClassroomManagement>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomManagement>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomManagement>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomManagement<
  TData = Awaited<ReturnType<typeof getClassroomManagement>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomManagement>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomManagement>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomManagement<
  TData = Awaited<ReturnType<typeof getClassroomManagement>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomManagement>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomManagement<
  TData = Awaited<ReturnType<typeof getClassroomManagement>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomManagement>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomManagementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateClassroomManagement = (
  id: number,
  classroomManagementUpdateRequestDto: BodyType<ClassroomManagementUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/classroom-managements/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: classroomManagementUpdateRequestDto,
  });
};

export const getUpdateClassroomManagementMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClassroomManagement>>,
    TError,
    { id: number; data: BodyType<ClassroomManagementUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClassroomManagement>>,
  TError,
  { id: number; data: BodyType<ClassroomManagementUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClassroomManagement>>,
    { id: number; data: BodyType<ClassroomManagementUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateClassroomManagement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClassroomManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClassroomManagement>>
>;
export type UpdateClassroomManagementMutationBody =
  BodyType<ClassroomManagementUpdateRequestDto>;
export type UpdateClassroomManagementMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateClassroomManagement = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClassroomManagement>>,
    TError,
    { id: number; data: BodyType<ClassroomManagementUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClassroomManagement>>,
  TError,
  { id: number; data: BodyType<ClassroomManagementUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateClassroomManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteClassroomManagement = (id: number) => {
  return configureAxios<void>({
    url: `/classroom-managements/${id}`,
    method: "DELETE",
  });
};

export const getDeleteClassroomManagementMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClassroomManagement>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClassroomManagement>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClassroomManagement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteClassroomManagement(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClassroomManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClassroomManagement>>
>;

export type DeleteClassroomManagementMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteClassroomManagement = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClassroomManagement>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClassroomManagement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteClassroomManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getChoiceBoard = (id: number, signal?: AbortSignal) => {
  return configureAxios<ChoiceBoardResponseDto>({
    url: `/choice-boards/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetChoiceBoardQueryKey = (id: number) => {
  return [`/choice-boards/${id}`] as const;
};

export const getGetChoiceBoardQueryOptions = <
  TData = Awaited<ReturnType<typeof getChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChoiceBoard>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChoiceBoardQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChoiceBoard>>> = ({
    signal,
  }) => getChoiceBoard(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChoiceBoard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetChoiceBoardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChoiceBoard>>
>;
export type GetChoiceBoardQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetChoiceBoard<
  TData = Awaited<ReturnType<typeof getChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChoiceBoard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChoiceBoard>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChoiceBoard<
  TData = Awaited<ReturnType<typeof getChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChoiceBoard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChoiceBoard>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChoiceBoard<
  TData = Awaited<ReturnType<typeof getChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChoiceBoard>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetChoiceBoard<
  TData = Awaited<ReturnType<typeof getChoiceBoard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChoiceBoard>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetChoiceBoardQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateChoiceBoard = (
  id: number,
  choiceBoardUpdateRequestDto: BodyType<ChoiceBoardUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/choice-boards/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: choiceBoardUpdateRequestDto,
  });
};

export const getUpdateChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChoiceBoard>>,
    TError,
    { id: number; data: BodyType<ChoiceBoardUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChoiceBoard>>,
  TError,
  { id: number; data: BodyType<ChoiceBoardUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChoiceBoard>>,
    { id: number; data: BodyType<ChoiceBoardUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateChoiceBoard(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChoiceBoard>>
>;
export type UpdateChoiceBoardMutationBody =
  BodyType<ChoiceBoardUpdateRequestDto>;
export type UpdateChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChoiceBoard>>,
    TError,
    { id: number; data: BodyType<ChoiceBoardUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChoiceBoard>>,
  TError,
  { id: number; data: BodyType<ChoiceBoardUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteChoiceBoard = (id: number) => {
  return configureAxios<void>({
    url: `/choice-boards/${id}`,
    method: "DELETE",
  });
};

export const getDeleteChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChoiceBoard>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteChoiceBoard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChoiceBoard>>
>;

export type DeleteChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getChat = (
  id: number,
  params?: GetChatParams,
  signal?: AbortSignal,
) => {
  return configureAxios<GetChatResponseDto>({
    url: `/chats/${id}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetChatQueryKey = (id: number, params?: GetChatParams) => {
  return [`/chats/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChat>>> = ({
    signal,
  }) => getChat(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChat>>
>;
export type GetChatQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | GetChatParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetChat<
  TData = Awaited<ReturnType<typeof getChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChat>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetChatQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const renameChat = (
  id: number,
  renameChatRequestBodyDto: BodyType<RenameChatRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/chats/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: renameChatRequestBodyDto,
  });
};

export const getRenameChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameChat>>,
    TError,
    { id: number; data: BodyType<RenameChatRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameChat>>,
  TError,
  { id: number; data: BodyType<RenameChatRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameChat>>,
    { id: number; data: BodyType<RenameChatRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return renameChat(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameChat>>
>;
export type RenameChatMutationBody = BodyType<RenameChatRequestBodyDto>;
export type RenameChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useRenameChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameChat>>,
    TError,
    { id: number; data: BodyType<RenameChatRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof renameChat>>,
  TError,
  { id: number; data: BodyType<RenameChatRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getRenameChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteChat = (id: number) => {
  return configureAxios<void>({ url: `/chats/${id}`, method: "DELETE" });
};

export const getDeleteChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChat>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChat>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteChat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChat>>
>;

export type DeleteChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteChat>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateMessage = (
  chatId: number,
  messageId: number,
  updateChatMessageRequestBodyDto: BodyType<UpdateChatMessageRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/chats/${chatId}/messages/${messageId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateChatMessageRequestBodyDto,
  });
};

export const getUpdateMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMessage>>,
    TError,
    {
      chatId: number;
      messageId: number;
      data: BodyType<UpdateChatMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMessage>>,
  TError,
  {
    chatId: number;
    messageId: number;
    data: BodyType<UpdateChatMessageRequestBodyDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMessage>>,
    {
      chatId: number;
      messageId: number;
      data: BodyType<UpdateChatMessageRequestBodyDto>;
    }
  > = (props) => {
    const { chatId, messageId, data } = props ?? {};

    return updateMessage(chatId, messageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMessage>>
>;
export type UpdateMessageMutationBody =
  BodyType<UpdateChatMessageRequestBodyDto>;
export type UpdateMessageMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMessage>>,
    TError,
    {
      chatId: number;
      messageId: number;
      data: BodyType<UpdateChatMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMessage>>,
  TError,
  {
    chatId: number;
    messageId: number;
    data: BodyType<UpdateChatMessageRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions = getUpdateMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeOrDislikeMessage = (
  chatId: number,
  messageId: number,
  likeOrDislikeMessageRequestBodyDto: BodyType<LikeOrDislikeMessageRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/chats/${chatId}/messages/${messageId}/like`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: likeOrDislikeMessageRequestBodyDto,
  });
};

export const getLikeOrDislikeMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeOrDislikeMessage>>,
    TError,
    {
      chatId: number;
      messageId: number;
      data: BodyType<LikeOrDislikeMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeOrDislikeMessage>>,
  TError,
  {
    chatId: number;
    messageId: number;
    data: BodyType<LikeOrDislikeMessageRequestBodyDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeOrDislikeMessage>>,
    {
      chatId: number;
      messageId: number;
      data: BodyType<LikeOrDislikeMessageRequestBodyDto>;
    }
  > = (props) => {
    const { chatId, messageId, data } = props ?? {};

    return likeOrDislikeMessage(chatId, messageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeOrDislikeMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeOrDislikeMessage>>
>;
export type LikeOrDislikeMessageMutationBody =
  BodyType<LikeOrDislikeMessageRequestBodyDto>;
export type LikeOrDislikeMessageMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeOrDislikeMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeOrDislikeMessage>>,
    TError,
    {
      chatId: number;
      messageId: number;
      data: BodyType<LikeOrDislikeMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeOrDislikeMessage>>,
  TError,
  {
    chatId: number;
    messageId: number;
    data: BodyType<LikeOrDislikeMessageRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions = getLikeOrDislikeMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateMessageDidactic = (
  chatId: number,
  messageId: number,
  updateChatMessageRequestBodyDto: BodyType<UpdateChatMessageRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/chats/${chatId}/messages/didactic/${messageId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateChatMessageRequestBodyDto,
  });
};

export const getUpdateMessageDidacticMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMessageDidactic>>,
    TError,
    {
      chatId: number;
      messageId: number;
      data: BodyType<UpdateChatMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMessageDidactic>>,
  TError,
  {
    chatId: number;
    messageId: number;
    data: BodyType<UpdateChatMessageRequestBodyDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMessageDidactic>>,
    {
      chatId: number;
      messageId: number;
      data: BodyType<UpdateChatMessageRequestBodyDto>;
    }
  > = (props) => {
    const { chatId, messageId, data } = props ?? {};

    return updateMessageDidactic(chatId, messageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMessageDidacticMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMessageDidactic>>
>;
export type UpdateMessageDidacticMutationBody =
  BodyType<UpdateChatMessageRequestBodyDto>;
export type UpdateMessageDidacticMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateMessageDidactic = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMessageDidactic>>,
    TError,
    {
      chatId: number;
      messageId: number;
      data: BodyType<UpdateChatMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMessageDidactic>>,
  TError,
  {
    chatId: number;
    messageId: number;
    data: BodyType<UpdateChatMessageRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions = getUpdateMessageDidacticMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateChatHistory = (
  chatId: number,
  updateChatHistoryRequestBodyDto: BodyType<UpdateChatHistoryRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/chats/${chatId}/history`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateChatHistoryRequestBodyDto,
  });
};

export const getUpdateChatHistoryMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChatHistory>>,
    TError,
    { chatId: number; data: BodyType<UpdateChatHistoryRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChatHistory>>,
  TError,
  { chatId: number; data: BodyType<UpdateChatHistoryRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChatHistory>>,
    { chatId: number; data: BodyType<UpdateChatHistoryRequestBodyDto> }
  > = (props) => {
    const { chatId, data } = props ?? {};

    return updateChatHistory(chatId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChatHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChatHistory>>
>;
export type UpdateChatHistoryMutationBody =
  BodyType<UpdateChatHistoryRequestBodyDto>;
export type UpdateChatHistoryMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateChatHistory = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChatHistory>>,
    TError,
    { chatId: number; data: BodyType<UpdateChatHistoryRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChatHistory>>,
  TError,
  { chatId: number; data: BodyType<UpdateChatHistoryRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getUpdateChatHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateDidacticChatConfigStudent = (
  id: number,
  jsonNode: BodyType<JsonNode>,
  params?: UpdateDidacticChatConfigStudentParams,
) => {
  return configureAxios<GetChatResponseDto>({
    url: `/chats/student/didactic/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: jsonNode,
    params,
  });
};

export const getUpdateDidacticChatConfigStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDidacticChatConfigStudent>>,
    TError,
    {
      id: number;
      data: BodyType<JsonNode>;
      params?: UpdateDidacticChatConfigStudentParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDidacticChatConfigStudent>>,
  TError,
  {
    id: number;
    data: BodyType<JsonNode>;
    params?: UpdateDidacticChatConfigStudentParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDidacticChatConfigStudent>>,
    {
      id: number;
      data: BodyType<JsonNode>;
      params?: UpdateDidacticChatConfigStudentParams;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return updateDidacticChatConfigStudent(id, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDidacticChatConfigStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDidacticChatConfigStudent>>
>;
export type UpdateDidacticChatConfigStudentMutationBody = BodyType<JsonNode>;
export type UpdateDidacticChatConfigStudentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateDidacticChatConfigStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDidacticChatConfigStudent>>,
    TError,
    {
      id: number;
      data: BodyType<JsonNode>;
      params?: UpdateDidacticChatConfigStudentParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateDidacticChatConfigStudent>>,
  TError,
  {
    id: number;
    data: BodyType<JsonNode>;
    params?: UpdateDidacticChatConfigStudentParams;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateDidacticChatConfigStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateChatMessageSuggestion = (
  id: number,
  updateChatMessageSuggestionRequestBodyDto: BodyType<UpdateChatMessageSuggestionRequestBodyDto>,
) => {
  return configureAxios<UpdateChatMessageSuggestionResponseDto>({
    url: `/chat-message-suggestions/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateChatMessageSuggestionRequestBodyDto,
  });
};

export const getUpdateChatMessageSuggestionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChatMessageSuggestion>>,
    TError,
    { id: number; data: BodyType<UpdateChatMessageSuggestionRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChatMessageSuggestion>>,
  TError,
  { id: number; data: BodyType<UpdateChatMessageSuggestionRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChatMessageSuggestion>>,
    { id: number; data: BodyType<UpdateChatMessageSuggestionRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateChatMessageSuggestion(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChatMessageSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChatMessageSuggestion>>
>;
export type UpdateChatMessageSuggestionMutationBody =
  BodyType<UpdateChatMessageSuggestionRequestBodyDto>;
export type UpdateChatMessageSuggestionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateChatMessageSuggestion = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChatMessageSuggestion>>,
    TError,
    { id: number; data: BodyType<UpdateChatMessageSuggestionRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChatMessageSuggestion>>,
  TError,
  { id: number; data: BodyType<UpdateChatMessageSuggestionRequestBodyDto> },
  TContext
> => {
  const mutationOptions =
    getUpdateChatMessageSuggestionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteChatMessageSuggestion = (id: number) => {
  return configureAxios<void>({
    url: `/chat-message-suggestions/${id}`,
    method: "DELETE",
  });
};

export const getDeleteChatMessageSuggestionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChatMessageSuggestion>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChatMessageSuggestion>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChatMessageSuggestion>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteChatMessageSuggestion(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChatMessageSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChatMessageSuggestion>>
>;

export type DeleteChatMessageSuggestionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteChatMessageSuggestion = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChatMessageSuggestion>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteChatMessageSuggestion>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteChatMessageSuggestionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getBloomsTaxonomyActivities = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<BloomsTaxonomyActivitiesResponseDto>({
    url: `/blooms-taxonomy-activities/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetBloomsTaxonomyActivitiesQueryKey = (id: number) => {
  return [`/blooms-taxonomy-activities/${id}`] as const;
};

export const getGetBloomsTaxonomyActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBloomsTaxonomyActivitiesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>
  > = ({ signal }) => getBloomsTaxonomyActivities(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBloomsTaxonomyActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>
>;
export type GetBloomsTaxonomyActivitiesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetBloomsTaxonomyActivitiesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateBloomsTaxonomyActivities = (
  id: number,
  bloomsTaxonomyActivitiesUpdateRequestDto: BodyType<BloomsTaxonomyActivitiesUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/blooms-taxonomy-activities/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bloomsTaxonomyActivitiesUpdateRequestDto,
  });
};

export const getUpdateBloomsTaxonomyActivitiesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBloomsTaxonomyActivities>>,
    TError,
    { id: number; data: BodyType<BloomsTaxonomyActivitiesUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBloomsTaxonomyActivities>>,
  TError,
  { id: number; data: BodyType<BloomsTaxonomyActivitiesUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBloomsTaxonomyActivities>>,
    { id: number; data: BodyType<BloomsTaxonomyActivitiesUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBloomsTaxonomyActivities(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBloomsTaxonomyActivitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBloomsTaxonomyActivities>>
>;
export type UpdateBloomsTaxonomyActivitiesMutationBody =
  BodyType<BloomsTaxonomyActivitiesUpdateRequestDto>;
export type UpdateBloomsTaxonomyActivitiesMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateBloomsTaxonomyActivities = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBloomsTaxonomyActivities>>,
    TError,
    { id: number; data: BodyType<BloomsTaxonomyActivitiesUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBloomsTaxonomyActivities>>,
  TError,
  { id: number; data: BodyType<BloomsTaxonomyActivitiesUpdateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getUpdateBloomsTaxonomyActivitiesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteBloomsTaxonomyActivities = (id: number) => {
  return configureAxios<void>({
    url: `/blooms-taxonomy-activities/${id}`,
    method: "DELETE",
  });
};

export const getDeleteBloomsTaxonomyActivitiesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBloomsTaxonomyActivities>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBloomsTaxonomyActivities>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBloomsTaxonomyActivities>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBloomsTaxonomyActivities(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBloomsTaxonomyActivitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBloomsTaxonomyActivities>>
>;

export type DeleteBloomsTaxonomyActivitiesMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteBloomsTaxonomyActivities = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBloomsTaxonomyActivities>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBloomsTaxonomyActivities>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteBloomsTaxonomyActivitiesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getBlog = (id: number, signal?: AbortSignal) => {
  return configureAxios<BlogPostResponseDto>({
    url: `/blogs/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetBlogQueryKey = (id: number) => {
  return [`/blogs/${id}`] as const;
};

export const getGetBlogQueryOptions = <
  TData = Awaited<ReturnType<typeof getBlog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlog>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBlogQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlog>>> = ({
    signal,
  }) => getBlog(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBlog>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetBlogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBlog>>
>;
export type GetBlogQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetBlog<
  TData = Awaited<ReturnType<typeof getBlog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlog>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBlog<
  TData = Awaited<ReturnType<typeof getBlog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlog>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBlog<
  TData = Awaited<ReturnType<typeof getBlog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlog>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetBlog<
  TData = Awaited<ReturnType<typeof getBlog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlog>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetBlogQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateBlog = (
  id: number,
  updateBlogRequestBodyDto: BodyType<UpdateBlogRequestBodyDto>,
) => {
  return configureAxios<void>({
    url: `/blogs/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateBlogRequestBodyDto,
  });
};

export const getUpdateBlogMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBlog>>,
    TError,
    { id: number; data: BodyType<UpdateBlogRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBlog>>,
  TError,
  { id: number; data: BodyType<UpdateBlogRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBlog>>,
    { id: number; data: BodyType<UpdateBlogRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBlog(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBlogMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBlog>>
>;
export type UpdateBlogMutationBody = BodyType<UpdateBlogRequestBodyDto>;
export type UpdateBlogMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateBlog = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBlog>>,
    TError,
    { id: number; data: BodyType<UpdateBlogRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBlog>>,
  TError,
  { id: number; data: BodyType<UpdateBlogRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getUpdateBlogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteBlog = (id: number) => {
  return configureAxios<void>({ url: `/blogs/${id}`, method: "DELETE" });
};

export const getDeleteBlogMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlog>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBlog>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBlog>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBlog(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBlogMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBlog>>
>;

export type DeleteBlogMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteBlog = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlog>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBlog>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteBlogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getArticleGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<ArticleGeneratorResponseDto>({
    url: `/article-generator/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetArticleGeneratorQueryKey = (id: number) => {
  return [`/article-generator/${id}`] as const;
};

export const getGetArticleGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getArticleGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetArticleGeneratorQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getArticleGenerator>>
  > = ({ signal }) => getArticleGenerator(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getArticleGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetArticleGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getArticleGenerator>>
>;
export type GetArticleGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetArticleGenerator<
  TData = Awaited<ReturnType<typeof getArticleGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetArticleGenerator<
  TData = Awaited<ReturnType<typeof getArticleGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetArticleGenerator<
  TData = Awaited<ReturnType<typeof getArticleGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetArticleGenerator<
  TData = Awaited<ReturnType<typeof getArticleGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetArticleGeneratorQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateArticleGenerator = (
  id: number,
  articleGeneratorUpdateRequestDto: BodyType<ArticleGeneratorUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/article-generator/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: articleGeneratorUpdateRequestDto,
  });
};

export const getUpdateArticleGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArticleGenerator>>,
    TError,
    { id: number; data: BodyType<ArticleGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateArticleGenerator>>,
  TError,
  { id: number; data: BodyType<ArticleGeneratorUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateArticleGenerator>>,
    { id: number; data: BodyType<ArticleGeneratorUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateArticleGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateArticleGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateArticleGenerator>>
>;
export type UpdateArticleGeneratorMutationBody =
  BodyType<ArticleGeneratorUpdateRequestDto>;
export type UpdateArticleGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateArticleGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArticleGenerator>>,
    TError,
    { id: number; data: BodyType<ArticleGeneratorUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateArticleGenerator>>,
  TError,
  { id: number; data: BodyType<ArticleGeneratorUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateArticleGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteArticleGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/article-generator/${id}`,
    method: "DELETE",
  });
};

export const getDeleteArticleGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteArticleGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteArticleGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteArticleGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteArticleGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteArticleGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteArticleGenerator>>
>;

export type DeleteArticleGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteArticleGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteArticleGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteArticleGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteArticleGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getLoggedinAnonymous = (signal?: AbortSignal) => {
  return configureAxios<AnonymousResponseDto>({
    url: `/anonymous/me`,
    method: "GET",
    signal,
  });
};

export const getGetLoggedinAnonymousQueryKey = () => {
  return [`/anonymous/me`] as const;
};

export const getGetLoggedinAnonymousQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoggedinAnonymous>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinAnonymous>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoggedinAnonymousQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoggedinAnonymous>>
  > = ({ signal }) => getLoggedinAnonymous(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoggedinAnonymous>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLoggedinAnonymousQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoggedinAnonymous>>
>;
export type GetLoggedinAnonymousQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLoggedinAnonymous<
  TData = Awaited<ReturnType<typeof getLoggedinAnonymous>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinAnonymous>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedinAnonymous>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLoggedinAnonymous<
  TData = Awaited<ReturnType<typeof getLoggedinAnonymous>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinAnonymous>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedinAnonymous>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLoggedinAnonymous<
  TData = Awaited<ReturnType<typeof getLoggedinAnonymous>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinAnonymous>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLoggedinAnonymous<
  TData = Awaited<ReturnType<typeof getLoggedinAnonymous>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinAnonymous>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLoggedinAnonymousQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateMe = (
  updateAnonymousUserMeBodyDto: BodyType<UpdateAnonymousUserMeBodyDto>,
) => {
  return configureAxios<AnonymousResponseDto>({
    url: `/anonymous/me`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateAnonymousUserMeBodyDto,
  });
};

export const getUpdateMeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    { data: BodyType<UpdateAnonymousUserMeBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: BodyType<UpdateAnonymousUserMeBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMe>>,
    { data: BodyType<UpdateAnonymousUserMeBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMe>>
>;
export type UpdateMeMutationBody = BodyType<UpdateAnonymousUserMeBodyDto>;
export type UpdateMeMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateMe = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMe>>,
    TError,
    { data: BodyType<UpdateAnonymousUserMeBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMe>>,
  TError,
  { data: BodyType<UpdateAnonymousUserMeBodyDto> },
  TContext
> => {
  const mutationOptions = getUpdateMeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAiSupportedTasks = (id: number, signal?: AbortSignal) => {
  return configureAxios<AiSupportedTasksResponseDto>({
    url: `/ai-supported-tasks/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAiSupportedTasksQueryKey = (id: number) => {
  return [`/ai-supported-tasks/${id}`] as const;
};

export const getGetAiSupportedTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiSupportedTasksQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiSupportedTasks>>
  > = ({ signal }) => getAiSupportedTasks(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiSupportedTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAiSupportedTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiSupportedTasks>>
>;
export type GetAiSupportedTasksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAiSupportedTasksQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAiSupportedTasks = (
  id: number,
  aiSupportedTasksUpdateRequestDto: BodyType<AiSupportedTasksUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/ai-supported-tasks/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiSupportedTasksUpdateRequestDto,
  });
};

export const getUpdateAiSupportedTasksMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiSupportedTasks>>,
    TError,
    { id: number; data: BodyType<AiSupportedTasksUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAiSupportedTasks>>,
  TError,
  { id: number; data: BodyType<AiSupportedTasksUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAiSupportedTasks>>,
    { id: number; data: BodyType<AiSupportedTasksUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAiSupportedTasks(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAiSupportedTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAiSupportedTasks>>
>;
export type UpdateAiSupportedTasksMutationBody =
  BodyType<AiSupportedTasksUpdateRequestDto>;
export type UpdateAiSupportedTasksMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateAiSupportedTasks = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiSupportedTasks>>,
    TError,
    { id: number; data: BodyType<AiSupportedTasksUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAiSupportedTasks>>,
  TError,
  { id: number; data: BodyType<AiSupportedTasksUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateAiSupportedTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAiSupportedTasks = (id: number) => {
  return configureAxios<void>({
    url: `/ai-supported-tasks/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAiSupportedTasksMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiSupportedTasks>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAiSupportedTasks>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAiSupportedTasks>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAiSupportedTasks(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAiSupportedTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAiSupportedTasks>>
>;

export type DeleteAiSupportedTasksMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteAiSupportedTasks = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiSupportedTasks>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAiSupportedTasks>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAiSupportedTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAiResistantHomework = (id: number, signal?: AbortSignal) => {
  return configureAxios<AiResistantHomeworkResponseDto>({
    url: `/ai-resistant-homework/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAiResistantHomeworkQueryKey = (id: number) => {
  return [`/ai-resistant-homework/${id}`] as const;
};

export const getGetAiResistantHomeworkQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAiResistantHomeworkQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiResistantHomework>>
  > = ({ signal }) => getAiResistantHomework(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiResistantHomework>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAiResistantHomeworkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiResistantHomework>>
>;
export type GetAiResistantHomeworkQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAiResistantHomework<
  TData = Awaited<ReturnType<typeof getAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiResistantHomework<
  TData = Awaited<ReturnType<typeof getAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAiResistantHomework<
  TData = Awaited<ReturnType<typeof getAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAiResistantHomework<
  TData = Awaited<ReturnType<typeof getAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAiResistantHomeworkQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAiResistantHomework = (
  id: number,
  aiResistantHomeworkUpdateRequestDto: BodyType<AiResistantHomeworkUpdateRequestDto>,
) => {
  return configureAxios<AiResistantHomeworkResponseDto>({
    url: `/ai-resistant-homework/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiResistantHomeworkUpdateRequestDto,
  });
};

export const getUpdateAiResistantHomeworkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiResistantHomework>>,
    TError,
    { id: number; data: BodyType<AiResistantHomeworkUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAiResistantHomework>>,
  TError,
  { id: number; data: BodyType<AiResistantHomeworkUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAiResistantHomework>>,
    { id: number; data: BodyType<AiResistantHomeworkUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAiResistantHomework(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAiResistantHomeworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAiResistantHomework>>
>;
export type UpdateAiResistantHomeworkMutationBody =
  BodyType<AiResistantHomeworkUpdateRequestDto>;
export type UpdateAiResistantHomeworkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateAiResistantHomework = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiResistantHomework>>,
    TError,
    { id: number; data: BodyType<AiResistantHomeworkUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAiResistantHomework>>,
  TError,
  { id: number; data: BodyType<AiResistantHomeworkUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateAiResistantHomeworkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAiResistantHomework = (id: number) => {
  return configureAxios<void>({
    url: `/ai-resistant-homework/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAiResistantHomeworkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiResistantHomework>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAiResistantHomework>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAiResistantHomework>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAiResistantHomework(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAiResistantHomeworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAiResistantHomework>>
>;

export type DeleteAiResistantHomeworkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteAiResistantHomework = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiResistantHomework>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAiResistantHomework>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAiResistantHomeworkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAiAssignment = (id: number, signal?: AbortSignal) => {
  return configureAxios<AiAssignmentResponseDto>({
    url: `/ai-assignment-designer/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAiAssignmentQueryKey = (id: number) => {
  return [`/ai-assignment-designer/${id}`] as const;
};

export const getGetAiAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssignment>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiAssignmentQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAssignment>>> = ({
    signal,
  }) => getAiAssignment(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAiAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiAssignment>>
>;
export type GetAiAssignmentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAiAssignment<
  TData = Awaited<ReturnType<typeof getAiAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiAssignment<
  TData = Awaited<ReturnType<typeof getAiAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAiAssignment<
  TData = Awaited<ReturnType<typeof getAiAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAiAssignment<
  TData = Awaited<ReturnType<typeof getAiAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAiAssignmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAiAssignment = (
  id: number,
  aiAssignmentUpdateRequestDto: BodyType<AiAssignmentUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/ai-assignment-designer/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiAssignmentUpdateRequestDto,
  });
};

export const getUpdateAiAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiAssignment>>,
    TError,
    { id: number; data: BodyType<AiAssignmentUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAiAssignment>>,
  TError,
  { id: number; data: BodyType<AiAssignmentUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAiAssignment>>,
    { id: number; data: BodyType<AiAssignmentUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAiAssignment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAiAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAiAssignment>>
>;
export type UpdateAiAssignmentMutationBody =
  BodyType<AiAssignmentUpdateRequestDto>;
export type UpdateAiAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useUpdateAiAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiAssignment>>,
    TError,
    { id: number; data: BodyType<AiAssignmentUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAiAssignment>>,
  TError,
  { id: number; data: BodyType<AiAssignmentUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateAiAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAiAssignment = (id: number) => {
  return configureAxios<void>({
    url: `/ai-assignment-designer/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAiAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAiAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAiAssignment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAiAssignment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAiAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAiAssignment>>
>;

export type DeleteAiAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteAiAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAiAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAiAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAiAssessmentScale = (id: number, signal?: AbortSignal) => {
  return configureAxios<AiAssessmentScaleResponseDto>({
    url: `/ai-assessment-scale/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAiAssessmentScaleQueryKey = (id: number) => {
  return [`/ai-assessment-scale/${id}`] as const;
};

export const getGetAiAssessmentScaleQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiAssessmentScale>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssessmentScale>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAiAssessmentScaleQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiAssessmentScale>>
  > = ({ signal }) => getAiAssessmentScale(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiAssessmentScale>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAiAssessmentScaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiAssessmentScale>>
>;
export type GetAiAssessmentScaleQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAiAssessmentScale<
  TData = Awaited<ReturnType<typeof getAiAssessmentScale>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssessmentScale>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAssessmentScale>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiAssessmentScale<
  TData = Awaited<ReturnType<typeof getAiAssessmentScale>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssessmentScale>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAssessmentScale>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAiAssessmentScale<
  TData = Awaited<ReturnType<typeof getAiAssessmentScale>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssessmentScale>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAiAssessmentScale<
  TData = Awaited<ReturnType<typeof getAiAssessmentScale>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiAssessmentScale>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAiAssessmentScaleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAiAssessmentScale = (
  id: number,
  aiAssessmentScaleUpdateRequestDto: BodyType<AiAssessmentScaleUpdateRequestDto>,
) => {
  return configureAxios<void>({
    url: `/ai-assessment-scale/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: aiAssessmentScaleUpdateRequestDto,
  });
};

export const getUpdateAiAssessmentScaleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiAssessmentScale>>,
    TError,
    { id: number; data: BodyType<AiAssessmentScaleUpdateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAiAssessmentScale>>,
  TError,
  { id: number; data: BodyType<AiAssessmentScaleUpdateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAiAssessmentScale>>,
    { id: number; data: BodyType<AiAssessmentScaleUpdateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAiAssessmentScale(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAiAssessmentScaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAiAssessmentScale>>
>;
export type UpdateAiAssessmentScaleMutationBody =
  BodyType<AiAssessmentScaleUpdateRequestDto>;
export type UpdateAiAssessmentScaleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUpdateAiAssessmentScale = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAiAssessmentScale>>,
    TError,
    { id: number; data: BodyType<AiAssessmentScaleUpdateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAiAssessmentScale>>,
  TError,
  { id: number; data: BodyType<AiAssessmentScaleUpdateRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateAiAssessmentScaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteAiAssessmentScale = (id: number) => {
  return configureAxios<void>({
    url: `/ai-assessment-scale/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAiAssessmentScaleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiAssessmentScale>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAiAssessmentScale>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAiAssessmentScale>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAiAssessmentScale(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAiAssessmentScaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAiAssessmentScale>>
>;

export type DeleteAiAssessmentScaleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteAiAssessmentScale = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAiAssessmentScale>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAiAssessmentScale>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAiAssessmentScaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const synthesizeTextGoogle = (
  synthesizeRequestBody: BodyType<SynthesizeRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/webhooks/tts/synthesize`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: synthesizeRequestBody,
    signal,
  });
};

export const getSynthesizeTextGoogleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextGoogle>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof synthesizeTextGoogle>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof synthesizeTextGoogle>>,
    { data: BodyType<SynthesizeRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return synthesizeTextGoogle(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SynthesizeTextGoogleMutationResult = NonNullable<
  Awaited<ReturnType<typeof synthesizeTextGoogle>>
>;
export type SynthesizeTextGoogleMutationBody = BodyType<SynthesizeRequestBody>;
export type SynthesizeTextGoogleMutationError = ErrorType<BaseErrorResponseDto>;

export const useSynthesizeTextGoogle = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextGoogle>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof synthesizeTextGoogle>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const mutationOptions = getSynthesizeTextGoogleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const synthesizeTextOpenai = (
  synthesizeRequestBody: BodyType<SynthesizeRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/webhooks/tts/synthesize/openai`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: synthesizeRequestBody,
    signal,
  });
};

export const getSynthesizeTextOpenaiMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextOpenai>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof synthesizeTextOpenai>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof synthesizeTextOpenai>>,
    { data: BodyType<SynthesizeRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return synthesizeTextOpenai(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SynthesizeTextOpenaiMutationResult = NonNullable<
  Awaited<ReturnType<typeof synthesizeTextOpenai>>
>;
export type SynthesizeTextOpenaiMutationBody = BodyType<SynthesizeRequestBody>;
export type SynthesizeTextOpenaiMutationError = ErrorType<BaseErrorResponseDto>;

export const useSynthesizeTextOpenai = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextOpenai>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof synthesizeTextOpenai>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const mutationOptions = getSynthesizeTextOpenaiMutationOptions(options);

  return useMutation(mutationOptions);
};

export const saveAIMessageToTeacherToolChat = (
  id: number,
  teacherToolChatSendMessageWebhookRequestDto: BodyType<TeacherToolChatSendMessageWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/teacher-tool-chat/${id}/message`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: teacherToolChatSendMessageWebhookRequestDto,
    signal,
  });
};

export const getSaveAIMessageToTeacherToolChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAIMessageToTeacherToolChat>>,
    TError,
    { id: number; data: BodyType<TeacherToolChatSendMessageWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveAIMessageToTeacherToolChat>>,
  TError,
  { id: number; data: BodyType<TeacherToolChatSendMessageWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveAIMessageToTeacherToolChat>>,
    { id: number; data: BodyType<TeacherToolChatSendMessageWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return saveAIMessageToTeacherToolChat(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveAIMessageToTeacherToolChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveAIMessageToTeacherToolChat>>
>;
export type SaveAIMessageToTeacherToolChatMutationBody =
  BodyType<TeacherToolChatSendMessageWebhookRequestDto>;
export type SaveAIMessageToTeacherToolChatMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSaveAIMessageToTeacherToolChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAIMessageToTeacherToolChat>>,
    TError,
    { id: number; data: BodyType<TeacherToolChatSendMessageWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveAIMessageToTeacherToolChat>>,
  TError,
  { id: number; data: BodyType<TeacherToolChatSendMessageWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getSaveAIMessageToTeacherToolChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const teacherChatSaveAITitle = (
  id: number,
  teacherChatUpdateTitleWebhookRequestDto: BodyType<TeacherChatUpdateTitleWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/teacher-chat/${id}/title`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: teacherChatUpdateTitleWebhookRequestDto,
    signal,
  });
};

export const getTeacherChatSaveAITitleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof teacherChatSaveAITitle>>,
    TError,
    { id: number; data: BodyType<TeacherChatUpdateTitleWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof teacherChatSaveAITitle>>,
  TError,
  { id: number; data: BodyType<TeacherChatUpdateTitleWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof teacherChatSaveAITitle>>,
    { id: number; data: BodyType<TeacherChatUpdateTitleWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return teacherChatSaveAITitle(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TeacherChatSaveAITitleMutationResult = NonNullable<
  Awaited<ReturnType<typeof teacherChatSaveAITitle>>
>;
export type TeacherChatSaveAITitleMutationBody =
  BodyType<TeacherChatUpdateTitleWebhookRequestDto>;
export type TeacherChatSaveAITitleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useTeacherChatSaveAITitle = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof teacherChatSaveAITitle>>,
    TError,
    { id: number; data: BodyType<TeacherChatUpdateTitleWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof teacherChatSaveAITitle>>,
  TError,
  { id: number; data: BodyType<TeacherChatUpdateTitleWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getTeacherChatSaveAITitleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const teacherChatSaveAIMessage = (
  id: number,
  teacherChatSendMessageWebhookRequestDto: BodyType<TeacherChatSendMessageWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/teacher-chat/${id}/message`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: teacherChatSendMessageWebhookRequestDto,
    signal,
  });
};

export const getTeacherChatSaveAIMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof teacherChatSaveAIMessage>>,
    TError,
    { id: number; data: BodyType<TeacherChatSendMessageWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof teacherChatSaveAIMessage>>,
  TError,
  { id: number; data: BodyType<TeacherChatSendMessageWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof teacherChatSaveAIMessage>>,
    { id: number; data: BodyType<TeacherChatSendMessageWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return teacherChatSaveAIMessage(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TeacherChatSaveAIMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof teacherChatSaveAIMessage>>
>;
export type TeacherChatSaveAIMessageMutationBody =
  BodyType<TeacherChatSendMessageWebhookRequestDto>;
export type TeacherChatSaveAIMessageMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useTeacherChatSaveAIMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof teacherChatSaveAIMessage>>,
    TError,
    { id: number; data: BodyType<TeacherChatSendMessageWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof teacherChatSaveAIMessage>>,
  TError,
  { id: number; data: BodyType<TeacherChatSendMessageWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getTeacherChatSaveAIMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleWebhook = (
  id: number,
  visualMatchingWebhookRequestDto: BodyType<VisualMatchingWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/swann-visual-matching/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: visualMatchingWebhookRequestDto,
    signal,
  });
};

export const getHandleWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleWebhook>>,
    TError,
    { id: number; data: BodyType<VisualMatchingWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleWebhook>>,
  TError,
  { id: number; data: BodyType<VisualMatchingWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleWebhook>>,
    { id: number; data: BodyType<VisualMatchingWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleWebhook>>
>;
export type HandleWebhookMutationBody =
  BodyType<VisualMatchingWebhookRequestDto>;
export type HandleWebhookMutationError = ErrorType<BaseErrorResponseDto>;

export const useHandleWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleWebhook>>,
    TError,
    { id: number; data: BodyType<VisualMatchingWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleWebhook>>,
  TError,
  { id: number; data: BodyType<VisualMatchingWebhookRequestDto> },
  TContext
> => {
  const mutationOptions = getHandleWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleSpokenDialogueWebhook = (
  id: number,
  spokenDialogueWebhookRequestDto: BodyType<SpokenDialogueWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/swann-spoken-dialogue/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: spokenDialogueWebhookRequestDto,
    signal,
  });
};

export const getHandleSpokenDialogueWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSpokenDialogueWebhook>>,
    TError,
    { id: number; data: BodyType<SpokenDialogueWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleSpokenDialogueWebhook>>,
  TError,
  { id: number; data: BodyType<SpokenDialogueWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleSpokenDialogueWebhook>>,
    { id: number; data: BodyType<SpokenDialogueWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleSpokenDialogueWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleSpokenDialogueWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleSpokenDialogueWebhook>>
>;
export type HandleSpokenDialogueWebhookMutationBody =
  BodyType<SpokenDialogueWebhookRequestDto>;
export type HandleSpokenDialogueWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleSpokenDialogueWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleSpokenDialogueWebhook>>,
    TError,
    { id: number; data: BodyType<SpokenDialogueWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleSpokenDialogueWebhook>>,
  TError,
  { id: number; data: BodyType<SpokenDialogueWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleSpokenDialogueWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleRevenueCatNotification = (
  handleRevenueCatNotificationBody: BodyType<string>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/webhooks/revenuecat`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: handleRevenueCatNotificationBody,
    signal,
  });
};

export const getHandleRevenueCatNotificationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleRevenueCatNotification>>,
    TError,
    { data: BodyType<string> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleRevenueCatNotification>>,
  TError,
  { data: BodyType<string> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleRevenueCatNotification>>,
    { data: BodyType<string> }
  > = (props) => {
    const { data } = props ?? {};

    return handleRevenueCatNotification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleRevenueCatNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleRevenueCatNotification>>
>;
export type HandleRevenueCatNotificationMutationBody = BodyType<string>;
export type HandleRevenueCatNotificationMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleRevenueCatNotification = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleRevenueCatNotification>>,
    TError,
    { data: BodyType<string> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleRevenueCatNotification>>,
  TError,
  { data: BodyType<string> },
  TContext
> => {
  const mutationOptions =
    getHandleRevenueCatNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleQuestionHelperWebhook = (
  id: number,
  questionHelperWebhookRequestDto: BodyType<QuestionHelperWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/question-helper/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: questionHelperWebhookRequestDto,
    signal,
  });
};

export const getHandleQuestionHelperWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleQuestionHelperWebhook>>,
    TError,
    { id: number; data: BodyType<QuestionHelperWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleQuestionHelperWebhook>>,
  TError,
  { id: number; data: BodyType<QuestionHelperWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleQuestionHelperWebhook>>,
    { id: number; data: BodyType<QuestionHelperWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleQuestionHelperWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleQuestionHelperWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleQuestionHelperWebhook>>
>;
export type HandleQuestionHelperWebhookMutationBody =
  BodyType<QuestionHelperWebhookRequestDto>;
export type HandleQuestionHelperWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleQuestionHelperWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleQuestionHelperWebhook>>,
    TError,
    { id: number; data: BodyType<QuestionHelperWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleQuestionHelperWebhook>>,
  TError,
  { id: number; data: BodyType<QuestionHelperWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleQuestionHelperWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleGooglePlayNotification = (
  projectName: BodyType<string>,
  topicId: string,
  handleGooglePlayNotificationBody: string,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/webhooks/play_store/${projectName}/topics/${topicId}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: handleGooglePlayNotificationBody,
    signal,
  });
};

export const getHandleGooglePlayNotificationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleGooglePlayNotification>>,
    TError,
    { projectName: string; topicId: string; data: BodyType<string> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleGooglePlayNotification>>,
  TError,
  { projectName: string; topicId: string; data: BodyType<string> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleGooglePlayNotification>>,
    { projectName: string; topicId: string; data: BodyType<string> }
  > = (props) => {
    const { projectName, topicId, data } = props ?? {};

    return handleGooglePlayNotification(projectName, topicId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleGooglePlayNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleGooglePlayNotification>>
>;
export type HandleGooglePlayNotificationMutationBody = BodyType<string>;
export type HandleGooglePlayNotificationMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleGooglePlayNotification = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleGooglePlayNotification>>,
    TError,
    { projectName: string; topicId: string; data: BodyType<string> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleGooglePlayNotification>>,
  TError,
  { projectName: string; topicId: string; data: BodyType<string> },
  TContext
> => {
  const mutationOptions =
    getHandleGooglePlayNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const singleEssayGraderChatSaveAIMessage = (
  id: number,
  createEssayGraderChatMessageRequestBodyDto: BodyType<CreateEssayGraderChatMessageRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/essay-grader-single-chat/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEssayGraderChatMessageRequestBodyDto,
    signal,
  });
};

export const getSingleEssayGraderChatSaveAIMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof singleEssayGraderChatSaveAIMessage>>,
    TError,
    { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof singleEssayGraderChatSaveAIMessage>>,
  TError,
  { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof singleEssayGraderChatSaveAIMessage>>,
    { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return singleEssayGraderChatSaveAIMessage(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SingleEssayGraderChatSaveAIMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof singleEssayGraderChatSaveAIMessage>>
>;
export type SingleEssayGraderChatSaveAIMessageMutationBody =
  BodyType<CreateEssayGraderChatMessageRequestBodyDto>;
export type SingleEssayGraderChatSaveAIMessageMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSingleEssayGraderChatSaveAIMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof singleEssayGraderChatSaveAIMessage>>,
    TError,
    { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof singleEssayGraderChatSaveAIMessage>>,
  TError,
  { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
  TContext
> => {
  const mutationOptions =
    getSingleEssayGraderChatSaveAIMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const essayGraderChatSaveAIMessage = (
  id: number,
  createEssayGraderChatMessageRequestBodyDto: BodyType<CreateEssayGraderChatMessageRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/webhooks/essay-grader-chat/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEssayGraderChatMessageRequestBodyDto,
    signal,
  });
};

export const getEssayGraderChatSaveAIMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayGraderChatSaveAIMessage>>,
    TError,
    { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof essayGraderChatSaveAIMessage>>,
  TError,
  { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof essayGraderChatSaveAIMessage>>,
    { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return essayGraderChatSaveAIMessage(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EssayGraderChatSaveAIMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof essayGraderChatSaveAIMessage>>
>;
export type EssayGraderChatSaveAIMessageMutationBody =
  BodyType<CreateEssayGraderChatMessageRequestBodyDto>;
export type EssayGraderChatSaveAIMessageMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEssayGraderChatSaveAIMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof essayGraderChatSaveAIMessage>>,
    TError,
    { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof essayGraderChatSaveAIMessage>>,
  TError,
  { id: number; data: BodyType<CreateEssayGraderChatMessageRequestBodyDto> },
  TContext
> => {
  const mutationOptions =
    getEssayGraderChatSaveAIMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleAppStoreNotification = (
  topicId: BodyType<string>,
  handleAppStoreNotificationBody: string,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/webhooks/apple/${topicId}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: handleAppStoreNotificationBody,
    signal,
  });
};

export const getHandleAppStoreNotificationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAppStoreNotification>>,
    TError,
    { topicId: string; data: BodyType<string> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleAppStoreNotification>>,
  TError,
  { topicId: string; data: BodyType<string> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleAppStoreNotification>>,
    { topicId: string; data: BodyType<string> }
  > = (props) => {
    const { topicId, data } = props ?? {};

    return handleAppStoreNotification(topicId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleAppStoreNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleAppStoreNotification>>
>;
export type HandleAppStoreNotificationMutationBody = BodyType<string>;
export type HandleAppStoreNotificationMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleAppStoreNotification = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleAppStoreNotification>>,
    TError,
    { topicId: string; data: BodyType<string> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleAppStoreNotification>>,
  TError,
  { topicId: string; data: BodyType<string> },
  TContext
> => {
  const mutationOptions = getHandleAppStoreNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createVocabularyList = (
  vocabularyListCreateRequestDto: BodyType<VocabularyListCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<VocabularyListResponseDto>({
    url: `/vocabulary-lists`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: vocabularyListCreateRequestDto,
    signal,
  });
};

export const getCreateVocabularyListMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVocabularyList>>,
    TError,
    { data: BodyType<VocabularyListCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVocabularyList>>,
  TError,
  { data: BodyType<VocabularyListCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVocabularyList>>,
    { data: BodyType<VocabularyListCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createVocabularyList(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVocabularyListMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVocabularyList>>
>;
export type CreateVocabularyListMutationBody =
  BodyType<VocabularyListCreateRequestDto>;
export type CreateVocabularyListMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateVocabularyList = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVocabularyList>>,
    TError,
    { data: BodyType<VocabularyListCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVocabularyList>>,
  TError,
  { data: BodyType<VocabularyListCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateVocabularyListMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateVocabularyList = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<VocabularyListResponseDto>({
    url: `/vocabulary-lists/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateVocabularyListMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateVocabularyList>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateVocabularyList>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateVocabularyList>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateVocabularyList(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateVocabularyListMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateVocabularyList>>
>;
export type RegenerateVocabularyListMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateVocabularyListMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateVocabularyList = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateVocabularyList>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateVocabularyList>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateVocabularyListMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeVocabularyList = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/vocabulary-lists/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeVocabularyListMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeVocabularyList>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeVocabularyList>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeVocabularyList>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeVocabularyList(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeVocabularyListMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeVocabularyList>>
>;

export type LikeVocabularyListMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeVocabularyList = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeVocabularyList>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeVocabularyList>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeVocabularyListMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeVocabularyList = (id: number) => {
  return configureAxios<void>({
    url: `/vocabulary-lists/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeVocabularyListMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeVocabularyList>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeVocabularyList>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeVocabularyList>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeVocabularyList(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeVocabularyListMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeVocabularyList>>
>;

export type UnlikeVocabularyListMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeVocabularyList = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeVocabularyList>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeVocabularyList>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeVocabularyListMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createVideoAvatar = (
  videoAvatarCreateRequestDto: BodyType<VideoAvatarCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<VideoAvatarResponseDto>({
    url: `/video-avatar`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: videoAvatarCreateRequestDto,
    signal,
  });
};

export const getCreateVideoAvatarMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVideoAvatar>>,
    TError,
    { data: BodyType<VideoAvatarCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVideoAvatar>>,
  TError,
  { data: BodyType<VideoAvatarCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVideoAvatar>>,
    { data: BodyType<VideoAvatarCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createVideoAvatar(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVideoAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVideoAvatar>>
>;
export type CreateVideoAvatarMutationBody =
  BodyType<VideoAvatarCreateRequestDto>;
export type CreateVideoAvatarMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateVideoAvatar = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVideoAvatar>>,
    TError,
    { data: BodyType<VideoAvatarCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVideoAvatar>>,
  TError,
  { data: BodyType<VideoAvatarCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateVideoAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateVideoAvatar = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<VideoAvatarResponseDto>({
    url: `/video-avatar/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateVideoAvatarMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateVideoAvatar>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateVideoAvatar>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateVideoAvatar>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateVideoAvatar(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateVideoAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateVideoAvatar>>
>;
export type RegenerateVideoAvatarMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateVideoAvatarMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateVideoAvatar = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateVideoAvatar>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateVideoAvatar>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateVideoAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeVideoAvatar = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/video-avatar/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeVideoAvatarMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeVideoAvatar>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeVideoAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeVideoAvatar>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeVideoAvatar(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeVideoAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeVideoAvatar>>
>;

export type LikeVideoAvatarMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeVideoAvatar = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeVideoAvatar>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeVideoAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeVideoAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeVideoAvatar = (id: number) => {
  return configureAxios<void>({
    url: `/video-avatar/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeVideoAvatarMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeVideoAvatar>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeVideoAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeVideoAvatar>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeVideoAvatar(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeVideoAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeVideoAvatar>>
>;

export type UnlikeVideoAvatarMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeVideoAvatar = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeVideoAvatar>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeVideoAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeVideoAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};

export const addTagToUser = (
  userId: number,
  addTagRequestDto: BodyType<AddTagRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/users/${userId}/tags`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addTagRequestDto,
    signal,
  });
};

export const getAddTagToUserMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTagToUser>>,
    TError,
    { userId: number; data: BodyType<AddTagRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addTagToUser>>,
  TError,
  { userId: number; data: BodyType<AddTagRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addTagToUser>>,
    { userId: number; data: BodyType<AddTagRequestDto> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return addTagToUser(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTagToUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTagToUser>>
>;
export type AddTagToUserMutationBody = BodyType<AddTagRequestDto>;
export type AddTagToUserMutationError = ErrorType<BaseErrorResponseDto>;

export const useAddTagToUser = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTagToUser>>,
    TError,
    { userId: number; data: BodyType<AddTagRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addTagToUser>>,
  TError,
  { userId: number; data: BodyType<AddTagRequestDto> },
  TContext
> => {
  const mutationOptions = getAddTagToUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeTagFromUser = (
  userId: number,
  addTagRequestDto: BodyType<AddTagRequestDto>,
) => {
  return configureAxios<void>({
    url: `/users/${userId}/tags`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: addTagRequestDto,
  });
};

export const getRemoveTagFromUserMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTagFromUser>>,
    TError,
    { userId: number; data: BodyType<AddTagRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeTagFromUser>>,
  TError,
  { userId: number; data: BodyType<AddTagRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeTagFromUser>>,
    { userId: number; data: BodyType<AddTagRequestDto> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return removeTagFromUser(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTagFromUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeTagFromUser>>
>;
export type RemoveTagFromUserMutationBody = BodyType<AddTagRequestDto>;
export type RemoveTagFromUserMutationError = ErrorType<BaseErrorResponseDto>;

export const useRemoveTagFromUser = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTagFromUser>>,
    TError,
    { userId: number; data: BodyType<AddTagRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeTagFromUser>>,
  TError,
  { userId: number; data: BodyType<AddTagRequestDto> },
  TContext
> => {
  const mutationOptions = getRemoveTagFromUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendSubscriptionEmail = (signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/users/subscriptions/subscription-email`,
    method: "POST",
    signal,
  });
};

export const getSendSubscriptionEmailMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSubscriptionEmail>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendSubscriptionEmail>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendSubscriptionEmail>>,
    void
  > = () => {
    return sendSubscriptionEmail();
  };

  return { mutationFn, ...mutationOptions };
};

export type SendSubscriptionEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendSubscriptionEmail>>
>;

export type SendSubscriptionEmailMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSendSubscriptionEmail = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSubscriptionEmail>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendSubscriptionEmail>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSendSubscriptionEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

export const activateInternalCode = (
  params: ActivateInternalCodeParams,
  signal?: AbortSignal,
) => {
  return configureAxios<JsonNode>({
    url: `/users/subscriptions/activateInternalCode`,
    method: "POST",
    params,
    signal,
  });
};

export const getActivateInternalCodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateInternalCode>>,
    TError,
    { params: ActivateInternalCodeParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateInternalCode>>,
  TError,
  { params: ActivateInternalCodeParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateInternalCode>>,
    { params: ActivateInternalCodeParams }
  > = (props) => {
    const { params } = props ?? {};

    return activateInternalCode(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateInternalCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateInternalCode>>
>;

export type ActivateInternalCodeMutationError = ErrorType<BaseErrorResponseDto>;

export const useActivateInternalCode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateInternalCode>>,
    TError,
    { params: ActivateInternalCodeParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof activateInternalCode>>,
  TError,
  { params: ActivateInternalCodeParams },
  TContext
> => {
  const mutationOptions = getActivateInternalCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const activateCode = (
  params: ActivateCodeParams,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/users/subscriptions/activateCode`,
    method: "POST",
    params,
    signal,
  });
};

export const getActivateCodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateCode>>,
    TError,
    { params: ActivateCodeParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateCode>>,
  TError,
  { params: ActivateCodeParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateCode>>,
    { params: ActivateCodeParams }
  > = (props) => {
    const { params } = props ?? {};

    return activateCode(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateCode>>
>;

export type ActivateCodeMutationError = ErrorType<BaseErrorResponseDto>;

export const useActivateCode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateCode>>,
    TError,
    { params: ActivateCodeParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof activateCode>>,
  TError,
  { params: ActivateCodeParams },
  TContext
> => {
  const mutationOptions = getActivateCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const loginWithName = (
  loginWithNameRequestDto: BodyType<LoginWithNameRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<FirebaseLoginResponseDto>({
    url: `/users/loginWithName`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginWithNameRequestDto,
    signal,
  });
};

export const getLoginWithNameMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithName>>,
    TError,
    { data: BodyType<LoginWithNameRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginWithName>>,
  TError,
  { data: BodyType<LoginWithNameRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginWithName>>,
    { data: BodyType<LoginWithNameRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return loginWithName(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginWithNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginWithName>>
>;
export type LoginWithNameMutationBody = BodyType<LoginWithNameRequestDto>;
export type LoginWithNameMutationError = ErrorType<BaseErrorResponseDto>;

export const useLoginWithName = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithName>>,
    TError,
    { data: BodyType<LoginWithNameRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginWithName>>,
  TError,
  { data: BodyType<LoginWithNameRequestDto> },
  TContext
> => {
  const mutationOptions = getLoginWithNameMutationOptions(options);

  return useMutation(mutationOptions);
};

export const firebaseLogin = (
  authFirebaseLoginRequestBodyDto: BodyType<AuthFirebaseLoginRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<FirebaseLoginResponseDto>({
    url: `/users/firebase`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: authFirebaseLoginRequestBodyDto,
    signal,
  });
};

export const getFirebaseLoginMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof firebaseLogin>>,
    TError,
    { data: BodyType<AuthFirebaseLoginRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof firebaseLogin>>,
  TError,
  { data: BodyType<AuthFirebaseLoginRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof firebaseLogin>>,
    { data: BodyType<AuthFirebaseLoginRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return firebaseLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FirebaseLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof firebaseLogin>>
>;
export type FirebaseLoginMutationBody =
  BodyType<AuthFirebaseLoginRequestBodyDto>;
export type FirebaseLoginMutationError = ErrorType<BaseErrorResponseDto>;

export const useFirebaseLogin = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof firebaseLogin>>,
    TError,
    { data: BodyType<AuthFirebaseLoginRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof firebaseLogin>>,
  TError,
  { data: BodyType<AuthFirebaseLoginRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getFirebaseLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createUdlChoiceBoard = (
  udlChoiceBoardCreateRequestDto: BodyType<UdlChoiceBoardCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<UdlChoiceBoardResponseDto>({
    url: `/udl-choice-board`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: udlChoiceBoardCreateRequestDto,
    signal,
  });
};

export const getCreateUdlChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUdlChoiceBoard>>,
    TError,
    { data: BodyType<UdlChoiceBoardCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUdlChoiceBoard>>,
  TError,
  { data: BodyType<UdlChoiceBoardCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUdlChoiceBoard>>,
    { data: BodyType<UdlChoiceBoardCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createUdlChoiceBoard(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUdlChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUdlChoiceBoard>>
>;
export type CreateUdlChoiceBoardMutationBody =
  BodyType<UdlChoiceBoardCreateRequestDto>;
export type CreateUdlChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateUdlChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUdlChoiceBoard>>,
    TError,
    { data: BodyType<UdlChoiceBoardCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUdlChoiceBoard>>,
  TError,
  { data: BodyType<UdlChoiceBoardCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateUdlChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeUdlChoiceBoard = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/udl-choice-board/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeUdlChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeUdlChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeUdlChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeUdlChoiceBoard>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeUdlChoiceBoard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeUdlChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeUdlChoiceBoard>>
>;

export type LikeUdlChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeUdlChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeUdlChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeUdlChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeUdlChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeUdlChoiceBoard = (id: number) => {
  return configureAxios<void>({
    url: `/udl-choice-board/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeUdlChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeUdlChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeUdlChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeUdlChoiceBoard>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeUdlChoiceBoard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeUdlChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeUdlChoiceBoard>>
>;

export type UnlikeUdlChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeUdlChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeUdlChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeUdlChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeUdlChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUbdPlanners = (signal?: AbortSignal) => {
  return configureAxios<UbdMaarifPlannerResponseDto[]>({
    url: `/ubd-planner`,
    method: "GET",
    signal,
  });
};

export const getGetUbdPlannersQueryKey = () => {
  return [`/ubd-planner`] as const;
};

export const getGetUbdPlannersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUbdPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanners>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUbdPlannersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUbdPlanners>>> = ({
    signal,
  }) => getUbdPlanners(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUbdPlanners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUbdPlannersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUbdPlanners>>
>;
export type GetUbdPlannersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUbdPlanners<
  TData = Awaited<ReturnType<typeof getUbdPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanners>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUbdPlanners>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUbdPlanners<
  TData = Awaited<ReturnType<typeof getUbdPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanners>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUbdPlanners>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUbdPlanners<
  TData = Awaited<ReturnType<typeof getUbdPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanners>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUbdPlanners<
  TData = Awaited<ReturnType<typeof getUbdPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUbdPlanners>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUbdPlannersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createUbdMaarifLessonPlanner = (
  generateUbdGoalsRequestDto: BodyType<GenerateUbdGoalsRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<UbdMaarifPlannerResponseDto>({
    url: `/ubd-planner`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateUbdGoalsRequestDto,
    signal,
  });
};

export const getCreateUbdMaarifLessonPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlanner>>,
    TError,
    { data: BodyType<GenerateUbdGoalsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlanner>>,
  TError,
  { data: BodyType<GenerateUbdGoalsRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlanner>>,
    { data: BodyType<GenerateUbdGoalsRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createUbdMaarifLessonPlanner(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUbdMaarifLessonPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlanner>>
>;
export type CreateUbdMaarifLessonPlannerMutationBody =
  BodyType<GenerateUbdGoalsRequestDto>;
export type CreateUbdMaarifLessonPlannerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateUbdMaarifLessonPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdMaarifLessonPlanner>>,
    TError,
    { data: BodyType<GenerateUbdGoalsRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUbdMaarifLessonPlanner>>,
  TError,
  { data: BodyType<GenerateUbdGoalsRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateUbdMaarifLessonPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listUbdExpertPlannerServices = (
  params?: ListUbdExpertPlannerServicesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListUbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner`,
    method: "GET",
    params,
    signal,
  });
};

export const getListUbdExpertPlannerServicesQueryKey = (
  params?: ListUbdExpertPlannerServicesParams,
) => {
  return [`/ubd-expert-planner`, ...(params ? [params] : [])] as const;
};

export const getListUbdExpertPlannerServicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListUbdExpertPlannerServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListUbdExpertPlannerServicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUbdExpertPlannerServices>>
  > = ({ signal }) => listUbdExpertPlannerServices(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListUbdExpertPlannerServicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUbdExpertPlannerServices>>
>;
export type ListUbdExpertPlannerServicesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useListUbdExpertPlannerServices<
  TData = Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | ListUbdExpertPlannerServicesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUbdExpertPlannerServices<
  TData = Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListUbdExpertPlannerServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUbdExpertPlannerServices<
  TData = Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListUbdExpertPlannerServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListUbdExpertPlannerServices<
  TData = Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListUbdExpertPlannerServicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUbdExpertPlannerServices>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListUbdExpertPlannerServicesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createUbdExpertPlannerService = (
  createUbdExpertPlannerRequestDto: BodyType<CreateUbdExpertPlannerRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<UbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createUbdExpertPlannerRequestDto,
    signal,
  });
};

export const getCreateUbdExpertPlannerServiceMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdExpertPlannerService>>,
    TError,
    { data: BodyType<CreateUbdExpertPlannerRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUbdExpertPlannerService>>,
  TError,
  { data: BodyType<CreateUbdExpertPlannerRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUbdExpertPlannerService>>,
    { data: BodyType<CreateUbdExpertPlannerRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createUbdExpertPlannerService(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUbdExpertPlannerServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUbdExpertPlannerService>>
>;
export type CreateUbdExpertPlannerServiceMutationBody =
  BodyType<CreateUbdExpertPlannerRequestDto>;
export type CreateUbdExpertPlannerServiceMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateUbdExpertPlannerService = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUbdExpertPlannerService>>,
    TError,
    { data: BodyType<CreateUbdExpertPlannerRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUbdExpertPlannerService>>,
  TError,
  { data: BodyType<CreateUbdExpertPlannerRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateUbdExpertPlannerServiceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const synthesizeText = (
  synthesizeRequestBody: BodyType<SynthesizeRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/tts/synthesize`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: synthesizeRequestBody,
    signal,
  });
};

export const getSynthesizeTextMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeText>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof synthesizeText>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof synthesizeText>>,
    { data: BodyType<SynthesizeRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return synthesizeText(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SynthesizeTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof synthesizeText>>
>;
export type SynthesizeTextMutationBody = BodyType<SynthesizeRequestBody>;
export type SynthesizeTextMutationError = ErrorType<BaseErrorResponseDto>;

export const useSynthesizeText = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeText>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof synthesizeText>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const mutationOptions = getSynthesizeTextMutationOptions(options);

  return useMutation(mutationOptions);
};

export const synthesizeTextOpenai1 = (
  synthesizeRequestBody: BodyType<SynthesizeRequestBody>,
  params?: SynthesizeTextOpenai1Params,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/tts/synthesize/openai`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: synthesizeRequestBody,
    params,
    signal,
  });
};

export const getSynthesizeTextOpenai1MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextOpenai1>>,
    TError,
    {
      data: BodyType<SynthesizeRequestBody>;
      params?: SynthesizeTextOpenai1Params;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof synthesizeTextOpenai1>>,
  TError,
  {
    data: BodyType<SynthesizeRequestBody>;
    params?: SynthesizeTextOpenai1Params;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof synthesizeTextOpenai1>>,
    {
      data: BodyType<SynthesizeRequestBody>;
      params?: SynthesizeTextOpenai1Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return synthesizeTextOpenai1(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SynthesizeTextOpenai1MutationResult = NonNullable<
  Awaited<ReturnType<typeof synthesizeTextOpenai1>>
>;
export type SynthesizeTextOpenai1MutationBody = BodyType<SynthesizeRequestBody>;
export type SynthesizeTextOpenai1MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSynthesizeTextOpenai1 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextOpenai1>>,
    TError,
    {
      data: BodyType<SynthesizeRequestBody>;
      params?: SynthesizeTextOpenai1Params;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof synthesizeTextOpenai1>>,
  TError,
  {
    data: BodyType<SynthesizeRequestBody>;
    params?: SynthesizeTextOpenai1Params;
  },
  TContext
> => {
  const mutationOptions = getSynthesizeTextOpenai1MutationOptions(options);

  return useMutation(mutationOptions);
};

export const synthesizeTextChirp = (
  synthesizeChirpRequestBody: BodyType<SynthesizeChirpRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/tts/synthesize/google-chirp`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: synthesizeChirpRequestBody,
    signal,
  });
};

export const getSynthesizeTextChirpMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextChirp>>,
    TError,
    { data: BodyType<SynthesizeChirpRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof synthesizeTextChirp>>,
  TError,
  { data: BodyType<SynthesizeChirpRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof synthesizeTextChirp>>,
    { data: BodyType<SynthesizeChirpRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return synthesizeTextChirp(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SynthesizeTextChirpMutationResult = NonNullable<
  Awaited<ReturnType<typeof synthesizeTextChirp>>
>;
export type SynthesizeTextChirpMutationBody =
  BodyType<SynthesizeChirpRequestBody>;
export type SynthesizeTextChirpMutationError = ErrorType<BaseErrorResponseDto>;

export const useSynthesizeTextChirp = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextChirp>>,
    TError,
    { data: BodyType<SynthesizeChirpRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof synthesizeTextChirp>>,
  TError,
  { data: BodyType<SynthesizeChirpRequestBody> },
  TContext
> => {
  const mutationOptions = getSynthesizeTextChirpMutationOptions(options);

  return useMutation(mutationOptions);
};

export const synthesizeTextAzure = (
  synthesizeRequestBody: BodyType<SynthesizeRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/tts/synthesize/azure`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: synthesizeRequestBody,
    signal,
  });
};

export const getSynthesizeTextAzureMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextAzure>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof synthesizeTextAzure>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof synthesizeTextAzure>>,
    { data: BodyType<SynthesizeRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return synthesizeTextAzure(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SynthesizeTextAzureMutationResult = NonNullable<
  Awaited<ReturnType<typeof synthesizeTextAzure>>
>;
export type SynthesizeTextAzureMutationBody = BodyType<SynthesizeRequestBody>;
export type SynthesizeTextAzureMutationError = ErrorType<BaseErrorResponseDto>;

export const useSynthesizeTextAzure = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof synthesizeTextAzure>>,
    TError,
    { data: BodyType<SynthesizeRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof synthesizeTextAzure>>,
  TError,
  { data: BodyType<SynthesizeRequestBody> },
  TContext
> => {
  const mutationOptions = getSynthesizeTextAzureMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createTransferActivity = (
  transferActivityCreateRequestDto: BodyType<TransferActivityCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TransferActivityResponseDto>({
    url: `/transfer-activity`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: transferActivityCreateRequestDto,
    signal,
  });
};

export const getCreateTransferActivityMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTransferActivity>>,
    TError,
    { data: BodyType<TransferActivityCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTransferActivity>>,
  TError,
  { data: BodyType<TransferActivityCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTransferActivity>>,
    { data: BodyType<TransferActivityCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTransferActivity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTransferActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTransferActivity>>
>;
export type CreateTransferActivityMutationBody =
  BodyType<TransferActivityCreateRequestDto>;
export type CreateTransferActivityMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateTransferActivity = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTransferActivity>>,
    TError,
    { data: BodyType<TransferActivityCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTransferActivity>>,
  TError,
  { data: BodyType<TransferActivityCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateTransferActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateTransferActivity = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<TransferActivityResponseDto>({
    url: `/transfer-activity/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateTransferActivityMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateTransferActivity>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateTransferActivity>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateTransferActivity>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateTransferActivity(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateTransferActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateTransferActivity>>
>;
export type RegenerateTransferActivityMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateTransferActivityMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateTransferActivity = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateTransferActivity>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateTransferActivity>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateTransferActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeTransferActivity = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/transfer-activity/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeTransferActivityMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeTransferActivity>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeTransferActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeTransferActivity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeTransferActivity(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeTransferActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeTransferActivity>>
>;

export type LikeTransferActivityMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeTransferActivity = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeTransferActivity>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeTransferActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeTransferActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeTransferActivity = (id: number) => {
  return configureAxios<void>({
    url: `/transfer-activity/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeTransferActivityMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeTransferActivity>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeTransferActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeTransferActivity>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeTransferActivity(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeTransferActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeTransferActivity>>
>;

export type UnlikeTransferActivityMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeTransferActivity = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeTransferActivity>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeTransferActivity>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeTransferActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createTextLeveler = (
  textLevelerCreateRequestDto: BodyType<TextLevelerCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TextLevelerResponseDto>({
    url: `/text-levelers`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: textLevelerCreateRequestDto,
    signal,
  });
};

export const getCreateTextLevelerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTextLeveler>>,
    TError,
    { data: BodyType<TextLevelerCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTextLeveler>>,
  TError,
  { data: BodyType<TextLevelerCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTextLeveler>>,
    { data: BodyType<TextLevelerCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTextLeveler(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTextLevelerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTextLeveler>>
>;
export type CreateTextLevelerMutationBody =
  BodyType<TextLevelerCreateRequestDto>;
export type CreateTextLevelerMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateTextLeveler = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTextLeveler>>,
    TError,
    { data: BodyType<TextLevelerCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTextLeveler>>,
  TError,
  { data: BodyType<TextLevelerCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateTextLevelerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateTextLeveler = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<TextLevelerResponseDto>({
    url: `/text-levelers/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateTextLevelerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateTextLeveler>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateTextLeveler>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateTextLeveler>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateTextLeveler(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateTextLevelerMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateTextLeveler>>
>;
export type RegenerateTextLevelerMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateTextLevelerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateTextLeveler = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateTextLeveler>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateTextLeveler>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateTextLevelerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeTextLeveler = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/text-levelers/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeTextLevelerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeTextLeveler>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeTextLeveler>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeTextLeveler>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeTextLeveler(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeTextLevelerMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeTextLeveler>>
>;

export type LikeTextLevelerMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeTextLeveler = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeTextLeveler>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeTextLeveler>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeTextLevelerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeTextLeveler = (id: number) => {
  return configureAxios<void>({
    url: `/text-levelers/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeTextLevelerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeTextLeveler>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeTextLeveler>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeTextLeveler>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeTextLeveler(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeTextLevelerMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeTextLeveler>>
>;

export type UnlikeTextLevelerMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeTextLeveler = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeTextLeveler>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeTextLeveler>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeTextLevelerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTedYearlyLessonPlanners = (
  params?: GetTedYearlyLessonPlannersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TedYearlyLessonPlannerResponseDto[]>({
    url: `/ted-yearly-lesson-planner`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTedYearlyLessonPlannersQueryKey = (
  params?: GetTedYearlyLessonPlannersParams,
) => {
  return [`/ted-yearly-lesson-planner`, ...(params ? [params] : [])] as const;
};

export const getGetTedYearlyLessonPlannersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTedYearlyLessonPlannersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>
  > = ({ signal }) => getTedYearlyLessonPlanners(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTedYearlyLessonPlannersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>
>;
export type GetTedYearlyLessonPlannersQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTedYearlyLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTedYearlyLessonPlannersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTedYearlyLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTedYearlyLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTedYearlyLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlanners>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTedYearlyLessonPlannersQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTedYearlyLessonPlanner = (
  tedYearlyLessonPlannerCreateRequestDto: BodyType<TedYearlyLessonPlannerCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TedYearlyLessonPlannerResponseDto>({
    url: `/ted-yearly-lesson-planner`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tedYearlyLessonPlannerCreateRequestDto,
    signal,
  });
};

export const getCreateTedYearlyLessonPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTedYearlyLessonPlanner>>,
    TError,
    { data: BodyType<TedYearlyLessonPlannerCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTedYearlyLessonPlanner>>,
  TError,
  { data: BodyType<TedYearlyLessonPlannerCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTedYearlyLessonPlanner>>,
    { data: BodyType<TedYearlyLessonPlannerCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTedYearlyLessonPlanner(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTedYearlyLessonPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTedYearlyLessonPlanner>>
>;
export type CreateTedYearlyLessonPlannerMutationBody =
  BodyType<TedYearlyLessonPlannerCreateRequestDto>;
export type CreateTedYearlyLessonPlannerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateTedYearlyLessonPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTedYearlyLessonPlanner>>,
    TError,
    { data: BodyType<TedYearlyLessonPlannerCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTedYearlyLessonPlanner>>,
  TError,
  { data: BodyType<TedYearlyLessonPlannerCreateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateTedYearlyLessonPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTedYearlyLessonPlannerWebhook = (
  id: number,
  tedYearlyLessonPlannerWebhookRequestDto: BodyType<TedYearlyLessonPlannerWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/ted-yearly-lesson-planner/webhook/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tedYearlyLessonPlannerWebhookRequestDto,
    signal,
  });
};

export const getHandleTedYearlyLessonPlannerWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTedYearlyLessonPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<TedYearlyLessonPlannerWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTedYearlyLessonPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<TedYearlyLessonPlannerWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTedYearlyLessonPlannerWebhook>>,
    { id: number; data: BodyType<TedYearlyLessonPlannerWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleTedYearlyLessonPlannerWebhook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTedYearlyLessonPlannerWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTedYearlyLessonPlannerWebhook>>
>;
export type HandleTedYearlyLessonPlannerWebhookMutationBody =
  BodyType<TedYearlyLessonPlannerWebhookRequestDto>;
export type HandleTedYearlyLessonPlannerWebhookMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleTedYearlyLessonPlannerWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTedYearlyLessonPlannerWebhook>>,
    TError,
    { id: number; data: BodyType<TedYearlyLessonPlannerWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTedYearlyLessonPlannerWebhook>>,
  TError,
  { id: number; data: BodyType<TedYearlyLessonPlannerWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleTedYearlyLessonPlannerWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTedLessonPlanners = (
  params?: GetTedLessonPlannersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TedLessonPlannerResponseDto[]>({
    url: `/ted-lesson-planner`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTedLessonPlannersQueryKey = (
  params?: GetTedLessonPlannersParams,
) => {
  return [`/ted-lesson-planner`, ...(params ? [params] : [])] as const;
};

export const getGetTedLessonPlannersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTedLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanners>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTedLessonPlannersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTedLessonPlanners>>
  > = ({ signal }) => getTedLessonPlanners(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTedLessonPlanners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTedLessonPlannersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTedLessonPlanners>>
>;
export type GetTedLessonPlannersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTedLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTedLessonPlannersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanners>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedLessonPlanners>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTedLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanners>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedLessonPlanners>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTedLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanners>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTedLessonPlanners<
  TData = Awaited<ReturnType<typeof getTedLessonPlanners>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlanners>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTedLessonPlannersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTedLessonPlanner = (
  tedLessonPlannerCreateRequestDto: BodyType<TedLessonPlannerCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TedLessonPlannerResponseDto>({
    url: `/ted-lesson-planner`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tedLessonPlannerCreateRequestDto,
    signal,
  });
};

export const getCreateTedLessonPlannerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTedLessonPlanner>>,
    TError,
    { data: BodyType<TedLessonPlannerCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTedLessonPlanner>>,
  TError,
  { data: BodyType<TedLessonPlannerCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTedLessonPlanner>>,
    { data: BodyType<TedLessonPlannerCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTedLessonPlanner(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTedLessonPlannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTedLessonPlanner>>
>;
export type CreateTedLessonPlannerMutationBody =
  BodyType<TedLessonPlannerCreateRequestDto>;
export type CreateTedLessonPlannerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateTedLessonPlanner = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTedLessonPlanner>>,
    TError,
    { data: BodyType<TedLessonPlannerCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTedLessonPlanner>>,
  TError,
  { data: BodyType<TedLessonPlannerCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateTedLessonPlannerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTedLessonPlannerWebhook1 = (
  id: number,
  tedLessonPlannerWebhookRequestDto: BodyType<TedLessonPlannerWebhookRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/ted-lesson-planner/webhook/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tedLessonPlannerWebhookRequestDto,
    signal,
  });
};

export const getHandleTedLessonPlannerWebhook1MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTedLessonPlannerWebhook1>>,
    TError,
    { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTedLessonPlannerWebhook1>>,
  TError,
  { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTedLessonPlannerWebhook1>>,
    { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return handleTedLessonPlannerWebhook1(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTedLessonPlannerWebhook1MutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTedLessonPlannerWebhook1>>
>;
export type HandleTedLessonPlannerWebhook1MutationBody =
  BodyType<TedLessonPlannerWebhookRequestDto>;
export type HandleTedLessonPlannerWebhook1MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useHandleTedLessonPlannerWebhook1 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTedLessonPlannerWebhook1>>,
    TError,
    { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTedLessonPlannerWebhook1>>,
  TError,
  { id: number; data: BodyType<TedLessonPlannerWebhookRequestDto> },
  TContext
> => {
  const mutationOptions =
    getHandleTedLessonPlannerWebhook1MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Convert document to pdf using lambda
 */
export const convertDocumentToPdf = (id: number, signal?: AbortSignal) => {
  return configureAxios<TeacherDocumentResponseDto>({
    url: `/teachers/documents/${id}/convert-to-pdf`,
    method: "POST",
    signal,
  });
};

export const getConvertDocumentToPdfMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof convertDocumentToPdf>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof convertDocumentToPdf>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof convertDocumentToPdf>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return convertDocumentToPdf(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConvertDocumentToPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof convertDocumentToPdf>>
>;

export type ConvertDocumentToPdfMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Convert document to pdf using lambda
 */
export const useConvertDocumentToPdf = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof convertDocumentToPdf>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof convertDocumentToPdf>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getConvertDocumentToPdfMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editTeacher = (
  editTeacherRequestBodyDto: BodyType<EditTeacherRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherResponseDto>({
    url: `/teachers/complete-register`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: editTeacherRequestBodyDto,
    signal,
  });
};

export const getEditTeacherMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editTeacher>>,
    TError,
    { data: BodyType<EditTeacherRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editTeacher>>,
  TError,
  { data: BodyType<EditTeacherRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editTeacher>>,
    { data: BodyType<EditTeacherRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return editTeacher(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditTeacherMutationResult = NonNullable<
  Awaited<ReturnType<typeof editTeacher>>
>;
export type EditTeacherMutationBody = BodyType<EditTeacherRequestBodyDto>;
export type EditTeacherMutationError = ErrorType<BaseErrorResponseDto>;

export const useEditTeacher = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editTeacher>>,
    TError,
    { data: BodyType<EditTeacherRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editTeacher>>,
  TError,
  { data: BodyType<EditTeacherRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getEditTeacherMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportAssignmentToGoogleClassroom = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/students/export-to-google-classroom`,
    method: "POST",
    signal,
  });
};

export const getExportAssignmentToGoogleClassroomMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAssignmentToGoogleClassroom>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAssignmentToGoogleClassroom>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAssignmentToGoogleClassroom>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return exportAssignmentToGoogleClassroom(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAssignmentToGoogleClassroomMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportAssignmentToGoogleClassroom>>
>;

export type ExportAssignmentToGoogleClassroomMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useExportAssignmentToGoogleClassroom = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAssignmentToGoogleClassroom>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportAssignmentToGoogleClassroom>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions =
    getExportAssignmentToGoogleClassroomMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Assign assignment to students
 */
export const assignAssignmentToStudentsNew = (
  assignmentId: number,
  assignAssignmentRequestBodyNew: BodyType<AssignAssignmentRequestBodyNew>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/students-new`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: assignAssignmentRequestBodyNew,
    signal,
  });
};

export const getAssignAssignmentToStudentsNewMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignAssignmentToStudentsNew>>,
    TError,
    { assignmentId: number; data: BodyType<AssignAssignmentRequestBodyNew> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignAssignmentToStudentsNew>>,
  TError,
  { assignmentId: number; data: BodyType<AssignAssignmentRequestBodyNew> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignAssignmentToStudentsNew>>,
    { assignmentId: number; data: BodyType<AssignAssignmentRequestBodyNew> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return assignAssignmentToStudentsNew(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignAssignmentToStudentsNewMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignAssignmentToStudentsNew>>
>;
export type AssignAssignmentToStudentsNewMutationBody =
  BodyType<AssignAssignmentRequestBodyNew>;
export type AssignAssignmentToStudentsNewMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Assign assignment to students
 */
export const useAssignAssignmentToStudentsNew = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignAssignmentToStudentsNew>>,
    TError,
    { assignmentId: number; data: BodyType<AssignAssignmentRequestBodyNew> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignAssignmentToStudentsNew>>,
  TError,
  { assignmentId: number; data: BodyType<AssignAssignmentRequestBodyNew> },
  TContext
> => {
  const mutationOptions =
    getAssignAssignmentToStudentsNewMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Grade answer of questions for a student
 * @summary Grade answer of questions
 */
export const gradeQuestionAnswers = (
  assignmentId: number,
  studentId: number,
  gradeQuestionAnswerRequestBodyDto: BodyType<
    GradeQuestionAnswerRequestBodyDto[]
  >,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/student/${studentId}/grade`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: gradeQuestionAnswerRequestBodyDto,
    signal,
  });
};

export const getGradeQuestionAnswersMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gradeQuestionAnswers>>,
    TError,
    {
      assignmentId: number;
      studentId: number;
      data: BodyType<GradeQuestionAnswerRequestBodyDto[]>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof gradeQuestionAnswers>>,
  TError,
  {
    assignmentId: number;
    studentId: number;
    data: BodyType<GradeQuestionAnswerRequestBodyDto[]>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gradeQuestionAnswers>>,
    {
      assignmentId: number;
      studentId: number;
      data: BodyType<GradeQuestionAnswerRequestBodyDto[]>;
    }
  > = (props) => {
    const { assignmentId, studentId, data } = props ?? {};

    return gradeQuestionAnswers(assignmentId, studentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GradeQuestionAnswersMutationResult = NonNullable<
  Awaited<ReturnType<typeof gradeQuestionAnswers>>
>;
export type GradeQuestionAnswersMutationBody = BodyType<
  GradeQuestionAnswerRequestBodyDto[]
>;
export type GradeQuestionAnswersMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Grade answer of questions
 */
export const useGradeQuestionAnswers = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gradeQuestionAnswers>>,
    TError,
    {
      assignmentId: number;
      studentId: number;
      data: BodyType<GradeQuestionAnswerRequestBodyDto[]>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof gradeQuestionAnswers>>,
  TError,
  {
    assignmentId: number;
    studentId: number;
    data: BodyType<GradeQuestionAnswerRequestBodyDto[]>;
  },
  TContext
> => {
  const mutationOptions = getGradeQuestionAnswersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get finished open ended questions of assignment
 * @summary Get finished open ended questions of assignment
 */
export const setStudentAssignmentToTeacherGraded = (
  assignmentId: number,
  setStudentAssignmentToTeacherGradedBody: BodyType<number[]>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/set-student-assignment-to-teacher-graded`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setStudentAssignmentToTeacherGradedBody,
    signal,
  });
};

export const getSetStudentAssignmentToTeacherGradedMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setStudentAssignmentToTeacherGraded>>,
    TError,
    { assignmentId: number; data: BodyType<number[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setStudentAssignmentToTeacherGraded>>,
  TError,
  { assignmentId: number; data: BodyType<number[]> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setStudentAssignmentToTeacherGraded>>,
    { assignmentId: number; data: BodyType<number[]> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return setStudentAssignmentToTeacherGraded(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetStudentAssignmentToTeacherGradedMutationResult = NonNullable<
  Awaited<ReturnType<typeof setStudentAssignmentToTeacherGraded>>
>;
export type SetStudentAssignmentToTeacherGradedMutationBody = BodyType<
  number[]
>;
export type SetStudentAssignmentToTeacherGradedMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Get finished open ended questions of assignment
 */
export const useSetStudentAssignmentToTeacherGraded = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setStudentAssignmentToTeacherGraded>>,
    TError,
    { assignmentId: number; data: BodyType<number[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof setStudentAssignmentToTeacherGraded>>,
  TError,
  { assignmentId: number; data: BodyType<number[]> },
  TContext
> => {
  const mutationOptions =
    getSetStudentAssignmentToTeacherGradedMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get finished open ended questions of assignment
 * @summary Get finished open ended questions of assignment
 */
export const gradeFinishedStudentsOpenEndedAnswers = (
  assignmentId: number,
  gradeFinishedStudentsOpenEndedAnswersRequestBody: BodyType<GradeFinishedStudentsOpenEndedAnswersRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/teachers/assignments/${assignmentId}/grade-open-ended`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: gradeFinishedStudentsOpenEndedAnswersRequestBody,
    signal,
  });
};

export const getGradeFinishedStudentsOpenEndedAnswersMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gradeFinishedStudentsOpenEndedAnswers>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<GradeFinishedStudentsOpenEndedAnswersRequestBody>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof gradeFinishedStudentsOpenEndedAnswers>>,
  TError,
  {
    assignmentId: number;
    data: BodyType<GradeFinishedStudentsOpenEndedAnswersRequestBody>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gradeFinishedStudentsOpenEndedAnswers>>,
    {
      assignmentId: number;
      data: BodyType<GradeFinishedStudentsOpenEndedAnswersRequestBody>;
    }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return gradeFinishedStudentsOpenEndedAnswers(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GradeFinishedStudentsOpenEndedAnswersMutationResult = NonNullable<
  Awaited<ReturnType<typeof gradeFinishedStudentsOpenEndedAnswers>>
>;
export type GradeFinishedStudentsOpenEndedAnswersMutationBody =
  BodyType<GradeFinishedStudentsOpenEndedAnswersRequestBody>;
export type GradeFinishedStudentsOpenEndedAnswersMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Get finished open ended questions of assignment
 */
export const useGradeFinishedStudentsOpenEndedAnswers = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gradeFinishedStudentsOpenEndedAnswers>>,
    TError,
    {
      assignmentId: number;
      data: BodyType<GradeFinishedStudentsOpenEndedAnswersRequestBody>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof gradeFinishedStudentsOpenEndedAnswers>>,
  TError,
  {
    assignmentId: number;
    data: BodyType<GradeFinishedStudentsOpenEndedAnswersRequestBody>;
  },
  TContext
> => {
  const mutationOptions =
    getGradeFinishedStudentsOpenEndedAnswersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cloneAssignment = (assignmentId: number, signal?: AbortSignal) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/teachers/assignments/${assignmentId}/clone`,
    method: "POST",
    signal,
  });
};

export const getCloneAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneAssignment>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return cloneAssignment(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneAssignment>>
>;

export type CloneAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useCloneAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cloneAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions = getCloneAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createQuizAssignment = (
  createQuizAssignmentRequestBody: BodyType<CreateQuizAssignmentRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/teachers/assignments/quiz`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createQuizAssignmentRequestBody,
    signal,
  });
};

export const getCreateQuizAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuizAssignment>>,
    TError,
    { data: BodyType<CreateQuizAssignmentRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuizAssignment>>,
  TError,
  { data: BodyType<CreateQuizAssignmentRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuizAssignment>>,
    { data: BodyType<CreateQuizAssignmentRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createQuizAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuizAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuizAssignment>>
>;
export type CreateQuizAssignmentMutationBody =
  BodyType<CreateQuizAssignmentRequestBody>;
export type CreateQuizAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateQuizAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuizAssignment>>,
    TError,
    { data: BodyType<CreateQuizAssignmentRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuizAssignment>>,
  TError,
  { data: BodyType<CreateQuizAssignmentRequestBody> },
  TContext
> => {
  const mutationOptions = getCreateQuizAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createHomeworkAssignment = (
  createHomeworkAssignmentRequestBody: BodyType<CreateHomeworkAssignmentRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/teachers/assignments/homework`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createHomeworkAssignmentRequestBody,
    signal,
  });
};

export const getCreateHomeworkAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHomeworkAssignment>>,
    TError,
    { data: BodyType<CreateHomeworkAssignmentRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHomeworkAssignment>>,
  TError,
  { data: BodyType<CreateHomeworkAssignmentRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHomeworkAssignment>>,
    { data: BodyType<CreateHomeworkAssignmentRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createHomeworkAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHomeworkAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHomeworkAssignment>>
>;
export type CreateHomeworkAssignmentMutationBody =
  BodyType<CreateHomeworkAssignmentRequestBody>;
export type CreateHomeworkAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateHomeworkAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHomeworkAssignment>>,
    TError,
    { data: BodyType<CreateHomeworkAssignmentRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createHomeworkAssignment>>,
  TError,
  { data: BodyType<CreateHomeworkAssignmentRequestBody> },
  TContext
> => {
  const mutationOptions = getCreateHomeworkAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createSpecialHomeworkAssignment = (
  createSpecialHomeworkAssignmentRequestBody: BodyType<CreateSpecialHomeworkAssignmentRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/teachers/assignments/homework/special`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSpecialHomeworkAssignmentRequestBody,
    signal,
  });
};

export const getCreateSpecialHomeworkAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpecialHomeworkAssignment>>,
    TError,
    { data: BodyType<CreateSpecialHomeworkAssignmentRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpecialHomeworkAssignment>>,
  TError,
  { data: BodyType<CreateSpecialHomeworkAssignmentRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpecialHomeworkAssignment>>,
    { data: BodyType<CreateSpecialHomeworkAssignmentRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSpecialHomeworkAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpecialHomeworkAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpecialHomeworkAssignment>>
>;
export type CreateSpecialHomeworkAssignmentMutationBody =
  BodyType<CreateSpecialHomeworkAssignmentRequestBody>;
export type CreateSpecialHomeworkAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateSpecialHomeworkAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpecialHomeworkAssignment>>,
    TError,
    { data: BodyType<CreateSpecialHomeworkAssignmentRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpecialHomeworkAssignment>>,
  TError,
  { data: BodyType<CreateSpecialHomeworkAssignmentRequestBody> },
  TContext
> => {
  const mutationOptions =
    getCreateSpecialHomeworkAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const shareTool = (
  toolType:
    | "AI_ASSESSMENT_SCALE"
    | "AI_ASSIGNMENT"
    | "AI_RESISTANT_HOMEWORK"
    | "AI_SUPPORTED_TASKS"
    | "BLOOMS_TAXONOMY_ACTIVITIES"
    | "CHOICE_BOARD"
    | "CLASSROOM_MANAGEMENT"
    | "COLLABORATIVE_GROUP_WORK"
    | "COMMON_MISCONCEPTION"
    | "CONCEPTUAL_UNDERSTANDING"
    | "ESSENTIAL_QUESTIONS"
    | "EXIT_TICKET_GENERATOR"
    | "FORMATIVE_ASSESSMENT"
    | "HOMEWORK_IDEA"
    | "IMAGE_GENERATOR"
    | "LESSON_HOOK"
    | "MINDMAP_GENERATOR"
    | "PERFORMANCE_TASK"
    | "PODCAST"
    | "PROJECT_BASED_LEARNING"
    | "REAL_WORLD_CONNECTION"
    | "RUBRIC_GENERATOR"
    | "SUMMARIZER"
    | "TEXT_LEVELER"
    | "TRANSFER_ACTIVITY"
    | "UDL_CHOICE_BOARD"
    | "VOCABULARY_LIST"
    | "HEYGEN_AVATAR"
    | "ARTICLE_GENERATOR"
    | "SKETCH_GENERATOR",
  toolId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<ShareTool200>({
    url: `/teacher-tools/${toolType}/${toolId}/share`,
    method: "POST",
    signal,
  });
};

export const getShareToolMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareTool>>,
    TError,
    {
      toolType:
        | "AI_ASSESSMENT_SCALE"
        | "AI_ASSIGNMENT"
        | "AI_RESISTANT_HOMEWORK"
        | "AI_SUPPORTED_TASKS"
        | "BLOOMS_TAXONOMY_ACTIVITIES"
        | "CHOICE_BOARD"
        | "CLASSROOM_MANAGEMENT"
        | "COLLABORATIVE_GROUP_WORK"
        | "COMMON_MISCONCEPTION"
        | "CONCEPTUAL_UNDERSTANDING"
        | "ESSENTIAL_QUESTIONS"
        | "EXIT_TICKET_GENERATOR"
        | "FORMATIVE_ASSESSMENT"
        | "HOMEWORK_IDEA"
        | "IMAGE_GENERATOR"
        | "LESSON_HOOK"
        | "MINDMAP_GENERATOR"
        | "PERFORMANCE_TASK"
        | "PODCAST"
        | "PROJECT_BASED_LEARNING"
        | "REAL_WORLD_CONNECTION"
        | "RUBRIC_GENERATOR"
        | "SUMMARIZER"
        | "TEXT_LEVELER"
        | "TRANSFER_ACTIVITY"
        | "UDL_CHOICE_BOARD"
        | "VOCABULARY_LIST"
        | "HEYGEN_AVATAR"
        | "ARTICLE_GENERATOR"
        | "SKETCH_GENERATOR";
      toolId: number;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shareTool>>,
  TError,
  {
    toolType:
      | "AI_ASSESSMENT_SCALE"
      | "AI_ASSIGNMENT"
      | "AI_RESISTANT_HOMEWORK"
      | "AI_SUPPORTED_TASKS"
      | "BLOOMS_TAXONOMY_ACTIVITIES"
      | "CHOICE_BOARD"
      | "CLASSROOM_MANAGEMENT"
      | "COLLABORATIVE_GROUP_WORK"
      | "COMMON_MISCONCEPTION"
      | "CONCEPTUAL_UNDERSTANDING"
      | "ESSENTIAL_QUESTIONS"
      | "EXIT_TICKET_GENERATOR"
      | "FORMATIVE_ASSESSMENT"
      | "HOMEWORK_IDEA"
      | "IMAGE_GENERATOR"
      | "LESSON_HOOK"
      | "MINDMAP_GENERATOR"
      | "PERFORMANCE_TASK"
      | "PODCAST"
      | "PROJECT_BASED_LEARNING"
      | "REAL_WORLD_CONNECTION"
      | "RUBRIC_GENERATOR"
      | "SUMMARIZER"
      | "TEXT_LEVELER"
      | "TRANSFER_ACTIVITY"
      | "UDL_CHOICE_BOARD"
      | "VOCABULARY_LIST"
      | "HEYGEN_AVATAR"
      | "ARTICLE_GENERATOR"
      | "SKETCH_GENERATOR";
    toolId: number;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareTool>>,
    {
      toolType:
        | "AI_ASSESSMENT_SCALE"
        | "AI_ASSIGNMENT"
        | "AI_RESISTANT_HOMEWORK"
        | "AI_SUPPORTED_TASKS"
        | "BLOOMS_TAXONOMY_ACTIVITIES"
        | "CHOICE_BOARD"
        | "CLASSROOM_MANAGEMENT"
        | "COLLABORATIVE_GROUP_WORK"
        | "COMMON_MISCONCEPTION"
        | "CONCEPTUAL_UNDERSTANDING"
        | "ESSENTIAL_QUESTIONS"
        | "EXIT_TICKET_GENERATOR"
        | "FORMATIVE_ASSESSMENT"
        | "HOMEWORK_IDEA"
        | "IMAGE_GENERATOR"
        | "LESSON_HOOK"
        | "MINDMAP_GENERATOR"
        | "PERFORMANCE_TASK"
        | "PODCAST"
        | "PROJECT_BASED_LEARNING"
        | "REAL_WORLD_CONNECTION"
        | "RUBRIC_GENERATOR"
        | "SUMMARIZER"
        | "TEXT_LEVELER"
        | "TRANSFER_ACTIVITY"
        | "UDL_CHOICE_BOARD"
        | "VOCABULARY_LIST"
        | "HEYGEN_AVATAR"
        | "ARTICLE_GENERATOR"
        | "SKETCH_GENERATOR";
      toolId: number;
    }
  > = (props) => {
    const { toolType, toolId } = props ?? {};

    return shareTool(toolType, toolId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof shareTool>>
>;

export type ShareToolMutationError = ErrorType<BaseErrorResponseDto>;

export const useShareTool = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareTool>>,
    TError,
    {
      toolType:
        | "AI_ASSESSMENT_SCALE"
        | "AI_ASSIGNMENT"
        | "AI_RESISTANT_HOMEWORK"
        | "AI_SUPPORTED_TASKS"
        | "BLOOMS_TAXONOMY_ACTIVITIES"
        | "CHOICE_BOARD"
        | "CLASSROOM_MANAGEMENT"
        | "COLLABORATIVE_GROUP_WORK"
        | "COMMON_MISCONCEPTION"
        | "CONCEPTUAL_UNDERSTANDING"
        | "ESSENTIAL_QUESTIONS"
        | "EXIT_TICKET_GENERATOR"
        | "FORMATIVE_ASSESSMENT"
        | "HOMEWORK_IDEA"
        | "IMAGE_GENERATOR"
        | "LESSON_HOOK"
        | "MINDMAP_GENERATOR"
        | "PERFORMANCE_TASK"
        | "PODCAST"
        | "PROJECT_BASED_LEARNING"
        | "REAL_WORLD_CONNECTION"
        | "RUBRIC_GENERATOR"
        | "SUMMARIZER"
        | "TEXT_LEVELER"
        | "TRANSFER_ACTIVITY"
        | "UDL_CHOICE_BOARD"
        | "VOCABULARY_LIST"
        | "HEYGEN_AVATAR"
        | "ARTICLE_GENERATOR"
        | "SKETCH_GENERATOR";
      toolId: number;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof shareTool>>,
  TError,
  {
    toolType:
      | "AI_ASSESSMENT_SCALE"
      | "AI_ASSIGNMENT"
      | "AI_RESISTANT_HOMEWORK"
      | "AI_SUPPORTED_TASKS"
      | "BLOOMS_TAXONOMY_ACTIVITIES"
      | "CHOICE_BOARD"
      | "CLASSROOM_MANAGEMENT"
      | "COLLABORATIVE_GROUP_WORK"
      | "COMMON_MISCONCEPTION"
      | "CONCEPTUAL_UNDERSTANDING"
      | "ESSENTIAL_QUESTIONS"
      | "EXIT_TICKET_GENERATOR"
      | "FORMATIVE_ASSESSMENT"
      | "HOMEWORK_IDEA"
      | "IMAGE_GENERATOR"
      | "LESSON_HOOK"
      | "MINDMAP_GENERATOR"
      | "PERFORMANCE_TASK"
      | "PODCAST"
      | "PROJECT_BASED_LEARNING"
      | "REAL_WORLD_CONNECTION"
      | "RUBRIC_GENERATOR"
      | "SUMMARIZER"
      | "TEXT_LEVELER"
      | "TRANSFER_ACTIVITY"
      | "UDL_CHOICE_BOARD"
      | "VOCABULARY_LIST"
      | "HEYGEN_AVATAR"
      | "ARTICLE_GENERATOR"
      | "SKETCH_GENERATOR";
    toolId: number;
  },
  TContext
> => {
  const mutationOptions = getShareToolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAllSuperTools = (
  params?: GetAllSuperToolsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSuperToolResponseDto>({
    url: `/teacher-tools/super-tool`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAllSuperToolsQueryKey = (
  params?: GetAllSuperToolsParams,
) => {
  return [`/teacher-tools/super-tool`, ...(params ? [params] : [])] as const;
};

export const getGetAllSuperToolsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllSuperTools>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllSuperToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllSuperTools>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllSuperToolsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllSuperTools>>
  > = ({ signal }) => getAllSuperTools(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllSuperTools>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllSuperToolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllSuperTools>>
>;
export type GetAllSuperToolsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAllSuperTools<
  TData = Awaited<ReturnType<typeof getAllSuperTools>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAllSuperToolsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllSuperTools>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSuperTools>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllSuperTools<
  TData = Awaited<ReturnType<typeof getAllSuperTools>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllSuperToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllSuperTools>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSuperTools>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllSuperTools<
  TData = Awaited<ReturnType<typeof getAllSuperTools>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllSuperToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllSuperTools>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAllSuperTools<
  TData = Awaited<ReturnType<typeof getAllSuperTools>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllSuperToolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllSuperTools>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllSuperToolsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createSuperTool = (
  superToolCreateRequestDto: BodyType<SuperToolCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SuperToolResponseDto>({
    url: `/teacher-tools/super-tool`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: superToolCreateRequestDto,
    signal,
  });
};

export const getCreateSuperToolMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSuperTool>>,
    TError,
    { data: BodyType<SuperToolCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSuperTool>>,
  TError,
  { data: BodyType<SuperToolCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSuperTool>>,
    { data: BodyType<SuperToolCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createSuperTool(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSuperToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSuperTool>>
>;
export type CreateSuperToolMutationBody = BodyType<SuperToolCreateRequestDto>;
export type CreateSuperToolMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateSuperTool = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSuperTool>>,
    TError,
    { data: BodyType<SuperToolCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSuperTool>>,
  TError,
  { data: BodyType<SuperToolCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateSuperToolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cloneSharedTool = (sharedUuid: string, signal?: AbortSignal) => {
  return configureAxios<CloneSharedTool200>({
    url: `/teacher-tools/shared/${sharedUuid}/clone`,
    method: "POST",
    signal,
  });
};

export const getCloneSharedToolMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneSharedTool>>,
    TError,
    { sharedUuid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneSharedTool>>,
  TError,
  { sharedUuid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneSharedTool>>,
    { sharedUuid: string }
  > = (props) => {
    const { sharedUuid } = props ?? {};

    return cloneSharedTool(sharedUuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneSharedToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneSharedTool>>
>;

export type CloneSharedToolMutationError = ErrorType<BaseErrorResponseDto>;

export const useCloneSharedTool = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneSharedTool>>,
    TError,
    { sharedUuid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cloneSharedTool>>,
  TError,
  { sharedUuid: string },
  TContext
> => {
  const mutationOptions = getCloneSharedToolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTeacherToolChats = (
  params?: GetTeacherToolChatsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTeacherToolChatResponseDto>({
    url: `/teacher-tool-chat`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherToolChatsQueryKey = (
  params?: GetTeacherToolChatsParams,
) => {
  return [`/teacher-tool-chat`, ...(params ? [params] : [])] as const;
};

export const getGetTeacherToolChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherToolChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChats>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherToolChatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherToolChats>>
  > = ({ signal }) => getTeacherToolChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherToolChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherToolChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherToolChats>>
>;
export type GetTeacherToolChatsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherToolChats<
  TData = Awaited<ReturnType<typeof getTeacherToolChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeacherToolChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherToolChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherToolChats<
  TData = Awaited<ReturnType<typeof getTeacherToolChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherToolChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherToolChats<
  TData = Awaited<ReturnType<typeof getTeacherToolChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherToolChats<
  TData = Awaited<ReturnType<typeof getTeacherToolChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherToolChatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTeacherToolChat = (
  createTeacherToolChatRequestDto: BodyType<CreateTeacherToolChatRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherToolChatResponseDto>({
    url: `/teacher-tool-chat`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTeacherToolChatRequestDto,
    signal,
  });
};

export const getCreateTeacherToolChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeacherToolChat>>,
    TError,
    { data: BodyType<CreateTeacherToolChatRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeacherToolChat>>,
  TError,
  { data: BodyType<CreateTeacherToolChatRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeacherToolChat>>,
    { data: BodyType<CreateTeacherToolChatRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTeacherToolChat(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeacherToolChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTeacherToolChat>>
>;
export type CreateTeacherToolChatMutationBody =
  BodyType<CreateTeacherToolChatRequestDto>;
export type CreateTeacherToolChatMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateTeacherToolChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeacherToolChat>>,
    TError,
    { data: BodyType<CreateTeacherToolChatRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTeacherToolChat>>,
  TError,
  { data: BodyType<CreateTeacherToolChatRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateTeacherToolChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendMessageToTeacherToolChat = (
  id: number,
  teacherToolChatSendMessageRequestDto: BodyType<TeacherToolChatSendMessageRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/teacher-tool-chat/${id}/messages`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: teacherToolChatSendMessageRequestDto,
    signal,
  });
};

export const getSendMessageToTeacherToolChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToTeacherToolChat>>,
    TError,
    { id: number; data: BodyType<TeacherToolChatSendMessageRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageToTeacherToolChat>>,
  TError,
  { id: number; data: BodyType<TeacherToolChatSendMessageRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageToTeacherToolChat>>,
    { id: number; data: BodyType<TeacherToolChatSendMessageRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendMessageToTeacherToolChat(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageToTeacherToolChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessageToTeacherToolChat>>
>;
export type SendMessageToTeacherToolChatMutationBody =
  BodyType<TeacherToolChatSendMessageRequestDto>;
export type SendMessageToTeacherToolChatMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSendMessageToTeacherToolChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToTeacherToolChat>>,
    TError,
    { id: number; data: BodyType<TeacherToolChatSendMessageRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageToTeacherToolChat>>,
  TError,
  { id: number; data: BodyType<TeacherToolChatSendMessageRequestDto> },
  TContext
> => {
  const mutationOptions =
    getSendMessageToTeacherToolChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTeacherChats = (
  params?: GetTeacherChatsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTeacherChatResponseDto>({
    url: `/teacher-chat`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherChatsQueryKey = (params?: GetTeacherChatsParams) => {
  return [`/teacher-chat`, ...(params ? [params] : [])] as const;
};

export const getGetTeacherChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherChats>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeacherChatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeacherChats>>> = ({
    signal,
  }) => getTeacherChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherChats>>
>;
export type GetTeacherChatsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherChats<
  TData = Awaited<ReturnType<typeof getTeacherChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeacherChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherChats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherChats<
  TData = Awaited<ReturnType<typeof getTeacherChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherChats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherChats<
  TData = Awaited<ReturnType<typeof getTeacherChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherChats<
  TData = Awaited<ReturnType<typeof getTeacherChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherChatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTeacherChat = (
  createTeacherChatRequestDto: BodyType<CreateTeacherChatRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherChatResponseDto>({
    url: `/teacher-chat`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTeacherChatRequestDto,
    signal,
  });
};

export const getCreateTeacherChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeacherChat>>,
    TError,
    { data: BodyType<CreateTeacherChatRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeacherChat>>,
  TError,
  { data: BodyType<CreateTeacherChatRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeacherChat>>,
    { data: BodyType<CreateTeacherChatRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTeacherChat(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeacherChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTeacherChat>>
>;
export type CreateTeacherChatMutationBody =
  BodyType<CreateTeacherChatRequestDto>;
export type CreateTeacherChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateTeacherChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeacherChat>>,
    TError,
    { data: BodyType<CreateTeacherChatRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTeacherChat>>,
  TError,
  { data: BodyType<CreateTeacherChatRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateTeacherChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendMessageToTeacherChat = (
  id: number,
  teacherChatSendMessageRequestDto: BodyType<TeacherChatSendMessageRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/teacher-chat/${id}/messages`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: teacherChatSendMessageRequestDto,
    signal,
  });
};

export const getSendMessageToTeacherChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToTeacherChat>>,
    TError,
    { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageToTeacherChat>>,
  TError,
  { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageToTeacherChat>>,
    { id: number; data: BodyType<TeacherChatSendMessageRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendMessageToTeacherChat(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageToTeacherChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessageToTeacherChat>>
>;
export type SendMessageToTeacherChatMutationBody =
  BodyType<TeacherChatSendMessageRequestDto>;
export type SendMessageToTeacherChatMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSendMessageToTeacherChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToTeacherChat>>,
    TError,
    { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageToTeacherChat>>,
  TError,
  { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
  TContext
> => {
  const mutationOptions = getSendMessageToTeacherChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendMessageToTeacherChatSSE = (
  id: number,
  teacherChatSendMessageRequestDto: BodyType<TeacherChatSendMessageRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ResponseBodyEmitter>({
    url: `/teacher-chat/${id}/messages/sse`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: teacherChatSendMessageRequestDto,
    signal,
  });
};

export const getSendMessageToTeacherChatSSEMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToTeacherChatSSE>>,
    TError,
    { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageToTeacherChatSSE>>,
  TError,
  { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageToTeacherChatSSE>>,
    { id: number; data: BodyType<TeacherChatSendMessageRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendMessageToTeacherChatSSE(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageToTeacherChatSSEMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessageToTeacherChatSSE>>
>;
export type SendMessageToTeacherChatSSEMutationBody =
  BodyType<TeacherChatSendMessageRequestDto>;
export type SendMessageToTeacherChatSSEMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSendMessageToTeacherChatSSE = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToTeacherChatSSE>>,
    TError,
    { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageToTeacherChatSSE>>,
  TError,
  { id: number; data: BodyType<TeacherChatSendMessageRequestDto> },
  TContext
> => {
  const mutationOptions =
    getSendMessageToTeacherChatSSEMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getVisualMatchingList = (
  params?: GetVisualMatchingListParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListVisualMatchingResponseDto>({
    url: `/swann-visual-matching`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetVisualMatchingListQueryKey = (
  params?: GetVisualMatchingListParams,
) => {
  return [`/swann-visual-matching`, ...(params ? [params] : [])] as const;
};

export const getGetVisualMatchingListQueryOptions = <
  TData = Awaited<ReturnType<typeof getVisualMatchingList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVisualMatchingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatchingList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVisualMatchingListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVisualMatchingList>>
  > = ({ signal }) => getVisualMatchingList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVisualMatchingList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVisualMatchingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVisualMatchingList>>
>;
export type GetVisualMatchingListQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetVisualMatchingList<
  TData = Awaited<ReturnType<typeof getVisualMatchingList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetVisualMatchingListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatchingList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisualMatchingList>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVisualMatchingList<
  TData = Awaited<ReturnType<typeof getVisualMatchingList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVisualMatchingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatchingList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisualMatchingList>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVisualMatchingList<
  TData = Awaited<ReturnType<typeof getVisualMatchingList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVisualMatchingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatchingList>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetVisualMatchingList<
  TData = Awaited<ReturnType<typeof getVisualMatchingList>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVisualMatchingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVisualMatchingList>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVisualMatchingListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createVisualMatching = (
  visualMatchingCreateRequestDto: BodyType<VisualMatchingCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<VisualMatchingResponseDto>({
    url: `/swann-visual-matching`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: visualMatchingCreateRequestDto,
    signal,
  });
};

export const getCreateVisualMatchingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVisualMatching>>,
    TError,
    { data: BodyType<VisualMatchingCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVisualMatching>>,
  TError,
  { data: BodyType<VisualMatchingCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVisualMatching>>,
    { data: BodyType<VisualMatchingCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createVisualMatching(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVisualMatchingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVisualMatching>>
>;
export type CreateVisualMatchingMutationBody =
  BodyType<VisualMatchingCreateRequestDto>;
export type CreateVisualMatchingMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateVisualMatching = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVisualMatching>>,
    TError,
    { data: BodyType<VisualMatchingCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVisualMatching>>,
  TError,
  { data: BodyType<VisualMatchingCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateVisualMatchingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const listSpokenDialogues = (
  params?: ListSpokenDialoguesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSpokenDialogueResponseDto>({
    url: `/swann-spoken-dialogue`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSpokenDialoguesQueryKey = (
  params?: ListSpokenDialoguesParams,
) => {
  return [`/swann-spoken-dialogue`, ...(params ? [params] : [])] as const;
};

export const getListSpokenDialoguesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSpokenDialogues>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListSpokenDialoguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSpokenDialogues>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSpokenDialoguesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSpokenDialogues>>
  > = ({ signal }) => listSpokenDialogues(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSpokenDialogues>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListSpokenDialoguesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSpokenDialogues>>
>;
export type ListSpokenDialoguesQueryError = ErrorType<BaseErrorResponseDto>;

export function useListSpokenDialogues<
  TData = Awaited<ReturnType<typeof listSpokenDialogues>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | ListSpokenDialoguesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSpokenDialogues>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpokenDialogues>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSpokenDialogues<
  TData = Awaited<ReturnType<typeof listSpokenDialogues>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListSpokenDialoguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSpokenDialogues>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpokenDialogues>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSpokenDialogues<
  TData = Awaited<ReturnType<typeof listSpokenDialogues>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListSpokenDialoguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSpokenDialogues>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListSpokenDialogues<
  TData = Awaited<ReturnType<typeof listSpokenDialogues>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListSpokenDialoguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSpokenDialogues>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListSpokenDialoguesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createSpokenDialogue = (
  spokenDialogueCreateRequestDto: BodyType<SpokenDialogueCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SpokenDialogueResponseDto>({
    url: `/swann-spoken-dialogue`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: spokenDialogueCreateRequestDto,
    signal,
  });
};

export const getCreateSpokenDialogueMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpokenDialogue>>,
    TError,
    { data: BodyType<SpokenDialogueCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpokenDialogue>>,
  TError,
  { data: BodyType<SpokenDialogueCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpokenDialogue>>,
    { data: BodyType<SpokenDialogueCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createSpokenDialogue(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpokenDialogueMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpokenDialogue>>
>;
export type CreateSpokenDialogueMutationBody =
  BodyType<SpokenDialogueCreateRequestDto>;
export type CreateSpokenDialogueMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateSpokenDialogue = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpokenDialogue>>,
    TError,
    { data: BodyType<SpokenDialogueCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpokenDialogue>>,
  TError,
  { data: BodyType<SpokenDialogueCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateSpokenDialogueMutationOptions(options);

  return useMutation(mutationOptions);
};

export const submitAudioFromS3 = (
  code: string,
  publicSubmitRequestDto: BodyType<PublicSubmitRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PublicSubmissionResponseDto>({
    url: `/swann-pronunciation/public/${code}/submit-url`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: publicSubmitRequestDto,
    signal,
  });
};

export const getSubmitAudioFromS3MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitAudioFromS3>>,
    TError,
    { code: string; data: BodyType<PublicSubmitRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitAudioFromS3>>,
  TError,
  { code: string; data: BodyType<PublicSubmitRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitAudioFromS3>>,
    { code: string; data: BodyType<PublicSubmitRequestDto> }
  > = (props) => {
    const { code, data } = props ?? {};

    return submitAudioFromS3(code, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitAudioFromS3MutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAudioFromS3>>
>;
export type SubmitAudioFromS3MutationBody = BodyType<PublicSubmitRequestDto>;
export type SubmitAudioFromS3MutationError = ErrorType<BaseErrorResponseDto>;

export const useSubmitAudioFromS3 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitAudioFromS3>>,
    TError,
    { code: string; data: BodyType<PublicSubmitRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitAudioFromS3>>,
  TError,
  { code: string; data: BodyType<PublicSubmitRequestDto> },
  TContext
> => {
  const mutationOptions = getSubmitAudioFromS3MutationOptions(options);

  return useMutation(mutationOptions);
};

export const createAssignment = (
  createPronunciationAssignmentRequestDto: BodyType<CreatePronunciationAssignmentRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PronunciationAssignmentResponseDto>({
    url: `/swann-pronunciation/assignments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPronunciationAssignmentRequestDto,
    signal,
  });
};

export const getCreateAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssignment>>,
    TError,
    { data: BodyType<CreatePronunciationAssignmentRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssignment>>,
  TError,
  { data: BodyType<CreatePronunciationAssignmentRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssignment>>,
    { data: BodyType<CreatePronunciationAssignmentRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAssignment>>
>;
export type CreateAssignmentMutationBody =
  BodyType<CreatePronunciationAssignmentRequestDto>;
export type CreateAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssignment>>,
    TError,
    { data: BodyType<CreatePronunciationAssignmentRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAssignment>>,
  TError,
  { data: BodyType<CreatePronunciationAssignmentRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const assignPronunciationAssignment = (
  id: number,
  assignInteractiveMaterialRequestDto: BodyType<AssignInteractiveMaterialRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PronunciationAssignmentResponseDto>({
    url: `/swann-pronunciation/assignments/${id}/assign`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: assignInteractiveMaterialRequestDto,
    signal,
  });
};

export const getAssignPronunciationAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPronunciationAssignment>>,
    TError,
    { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignPronunciationAssignment>>,
  TError,
  { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignPronunciationAssignment>>,
    { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignPronunciationAssignment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignPronunciationAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignPronunciationAssignment>>
>;
export type AssignPronunciationAssignmentMutationBody =
  BodyType<AssignInteractiveMaterialRequestDto>;
export type AssignPronunciationAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAssignPronunciationAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPronunciationAssignment>>,
    TError,
    { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignPronunciationAssignment>>,
  TError,
  { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
  TContext
> => {
  const mutationOptions =
    getAssignPronunciationAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const submitAudioFromS3ForStudent = (
  submissionId: number,
  publicSubmitRequestDto: BodyType<PublicSubmitRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PublicSubmissionResponseDto>({
    url: `/swann-pronunciation/assignments/student/${submissionId}/submit-url`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: publicSubmitRequestDto,
    signal,
  });
};

export const getSubmitAudioFromS3ForStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitAudioFromS3ForStudent>>,
    TError,
    { submissionId: number; data: BodyType<PublicSubmitRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitAudioFromS3ForStudent>>,
  TError,
  { submissionId: number; data: BodyType<PublicSubmitRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitAudioFromS3ForStudent>>,
    { submissionId: number; data: BodyType<PublicSubmitRequestDto> }
  > = (props) => {
    const { submissionId, data } = props ?? {};

    return submitAudioFromS3ForStudent(submissionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitAudioFromS3ForStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAudioFromS3ForStudent>>
>;
export type SubmitAudioFromS3ForStudentMutationBody =
  BodyType<PublicSubmitRequestDto>;
export type SubmitAudioFromS3ForStudentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSubmitAudioFromS3ForStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitAudioFromS3ForStudent>>,
    TError,
    { submissionId: number; data: BodyType<PublicSubmitRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitAudioFromS3ForStudent>>,
  TError,
  { submissionId: number; data: BodyType<PublicSubmitRequestDto> },
  TContext
> => {
  const mutationOptions =
    getSubmitAudioFromS3ForStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createSummarizer = (
  summarizerCreateRequestDto: BodyType<SummarizerCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SummarizerResponseDto>({
    url: `/summarizers`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: summarizerCreateRequestDto,
    signal,
  });
};

export const getCreateSummarizerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSummarizer>>,
    TError,
    { data: BodyType<SummarizerCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSummarizer>>,
  TError,
  { data: BodyType<SummarizerCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSummarizer>>,
    { data: BodyType<SummarizerCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createSummarizer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSummarizerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSummarizer>>
>;
export type CreateSummarizerMutationBody = BodyType<SummarizerCreateRequestDto>;
export type CreateSummarizerMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateSummarizer = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSummarizer>>,
    TError,
    { data: BodyType<SummarizerCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSummarizer>>,
  TError,
  { data: BodyType<SummarizerCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateSummarizerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateSummarizer = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<SummarizerResponseDto>({
    url: `/summarizers/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateSummarizerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSummarizer>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateSummarizer>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateSummarizer>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateSummarizer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateSummarizerMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateSummarizer>>
>;
export type RegenerateSummarizerMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateSummarizerMutationError = ErrorType<BaseErrorResponseDto>;

export const useRegenerateSummarizer = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSummarizer>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateSummarizer>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateSummarizerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const registerStudent = (
  registerStudentRequestBodyDto: BodyType<RegisterStudentRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<RegisterStudentResponseDto>({
    url: `/students/register`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: registerStudentRequestBodyDto,
    signal,
  });
};

export const getRegisterStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerStudent>>,
    TError,
    { data: BodyType<RegisterStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerStudent>>,
  TError,
  { data: BodyType<RegisterStudentRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerStudent>>,
    { data: BodyType<RegisterStudentRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return registerStudent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerStudent>>
>;
export type RegisterStudentMutationBody =
  BodyType<RegisterStudentRequestBodyDto>;
export type RegisterStudentMutationError = ErrorType<BaseErrorResponseDto>;

export const useRegisterStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerStudent>>,
    TError,
    { data: BodyType<RegisterStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerStudent>>,
  TError,
  { data: BodyType<RegisterStudentRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getRegisterStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const enrollClassroomWithCode = (
  enrollClassroomWithCodeRequestBodyDto: BodyType<EnrollClassroomWithCodeRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/students/enrollClassroomWithCode`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: enrollClassroomWithCodeRequestBodyDto,
    signal,
  });
};

export const getEnrollClassroomWithCodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollClassroomWithCode>>,
    TError,
    { data: BodyType<EnrollClassroomWithCodeRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrollClassroomWithCode>>,
  TError,
  { data: BodyType<EnrollClassroomWithCodeRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrollClassroomWithCode>>,
    { data: BodyType<EnrollClassroomWithCodeRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return enrollClassroomWithCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnrollClassroomWithCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrollClassroomWithCode>>
>;
export type EnrollClassroomWithCodeMutationBody =
  BodyType<EnrollClassroomWithCodeRequestBodyDto>;
export type EnrollClassroomWithCodeMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEnrollClassroomWithCode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrollClassroomWithCode>>,
    TError,
    { data: BodyType<EnrollClassroomWithCodeRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof enrollClassroomWithCode>>,
  TError,
  { data: BodyType<EnrollClassroomWithCodeRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getEnrollClassroomWithCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editStudent = (
  editStudentRequestBodyDto: BodyType<EditStudentRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentResponseDto>({
    url: `/students/edit`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: editStudentRequestBodyDto,
    signal,
  });
};

export const getEditStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editStudent>>,
    TError,
    { data: BodyType<EditStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editStudent>>,
  TError,
  { data: BodyType<EditStudentRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editStudent>>,
    { data: BodyType<EditStudentRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return editStudent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof editStudent>>
>;
export type EditStudentMutationBody = BodyType<EditStudentRequestBodyDto>;
export type EditStudentMutationError = ErrorType<BaseErrorResponseDto>;

export const useEditStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editStudent>>,
    TError,
    { data: BodyType<EditStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editStudent>>,
  TError,
  { data: BodyType<EditStudentRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getEditStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Start assignment of student
 * @summary Start assignment of student (Homework)
 */
export const startStudentAssignment = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/students/assignments/${assignmentId}/start`,
    method: "POST",
    signal,
  });
};

export const getStartStudentAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startStudentAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startStudentAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startStudentAssignment>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return startStudentAssignment(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartStudentAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof startStudentAssignment>>
>;

export type StartStudentAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Start assignment of student (Homework)
 */
export const useStartStudentAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startStudentAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof startStudentAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions = getStartStudentAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Create answer of question for student
 * @summary Create answer of question
 */
export const createQuestionAnswer = (
  assignmentId: number,
  questionId: number,
  createQuestionAnswerRequestBodyDto: BodyType<CreateQuestionAnswerRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/students/assignments/${assignmentId}/questions/${questionId}/answer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createQuestionAnswerRequestBodyDto,
    signal,
  });
};

export const getCreateQuestionAnswerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionAnswer>>,
    TError,
    {
      assignmentId: number;
      questionId: number;
      data: BodyType<CreateQuestionAnswerRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuestionAnswer>>,
  TError,
  {
    assignmentId: number;
    questionId: number;
    data: BodyType<CreateQuestionAnswerRequestBodyDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuestionAnswer>>,
    {
      assignmentId: number;
      questionId: number;
      data: BodyType<CreateQuestionAnswerRequestBodyDto>;
    }
  > = (props) => {
    const { assignmentId, questionId, data } = props ?? {};

    return createQuestionAnswer(assignmentId, questionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuestionAnswerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuestionAnswer>>
>;
export type CreateQuestionAnswerMutationBody =
  BodyType<CreateQuestionAnswerRequestBodyDto>;
export type CreateQuestionAnswerMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Create answer of question
 */
export const useCreateQuestionAnswer = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionAnswer>>,
    TError,
    {
      assignmentId: number;
      questionId: number;
      data: BodyType<CreateQuestionAnswerRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuestionAnswer>>,
  TError,
  {
    assignmentId: number;
    questionId: number;
    data: BodyType<CreateQuestionAnswerRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions = getCreateQuestionAnswerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Finish assignment of student
 * @summary Finish assignment of student
 */
export const endStudentAssignment = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/students/assignments/${assignmentId}/finish`,
    method: "POST",
    signal,
  });
};

export const getEndStudentAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endStudentAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof endStudentAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endStudentAssignment>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return endStudentAssignment(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type EndStudentAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof endStudentAssignment>>
>;

export type EndStudentAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Finish assignment of student
 */
export const useEndStudentAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endStudentAssignment>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof endStudentAssignment>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions = getEndStudentAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const assignInteractiveMaterial = (
  id: number,
  assignInteractiveMaterialRequestDto: BodyType<AssignInteractiveMaterialRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentInteractiveMaterialResponseDto[]>({
    url: `/student-interactive-materials/${id}/assign`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: assignInteractiveMaterialRequestDto,
    signal,
  });
};

export const getAssignInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignInteractiveMaterial>>,
    TError,
    { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignInteractiveMaterial>>,
  TError,
  { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignInteractiveMaterial>>,
    { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignInteractiveMaterial(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignInteractiveMaterial>>
>;
export type AssignInteractiveMaterialMutationBody =
  BodyType<AssignInteractiveMaterialRequestDto>;
export type AssignInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAssignInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignInteractiveMaterial>>,
    TError,
    { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignInteractiveMaterial>>,
  TError,
  { id: number; data: BodyType<AssignInteractiveMaterialRequestDto> },
  TContext
> => {
  const mutationOptions = getAssignInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleTokenRequest = (
  params: HandleTokenRequestParams,
  signal?: AbortSignal,
) => {
  return configureAxios<HandleTokenRequest200>({
    url: `/sso/circle/token`,
    method: "POST",
    params,
    signal,
  });
};

export const getHandleTokenRequestMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTokenRequest>>,
    TError,
    { params: HandleTokenRequestParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleTokenRequest>>,
  TError,
  { params: HandleTokenRequestParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleTokenRequest>>,
    { params: HandleTokenRequestParams }
  > = (props) => {
    const { params } = props ?? {};

    return handleTokenRequest(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleTokenRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleTokenRequest>>
>;

export type HandleTokenRequestMutationError = ErrorType<BaseErrorResponseDto>;

export const useHandleTokenRequest = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleTokenRequest>>,
    TError,
    { params: HandleTokenRequestParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleTokenRequest>>,
  TError,
  { params: HandleTokenRequestParams },
  TContext
> => {
  const mutationOptions = getHandleTokenRequestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSlideGenerators = (signal?: AbortSignal) => {
  return configureAxios<SlideGeneratorResponseDto[]>({
    url: `/slide-generator`,
    method: "GET",
    signal,
  });
};

export const getGetSlideGeneratorsQueryKey = () => {
  return [`/slide-generator`] as const;
};

export const getGetSlideGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSlideGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSlideGenerators>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSlideGeneratorsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSlideGenerators>>
  > = ({ signal }) => getSlideGenerators(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSlideGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSlideGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSlideGenerators>>
>;
export type GetSlideGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSlideGenerators<
  TData = Awaited<ReturnType<typeof getSlideGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSlideGenerators>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSlideGenerators>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSlideGenerators<
  TData = Awaited<ReturnType<typeof getSlideGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSlideGenerators>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSlideGenerators>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSlideGenerators<
  TData = Awaited<ReturnType<typeof getSlideGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSlideGenerators>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSlideGenerators<
  TData = Awaited<ReturnType<typeof getSlideGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSlideGenerators>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSlideGeneratorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createSlideOutlineGenerator = (
  createSlideGeneratorOutlineRequestDto: BodyType<CreateSlideGeneratorOutlineRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SlideGeneratorResponseDto>({
    url: `/slide-generator`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSlideGeneratorOutlineRequestDto,
    signal,
  });
};

export const getCreateSlideOutlineGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSlideOutlineGenerator>>,
    TError,
    { data: BodyType<CreateSlideGeneratorOutlineRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSlideOutlineGenerator>>,
  TError,
  { data: BodyType<CreateSlideGeneratorOutlineRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSlideOutlineGenerator>>,
    { data: BodyType<CreateSlideGeneratorOutlineRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createSlideOutlineGenerator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSlideOutlineGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSlideOutlineGenerator>>
>;
export type CreateSlideOutlineGeneratorMutationBody =
  BodyType<CreateSlideGeneratorOutlineRequestDto>;
export type CreateSlideOutlineGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateSlideOutlineGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSlideOutlineGenerator>>,
    TError,
    { data: BodyType<CreateSlideGeneratorOutlineRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSlideOutlineGenerator>>,
  TError,
  { data: BodyType<CreateSlideGeneratorOutlineRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateSlideOutlineGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenSlideOutlineGenerator = (
  id: number,
  regenSlideGeneratorOutlineRequestDto: BodyType<RegenSlideGeneratorOutlineRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SlideGeneratorResponseDto>({
    url: `/slide-generator/${id}/regen-outline`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenSlideGeneratorOutlineRequestDto,
    signal,
  });
};

export const getRegenSlideOutlineGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenSlideOutlineGenerator>>,
    TError,
    { id: number; data: BodyType<RegenSlideGeneratorOutlineRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenSlideOutlineGenerator>>,
  TError,
  { id: number; data: BodyType<RegenSlideGeneratorOutlineRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenSlideOutlineGenerator>>,
    { id: number; data: BodyType<RegenSlideGeneratorOutlineRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenSlideOutlineGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenSlideOutlineGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenSlideOutlineGenerator>>
>;
export type RegenSlideOutlineGeneratorMutationBody =
  BodyType<RegenSlideGeneratorOutlineRequestDto>;
export type RegenSlideOutlineGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenSlideOutlineGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenSlideOutlineGenerator>>,
    TError,
    { id: number; data: BodyType<RegenSlideGeneratorOutlineRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenSlideOutlineGenerator>>,
  TError,
  { id: number; data: BodyType<RegenSlideGeneratorOutlineRequestDto> },
  TContext
> => {
  const mutationOptions = getRegenSlideOutlineGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateSlides = (
  id: number,
  createSlideGeneratorSlidesRequestDto: BodyType<CreateSlideGeneratorSlidesRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SlideGeneratorResponseDto>({
    url: `/slide-generator/${id}/generate-slides`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createSlideGeneratorSlidesRequestDto,
    signal,
  });
};

export const getGenerateSlidesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSlides>>,
    TError,
    { id: number; data: BodyType<CreateSlideGeneratorSlidesRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSlides>>,
  TError,
  { id: number; data: BodyType<CreateSlideGeneratorSlidesRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSlides>>,
    { id: number; data: BodyType<CreateSlideGeneratorSlidesRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateSlides(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSlidesMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSlides>>
>;
export type GenerateSlidesMutationBody =
  BodyType<CreateSlideGeneratorSlidesRequestDto>;
export type GenerateSlidesMutationError = ErrorType<BaseErrorResponseDto>;

export const useGenerateSlides = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSlides>>,
    TError,
    { id: number; data: BodyType<CreateSlideGeneratorSlidesRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateSlides>>,
  TError,
  { id: number; data: BodyType<CreateSlideGeneratorSlidesRequestDto> },
  TContext
> => {
  const mutationOptions = getGenerateSlidesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createSketchGenerator = (
  sketchGeneratorCreateRequestDto: BodyType<SketchGeneratorCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SketchGeneratorResponseDto>({
    url: `/sketch-generator`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sketchGeneratorCreateRequestDto,
    signal,
  });
};

export const getCreateSketchGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSketchGenerator>>,
    TError,
    { data: BodyType<SketchGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSketchGenerator>>,
  TError,
  { data: BodyType<SketchGeneratorCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSketchGenerator>>,
    { data: BodyType<SketchGeneratorCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createSketchGenerator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSketchGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSketchGenerator>>
>;
export type CreateSketchGeneratorMutationBody =
  BodyType<SketchGeneratorCreateRequestDto>;
export type CreateSketchGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateSketchGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSketchGenerator>>,
    TError,
    { data: BodyType<SketchGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSketchGenerator>>,
  TError,
  { data: BodyType<SketchGeneratorCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateSketchGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateVideo = (id: number, signal?: AbortSignal) => {
  return configureAxios<SketchGeneratorResponseDto>({
    url: `/sketch-generator/${id}/regenerate`,
    method: "POST",
    signal,
  });
};

export const getRegenerateVideoMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateVideo>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateVideo>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateVideo>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return regenerateVideo(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateVideo>>
>;

export type RegenerateVideoMutationError = ErrorType<BaseErrorResponseDto>;

export const useRegenerateVideo = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateVideo>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateVideo>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getRegenerateVideoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeSketchGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/sketch-generator/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeSketchGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeSketchGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeSketchGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeSketchGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeSketchGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeSketchGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeSketchGenerator>>
>;

export type LikeSketchGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeSketchGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeSketchGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeSketchGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeSketchGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeSketchGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/sketch-generator/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeSketchGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeSketchGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeSketchGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeSketchGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeSketchGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeSketchGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeSketchGenerator>>
>;

export type UnlikeSketchGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeSketchGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeSketchGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeSketchGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeSketchGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createRubricGenerator = (
  rubricGeneratorCreateRequestDto: BodyType<RubricGeneratorCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<RubricGeneratorResponseDto>({
    url: `/rubric-generator`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: rubricGeneratorCreateRequestDto,
    signal,
  });
};

export const getCreateRubricGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRubricGenerator>>,
    TError,
    { data: BodyType<RubricGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRubricGenerator>>,
  TError,
  { data: BodyType<RubricGeneratorCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRubricGenerator>>,
    { data: BodyType<RubricGeneratorCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createRubricGenerator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRubricGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRubricGenerator>>
>;
export type CreateRubricGeneratorMutationBody =
  BodyType<RubricGeneratorCreateRequestDto>;
export type CreateRubricGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateRubricGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRubricGenerator>>,
    TError,
    { data: BodyType<RubricGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRubricGenerator>>,
  TError,
  { data: BodyType<RubricGeneratorCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateRubricGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateRubricGenerator = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<RubricGeneratorResponseDto>({
    url: `/rubric-generator/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateRubricGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateRubricGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateRubricGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateRubricGenerator>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateRubricGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateRubricGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateRubricGenerator>>
>;
export type RegenerateRubricGeneratorMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateRubricGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateRubricGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateRubricGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateRubricGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateRubricGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeRubricGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/rubric-generator/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeRubricGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeRubricGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeRubricGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeRubricGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeRubricGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeRubricGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeRubricGenerator>>
>;

export type LikeRubricGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeRubricGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeRubricGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeRubricGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeRubricGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeRubricGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/rubric-generator/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeRubricGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeRubricGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeRubricGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeRubricGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeRubricGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeRubricGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeRubricGenerator>>
>;

export type UnlikeRubricGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeRubricGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeRubricGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeRubricGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeRubricGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createRealWorldConnection = (
  realWorldConnectionCreateRequestDto: BodyType<RealWorldConnectionCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<RealWorldConnectionResponseDto>({
    url: `/real-world-connections`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: realWorldConnectionCreateRequestDto,
    signal,
  });
};

export const getCreateRealWorldConnectionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRealWorldConnection>>,
    TError,
    { data: BodyType<RealWorldConnectionCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRealWorldConnection>>,
  TError,
  { data: BodyType<RealWorldConnectionCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRealWorldConnection>>,
    { data: BodyType<RealWorldConnectionCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createRealWorldConnection(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRealWorldConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRealWorldConnection>>
>;
export type CreateRealWorldConnectionMutationBody =
  BodyType<RealWorldConnectionCreateRequestDto>;
export type CreateRealWorldConnectionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateRealWorldConnection = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRealWorldConnection>>,
    TError,
    { data: BodyType<RealWorldConnectionCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRealWorldConnection>>,
  TError,
  { data: BodyType<RealWorldConnectionCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateRealWorldConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateRealWorldConnection = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<RealWorldConnectionResponseDto>({
    url: `/real-world-connections/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateRealWorldConnectionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateRealWorldConnection>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateRealWorldConnection>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateRealWorldConnection>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateRealWorldConnection(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateRealWorldConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateRealWorldConnection>>
>;
export type RegenerateRealWorldConnectionMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateRealWorldConnectionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateRealWorldConnection = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateRealWorldConnection>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateRealWorldConnection>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateRealWorldConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeRealWorldConnection = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/real-world-connections/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeRealWorldConnectionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeRealWorldConnection>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeRealWorldConnection>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeRealWorldConnection>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeRealWorldConnection(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeRealWorldConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeRealWorldConnection>>
>;

export type LikeRealWorldConnectionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeRealWorldConnection = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeRealWorldConnection>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeRealWorldConnection>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeRealWorldConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeRealWorldConnection = (id: number) => {
  return configureAxios<void>({
    url: `/real-world-connections/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeRealWorldConnectionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeRealWorldConnection>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeRealWorldConnection>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeRealWorldConnection>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeRealWorldConnection(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeRealWorldConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeRealWorldConnection>>
>;

export type UnlikeRealWorldConnectionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeRealWorldConnection = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeRealWorldConnection>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeRealWorldConnection>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeRealWorldConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createQuestionSolverV2 = (
  questionSolverCreateRequestDto: BodyType<QuestionSolverCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<GetQuestionSolverResponseDtoV2>({
    url: `/question-solver/v2`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: questionSolverCreateRequestDto,
    signal,
  });
};

export const getCreateQuestionSolverV2MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionSolverV2>>,
    TError,
    { data: BodyType<QuestionSolverCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuestionSolverV2>>,
  TError,
  { data: BodyType<QuestionSolverCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuestionSolverV2>>,
    { data: BodyType<QuestionSolverCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createQuestionSolverV2(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuestionSolverV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuestionSolverV2>>
>;
export type CreateQuestionSolverV2MutationBody =
  BodyType<QuestionSolverCreateRequestDto>;
export type CreateQuestionSolverV2MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateQuestionSolverV2 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionSolverV2>>,
    TError,
    { data: BodyType<QuestionSolverCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuestionSolverV2>>,
  TError,
  { data: BodyType<QuestionSolverCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateQuestionSolverV2MutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenQuestionSolverV2 = (
  id: number,
  params?: RegenQuestionSolverV2Params,
  signal?: AbortSignal,
) => {
  return configureAxios<GetQuestionSolverResponseDtoV2>({
    url: `/question-solver/v2/${id}/regen`,
    method: "POST",
    params,
    signal,
  });
};

export const getRegenQuestionSolverV2MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenQuestionSolverV2>>,
    TError,
    { id: number; params?: RegenQuestionSolverV2Params },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenQuestionSolverV2>>,
  TError,
  { id: number; params?: RegenQuestionSolverV2Params },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenQuestionSolverV2>>,
    { id: number; params?: RegenQuestionSolverV2Params }
  > = (props) => {
    const { id, params } = props ?? {};

    return regenQuestionSolverV2(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenQuestionSolverV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof regenQuestionSolverV2>>
>;

export type RegenQuestionSolverV2MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenQuestionSolverV2 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenQuestionSolverV2>>,
    TError,
    { id: number; params?: RegenQuestionSolverV2Params },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenQuestionSolverV2>>,
  TError,
  { id: number; params?: RegenQuestionSolverV2Params },
  TContext
> => {
  const mutationOptions = getRegenQuestionSolverV2MutationOptions(options);

  return useMutation(mutationOptions);
};

export const createQuestionRegen = (
  createQuestionRegenRequestDto: BodyType<CreateQuestionRegenRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<QuestionRegenResponseDto>({
    url: `/question-regen`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createQuestionRegenRequestDto,
    signal,
  });
};

export const getCreateQuestionRegenMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionRegen>>,
    TError,
    { data: BodyType<CreateQuestionRegenRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuestionRegen>>,
  TError,
  { data: BodyType<CreateQuestionRegenRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuestionRegen>>,
    { data: BodyType<CreateQuestionRegenRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createQuestionRegen(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuestionRegenMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuestionRegen>>
>;
export type CreateQuestionRegenMutationBody =
  BodyType<CreateQuestionRegenRequestDto>;
export type CreateQuestionRegenMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateQuestionRegen = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionRegen>>,
    TError,
    { data: BodyType<CreateQuestionRegenRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuestionRegen>>,
  TError,
  { data: BodyType<CreateQuestionRegenRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateQuestionRegenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const applyQuestionRegenToQuestion = (
  applyQuestionRegenRequestDto: BodyType<ApplyQuestionRegenRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/question-regen/apply`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: applyQuestionRegenRequestDto,
    signal,
  });
};

export const getApplyQuestionRegenToQuestionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyQuestionRegenToQuestion>>,
    TError,
    { data: BodyType<ApplyQuestionRegenRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyQuestionRegenToQuestion>>,
  TError,
  { data: BodyType<ApplyQuestionRegenRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyQuestionRegenToQuestion>>,
    { data: BodyType<ApplyQuestionRegenRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return applyQuestionRegenToQuestion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyQuestionRegenToQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyQuestionRegenToQuestion>>
>;
export type ApplyQuestionRegenToQuestionMutationBody =
  BodyType<ApplyQuestionRegenRequestDto>;
export type ApplyQuestionRegenToQuestionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useApplyQuestionRegenToQuestion = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyQuestionRegenToQuestion>>,
    TError,
    { data: BodyType<ApplyQuestionRegenRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyQuestionRegenToQuestion>>,
  TError,
  { data: BodyType<ApplyQuestionRegenRequestDto> },
  TContext
> => {
  const mutationOptions =
    getApplyQuestionRegenToQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieve a paginated list of question helpers with optional filtering by tags, title, and status
 * @summary Get all question helpers for the authenticated user
 */
export const getQuestionHelpers = (
  params?: GetQuestionHelpersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<QuestionHelperListResponseDto>({
    url: `/question-helper`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetQuestionHelpersQueryKey = (
  params?: GetQuestionHelpersParams,
) => {
  return [`/question-helper`, ...(params ? [params] : [])] as const;
};

export const getGetQuestionHelpersQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionHelpers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionHelpersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelpers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionHelpersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionHelpers>>
  > = ({ signal }) => getQuestionHelpers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionHelpers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionHelpersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionHelpers>>
>;
export type GetQuestionHelpersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetQuestionHelpers<
  TData = Awaited<ReturnType<typeof getQuestionHelpers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetQuestionHelpersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelpers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionHelpers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionHelpers<
  TData = Awaited<ReturnType<typeof getQuestionHelpers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionHelpersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelpers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionHelpers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionHelpers<
  TData = Awaited<ReturnType<typeof getQuestionHelpers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionHelpersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelpers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all question helpers for the authenticated user
 */

export function useGetQuestionHelpers<
  TData = Awaited<ReturnType<typeof getQuestionHelpers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionHelpersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionHelpers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionHelpersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Submit an image of a question to get AI-generated solution steps
 * @summary Create a new question helper request
 */
export const createQuestionHelper = (
  questionHelperCreateRequestDto: BodyType<QuestionHelperCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<QuestionHelperResponseDto>({
    url: `/question-helper`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: questionHelperCreateRequestDto,
    signal,
  });
};

export const getCreateQuestionHelperMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionHelper>>,
    TError,
    { data: BodyType<QuestionHelperCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuestionHelper>>,
  TError,
  { data: BodyType<QuestionHelperCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuestionHelper>>,
    { data: BodyType<QuestionHelperCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createQuestionHelper(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuestionHelperMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuestionHelper>>
>;
export type CreateQuestionHelperMutationBody =
  BodyType<QuestionHelperCreateRequestDto>;
export type CreateQuestionHelperMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Create a new question helper request
 */
export const useCreateQuestionHelper = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuestionHelper>>,
    TError,
    { data: BodyType<QuestionHelperCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuestionHelper>>,
  TError,
  { data: BodyType<QuestionHelperCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateQuestionHelperMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createSpokenDialogueSession = (
  publicCode: string,
  createPublicSessionRequestDto: BodyType<CreatePublicSessionRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreatePublicSessionResponseDto>({
    url: `/public/spoken-dialogue/${publicCode}/session`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPublicSessionRequestDto,
    signal,
  });
};

export const getCreateSpokenDialogueSessionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpokenDialogueSession>>,
    TError,
    { publicCode: string; data: BodyType<CreatePublicSessionRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpokenDialogueSession>>,
  TError,
  { publicCode: string; data: BodyType<CreatePublicSessionRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpokenDialogueSession>>,
    { publicCode: string; data: BodyType<CreatePublicSessionRequestDto> }
  > = (props) => {
    const { publicCode, data } = props ?? {};

    return createSpokenDialogueSession(publicCode, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpokenDialogueSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpokenDialogueSession>>
>;
export type CreateSpokenDialogueSessionMutationBody =
  BodyType<CreatePublicSessionRequestDto>;
export type CreateSpokenDialogueSessionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateSpokenDialogueSession = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpokenDialogueSession>>,
    TError,
    { publicCode: string; data: BodyType<CreatePublicSessionRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpokenDialogueSession>>,
  TError,
  { publicCode: string; data: BodyType<CreatePublicSessionRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateSpokenDialogueSessionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const enhancePrompt = (
  promptEnhancerCreateRequestDto: BodyType<PromptEnhancerCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PromptEnhancerResponseDto>({
    url: `/prompt-enhancer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: promptEnhancerCreateRequestDto,
    signal,
  });
};

export const getEnhancePromptMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enhancePrompt>>,
    TError,
    { data: BodyType<PromptEnhancerCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enhancePrompt>>,
  TError,
  { data: BodyType<PromptEnhancerCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enhancePrompt>>,
    { data: BodyType<PromptEnhancerCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return enhancePrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnhancePromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof enhancePrompt>>
>;
export type EnhancePromptMutationBody =
  BodyType<PromptEnhancerCreateRequestDto>;
export type EnhancePromptMutationError = ErrorType<BaseErrorResponseDto>;

export const useEnhancePrompt = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enhancePrompt>>,
    TError,
    { data: BodyType<PromptEnhancerCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof enhancePrompt>>,
  TError,
  { data: BodyType<PromptEnhancerCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getEnhancePromptMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createProjectBasedLearning = (
  projectBasedLearningCreateRequestDto: BodyType<ProjectBasedLearningCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ProjectBasedLearningResponseDto>({
    url: `/project-based-learning`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: projectBasedLearningCreateRequestDto,
    signal,
  });
};

export const getCreateProjectBasedLearningMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectBasedLearning>>,
    TError,
    { data: BodyType<ProjectBasedLearningCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProjectBasedLearning>>,
  TError,
  { data: BodyType<ProjectBasedLearningCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProjectBasedLearning>>,
    { data: BodyType<ProjectBasedLearningCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createProjectBasedLearning(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectBasedLearningMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProjectBasedLearning>>
>;
export type CreateProjectBasedLearningMutationBody =
  BodyType<ProjectBasedLearningCreateRequestDto>;
export type CreateProjectBasedLearningMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateProjectBasedLearning = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProjectBasedLearning>>,
    TError,
    { data: BodyType<ProjectBasedLearningCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProjectBasedLearning>>,
  TError,
  { data: BodyType<ProjectBasedLearningCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateProjectBasedLearningMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateProjectBasedLearning = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<ProjectBasedLearningResponseDto>({
    url: `/project-based-learning/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateProjectBasedLearningMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateProjectBasedLearning>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateProjectBasedLearning>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateProjectBasedLearning>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateProjectBasedLearning(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateProjectBasedLearningMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateProjectBasedLearning>>
>;
export type RegenerateProjectBasedLearningMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateProjectBasedLearningMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateProjectBasedLearning = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateProjectBasedLearning>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateProjectBasedLearning>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateProjectBasedLearningMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeProjectBasedLearning = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/project-based-learning/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeProjectBasedLearningMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeProjectBasedLearning>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeProjectBasedLearning>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeProjectBasedLearning>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeProjectBasedLearning(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeProjectBasedLearningMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeProjectBasedLearning>>
>;

export type LikeProjectBasedLearningMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeProjectBasedLearning = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeProjectBasedLearning>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeProjectBasedLearning>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeProjectBasedLearningMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeProjectBasedLearning = (id: number) => {
  return configureAxios<void>({
    url: `/project-based-learning/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeProjectBasedLearningMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeProjectBasedLearning>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeProjectBasedLearning>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeProjectBasedLearning>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeProjectBasedLearning(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeProjectBasedLearningMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeProjectBasedLearning>>
>;

export type UnlikeProjectBasedLearningMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeProjectBasedLearning = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeProjectBasedLearning>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeProjectBasedLearning>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeProjectBasedLearningMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createPodcast = (
  createPodcastRequestDto: BodyType<CreatePodcastRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PodcastResponseDto>({
    url: `/podcasts`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPodcastRequestDto,
    signal,
  });
};

export const getCreatePodcastMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPodcast>>,
    TError,
    { data: BodyType<CreatePodcastRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPodcast>>,
  TError,
  { data: BodyType<CreatePodcastRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPodcast>>,
    { data: BodyType<CreatePodcastRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createPodcast(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePodcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPodcast>>
>;
export type CreatePodcastMutationBody = BodyType<CreatePodcastRequestDto>;
export type CreatePodcastMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreatePodcast = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPodcast>>,
    TError,
    { data: BodyType<CreatePodcastRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPodcast>>,
  TError,
  { data: BodyType<CreatePodcastRequestDto> },
  TContext
> => {
  const mutationOptions = getCreatePodcastMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likePodcast = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/podcasts/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikePodcastMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likePodcast>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likePodcast>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likePodcast>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likePodcast(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikePodcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof likePodcast>>
>;

export type LikePodcastMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikePodcast = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likePodcast>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likePodcast>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikePodcastMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikePodcast = (id: number) => {
  return configureAxios<void>({
    url: `/podcasts/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikePodcastMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikePodcast>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikePodcast>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikePodcast>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikePodcast(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikePodcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikePodcast>>
>;

export type UnlikePodcastMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikePodcast = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikePodcast>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikePodcast>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikePodcastMutationOptions(options);

  return useMutation(mutationOptions);
};

export const assignPodcastToStudents = (
  id: number,
  assignPodcastRequestDto: BodyType<AssignPodcastRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentPodcastResponseDto[]>({
    url: `/podcasts/students/${id}/assign`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: assignPodcastRequestDto,
    signal,
  });
};

export const getAssignPodcastToStudentsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPodcastToStudents>>,
    TError,
    { id: number; data: BodyType<AssignPodcastRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignPodcastToStudents>>,
  TError,
  { id: number; data: BodyType<AssignPodcastRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignPodcastToStudents>>,
    { id: number; data: BodyType<AssignPodcastRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignPodcastToStudents(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignPodcastToStudentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignPodcastToStudents>>
>;
export type AssignPodcastToStudentsMutationBody =
  BodyType<AssignPodcastRequestDto>;
export type AssignPodcastToStudentsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAssignPodcastToStudents = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPodcastToStudents>>,
    TError,
    { id: number; data: BodyType<AssignPodcastRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignPodcastToStudents>>,
  TError,
  { id: number; data: BodyType<AssignPodcastRequestDto> },
  TContext
> => {
  const mutationOptions = getAssignPodcastToStudentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createPodcastFromReference = (
  createPodcastFromReferenceRequestDto: BodyType<CreatePodcastFromReferenceRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PodcastResponseDto>({
    url: `/podcasts/from-reference`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPodcastFromReferenceRequestDto,
    signal,
  });
};

export const getCreatePodcastFromReferenceMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPodcastFromReference>>,
    TError,
    { data: BodyType<CreatePodcastFromReferenceRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPodcastFromReference>>,
  TError,
  { data: BodyType<CreatePodcastFromReferenceRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPodcastFromReference>>,
    { data: BodyType<CreatePodcastFromReferenceRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createPodcastFromReference(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePodcastFromReferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPodcastFromReference>>
>;
export type CreatePodcastFromReferenceMutationBody =
  BodyType<CreatePodcastFromReferenceRequestDto>;
export type CreatePodcastFromReferenceMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreatePodcastFromReference = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPodcastFromReference>>,
    TError,
    { data: BodyType<CreatePodcastFromReferenceRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPodcastFromReference>>,
  TError,
  { data: BodyType<CreatePodcastFromReferenceRequestDto> },
  TContext
> => {
  const mutationOptions = getCreatePodcastFromReferenceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createPerformanceTask = (
  performanceTaskCreateRequestDto: BodyType<PerformanceTaskCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PerformanceTaskResponseDto>({
    url: `/performance-task`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: performanceTaskCreateRequestDto,
    signal,
  });
};

export const getCreatePerformanceTaskMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPerformanceTask>>,
    TError,
    { data: BodyType<PerformanceTaskCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPerformanceTask>>,
  TError,
  { data: BodyType<PerformanceTaskCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPerformanceTask>>,
    { data: BodyType<PerformanceTaskCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createPerformanceTask(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePerformanceTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPerformanceTask>>
>;
export type CreatePerformanceTaskMutationBody =
  BodyType<PerformanceTaskCreateRequestDto>;
export type CreatePerformanceTaskMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreatePerformanceTask = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPerformanceTask>>,
    TError,
    { data: BodyType<PerformanceTaskCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPerformanceTask>>,
  TError,
  { data: BodyType<PerformanceTaskCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreatePerformanceTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regeneratePerformanceTask = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<PerformanceTaskResponseDto>({
    url: `/performance-task/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegeneratePerformanceTaskMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regeneratePerformanceTask>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regeneratePerformanceTask>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regeneratePerformanceTask>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regeneratePerformanceTask(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegeneratePerformanceTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof regeneratePerformanceTask>>
>;
export type RegeneratePerformanceTaskMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegeneratePerformanceTaskMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegeneratePerformanceTask = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regeneratePerformanceTask>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regeneratePerformanceTask>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegeneratePerformanceTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likePerformanceTask = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/performance-task/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikePerformanceTaskMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likePerformanceTask>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likePerformanceTask>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likePerformanceTask>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likePerformanceTask(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikePerformanceTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof likePerformanceTask>>
>;

export type LikePerformanceTaskMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikePerformanceTask = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likePerformanceTask>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likePerformanceTask>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikePerformanceTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikePerformanceTask = (id: number) => {
  return configureAxios<void>({
    url: `/performance-task/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikePerformanceTaskMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikePerformanceTask>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikePerformanceTask>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikePerformanceTask>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikePerformanceTask(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikePerformanceTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikePerformanceTask>>
>;

export type UnlikePerformanceTaskMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikePerformanceTask = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikePerformanceTask>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikePerformanceTask>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikePerformanceTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

export const downloadAssignmentPdf = (id: number, signal?: AbortSignal) => {
  return configureAxios<string>({
    url: `/pdf-renderer/assignments/${id}`,
    method: "GET",
    signal,
  });
};

export const getDownloadAssignmentPdfQueryKey = (id: number) => {
  return [`/pdf-renderer/assignments/${id}`] as const;
};

export const getDownloadAssignmentPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAssignmentPdf>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAssignmentPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadAssignmentPdfQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadAssignmentPdf>>
  > = ({ signal }) => downloadAssignmentPdf(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAssignmentPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DownloadAssignmentPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAssignmentPdf>>
>;
export type DownloadAssignmentPdfQueryError = ErrorType<BaseErrorResponseDto>;

export function useDownloadAssignmentPdf<
  TData = Awaited<ReturnType<typeof downloadAssignmentPdf>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAssignmentPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAssignmentPdf>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadAssignmentPdf<
  TData = Awaited<ReturnType<typeof downloadAssignmentPdf>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAssignmentPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAssignmentPdf>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadAssignmentPdf<
  TData = Awaited<ReturnType<typeof downloadAssignmentPdf>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAssignmentPdf>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useDownloadAssignmentPdf<
  TData = Awaited<ReturnType<typeof downloadAssignmentPdf>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof downloadAssignmentPdf>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDownloadAssignmentPdfQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentAsPdf = (
  id: number,
  params?: GetAssignmentAsPdfParams,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/pdf-renderer/assignments/${id}`,
    method: "POST",
    params,
    signal,
  });
};

export const getGetAssignmentAsPdfMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAssignmentAsPdf>>,
    TError,
    { id: number; params?: GetAssignmentAsPdfParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAssignmentAsPdf>>,
  TError,
  { id: number; params?: GetAssignmentAsPdfParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAssignmentAsPdf>>,
    { id: number; params?: GetAssignmentAsPdfParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return getAssignmentAsPdf(id, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAssignmentAsPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentAsPdf>>
>;

export type GetAssignmentAsPdfMutationError = ErrorType<BaseErrorResponseDto>;

export const useGetAssignmentAsPdf = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAssignmentAsPdf>>,
    TError,
    { id: number; params?: GetAssignmentAsPdfParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAssignmentAsPdf>>,
  TError,
  { id: number; params?: GetAssignmentAsPdfParams },
  TContext
> => {
  const mutationOptions = getGetAssignmentAsPdfMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTeachers1 = (
  params?: GetTeachers1Params,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedTeacherResponseDto>({
    url: `/organization-admin/teachers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeachers1QueryKey = (params?: GetTeachers1Params) => {
  return [`/organization-admin/teachers`, ...(params ? [params] : [])] as const;
};

export const getGetTeachers1QueryOptions = <
  TData = Awaited<ReturnType<typeof getTeachers1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachers1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers1>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeachers1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeachers1>>> = ({
    signal,
  }) => getTeachers1(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeachers1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeachers1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeachers1>>
>;
export type GetTeachers1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeachers1<
  TData = Awaited<ReturnType<typeof getTeachers1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeachers1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeachers1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeachers1<
  TData = Awaited<ReturnType<typeof getTeachers1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachers1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeachers1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeachers1<
  TData = Awaited<ReturnType<typeof getTeachers1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachers1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeachers1<
  TData = Awaited<ReturnType<typeof getTeachers1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachers1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeachers1QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTeacher = (
  createTeacherRequestBodyDto: BodyType<CreateTeacherRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherResponseDto>({
    url: `/organization-admin/teachers`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTeacherRequestBodyDto,
    signal,
  });
};

export const getCreateTeacherMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeacher>>,
    TError,
    { data: BodyType<CreateTeacherRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeacher>>,
  TError,
  { data: BodyType<CreateTeacherRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeacher>>,
    { data: BodyType<CreateTeacherRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTeacher(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeacherMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTeacher>>
>;
export type CreateTeacherMutationBody = BodyType<CreateTeacherRequestBodyDto>;
export type CreateTeacherMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateTeacher = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeacher>>,
    TError,
    { data: BodyType<CreateTeacherRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTeacher>>,
  TError,
  { data: BodyType<CreateTeacherRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateTeacherMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createStudent = (
  createStudentRequestBodyDto: BodyType<CreateStudentRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentResponseDto>({
    url: `/organization-admin/students`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createStudentRequestBodyDto,
    signal,
  });
};

export const getCreateStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStudent>>,
    TError,
    { data: BodyType<CreateStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStudent>>,
  TError,
  { data: BodyType<CreateStudentRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStudent>>,
    { data: BodyType<CreateStudentRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createStudent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStudent>>
>;
export type CreateStudentMutationBody = BodyType<CreateStudentRequestBodyDto>;
export type CreateStudentMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStudent>>,
    TError,
    { data: BodyType<CreateStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStudent>>,
  TError,
  { data: BodyType<CreateStudentRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editOrganizationAdmin = (signal?: AbortSignal) => {
  return configureAxios<OrganizationAdminResponseDto>({
    url: `/organization-admin/complete-register`,
    method: "POST",
    signal,
  });
};

export const getEditOrganizationAdminMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOrganizationAdmin>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editOrganizationAdmin>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editOrganizationAdmin>>,
    void
  > = () => {
    return editOrganizationAdmin();
  };

  return { mutationFn, ...mutationOptions };
};

export type EditOrganizationAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof editOrganizationAdmin>>
>;

export type EditOrganizationAdminMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEditOrganizationAdmin = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOrganizationAdmin>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editOrganizationAdmin>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getEditOrganizationAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const editOrganizationAdmin1 = (signal?: AbortSignal) => {
  return configureAxios<OrganizationAdminResponseDto>({
    url: `/organization-admin/edit`,
    method: "POST",
    signal,
  });
};

export const getEditOrganizationAdmin1MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOrganizationAdmin1>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editOrganizationAdmin1>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editOrganizationAdmin1>>,
    void
  > = () => {
    return editOrganizationAdmin1();
  };

  return { mutationFn, ...mutationOptions };
};

export type EditOrganizationAdmin1MutationResult = NonNullable<
  Awaited<ReturnType<typeof editOrganizationAdmin1>>
>;

export type EditOrganizationAdmin1MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useEditOrganizationAdmin1 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editOrganizationAdmin1>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof editOrganizationAdmin1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getEditOrganizationAdmin1MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get classrooms of organization. You can filter with respect to grade and courseType. Does not contain students and their assignments.
 * @summary Get classrooms
 */
export const getClassrooms = (
  params?: GetClassroomsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomResponseDto[]>({
    url: `/organization-admin/classrooms`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomsQueryKey = (params?: GetClassroomsParams) => {
  return [
    `/organization-admin/classrooms`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassrooms>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassrooms>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClassroomsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassrooms>>> = ({
    signal,
  }) => getClassrooms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassrooms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassrooms>>
>;
export type GetClassroomsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassrooms<
  TData = Awaited<ReturnType<typeof getClassrooms>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetClassroomsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassrooms>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassrooms>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassrooms<
  TData = Awaited<ReturnType<typeof getClassrooms>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassrooms>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassrooms>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassrooms<
  TData = Awaited<ReturnType<typeof getClassrooms>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassrooms>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classrooms
 */

export function useGetClassrooms<
  TData = Awaited<ReturnType<typeof getClassrooms>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClassrooms>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createClassroom = (
  createClassroomRequestBodyDto: BodyType<CreateClassroomRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomResponseDto>({
    url: `/organization-admin/classrooms`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createClassroomRequestBodyDto,
    signal,
  });
};

export const getCreateClassroomMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClassroom>>,
    TError,
    { data: BodyType<CreateClassroomRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClassroom>>,
  TError,
  { data: BodyType<CreateClassroomRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClassroom>>,
    { data: BodyType<CreateClassroomRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createClassroom(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClassroomMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClassroom>>
>;
export type CreateClassroomMutationBody =
  BodyType<CreateClassroomRequestBodyDto>;
export type CreateClassroomMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateClassroom = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClassroom>>,
    TError,
    { data: BodyType<CreateClassroomRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClassroom>>,
  TError,
  { data: BodyType<CreateClassroomRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateClassroomMutationOptions(options);

  return useMutation(mutationOptions);
};

export const addStudentsToClassroomInOrganizationAdminController = (
  classroomId: number,
  addRemoveStudentsToFromClassroomRequestBodyDto: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<AddStudentsToClassroomInOrganizationAdminController200>(
    {
      url: `/organization-admin/classrooms/${classroomId}/students`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addRemoveStudentsToFromClassroomRequestBodyDto,
      signal,
    },
  );
};

export const getAddStudentsToClassroomInOrganizationAdminControllerMutationOptions =
  <TError = ErrorType<BaseErrorResponseDto>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addStudentsToClassroomInOrganizationAdminController>
      >,
      TError,
      {
        classroomId: number;
        data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addStudentsToClassroomInOrganizationAdminController>
    >,
    TError,
    {
      classroomId: number;
      data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addStudentsToClassroomInOrganizationAdminController>
      >,
      {
        classroomId: number;
        data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
      }
    > = (props) => {
      const { classroomId, data } = props ?? {};

      return addStudentsToClassroomInOrganizationAdminController(
        classroomId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddStudentsToClassroomInOrganizationAdminControllerMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addStudentsToClassroomInOrganizationAdminController>
    >
  >;
export type AddStudentsToClassroomInOrganizationAdminControllerMutationBody =
  BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
export type AddStudentsToClassroomInOrganizationAdminControllerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useAddStudentsToClassroomInOrganizationAdminController = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof addStudentsToClassroomInOrganizationAdminController>
    >,
    TError,
    {
      classroomId: number;
      data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof addStudentsToClassroomInOrganizationAdminController>
  >,
  TError,
  {
    classroomId: number;
    data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions =
    getAddStudentsToClassroomInOrganizationAdminControllerMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

export const removeStudentsFromClassroomInOrganizationAdminController = (
  classroomId: number,
  addRemoveStudentsToFromClassroomRequestBodyDto: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>,
) => {
  return configureAxios<RemoveStudentsFromClassroomInOrganizationAdminController200>(
    {
      url: `/organization-admin/classrooms/${classroomId}/students`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: addRemoveStudentsToFromClassroomRequestBodyDto,
    },
  );
};

export const getRemoveStudentsFromClassroomInOrganizationAdminControllerMutationOptions =
  <TError = ErrorType<BaseErrorResponseDto>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeStudentsFromClassroomInOrganizationAdminController
        >
      >,
      TError,
      {
        classroomId: number;
        data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeStudentsFromClassroomInOrganizationAdminController
      >
    >,
    TError,
    {
      classroomId: number;
      data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeStudentsFromClassroomInOrganizationAdminController
        >
      >,
      {
        classroomId: number;
        data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
      }
    > = (props) => {
      const { classroomId, data } = props ?? {};

      return removeStudentsFromClassroomInOrganizationAdminController(
        classroomId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveStudentsFromClassroomInOrganizationAdminControllerMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeStudentsFromClassroomInOrganizationAdminController
      >
    >
  >;
export type RemoveStudentsFromClassroomInOrganizationAdminControllerMutationBody =
  BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
export type RemoveStudentsFromClassroomInOrganizationAdminControllerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRemoveStudentsFromClassroomInOrganizationAdminController = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeStudentsFromClassroomInOrganizationAdminController
      >
    >,
    TError,
    {
      classroomId: number;
      data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof removeStudentsFromClassroomInOrganizationAdminController>
  >,
  TError,
  {
    classroomId: number;
    data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions =
    getRemoveStudentsFromClassroomInOrganizationAdminControllerMutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};

export const getApiKeys = (params?: GetApiKeysParams, signal?: AbortSignal) => {
  return configureAxios<ApiKeyEntity[]>({
    url: `/organization-admin/api-keys`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetApiKeysQueryKey = (params?: GetApiKeysParams) => {
  return [`/organization-admin/api-keys`, ...(params ? [params] : [])] as const;
};

export const getGetApiKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKeys>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetApiKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiKeysQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiKeys>>> = ({
    signal,
  }) => getApiKeys(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKeys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetApiKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKeys>>
>;
export type GetApiKeysQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetApiKeys<
  TData = Awaited<ReturnType<typeof getApiKeys>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetApiKeysParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKeys>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApiKeys<
  TData = Awaited<ReturnType<typeof getApiKeys>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetApiKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKeys>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApiKeys<
  TData = Awaited<ReturnType<typeof getApiKeys>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetApiKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetApiKeys<
  TData = Awaited<ReturnType<typeof getApiKeys>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetApiKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiKeys>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetApiKeysQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addApiKeys = (
  addApiKeyRequestDto: BodyType<AddApiKeyRequestDto[]>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/organization-admin/api-keys`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addApiKeyRequestDto,
    signal,
  });
};

export const getAddApiKeysMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addApiKeys>>,
    TError,
    { data: BodyType<AddApiKeyRequestDto[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addApiKeys>>,
  TError,
  { data: BodyType<AddApiKeyRequestDto[]> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addApiKeys>>,
    { data: BodyType<AddApiKeyRequestDto[]> }
  > = (props) => {
    const { data } = props ?? {};

    return addApiKeys(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddApiKeysMutationResult = NonNullable<
  Awaited<ReturnType<typeof addApiKeys>>
>;
export type AddApiKeysMutationBody = BodyType<AddApiKeyRequestDto[]>;
export type AddApiKeysMutationError = ErrorType<BaseErrorResponseDto>;

export const useAddApiKeys = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addApiKeys>>,
    TError,
    { data: BodyType<AddApiKeyRequestDto[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addApiKeys>>,
  TError,
  { data: BodyType<AddApiKeyRequestDto[]> },
  TContext
> => {
  const mutationOptions = getAddApiKeysMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeApiKeys = (removeApiKeysBody: BodyType<number[]>) => {
  return configureAxios<void>({
    url: `/organization-admin/api-keys`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: removeApiKeysBody,
  });
};

export const getRemoveApiKeysMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeApiKeys>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeApiKeys>>,
  TError,
  { data: BodyType<number[]> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeApiKeys>>,
    { data: BodyType<number[]> }
  > = (props) => {
    const { data } = props ?? {};

    return removeApiKeys(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveApiKeysMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeApiKeys>>
>;
export type RemoveApiKeysMutationBody = BodyType<number[]>;
export type RemoveApiKeysMutationError = ErrorType<BaseErrorResponseDto>;

export const useRemoveApiKeys = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeApiKeys>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeApiKeys>>,
  TError,
  { data: BodyType<number[]> },
  TContext
> => {
  const mutationOptions = getRemoveApiKeysMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOrganizations = (signal?: AbortSignal) => {
  return configureAxios<BaseOrganizationDTO[]>({
    url: `/org`,
    method: "GET",
    signal,
  });
};

export const getGetOrganizationsQueryKey = () => {
  return [`/org`] as const;
};

export const getGetOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizations>>
  > = ({ signal }) => getOrganizations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizations>>
>;
export type GetOrganizationsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getOrganizations>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getOrganizations>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addOrganization = (
  organizationCreateRequestBodyDto: BodyType<OrganizationCreateRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateOrganizationResponseDto>({
    url: `/org`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: organizationCreateRequestBodyDto,
    signal,
  });
};

export const getAddOrganizationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addOrganization>>,
    TError,
    { data: BodyType<OrganizationCreateRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addOrganization>>,
  TError,
  { data: BodyType<OrganizationCreateRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addOrganization>>,
    { data: BodyType<OrganizationCreateRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return addOrganization(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof addOrganization>>
>;
export type AddOrganizationMutationBody =
  BodyType<OrganizationCreateRequestBodyDto>;
export type AddOrganizationMutationError = ErrorType<BaseErrorResponseDto>;

export const useAddOrganization = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addOrganization>>,
    TError,
    { data: BodyType<OrganizationCreateRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addOrganization>>,
  TError,
  { data: BodyType<OrganizationCreateRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getAddOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createMindmapGenerator = (
  mindmapGeneratorCreateRequestDto: BodyType<MindmapGeneratorCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<MindmapGeneratorResponseDto>({
    url: `/mindmap-generator`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: mindmapGeneratorCreateRequestDto,
    signal,
  });
};

export const getCreateMindmapGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMindmapGenerator>>,
    TError,
    { data: BodyType<MindmapGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMindmapGenerator>>,
  TError,
  { data: BodyType<MindmapGeneratorCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMindmapGenerator>>,
    { data: BodyType<MindmapGeneratorCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createMindmapGenerator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMindmapGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMindmapGenerator>>
>;
export type CreateMindmapGeneratorMutationBody =
  BodyType<MindmapGeneratorCreateRequestDto>;
export type CreateMindmapGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateMindmapGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMindmapGenerator>>,
    TError,
    { data: BodyType<MindmapGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMindmapGenerator>>,
  TError,
  { data: BodyType<MindmapGeneratorCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateMindmapGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const generateToolFromMindmapNode = (
  mindmapId: number,
  generateToolFromNodeRequestDto: BodyType<GenerateToolFromNodeRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<MindmapGeneratorResponseDto>({
    url: `/mindmap-generator/${mindmapId}/nodes/generate-tool`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateToolFromNodeRequestDto,
    signal,
  });
};

export const getGenerateToolFromMindmapNodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateToolFromMindmapNode>>,
    TError,
    { mindmapId: number; data: BodyType<GenerateToolFromNodeRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateToolFromMindmapNode>>,
  TError,
  { mindmapId: number; data: BodyType<GenerateToolFromNodeRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateToolFromMindmapNode>>,
    { mindmapId: number; data: BodyType<GenerateToolFromNodeRequestDto> }
  > = (props) => {
    const { mindmapId, data } = props ?? {};

    return generateToolFromMindmapNode(mindmapId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateToolFromMindmapNodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateToolFromMindmapNode>>
>;
export type GenerateToolFromMindmapNodeMutationBody =
  BodyType<GenerateToolFromNodeRequestDto>;
export type GenerateToolFromMindmapNodeMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useGenerateToolFromMindmapNode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateToolFromMindmapNode>>,
    TError,
    { mindmapId: number; data: BodyType<GenerateToolFromNodeRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateToolFromMindmapNode>>,
  TError,
  { mindmapId: number; data: BodyType<GenerateToolFromNodeRequestDto> },
  TContext
> => {
  const mutationOptions =
    getGenerateToolFromMindmapNodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateMindmapGenerator = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<MindmapGeneratorResponseDto>({
    url: `/mindmap-generator/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateMindmapGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateMindmapGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateMindmapGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateMindmapGenerator>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateMindmapGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateMindmapGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateMindmapGenerator>>
>;
export type RegenerateMindmapGeneratorMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateMindmapGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateMindmapGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateMindmapGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateMindmapGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateMindmapGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeMindmapGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/mindmap-generator/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeMindmapGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeMindmapGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeMindmapGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeMindmapGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeMindmapGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeMindmapGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeMindmapGenerator>>
>;

export type LikeMindmapGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeMindmapGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeMindmapGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeMindmapGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeMindmapGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeMindmapGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/mindmap-generator/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeMindmapGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeMindmapGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeMindmapGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeMindmapGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeMindmapGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeMindmapGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeMindmapGenerator>>
>;

export type UnlikeMindmapGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeMindmapGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeMindmapGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeMindmapGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeMindmapGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves a paginated list of boards owned by the authenticated user.
 * @summary List User's Boards
 */
export const listMadlenBoardUserBoards = (
  params?: ListMadlenBoardUserBoardsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListBoardsResponseDto>({
    url: `/madlen-boards/boards`,
    method: "GET",
    params,
    signal,
  });
};

export const getListMadlenBoardUserBoardsQueryKey = (
  params?: ListMadlenBoardUserBoardsParams,
) => {
  return [`/madlen-boards/boards`, ...(params ? [params] : [])] as const;
};

export const getListMadlenBoardUserBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListMadlenBoardUserBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMadlenBoardUserBoardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMadlenBoardUserBoards>>
  > = ({ signal }) => listMadlenBoardUserBoards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMadlenBoardUserBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMadlenBoardUserBoards>>
>;
export type ListMadlenBoardUserBoardsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useListMadlenBoardUserBoards<
  TData = Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | ListMadlenBoardUserBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMadlenBoardUserBoards<
  TData = Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListMadlenBoardUserBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMadlenBoardUserBoards<
  TData = Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListMadlenBoardUserBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List User's Boards
 */

export function useListMadlenBoardUserBoards<
  TData = Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListMadlenBoardUserBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMadlenBoardUserBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListMadlenBoardUserBoardsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new board for the authenticated user.
 * @summary Create Board
 */
export const createMadlenBoard = (
  createBoardRequestDto: BodyType<CreateBoardRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<BoardResponseDto>({
    url: `/madlen-boards/boards`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createBoardRequestDto,
    signal,
  });
};

export const getCreateMadlenBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMadlenBoard>>,
    TError,
    { data: BodyType<CreateBoardRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMadlenBoard>>,
  TError,
  { data: BodyType<CreateBoardRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMadlenBoard>>,
    { data: BodyType<CreateBoardRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createMadlenBoard(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMadlenBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMadlenBoard>>
>;
export type CreateMadlenBoardMutationBody = BodyType<CreateBoardRequestDto>;
export type CreateMadlenBoardMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Create Board
 */
export const useCreateMadlenBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMadlenBoard>>,
    TError,
    { data: BodyType<CreateBoardRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMadlenBoard>>,
  TError,
  { data: BodyType<CreateBoardRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateMadlenBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a new post on a board. Behavior depends on board layoutType.
 * @summary Create Post
 */
export const createMadlenBoardPost = (
  boardId: number,
  createPostRequestDto: BodyType<CreatePostRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PostResponseDto>({
    url: `/madlen-boards/boards/${boardId}/posts`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createPostRequestDto,
    signal,
  });
};

export const getCreateMadlenBoardPostMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMadlenBoardPost>>,
    TError,
    { boardId: number; data: BodyType<CreatePostRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMadlenBoardPost>>,
  TError,
  { boardId: number; data: BodyType<CreatePostRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMadlenBoardPost>>,
    { boardId: number; data: BodyType<CreatePostRequestDto> }
  > = (props) => {
    const { boardId, data } = props ?? {};

    return createMadlenBoardPost(boardId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMadlenBoardPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMadlenBoardPost>>
>;
export type CreateMadlenBoardPostMutationBody = BodyType<CreatePostRequestDto>;
export type CreateMadlenBoardPostMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Create Post
 */
export const useCreateMadlenBoardPost = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMadlenBoardPost>>,
    TError,
    { boardId: number; data: BodyType<CreatePostRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMadlenBoardPost>>,
  TError,
  { boardId: number; data: BodyType<CreatePostRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateMadlenBoardPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Adds a new column to a specific board (layoutType must be COLUMNS).
 * @summary Create Column
 */
export const createMadlenBoardColumn = (
  boardId: number,
  createColumnRequestDto: BodyType<CreateColumnRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ColumnResponseDto>({
    url: `/madlen-boards/boards/${boardId}/columns`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createColumnRequestDto,
    signal,
  });
};

export const getCreateMadlenBoardColumnMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMadlenBoardColumn>>,
    TError,
    { boardId: number; data: BodyType<CreateColumnRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMadlenBoardColumn>>,
  TError,
  { boardId: number; data: BodyType<CreateColumnRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMadlenBoardColumn>>,
    { boardId: number; data: BodyType<CreateColumnRequestDto> }
  > = (props) => {
    const { boardId, data } = props ?? {};

    return createMadlenBoardColumn(boardId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMadlenBoardColumnMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMadlenBoardColumn>>
>;
export type CreateMadlenBoardColumnMutationBody =
  BodyType<CreateColumnRequestDto>;
export type CreateMadlenBoardColumnMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Create Column
 */
export const useCreateMadlenBoardColumn = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMadlenBoardColumn>>,
    TError,
    { boardId: number; data: BodyType<CreateColumnRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMadlenBoardColumn>>,
  TError,
  { boardId: number; data: BodyType<CreateColumnRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateMadlenBoardColumnMutationOptions(options);

  return useMutation(mutationOptions);
};

export const addSubscriptionCode = (
  subscriptionCodeCreateRequestDto: BodyType<SubscriptionCodeCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/madlen-admin/user-subscriptions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: subscriptionCodeCreateRequestDto,
    signal,
  });
};

export const getAddSubscriptionCodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSubscriptionCode>>,
    TError,
    { data: BodyType<SubscriptionCodeCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSubscriptionCode>>,
  TError,
  { data: BodyType<SubscriptionCodeCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSubscriptionCode>>,
    { data: BodyType<SubscriptionCodeCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return addSubscriptionCode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSubscriptionCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof addSubscriptionCode>>
>;
export type AddSubscriptionCodeMutationBody =
  BodyType<SubscriptionCodeCreateRequestDto>;
export type AddSubscriptionCodeMutationError = ErrorType<BaseErrorResponseDto>;

export const useAddSubscriptionCode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSubscriptionCode>>,
    TError,
    { data: BodyType<SubscriptionCodeCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof addSubscriptionCode>>,
  TError,
  { data: BodyType<SubscriptionCodeCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getAddSubscriptionCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPrompt = (
  promptRequestDto: BodyType<PromptRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<PromptResponseDto>({
    url: `/livekit/prompt`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: promptRequestDto,
    signal,
  });
};

export const getGetPromptMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPrompt>>,
    TError,
    { data: BodyType<PromptRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPrompt>>,
  TError,
  { data: BodyType<PromptRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPrompt>>,
    { data: BodyType<PromptRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return getPrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPrompt>>
>;
export type GetPromptMutationBody = BodyType<PromptRequestDto>;
export type GetPromptMutationError = ErrorType<BaseErrorResponseDto>;

export const useGetPrompt = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPrompt>>,
    TError,
    { data: BodyType<PromptRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPrompt>>,
  TError,
  { data: BodyType<PromptRequestDto> },
  TContext
> => {
  const mutationOptions = getGetPromptMutationOptions(options);

  return useMutation(mutationOptions);
};

export const receiveEvent = (
  livekitEventsRequestDto: BodyType<LivekitEventsRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/livekit/events`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: livekitEventsRequestDto,
    signal,
  });
};

export const getReceiveEventMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveEvent>>,
    TError,
    { data: BodyType<LivekitEventsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiveEvent>>,
  TError,
  { data: BodyType<LivekitEventsRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiveEvent>>,
    { data: BodyType<LivekitEventsRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return receiveEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiveEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiveEvent>>
>;
export type ReceiveEventMutationBody = BodyType<LivekitEventsRequestDto>;
export type ReceiveEventMutationError = ErrorType<BaseErrorResponseDto>;

export const useReceiveEvent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveEvent>>,
    TError,
    { data: BodyType<LivekitEventsRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof receiveEvent>>,
  TError,
  { data: BodyType<LivekitEventsRequestDto> },
  TContext
> => {
  const mutationOptions = getReceiveEventMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getLessonPlannersV2 = (
  params?: GetLessonPlannersV2Params,
  signal?: AbortSignal,
) => {
  return configureAxios<ListLessonPlannerV2ResponseDto>({
    url: `/lesson-planner/v2`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetLessonPlannersV2QueryKey = (
  params?: GetLessonPlannersV2Params,
) => {
  return [`/lesson-planner/v2`, ...(params ? [params] : [])] as const;
};

export const getGetLessonPlannersV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getLessonPlannersV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersV2>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLessonPlannersV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLessonPlannersV2>>
  > = ({ signal }) => getLessonPlannersV2(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLessonPlannersV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLessonPlannersV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getLessonPlannersV2>>
>;
export type GetLessonPlannersV2QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLessonPlannersV2<
  TData = Awaited<ReturnType<typeof getLessonPlannersV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetLessonPlannersV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonPlannersV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLessonPlannersV2<
  TData = Awaited<ReturnType<typeof getLessonPlannersV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonPlannersV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLessonPlannersV2<
  TData = Awaited<ReturnType<typeof getLessonPlannersV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLessonPlannersV2<
  TData = Awaited<ReturnType<typeof getLessonPlannersV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLessonPlannersV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createLessonPlannerV2 = (
  createLessonPlannerV2RequestDto: BodyType<CreateLessonPlannerV2RequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<LessonPlannerV2ResponseDto>({
    url: `/lesson-planner/v2`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createLessonPlannerV2RequestDto,
    signal,
  });
};

export const getCreateLessonPlannerV2MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLessonPlannerV2>>,
    TError,
    { data: BodyType<CreateLessonPlannerV2RequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLessonPlannerV2>>,
  TError,
  { data: BodyType<CreateLessonPlannerV2RequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLessonPlannerV2>>,
    { data: BodyType<CreateLessonPlannerV2RequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createLessonPlannerV2(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLessonPlannerV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof createLessonPlannerV2>>
>;
export type CreateLessonPlannerV2MutationBody =
  BodyType<CreateLessonPlannerV2RequestDto>;
export type CreateLessonPlannerV2MutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateLessonPlannerV2 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLessonPlannerV2>>,
    TError,
    { data: BodyType<CreateLessonPlannerV2RequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLessonPlannerV2>>,
  TError,
  { data: BodyType<CreateLessonPlannerV2RequestDto> },
  TContext
> => {
  const mutationOptions = getCreateLessonPlannerV2MutationOptions(options);

  return useMutation(mutationOptions);
};

export const createExtraCard = (
  id: number,
  createExtraCardRequestDto: BodyType<CreateExtraCardRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<LessonPlannerV2ResponseDto>({
    url: `/lesson-planner/v2/create-extra-card/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createExtraCardRequestDto,
    signal,
  });
};

export const getCreateExtraCardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExtraCard>>,
    TError,
    { id: number; data: BodyType<CreateExtraCardRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExtraCard>>,
  TError,
  { id: number; data: BodyType<CreateExtraCardRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExtraCard>>,
    { id: number; data: BodyType<CreateExtraCardRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createExtraCard(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExtraCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExtraCard>>
>;
export type CreateExtraCardMutationBody = BodyType<CreateExtraCardRequestDto>;
export type CreateExtraCardMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateExtraCard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExtraCard>>,
    TError,
    { id: number; data: BodyType<CreateExtraCardRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExtraCard>>,
  TError,
  { id: number; data: BodyType<CreateExtraCardRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateExtraCardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createLessonHook = (
  lessonHookCreateRequestDto: BodyType<LessonHookCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<LessonHookResponseDto>({
    url: `/lesson-hooks`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: lessonHookCreateRequestDto,
    signal,
  });
};

export const getCreateLessonHookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLessonHook>>,
    TError,
    { data: BodyType<LessonHookCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLessonHook>>,
  TError,
  { data: BodyType<LessonHookCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLessonHook>>,
    { data: BodyType<LessonHookCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createLessonHook(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLessonHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLessonHook>>
>;
export type CreateLessonHookMutationBody = BodyType<LessonHookCreateRequestDto>;
export type CreateLessonHookMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateLessonHook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLessonHook>>,
    TError,
    { data: BodyType<LessonHookCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLessonHook>>,
  TError,
  { data: BodyType<LessonHookCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateLessonHookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateLessonHook = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<LessonHookResponseDto>({
    url: `/lesson-hooks/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateLessonHookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateLessonHook>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateLessonHook>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateLessonHook>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateLessonHook(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateLessonHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateLessonHook>>
>;
export type RegenerateLessonHookMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateLessonHookMutationError = ErrorType<BaseErrorResponseDto>;

export const useRegenerateLessonHook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateLessonHook>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateLessonHook>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateLessonHookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeLessonHook = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/lesson-hooks/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeLessonHookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeLessonHook>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeLessonHook>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeLessonHook>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeLessonHook(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeLessonHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeLessonHook>>
>;

export type LikeLessonHookMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeLessonHook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeLessonHook>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeLessonHook>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeLessonHookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeLessonHook = (id: number) => {
  return configureAxios<void>({
    url: `/lesson-hooks/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeLessonHookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeLessonHook>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeLessonHook>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeLessonHook>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeLessonHook(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeLessonHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeLessonHook>>
>;

export type UnlikeLessonHookMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeLessonHook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeLessonHook>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeLessonHook>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeLessonHookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAllInteractiveMaterials = (
  params?: GetAllInteractiveMaterialsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListInteractiveMaterialResponseDto>({
    url: `/interactive-materials`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAllInteractiveMaterialsQueryKey = (
  params?: GetAllInteractiveMaterialsParams,
) => {
  return [`/interactive-materials`, ...(params ? [params] : [])] as const;
};

export const getGetAllInteractiveMaterialsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllInteractiveMaterialsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllInteractiveMaterials>>
  > = ({ signal }) => getAllInteractiveMaterials(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllInteractiveMaterialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllInteractiveMaterials>>
>;
export type GetAllInteractiveMaterialsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAllInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAllInteractiveMaterialsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAllInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllInteractiveMaterialsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createInteractiveMaterial = (
  createInteractiveMaterialRequest: BodyType<CreateInteractiveMaterialRequest>,
  signal?: AbortSignal,
) => {
  return configureAxios<InteractiveMaterialResponseDto>({
    url: `/interactive-materials`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createInteractiveMaterialRequest,
    signal,
  });
};

export const getCreateInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInteractiveMaterial>>,
    TError,
    { data: BodyType<CreateInteractiveMaterialRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInteractiveMaterial>>,
  TError,
  { data: BodyType<CreateInteractiveMaterialRequest> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInteractiveMaterial>>,
    { data: BodyType<CreateInteractiveMaterialRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createInteractiveMaterial(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInteractiveMaterial>>
>;
export type CreateInteractiveMaterialMutationBody =
  BodyType<CreateInteractiveMaterialRequest>;
export type CreateInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInteractiveMaterial>>,
    TError,
    { data: BodyType<CreateInteractiveMaterialRequest> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInteractiveMaterial>>,
  TError,
  { data: BodyType<CreateInteractiveMaterialRequest> },
  TContext
> => {
  const mutationOptions = getCreateInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const finishStudentInteractiveMaterial = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentInteractiveMaterialResponseDto>({
    url: `/interactive-materials/${id}/finish`,
    method: "POST",
    signal,
  });
};

export const getFinishStudentInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finishStudentInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finishStudentInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finishStudentInteractiveMaterial>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return finishStudentInteractiveMaterial(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinishStudentInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof finishStudentInteractiveMaterial>>
>;

export type FinishStudentInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useFinishStudentInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finishStudentInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof finishStudentInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getFinishStudentInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const finalizeInteractiveMaterial = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<InteractiveMaterialResponseDto>({
    url: `/interactive-materials/${id}/finalize`,
    method: "POST",
    signal,
  });
};

export const getFinalizeInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeInteractiveMaterial>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return finalizeInteractiveMaterial(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeInteractiveMaterial>>
>;

export type FinalizeInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useFinalizeInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof finalizeInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getFinalizeInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportInteractiveMaterialAsH5P = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<H5pExportResponseDto>({
    url: `/interactive-materials/${id}/export-as-h5p`,
    method: "POST",
    signal,
  });
};

export const getExportInteractiveMaterialAsH5PMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportInteractiveMaterialAsH5P>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportInteractiveMaterialAsH5P>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportInteractiveMaterialAsH5P>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return exportInteractiveMaterialAsH5P(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportInteractiveMaterialAsH5PMutationResult = NonNullable<
  Awaited<ReturnType<typeof exportInteractiveMaterialAsH5P>>
>;

export type ExportInteractiveMaterialAsH5PMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useExportInteractiveMaterialAsH5P = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportInteractiveMaterialAsH5P>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportInteractiveMaterialAsH5P>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getExportInteractiveMaterialAsH5PMutationOptions(options);

  return useMutation(mutationOptions);
};

export const interactiveMaterialsCaptureStudentEvents = (
  id: number,
  interactiveMaterialsCaptureStudentEventRequestDto: BodyType<InteractiveMaterialsCaptureStudentEventRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/interactive-materials/${id}/events`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: interactiveMaterialsCaptureStudentEventRequestDto,
    signal,
  });
};

export const getInteractiveMaterialsCaptureStudentEventsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof interactiveMaterialsCaptureStudentEvents>>,
    TError,
    {
      id: number;
      data: BodyType<InteractiveMaterialsCaptureStudentEventRequestDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof interactiveMaterialsCaptureStudentEvents>>,
  TError,
  {
    id: number;
    data: BodyType<InteractiveMaterialsCaptureStudentEventRequestDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof interactiveMaterialsCaptureStudentEvents>>,
    {
      id: number;
      data: BodyType<InteractiveMaterialsCaptureStudentEventRequestDto>;
    }
  > = (props) => {
    const { id, data } = props ?? {};

    return interactiveMaterialsCaptureStudentEvents(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type InteractiveMaterialsCaptureStudentEventsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof interactiveMaterialsCaptureStudentEvents>>
  >;
export type InteractiveMaterialsCaptureStudentEventsMutationBody =
  BodyType<InteractiveMaterialsCaptureStudentEventRequestDto>;
export type InteractiveMaterialsCaptureStudentEventsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useInteractiveMaterialsCaptureStudentEvents = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof interactiveMaterialsCaptureStudentEvents>>,
    TError,
    {
      id: number;
      data: BodyType<InteractiveMaterialsCaptureStudentEventRequestDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof interactiveMaterialsCaptureStudentEvents>>,
  TError,
  {
    id: number;
    data: BodyType<InteractiveMaterialsCaptureStudentEventRequestDto>;
  },
  TContext
> => {
  const mutationOptions =
    getInteractiveMaterialsCaptureStudentEventsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cloneInteractiveMaterial = (id: number, signal?: AbortSignal) => {
  return configureAxios<InteractiveMaterialResponseDto>({
    url: `/interactive-materials/${id}/clone`,
    method: "POST",
    signal,
  });
};

export const getCloneInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneInteractiveMaterial>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return cloneInteractiveMaterial(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneInteractiveMaterial>>
>;

export type CloneInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCloneInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneInteractiveMaterial>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cloneInteractiveMaterial>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getCloneInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

export const exportInteractiveMaterialToGoogleClassroom = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/interactive-materials/${assignmentId}/export-to-google-classroom`,
    method: "POST",
    signal,
  });
};

export const getExportInteractiveMaterialToGoogleClassroomMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportInteractiveMaterialToGoogleClassroom>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportInteractiveMaterialToGoogleClassroom>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportInteractiveMaterialToGoogleClassroom>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return exportInteractiveMaterialToGoogleClassroom(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportInteractiveMaterialToGoogleClassroomMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof exportInteractiveMaterialToGoogleClassroom>>
  >;

export type ExportInteractiveMaterialToGoogleClassroomMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useExportInteractiveMaterialToGoogleClassroom = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportInteractiveMaterialToGoogleClassroom>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportInteractiveMaterialToGoogleClassroom>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions =
    getExportInteractiveMaterialToGoogleClassroomMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createImageGenerator = (
  imageGeneratorCreateRequestDto: BodyType<ImageGeneratorCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ImageGeneratorResponseDto>({
    url: `/image-generators`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: imageGeneratorCreateRequestDto,
    signal,
  });
};

export const getCreateImageGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createImageGenerator>>,
    TError,
    { data: BodyType<ImageGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createImageGenerator>>,
  TError,
  { data: BodyType<ImageGeneratorCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createImageGenerator>>,
    { data: BodyType<ImageGeneratorCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createImageGenerator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateImageGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createImageGenerator>>
>;
export type CreateImageGeneratorMutationBody =
  BodyType<ImageGeneratorCreateRequestDto>;
export type CreateImageGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateImageGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createImageGenerator>>,
    TError,
    { data: BodyType<ImageGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createImageGenerator>>,
  TError,
  { data: BodyType<ImageGeneratorCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateImageGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeImageGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/image-generators/${id}/unlike`,
    method: "POST",
    signal,
  });
};

export const getUnlikeImageGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeImageGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeImageGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeImageGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeImageGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeImageGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeImageGenerator>>
>;

export type UnlikeImageGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeImageGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeImageGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeImageGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeImageGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeImageGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/image-generators/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeImageGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeImageGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeImageGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeImageGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeImageGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeImageGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeImageGenerator>>
>;

export type LikeImageGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeImageGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeImageGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeImageGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeImageGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createHomeworkIdea = (
  homeworkIdeaCreateRequestDto: BodyType<HomeworkIdeaCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<HomeworkIdeaResponseDto>({
    url: `/homework-ideas`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: homeworkIdeaCreateRequestDto,
    signal,
  });
};

export const getCreateHomeworkIdeaMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHomeworkIdea>>,
    TError,
    { data: BodyType<HomeworkIdeaCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHomeworkIdea>>,
  TError,
  { data: BodyType<HomeworkIdeaCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHomeworkIdea>>,
    { data: BodyType<HomeworkIdeaCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createHomeworkIdea(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHomeworkIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHomeworkIdea>>
>;
export type CreateHomeworkIdeaMutationBody =
  BodyType<HomeworkIdeaCreateRequestDto>;
export type CreateHomeworkIdeaMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateHomeworkIdea = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHomeworkIdea>>,
    TError,
    { data: BodyType<HomeworkIdeaCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createHomeworkIdea>>,
  TError,
  { data: BodyType<HomeworkIdeaCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateHomeworkIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateHomeworkIdea = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<HomeworkIdeaResponseDto>({
    url: `/homework-ideas/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateHomeworkIdeaMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateHomeworkIdea>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateHomeworkIdea>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateHomeworkIdea>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateHomeworkIdea(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateHomeworkIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateHomeworkIdea>>
>;
export type RegenerateHomeworkIdeaMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateHomeworkIdeaMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateHomeworkIdea = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateHomeworkIdea>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateHomeworkIdea>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateHomeworkIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeHomeWorkIdea = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/homework-ideas/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeHomeWorkIdeaMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeHomeWorkIdea>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeHomeWorkIdea>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeHomeWorkIdea>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeHomeWorkIdea(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeHomeWorkIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeHomeWorkIdea>>
>;

export type LikeHomeWorkIdeaMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeHomeWorkIdea = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeHomeWorkIdea>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeHomeWorkIdea>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeHomeWorkIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeHomeWorkIdea = (id: number) => {
  return configureAxios<void>({
    url: `/homework-ideas/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeHomeWorkIdeaMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeHomeWorkIdea>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeHomeWorkIdea>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeHomeWorkIdea>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeHomeWorkIdea(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeHomeWorkIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeHomeWorkIdea>>
>;

export type UnlikeHomeWorkIdeaMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeHomeWorkIdea = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeHomeWorkIdea>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeHomeWorkIdea>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeHomeWorkIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const googleLogin = (
  googleLoginRequestDto: BodyType<GoogleLoginRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<GoogleLoginResponseDto>({
    url: `/google/login`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: googleLoginRequestDto,
    signal,
  });
};

export const getGoogleLoginMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof googleLogin>>,
    TError,
    { data: BodyType<GoogleLoginRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof googleLogin>>,
  TError,
  { data: BodyType<GoogleLoginRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof googleLogin>>,
    { data: BodyType<GoogleLoginRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return googleLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GoogleLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof googleLogin>>
>;
export type GoogleLoginMutationBody = BodyType<GoogleLoginRequestDto>;
export type GoogleLoginMutationError = ErrorType<BaseErrorResponseDto>;

export const useGoogleLogin = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof googleLogin>>,
    TError,
    { data: BodyType<GoogleLoginRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof googleLogin>>,
  TError,
  { data: BodyType<GoogleLoginRequestDto> },
  TContext
> => {
  const mutationOptions = getGoogleLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getGoogleDrivePickerToken = (signal?: AbortSignal) => {
  return configureAxios<GetGoogleDrivePickerTokenResponseDto>({
    url: `/google/drive-picker/token`,
    method: "GET",
    signal,
  });
};

export const getGetGoogleDrivePickerTokenQueryKey = () => {
  return [`/google/drive-picker/token`] as const;
};

export const getGetGoogleDrivePickerTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGoogleDrivePickerTokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoogleDrivePickerToken>>
  > = ({ signal }) => getGoogleDrivePickerToken(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGoogleDrivePickerTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoogleDrivePickerToken>>
>;
export type GetGoogleDrivePickerTokenQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetGoogleDrivePickerToken<
  TData = Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGoogleDrivePickerToken<
  TData = Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGoogleDrivePickerToken<
  TData = Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetGoogleDrivePickerToken<
  TData = Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGoogleDrivePickerToken>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetGoogleDrivePickerTokenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const setGoogleDrivePickerToken = (
  setGoogleDrivePickerTokenRequestDto: BodyType<SetGoogleDrivePickerTokenRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<SetGoogleDrivePickerTokenResponseDto>({
    url: `/google/drive-picker/token`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setGoogleDrivePickerTokenRequestDto,
    signal,
  });
};

export const getSetGoogleDrivePickerTokenMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGoogleDrivePickerToken>>,
    TError,
    { data: BodyType<SetGoogleDrivePickerTokenRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setGoogleDrivePickerToken>>,
  TError,
  { data: BodyType<SetGoogleDrivePickerTokenRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setGoogleDrivePickerToken>>,
    { data: BodyType<SetGoogleDrivePickerTokenRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return setGoogleDrivePickerToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetGoogleDrivePickerTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof setGoogleDrivePickerToken>>
>;
export type SetGoogleDrivePickerTokenMutationBody =
  BodyType<SetGoogleDrivePickerTokenRequestDto>;
export type SetGoogleDrivePickerTokenMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSetGoogleDrivePickerToken = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGoogleDrivePickerToken>>,
    TError,
    { data: BodyType<SetGoogleDrivePickerTokenRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof setGoogleDrivePickerToken>>,
  TError,
  { data: BodyType<SetGoogleDrivePickerTokenRequestDto> },
  TContext
> => {
  const mutationOptions = getSetGoogleDrivePickerTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

export const uploadGoogleDriveFilesToTeacherDocuments = (
  uploadGoogleDriveFilesToTeacherDocumentsRequestDto: BodyType<UploadGoogleDriveFilesToTeacherDocumentsRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<UploadGoogleDriveFilesToTeacherDocumentsResponseDto>({
    url: `/google/drive-files/upload-to-teacher-documents`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: uploadGoogleDriveFilesToTeacherDocumentsRequestDto,
    signal,
  });
};

export const getUploadGoogleDriveFilesToTeacherDocumentsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadGoogleDriveFilesToTeacherDocuments>>,
    TError,
    { data: BodyType<UploadGoogleDriveFilesToTeacherDocumentsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadGoogleDriveFilesToTeacherDocuments>>,
  TError,
  { data: BodyType<UploadGoogleDriveFilesToTeacherDocumentsRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadGoogleDriveFilesToTeacherDocuments>>,
    { data: BodyType<UploadGoogleDriveFilesToTeacherDocumentsRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadGoogleDriveFilesToTeacherDocuments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadGoogleDriveFilesToTeacherDocumentsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof uploadGoogleDriveFilesToTeacherDocuments>>
  >;
export type UploadGoogleDriveFilesToTeacherDocumentsMutationBody =
  BodyType<UploadGoogleDriveFilesToTeacherDocumentsRequestDto>;
export type UploadGoogleDriveFilesToTeacherDocumentsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUploadGoogleDriveFilesToTeacherDocuments = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadGoogleDriveFilesToTeacherDocuments>>,
    TError,
    { data: BodyType<UploadGoogleDriveFilesToTeacherDocumentsRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadGoogleDriveFilesToTeacherDocuments>>,
  TError,
  { data: BodyType<UploadGoogleDriveFilesToTeacherDocumentsRequestDto> },
  TContext
> => {
  const mutationOptions =
    getUploadGoogleDriveFilesToTeacherDocumentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cloneClassroom = (
  syncClassroomRequestDto: BodyType<SyncClassroomRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/google/classroom/sync-classroom`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: syncClassroomRequestDto,
    signal,
  });
};

export const getCloneClassroomMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneClassroom>>,
    TError,
    { data: BodyType<SyncClassroomRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneClassroom>>,
  TError,
  { data: BodyType<SyncClassroomRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneClassroom>>,
    { data: BodyType<SyncClassroomRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return cloneClassroom(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneClassroomMutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneClassroom>>
>;
export type CloneClassroomMutationBody = BodyType<SyncClassroomRequestDto>;
export type CloneClassroomMutationError = ErrorType<BaseErrorResponseDto>;

export const useCloneClassroom = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneClassroom>>,
    TError,
    { data: BodyType<SyncClassroomRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cloneClassroom>>,
  TError,
  { data: BodyType<SyncClassroomRequestDto> },
  TContext
> => {
  const mutationOptions = getCloneClassroomMutationOptions(options);

  return useMutation(mutationOptions);
};

export const publishAssignment = (
  publishAssignmentRequestDto: BodyType<PublishAssignmentRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<GetCoursesResponseDto>({
    url: `/google/classroom/publish-assignment`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: publishAssignmentRequestDto,
    signal,
  });
};

export const getPublishAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishAssignment>>,
    TError,
    { data: BodyType<PublishAssignmentRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishAssignment>>,
  TError,
  { data: BodyType<PublishAssignmentRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishAssignment>>,
    { data: BodyType<PublishAssignmentRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return publishAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishAssignment>>
>;
export type PublishAssignmentMutationBody =
  BodyType<PublishAssignmentRequestDto>;
export type PublishAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const usePublishAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishAssignment>>,
    TError,
    { data: BodyType<PublishAssignmentRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof publishAssignment>>,
  TError,
  { data: BodyType<PublishAssignmentRequestDto> },
  TContext
> => {
  const mutationOptions = getPublishAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cloneClassroom1 = (
  cloneClassroomRequestDto: BodyType<CloneClassroomRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/google/classroom/clone-classroom`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: cloneClassroomRequestDto,
    signal,
  });
};

export const getCloneClassroom1MutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneClassroom1>>,
    TError,
    { data: BodyType<CloneClassroomRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneClassroom1>>,
  TError,
  { data: BodyType<CloneClassroomRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneClassroom1>>,
    { data: BodyType<CloneClassroomRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return cloneClassroom1(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneClassroom1MutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneClassroom1>>
>;
export type CloneClassroom1MutationBody = BodyType<CloneClassroomRequestDto>;
export type CloneClassroom1MutationError = ErrorType<BaseErrorResponseDto>;

export const useCloneClassroom1 = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneClassroom1>>,
    TError,
    { data: BodyType<CloneClassroomRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cloneClassroom1>>,
  TError,
  { data: BodyType<CloneClassroomRequestDto> },
  TContext
> => {
  const mutationOptions = getCloneClassroom1MutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPosts = (signal?: AbortSignal) => {
  return configureAxios<ForumPostDto[]>({
    url: `/forum-posts`,
    method: "GET",
    signal,
  });
};

export const getGetPostsQueryKey = () => {
  return [`/forum-posts`] as const;
};

export const getGetPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPosts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPosts>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPostsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPosts>>> = ({
    signal,
  }) => getPosts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPosts>>
>;
export type GetPostsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetPosts<
  TData = Awaited<ReturnType<typeof getPosts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPosts>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getPosts>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPosts<
  TData = Awaited<ReturnType<typeof getPosts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPosts>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getPosts>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPosts<
  TData = Awaited<ReturnType<typeof getPosts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPosts>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPosts<
  TData = Awaited<ReturnType<typeof getPosts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPosts>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPostsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createPost = (
  createForumPostRequestDto: BodyType<CreateForumPostRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ForumPostDto>({
    url: `/forum-posts`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createForumPostRequestDto,
    signal,
  });
};

export const getCreatePostMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPost>>,
    TError,
    { data: BodyType<CreateForumPostRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPost>>,
  TError,
  { data: BodyType<CreateForumPostRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPost>>,
    { data: BodyType<CreateForumPostRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPost>>
>;
export type CreatePostMutationBody = BodyType<CreateForumPostRequestDto>;
export type CreatePostMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreatePost = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPost>>,
    TError,
    { data: BodyType<CreateForumPostRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPost>>,
  TError,
  { data: BodyType<CreateForumPostRequestDto> },
  TContext
> => {
  const mutationOptions = getCreatePostMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createComment = (
  postId: number,
  createForumCommentRequestDto: BodyType<CreateForumCommentRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ForumCommentDto>({
    url: `/forum-posts/${postId}/comments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createForumCommentRequestDto,
    signal,
  });
};

export const getCreateCommentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    { postId: number; data: BodyType<CreateForumCommentRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { postId: number; data: BodyType<CreateForumCommentRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createComment>>,
    { postId: number; data: BodyType<CreateForumCommentRequestDto> }
  > = (props) => {
    const { postId, data } = props ?? {};

    return createComment(postId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createComment>>
>;
export type CreateCommentMutationBody = BodyType<CreateForumCommentRequestDto>;
export type CreateCommentMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateComment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    { postId: number; data: BodyType<CreateForumCommentRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { postId: number; data: BodyType<CreateForumCommentRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createFormativeAssessment = (
  formativeAssessmentCreateRequestDto: BodyType<FormativeAssessmentCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<FormativeAssessmentResponseDto>({
    url: `/formative-assessment`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: formativeAssessmentCreateRequestDto,
    signal,
  });
};

export const getCreateFormativeAssessmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFormativeAssessment>>,
    TError,
    { data: BodyType<FormativeAssessmentCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFormativeAssessment>>,
  TError,
  { data: BodyType<FormativeAssessmentCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFormativeAssessment>>,
    { data: BodyType<FormativeAssessmentCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createFormativeAssessment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFormativeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFormativeAssessment>>
>;
export type CreateFormativeAssessmentMutationBody =
  BodyType<FormativeAssessmentCreateRequestDto>;
export type CreateFormativeAssessmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateFormativeAssessment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFormativeAssessment>>,
    TError,
    { data: BodyType<FormativeAssessmentCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFormativeAssessment>>,
  TError,
  { data: BodyType<FormativeAssessmentCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateFormativeAssessmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateFormativeAssessment = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<FormativeAssessmentResponseDto>({
    url: `/formative-assessment/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateFormativeAssessmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateFormativeAssessment>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateFormativeAssessment>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateFormativeAssessment>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateFormativeAssessment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateFormativeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateFormativeAssessment>>
>;
export type RegenerateFormativeAssessmentMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateFormativeAssessmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateFormativeAssessment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateFormativeAssessment>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateFormativeAssessment>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateFormativeAssessmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeFormativeAssessment = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/formative-assessment/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeFormativeAssessmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeFormativeAssessment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeFormativeAssessment>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeFormativeAssessment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeFormativeAssessment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeFormativeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeFormativeAssessment>>
>;

export type LikeFormativeAssessmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeFormativeAssessment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeFormativeAssessment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeFormativeAssessment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeFormativeAssessmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeFormativeAssessment = (id: number) => {
  return configureAxios<void>({
    url: `/formative-assessment/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeFormativeAssessmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeFormativeAssessment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeFormativeAssessment>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeFormativeAssessment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeFormativeAssessment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeFormativeAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeFormativeAssessment>>
>;

export type UnlikeFormativeAssessmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeFormativeAssessment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeFormativeAssessment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeFormativeAssessment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeFormativeAssessmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const searchNodes = (
  params?: SearchNodesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseFileNodeDto[]>({
    url: `/filenodes`,
    method: "GET",
    params,
    signal,
  });
};

export const getSearchNodesQueryKey = (params?: SearchNodesParams) => {
  return [`/filenodes`, ...(params ? [params] : [])] as const;
};

export const getSearchNodesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchNodes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: SearchNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchNodes>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchNodesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchNodes>>> = ({
    signal,
  }) => searchNodes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchNodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchNodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchNodes>>
>;
export type SearchNodesQueryError = ErrorType<BaseErrorResponseDto>;

export function useSearchNodes<
  TData = Awaited<ReturnType<typeof searchNodes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | SearchNodesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchNodes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNodes>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchNodes<
  TData = Awaited<ReturnType<typeof searchNodes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: SearchNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchNodes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNodes>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchNodes<
  TData = Awaited<ReturnType<typeof searchNodes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: SearchNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchNodes>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useSearchNodes<
  TData = Awaited<ReturnType<typeof searchNodes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: SearchNodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchNodes>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchNodesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createNode = (
  fileNodeCreateDto: BodyType<FileNodeCreateDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseFileNodeDto>({
    url: `/filenodes`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: fileNodeCreateDto,
    signal,
  });
};

export const getCreateNodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNode>>,
    TError,
    { data: BodyType<FileNodeCreateDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNode>>,
  TError,
  { data: BodyType<FileNodeCreateDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNode>>,
    { data: BodyType<FileNodeCreateDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createNode(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNode>>
>;
export type CreateNodeMutationBody = BodyType<FileNodeCreateDto>;
export type CreateNodeMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateNode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNode>>,
    TError,
    { data: BodyType<FileNodeCreateDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNode>>,
  TError,
  { data: BodyType<FileNodeCreateDto> },
  TContext
> => {
  const mutationOptions = getCreateNodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const takeFeedback = (
  feedbackRequestDto: BodyType<FeedbackRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/feedback`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: feedbackRequestDto,
    signal,
  });
};

export const getTakeFeedbackMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof takeFeedback>>,
    TError,
    { data: BodyType<FeedbackRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof takeFeedback>>,
  TError,
  { data: BodyType<FeedbackRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof takeFeedback>>,
    { data: BodyType<FeedbackRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return takeFeedback(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TakeFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof takeFeedback>>
>;
export type TakeFeedbackMutationBody = BodyType<FeedbackRequestDto>;
export type TakeFeedbackMutationError = ErrorType<BaseErrorResponseDto>;

export const useTakeFeedback = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof takeFeedback>>,
    TError,
    { data: BodyType<FeedbackRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof takeFeedback>>,
  TError,
  { data: BodyType<FeedbackRequestDto> },
  TContext
> => {
  const mutationOptions = getTakeFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFavouriteChatMessage = (id: number, signal?: AbortSignal) => {
  return configureAxios<BaseChatMessageDto>({
    url: `/favourites/messages/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetFavouriteChatMessageQueryKey = (id: number) => {
  return [`/favourites/messages/${id}`] as const;
};

export const getGetFavouriteChatMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavouriteChatMessage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFavouriteChatMessageQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFavouriteChatMessage>>
  > = ({ signal }) => getFavouriteChatMessage(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavouriteChatMessage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFavouriteChatMessageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavouriteChatMessage>>
>;
export type GetFavouriteChatMessageQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetFavouriteChatMessage<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChatMessage>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFavouriteChatMessage<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChatMessage>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFavouriteChatMessage<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessage>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFavouriteChatMessage<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessage>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFavouriteChatMessageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const favouriteChatMessage = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/favourites/messages/${id}`,
    method: "POST",
    signal,
  });
};

export const getFavouriteChatMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof favouriteChatMessage>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof favouriteChatMessage>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof favouriteChatMessage>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return favouriteChatMessage(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FavouriteChatMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof favouriteChatMessage>>
>;

export type FavouriteChatMessageMutationError = ErrorType<BaseErrorResponseDto>;

export const useFavouriteChatMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof favouriteChatMessage>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof favouriteChatMessage>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getFavouriteChatMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteFavouriteChatMessage = (id: number) => {
  return configureAxios<void>({
    url: `/favourites/messages/${id}`,
    method: "DELETE",
  });
};

export const getDeleteFavouriteChatMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFavouriteChatMessage>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFavouriteChatMessage>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFavouriteChatMessage>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteFavouriteChatMessage(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFavouriteChatMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFavouriteChatMessage>>
>;

export type DeleteFavouriteChatMessageMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteFavouriteChatMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFavouriteChatMessage>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFavouriteChatMessage>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteFavouriteChatMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFavouriteChat = (id: number, signal?: AbortSignal) => {
  return configureAxios<BaseChatDto>({
    url: `/favourites/chats/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetFavouriteChatQueryKey = (id: number) => {
  return [`/favourites/chats/${id}`] as const;
};

export const getGetFavouriteChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavouriteChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChat>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFavouriteChatQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFavouriteChat>>
  > = ({ signal }) => getFavouriteChat(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavouriteChat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFavouriteChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavouriteChat>>
>;
export type GetFavouriteChatQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetFavouriteChat<
  TData = Awaited<ReturnType<typeof getFavouriteChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFavouriteChat<
  TData = Awaited<ReturnType<typeof getFavouriteChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFavouriteChat<
  TData = Awaited<ReturnType<typeof getFavouriteChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFavouriteChat<
  TData = Awaited<ReturnType<typeof getFavouriteChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFavouriteChatQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const favouriteChat = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/favourites/chats/${id}`,
    method: "POST",
    signal,
  });
};

export const getFavouriteChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof favouriteChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof favouriteChat>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof favouriteChat>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return favouriteChat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type FavouriteChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof favouriteChat>>
>;

export type FavouriteChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useFavouriteChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof favouriteChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof favouriteChat>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getFavouriteChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteFavouriteChat = (id: number) => {
  return configureAxios<void>({
    url: `/favourites/chats/${id}`,
    method: "DELETE",
  });
};

export const getDeleteFavouriteChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFavouriteChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFavouriteChat>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFavouriteChat>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteFavouriteChat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFavouriteChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFavouriteChat>>
>;

export type DeleteFavouriteChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteFavouriteChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFavouriteChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFavouriteChat>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteFavouriteChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createExitTicketGenerator = (
  exitTicketGeneratorCreateRequestDto: BodyType<ExitTicketGeneratorCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ExitTicketGeneratorResponseDto>({
    url: `/exit-ticket-generator`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: exitTicketGeneratorCreateRequestDto,
    signal,
  });
};

export const getCreateExitTicketGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExitTicketGenerator>>,
    TError,
    { data: BodyType<ExitTicketGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExitTicketGenerator>>,
  TError,
  { data: BodyType<ExitTicketGeneratorCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExitTicketGenerator>>,
    { data: BodyType<ExitTicketGeneratorCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createExitTicketGenerator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExitTicketGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExitTicketGenerator>>
>;
export type CreateExitTicketGeneratorMutationBody =
  BodyType<ExitTicketGeneratorCreateRequestDto>;
export type CreateExitTicketGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateExitTicketGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExitTicketGenerator>>,
    TError,
    { data: BodyType<ExitTicketGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExitTicketGenerator>>,
  TError,
  { data: BodyType<ExitTicketGeneratorCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateExitTicketGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateExitTicketGenerator = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<ExitTicketGeneratorResponseDto>({
    url: `/exit-ticket-generator/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateExitTicketGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateExitTicketGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateExitTicketGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateExitTicketGenerator>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateExitTicketGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateExitTicketGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateExitTicketGenerator>>
>;
export type RegenerateExitTicketGeneratorMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateExitTicketGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateExitTicketGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateExitTicketGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateExitTicketGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateExitTicketGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeExitTicketGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/exit-ticket-generator/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeExitTicketGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeExitTicketGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeExitTicketGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeExitTicketGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeExitTicketGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeExitTicketGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeExitTicketGenerator>>
>;

export type LikeExitTicketGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeExitTicketGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeExitTicketGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeExitTicketGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeExitTicketGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeExitTicketGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/exit-ticket-generator/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeExitTicketGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeExitTicketGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeExitTicketGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeExitTicketGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeExitTicketGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeExitTicketGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeExitTicketGenerator>>
>;

export type UnlikeExitTicketGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeExitTicketGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeExitTicketGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeExitTicketGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeExitTicketGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createEssentialQuestions = (
  essentialQuestionsCreateRequestDto: BodyType<EssentialQuestionsCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<EssentialQuestionsResponseDto>({
    url: `/essential-questions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: essentialQuestionsCreateRequestDto,
    signal,
  });
};

export const getCreateEssentialQuestionsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEssentialQuestions>>,
    TError,
    { data: BodyType<EssentialQuestionsCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEssentialQuestions>>,
  TError,
  { data: BodyType<EssentialQuestionsCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEssentialQuestions>>,
    { data: BodyType<EssentialQuestionsCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createEssentialQuestions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEssentialQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEssentialQuestions>>
>;
export type CreateEssentialQuestionsMutationBody =
  BodyType<EssentialQuestionsCreateRequestDto>;
export type CreateEssentialQuestionsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateEssentialQuestions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEssentialQuestions>>,
    TError,
    { data: BodyType<EssentialQuestionsCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEssentialQuestions>>,
  TError,
  { data: BodyType<EssentialQuestionsCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateEssentialQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateEssentialQuestions = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<EssentialQuestionsResponseDto>({
    url: `/essential-questions/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateEssentialQuestionsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateEssentialQuestions>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateEssentialQuestions>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateEssentialQuestions>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateEssentialQuestions(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateEssentialQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateEssentialQuestions>>
>;
export type RegenerateEssentialQuestionsMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateEssentialQuestionsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateEssentialQuestions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateEssentialQuestions>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateEssentialQuestions>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateEssentialQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeEssentialQuestions = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/essential-questions/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeEssentialQuestionsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeEssentialQuestions>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeEssentialQuestions>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeEssentialQuestions>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeEssentialQuestions(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeEssentialQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeEssentialQuestions>>
>;

export type LikeEssentialQuestionsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeEssentialQuestions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeEssentialQuestions>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeEssentialQuestions>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeEssentialQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeEssentialQuestions = (id: number) => {
  return configureAxios<void>({
    url: `/essential-questions/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeEssentialQuestionsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeEssentialQuestions>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeEssentialQuestions>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeEssentialQuestions>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeEssentialQuestions(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeEssentialQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeEssentialQuestions>>
>;

export type UnlikeEssentialQuestionsMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeEssentialQuestions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeEssentialQuestions>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeEssentialQuestions>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeEssentialQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Submit essay for assignment
 */
export const submitEssay = (
  assignmentId: number,
  submitEssayRequestDto: BodyType<SubmitEssayRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentEssaySubmissionResponseDto>({
    url: `/essay-submissions/assignments/${assignmentId}/submit`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitEssayRequestDto,
    signal,
  });
};

export const getSubmitEssayMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitEssay>>,
    TError,
    { assignmentId: number; data: BodyType<SubmitEssayRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitEssay>>,
  TError,
  { assignmentId: number; data: BodyType<SubmitEssayRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitEssay>>,
    { assignmentId: number; data: BodyType<SubmitEssayRequestDto> }
  > = (props) => {
    const { assignmentId, data } = props ?? {};

    return submitEssay(assignmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitEssayMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitEssay>>
>;
export type SubmitEssayMutationBody = BodyType<SubmitEssayRequestDto>;
export type SubmitEssayMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Submit essay for assignment
 */
export const useSubmitEssay = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitEssay>>,
    TError,
    { assignmentId: number; data: BodyType<SubmitEssayRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitEssay>>,
  TError,
  { assignmentId: number; data: BodyType<SubmitEssayRequestDto> },
  TContext
> => {
  const mutationOptions = getSubmitEssayMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEssayGraders = (
  params?: GetEssayGradersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListEssayGradingResultDto>({
    url: `/essay-grader`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetEssayGradersQueryKey = (params?: GetEssayGradersParams) => {
  return [`/essay-grader`, ...(params ? [params] : [])] as const;
};

export const getGetEssayGradersQueryOptions = <
  TData = Awaited<ReturnType<typeof getEssayGraders>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGraders>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEssayGradersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEssayGraders>>> = ({
    signal,
  }) => getEssayGraders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEssayGraders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEssayGradersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEssayGraders>>
>;
export type GetEssayGradersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetEssayGraders<
  TData = Awaited<ReturnType<typeof getEssayGraders>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetEssayGradersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGraders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayGraders>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEssayGraders<
  TData = Awaited<ReturnType<typeof getEssayGraders>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGraders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayGraders>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEssayGraders<
  TData = Awaited<ReturnType<typeof getEssayGraders>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGraders>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetEssayGraders<
  TData = Awaited<ReturnType<typeof getEssayGraders>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGraders>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEssayGradersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createEssayGrader = (
  essayGradingRequestBodyDto: BodyType<EssayGradingRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<EssayGradingResultDto>({
    url: `/essay-grader`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: essayGradingRequestBodyDto,
    signal,
  });
};

export const getCreateEssayGraderMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEssayGrader>>,
    TError,
    { data: BodyType<EssayGradingRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEssayGrader>>,
  TError,
  { data: BodyType<EssayGradingRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEssayGrader>>,
    { data: BodyType<EssayGradingRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createEssayGrader(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEssayGraderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEssayGrader>>
>;
export type CreateEssayGraderMutationBody =
  BodyType<EssayGradingRequestBodyDto>;
export type CreateEssayGraderMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateEssayGrader = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEssayGrader>>,
    TError,
    { data: BodyType<EssayGradingRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEssayGrader>>,
  TError,
  { data: BodyType<EssayGradingRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateEssayGraderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendMessageToSingleEssayGrader = (
  mainId: number,
  singleId: number,
  createChatMessageRequestBodyDto: BodyType<CreateChatMessageRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<EssayGradingSubSingleResultDto>({
    url: `/essay-grader/${mainId}/${singleId}/messages`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createChatMessageRequestBodyDto,
    signal,
  });
};

export const getSendMessageToSingleEssayGraderMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToSingleEssayGrader>>,
    TError,
    {
      mainId: number;
      singleId: number;
      data: BodyType<CreateChatMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageToSingleEssayGrader>>,
  TError,
  {
    mainId: number;
    singleId: number;
    data: BodyType<CreateChatMessageRequestBodyDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageToSingleEssayGrader>>,
    {
      mainId: number;
      singleId: number;
      data: BodyType<CreateChatMessageRequestBodyDto>;
    }
  > = (props) => {
    const { mainId, singleId, data } = props ?? {};

    return sendMessageToSingleEssayGrader(mainId, singleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageToSingleEssayGraderMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessageToSingleEssayGrader>>
>;
export type SendMessageToSingleEssayGraderMutationBody =
  BodyType<CreateChatMessageRequestBodyDto>;
export type SendMessageToSingleEssayGraderMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSendMessageToSingleEssayGrader = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToSingleEssayGrader>>,
    TError,
    {
      mainId: number;
      singleId: number;
      data: BodyType<CreateChatMessageRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageToSingleEssayGrader>>,
  TError,
  {
    mainId: number;
    singleId: number;
    data: BodyType<CreateChatMessageRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions =
    getSendMessageToSingleEssayGraderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const sendMessageToEssayGrader = (
  id: number,
  createChatMessageRequestBodyDto: BodyType<CreateChatMessageRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<EssayGradingResultDto>({
    url: `/essay-grader/${id}/messages`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createChatMessageRequestBodyDto,
    signal,
  });
};

export const getSendMessageToEssayGraderMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToEssayGrader>>,
    TError,
    { id: number; data: BodyType<CreateChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageToEssayGrader>>,
  TError,
  { id: number; data: BodyType<CreateChatMessageRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageToEssayGrader>>,
    { id: number; data: BodyType<CreateChatMessageRequestBodyDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendMessageToEssayGrader(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageToEssayGraderMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessageToEssayGrader>>
>;
export type SendMessageToEssayGraderMutationBody =
  BodyType<CreateChatMessageRequestBodyDto>;
export type SendMessageToEssayGraderMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSendMessageToEssayGrader = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageToEssayGrader>>,
    TError,
    { id: number; data: BodyType<CreateChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageToEssayGrader>>,
  TError,
  { id: number; data: BodyType<CreateChatMessageRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getSendMessageToEssayGraderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all essay assignments for current teacher
 */
export const getEssayAssignments = (
  params?: GetEssayAssignmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListEssayAssignmentResponseDto>({
    url: `/essay-assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetEssayAssignmentsQueryKey = (
  params?: GetEssayAssignmentsParams,
) => {
  return [`/essay-assignments`, ...(params ? [params] : [])] as const;
};

export const getGetEssayAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEssayAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEssayAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEssayAssignments>>
  > = ({ signal }) => getEssayAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEssayAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEssayAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEssayAssignments>>
>;
export type GetEssayAssignmentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetEssayAssignments<
  TData = Awaited<ReturnType<typeof getEssayAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetEssayAssignmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEssayAssignments<
  TData = Awaited<ReturnType<typeof getEssayAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEssayAssignments<
  TData = Awaited<ReturnType<typeof getEssayAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all essay assignments for current teacher
 */

export function useGetEssayAssignments<
  TData = Awaited<ReturnType<typeof getEssayAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEssayAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create new essay assignment
 */
export const createEssayAssignment = (
  createEssayAssignmentRequestDto: BodyType<CreateEssayAssignmentRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<EssayAssignmentResponseDto>({
    url: `/essay-assignments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEssayAssignmentRequestDto,
    signal,
  });
};

export const getCreateEssayAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEssayAssignment>>,
    TError,
    { data: BodyType<CreateEssayAssignmentRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEssayAssignment>>,
  TError,
  { data: BodyType<CreateEssayAssignmentRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEssayAssignment>>,
    { data: BodyType<CreateEssayAssignmentRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createEssayAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEssayAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEssayAssignment>>
>;
export type CreateEssayAssignmentMutationBody =
  BodyType<CreateEssayAssignmentRequestDto>;
export type CreateEssayAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Create new essay assignment
 */
export const useCreateEssayAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEssayAssignment>>,
    TError,
    { data: BodyType<CreateEssayAssignmentRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEssayAssignment>>,
  TError,
  { data: BodyType<CreateEssayAssignmentRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateEssayAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Release grades to students
 */
export const releaseGrades = (
  id: number,
  releaseGradesRequestDto: BodyType<ReleaseGradesRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/essay-assignments/${id}/release-grades`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: releaseGradesRequestDto,
    signal,
  });
};

export const getReleaseGradesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseGrades>>,
    TError,
    { id: number; data: BodyType<ReleaseGradesRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releaseGrades>>,
  TError,
  { id: number; data: BodyType<ReleaseGradesRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releaseGrades>>,
    { id: number; data: BodyType<ReleaseGradesRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return releaseGrades(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseGradesMutationResult = NonNullable<
  Awaited<ReturnType<typeof releaseGrades>>
>;
export type ReleaseGradesMutationBody = BodyType<ReleaseGradesRequestDto>;
export type ReleaseGradesMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Release grades to students
 */
export const useReleaseGrades = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseGrades>>,
    TError,
    { id: number; data: BodyType<ReleaseGradesRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof releaseGrades>>,
  TError,
  { id: number; data: BodyType<ReleaseGradesRequestDto> },
  TContext
> => {
  const mutationOptions = getReleaseGradesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Assign students to essay assignment
 */
export const assignStudents = (
  id: number,
  assignStudentsRequestDto: BodyType<AssignStudentsRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/essay-assignments/${id}/assign-students`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: assignStudentsRequestDto,
    signal,
  });
};

export const getAssignStudentsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignStudents>>,
    TError,
    { id: number; data: BodyType<AssignStudentsRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignStudents>>,
  TError,
  { id: number; data: BodyType<AssignStudentsRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignStudents>>,
    { id: number; data: BodyType<AssignStudentsRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignStudents(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignStudentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignStudents>>
>;
export type AssignStudentsMutationBody = BodyType<AssignStudentsRequestDto>;
export type AssignStudentsMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Assign students to essay assignment
 */
export const useAssignStudents = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignStudents>>,
    TError,
    { id: number; data: BodyType<AssignStudentsRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignStudents>>,
  TError,
  { id: number; data: BodyType<AssignStudentsRequestDto> },
  TContext
> => {
  const mutationOptions = getAssignStudentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const saveEmailForSubscription = (
  subscribeEmailItem: BodyType<SubscribeEmailItem>,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseSuccessResponseDto>({
    url: `/email`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: subscribeEmailItem,
    signal,
  });
};

export const getSaveEmailForSubscriptionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveEmailForSubscription>>,
    TError,
    { data: BodyType<SubscribeEmailItem> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveEmailForSubscription>>,
  TError,
  { data: BodyType<SubscribeEmailItem> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveEmailForSubscription>>,
    { data: BodyType<SubscribeEmailItem> }
  > = (props) => {
    const { data } = props ?? {};

    return saveEmailForSubscription(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveEmailForSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveEmailForSubscription>>
>;
export type SaveEmailForSubscriptionMutationBody = BodyType<SubscribeEmailItem>;
export type SaveEmailForSubscriptionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useSaveEmailForSubscription = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveEmailForSubscription>>,
    TError,
    { data: BodyType<SubscribeEmailItem> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveEmailForSubscription>>,
  TError,
  { data: BodyType<SubscribeEmailItem> },
  TContext
> => {
  const mutationOptions = getSaveEmailForSubscriptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const handleNewEmail = (
  handleNewEmailBody: BodyType<HandleNewEmailBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<string>({
    url: `/email-new`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: handleNewEmailBody,
    signal,
  });
};

export const getHandleNewEmailMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleNewEmail>>,
    TError,
    { data: BodyType<HandleNewEmailBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof handleNewEmail>>,
  TError,
  { data: BodyType<HandleNewEmailBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof handleNewEmail>>,
    { data: BodyType<HandleNewEmailBody> }
  > = (props) => {
    const { data } = props ?? {};

    return handleNewEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleNewEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleNewEmail>>
>;
export type HandleNewEmailMutationBody = BodyType<HandleNewEmailBody>;
export type HandleNewEmailMutationError = ErrorType<BaseErrorResponseDto>;

export const useHandleNewEmail = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleNewEmail>>,
    TError,
    { data: BodyType<HandleNewEmailBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof handleNewEmail>>,
  TError,
  { data: BodyType<HandleNewEmailBody> },
  TContext
> => {
  const mutationOptions = getHandleNewEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @deprecated
 */
export const edlinkPublishInteractiveMaterial = (
  edlinkAssignmentPublishRequestDto: BodyType<EdlinkAssignmentPublishRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/edlink/publish-interactive-material`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: edlinkAssignmentPublishRequestDto,
    signal,
  });
};

export const getEdlinkPublishInteractiveMaterialMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof edlinkPublishInteractiveMaterial>>,
    TError,
    { data: BodyType<EdlinkAssignmentPublishRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof edlinkPublishInteractiveMaterial>>,
  TError,
  { data: BodyType<EdlinkAssignmentPublishRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof edlinkPublishInteractiveMaterial>>,
    { data: BodyType<EdlinkAssignmentPublishRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return edlinkPublishInteractiveMaterial(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdlinkPublishInteractiveMaterialMutationResult = NonNullable<
  Awaited<ReturnType<typeof edlinkPublishInteractiveMaterial>>
>;
export type EdlinkPublishInteractiveMaterialMutationBody =
  BodyType<EdlinkAssignmentPublishRequestDto>;
export type EdlinkPublishInteractiveMaterialMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @deprecated
 */
export const useEdlinkPublishInteractiveMaterial = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof edlinkPublishInteractiveMaterial>>,
    TError,
    { data: BodyType<EdlinkAssignmentPublishRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof edlinkPublishInteractiveMaterial>>,
  TError,
  { data: BodyType<EdlinkAssignmentPublishRequestDto> },
  TContext
> => {
  const mutationOptions =
    getEdlinkPublishInteractiveMaterialMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @deprecated
 */
export const edlinkPublishAssignment = (
  edlinkAssignmentPublishRequestDto: BodyType<EdlinkAssignmentPublishRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/edlink/publish-assignment`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: edlinkAssignmentPublishRequestDto,
    signal,
  });
};

export const getEdlinkPublishAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof edlinkPublishAssignment>>,
    TError,
    { data: BodyType<EdlinkAssignmentPublishRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof edlinkPublishAssignment>>,
  TError,
  { data: BodyType<EdlinkAssignmentPublishRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof edlinkPublishAssignment>>,
    { data: BodyType<EdlinkAssignmentPublishRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return edlinkPublishAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdlinkPublishAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof edlinkPublishAssignment>>
>;
export type EdlinkPublishAssignmentMutationBody =
  BodyType<EdlinkAssignmentPublishRequestDto>;
export type EdlinkPublishAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @deprecated
 */
export const useEdlinkPublishAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof edlinkPublishAssignment>>,
    TError,
    { data: BodyType<EdlinkAssignmentPublishRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof edlinkPublishAssignment>>,
  TError,
  { data: BodyType<EdlinkAssignmentPublishRequestDto> },
  TContext
> => {
  const mutationOptions = getEdlinkPublishAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const importBulkUsers = (
  edlinkBulkUserImportRequestDto: BodyType<EdlinkBulkUserImportRequestDto[]>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/edlink/import-bulk-users`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: edlinkBulkUserImportRequestDto,
    signal,
  });
};

export const getImportBulkUsersMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBulkUsers>>,
    TError,
    { data: BodyType<EdlinkBulkUserImportRequestDto[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importBulkUsers>>,
  TError,
  { data: BodyType<EdlinkBulkUserImportRequestDto[]> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importBulkUsers>>,
    { data: BodyType<EdlinkBulkUserImportRequestDto[]> }
  > = (props) => {
    const { data } = props ?? {};

    return importBulkUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportBulkUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof importBulkUsers>>
>;
export type ImportBulkUsersMutationBody = BodyType<
  EdlinkBulkUserImportRequestDto[]
>;
export type ImportBulkUsersMutationError = ErrorType<BaseErrorResponseDto>;

export const useImportBulkUsers = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBulkUsers>>,
    TError,
    { data: BodyType<EdlinkBulkUserImportRequestDto[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof importBulkUsers>>,
  TError,
  { data: BodyType<EdlinkBulkUserImportRequestDto[]> },
  TContext
> => {
  const mutationOptions = getImportBulkUsersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const edlinkCloneClassroom = (
  edlinkClassroomCloneRequestDto: BodyType<EdlinkClassroomCloneRequestDto[]>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/edlink/clone-classroom`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: edlinkClassroomCloneRequestDto,
    signal,
  });
};

export const getEdlinkCloneClassroomMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof edlinkCloneClassroom>>,
    TError,
    { data: BodyType<EdlinkClassroomCloneRequestDto[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof edlinkCloneClassroom>>,
  TError,
  { data: BodyType<EdlinkClassroomCloneRequestDto[]> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof edlinkCloneClassroom>>,
    { data: BodyType<EdlinkClassroomCloneRequestDto[]> }
  > = (props) => {
    const { data } = props ?? {};

    return edlinkCloneClassroom(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EdlinkCloneClassroomMutationResult = NonNullable<
  Awaited<ReturnType<typeof edlinkCloneClassroom>>
>;
export type EdlinkCloneClassroomMutationBody = BodyType<
  EdlinkClassroomCloneRequestDto[]
>;
export type EdlinkCloneClassroomMutationError = ErrorType<BaseErrorResponseDto>;

export const useEdlinkCloneClassroom = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof edlinkCloneClassroom>>,
    TError,
    { data: BodyType<EdlinkClassroomCloneRequestDto[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof edlinkCloneClassroom>>,
  TError,
  { data: BodyType<EdlinkClassroomCloneRequestDto[]> },
  TContext
> => {
  const mutationOptions = getEdlinkCloneClassroomMutationOptions(options);

  return useMutation(mutationOptions);
};

export const requestADemo = (
  requestDemoEmailItem: BodyType<RequestDemoEmailItem>,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseSuccessResponseDto>({
    url: `/demo`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requestDemoEmailItem,
    signal,
  });
};

export const getRequestADemoMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestADemo>>,
    TError,
    { data: BodyType<RequestDemoEmailItem> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestADemo>>,
  TError,
  { data: BodyType<RequestDemoEmailItem> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestADemo>>,
    { data: BodyType<RequestDemoEmailItem> }
  > = (props) => {
    const { data } = props ?? {};

    return requestADemo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestADemoMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestADemo>>
>;
export type RequestADemoMutationBody = BodyType<RequestDemoEmailItem>;
export type RequestADemoMutationError = ErrorType<BaseErrorResponseDto>;

export const useRequestADemo = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestADemo>>,
    TError,
    { data: BodyType<RequestDemoEmailItem> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestADemo>>,
  TError,
  { data: BodyType<RequestDemoEmailItem> },
  TContext
> => {
  const mutationOptions = getRequestADemoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const triggerWeeklyAnalysis = (
  triggerWeeklyAnalysisRequestDto: BodyType<TriggerWeeklyAnalysisRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/dashboard-analysis/trigger-weekly-analysis`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: triggerWeeklyAnalysisRequestDto,
    signal,
  });
};

export const getTriggerWeeklyAnalysisMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerWeeklyAnalysis>>,
    TError,
    { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerWeeklyAnalysis>>,
  TError,
  { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerWeeklyAnalysis>>,
    { data: BodyType<TriggerWeeklyAnalysisRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return triggerWeeklyAnalysis(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerWeeklyAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerWeeklyAnalysis>>
>;
export type TriggerWeeklyAnalysisMutationBody =
  BodyType<TriggerWeeklyAnalysisRequestDto>;
export type TriggerWeeklyAnalysisMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useTriggerWeeklyAnalysis = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerWeeklyAnalysis>>,
    TError,
    { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerWeeklyAnalysis>>,
  TError,
  { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
  TContext
> => {
  const mutationOptions = getTriggerWeeklyAnalysisMutationOptions(options);

  return useMutation(mutationOptions);
};

export const triggerTopicMerger = (
  triggerWeeklyAnalysisRequestDto: BodyType<TriggerWeeklyAnalysisRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/dashboard-analysis/trigger-topic-merger`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: triggerWeeklyAnalysisRequestDto,
    signal,
  });
};

export const getTriggerTopicMergerMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerTopicMerger>>,
    TError,
    { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerTopicMerger>>,
  TError,
  { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerTopicMerger>>,
    { data: BodyType<TriggerWeeklyAnalysisRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return triggerTopicMerger(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerTopicMergerMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerTopicMerger>>
>;
export type TriggerTopicMergerMutationBody =
  BodyType<TriggerWeeklyAnalysisRequestDto>;
export type TriggerTopicMergerMutationError = ErrorType<BaseErrorResponseDto>;

export const useTriggerTopicMerger = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerTopicMerger>>,
    TError,
    { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerTopicMerger>>,
  TError,
  { data: BodyType<TriggerWeeklyAnalysisRequestDto> },
  TContext
> => {
  const mutationOptions = getTriggerTopicMergerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const triggerTeacherChatAnalysis = (
  triggerTeacherChatAnalysisRequestDto: BodyType<TriggerTeacherChatAnalysisRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/dashboard-analysis/trigger-teacher-chat-analysis`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: triggerTeacherChatAnalysisRequestDto,
    signal,
  });
};

export const getTriggerTeacherChatAnalysisMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerTeacherChatAnalysis>>,
    TError,
    { data: BodyType<TriggerTeacherChatAnalysisRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerTeacherChatAnalysis>>,
  TError,
  { data: BodyType<TriggerTeacherChatAnalysisRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerTeacherChatAnalysis>>,
    { data: BodyType<TriggerTeacherChatAnalysisRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return triggerTeacherChatAnalysis(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerTeacherChatAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerTeacherChatAnalysis>>
>;
export type TriggerTeacherChatAnalysisMutationBody =
  BodyType<TriggerTeacherChatAnalysisRequestDto>;
export type TriggerTeacherChatAnalysisMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useTriggerTeacherChatAnalysis = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerTeacherChatAnalysis>>,
    TError,
    { data: BodyType<TriggerTeacherChatAnalysisRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerTeacherChatAnalysis>>,
  TError,
  { data: BodyType<TriggerTeacherChatAnalysisRequestDto> },
  TContext
> => {
  const mutationOptions = getTriggerTeacherChatAnalysisMutationOptions(options);

  return useMutation(mutationOptions);
};

export const triggerChatAnalysis = (
  triggerChatAnalysisRequestDto: BodyType<TriggerChatAnalysisRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/dashboard-analysis/trigger-chat-analysis`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: triggerChatAnalysisRequestDto,
    signal,
  });
};

export const getTriggerChatAnalysisMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerChatAnalysis>>,
    TError,
    { data: BodyType<TriggerChatAnalysisRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerChatAnalysis>>,
  TError,
  { data: BodyType<TriggerChatAnalysisRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerChatAnalysis>>,
    { data: BodyType<TriggerChatAnalysisRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return triggerChatAnalysis(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerChatAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerChatAnalysis>>
>;
export type TriggerChatAnalysisMutationBody =
  BodyType<TriggerChatAnalysisRequestDto>;
export type TriggerChatAnalysisMutationError = ErrorType<BaseErrorResponseDto>;

export const useTriggerChatAnalysis = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerChatAnalysis>>,
    TError,
    { data: BodyType<TriggerChatAnalysisRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerChatAnalysis>>,
  TError,
  { data: BodyType<TriggerChatAnalysisRequestDto> },
  TContext
> => {
  const mutationOptions = getTriggerChatAnalysisMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postDailyAssignments = (
  id: number,
  dailyAssignmentFinishRequestDto: BodyType<DailyAssignmentFinishRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/daily-assignments/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: dailyAssignmentFinishRequestDto,
    signal,
  });
};

export const getPostDailyAssignmentsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDailyAssignments>>,
    TError,
    { id: number; data: BodyType<DailyAssignmentFinishRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDailyAssignments>>,
  TError,
  { id: number; data: BodyType<DailyAssignmentFinishRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDailyAssignments>>,
    { id: number; data: BodyType<DailyAssignmentFinishRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postDailyAssignments(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDailyAssignmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDailyAssignments>>
>;
export type PostDailyAssignmentsMutationBody =
  BodyType<DailyAssignmentFinishRequestDto>;
export type PostDailyAssignmentsMutationError = ErrorType<BaseErrorResponseDto>;

export const usePostDailyAssignments = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDailyAssignments>>,
    TError,
    { id: number; data: BodyType<DailyAssignmentFinishRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof postDailyAssignments>>,
  TError,
  { id: number; data: BodyType<DailyAssignmentFinishRequestDto> },
  TContext
> => {
  const mutationOptions = getPostDailyAssignmentsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createConceptualUnderstanding = (
  conceptualUnderstandingCreateRequestDto: BodyType<ConceptualUnderstandingCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ConceptualUnderstandingResponseDto>({
    url: `/conceptual-understandings`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: conceptualUnderstandingCreateRequestDto,
    signal,
  });
};

export const getCreateConceptualUnderstandingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConceptualUnderstanding>>,
    TError,
    { data: BodyType<ConceptualUnderstandingCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createConceptualUnderstanding>>,
  TError,
  { data: BodyType<ConceptualUnderstandingCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createConceptualUnderstanding>>,
    { data: BodyType<ConceptualUnderstandingCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createConceptualUnderstanding(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateConceptualUnderstandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createConceptualUnderstanding>>
>;
export type CreateConceptualUnderstandingMutationBody =
  BodyType<ConceptualUnderstandingCreateRequestDto>;
export type CreateConceptualUnderstandingMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateConceptualUnderstanding = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConceptualUnderstanding>>,
    TError,
    { data: BodyType<ConceptualUnderstandingCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createConceptualUnderstanding>>,
  TError,
  { data: BodyType<ConceptualUnderstandingCreateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateConceptualUnderstandingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateConceptualUnderstanding = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<ConceptualUnderstandingResponseDto>({
    url: `/conceptual-understandings/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateConceptualUnderstandingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateConceptualUnderstanding>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateConceptualUnderstanding>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateConceptualUnderstanding>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateConceptualUnderstanding(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateConceptualUnderstandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateConceptualUnderstanding>>
>;
export type RegenerateConceptualUnderstandingMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateConceptualUnderstandingMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateConceptualUnderstanding = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateConceptualUnderstanding>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateConceptualUnderstanding>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateConceptualUnderstandingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeConceptualUnderstanding = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/conceptual-understandings/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeConceptualUnderstandingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeConceptualUnderstanding>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeConceptualUnderstanding>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeConceptualUnderstanding>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeConceptualUnderstanding(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeConceptualUnderstandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeConceptualUnderstanding>>
>;

export type LikeConceptualUnderstandingMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeConceptualUnderstanding = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeConceptualUnderstanding>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeConceptualUnderstanding>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getLikeConceptualUnderstandingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeConceptualUnderstanding = (id: number) => {
  return configureAxios<void>({
    url: `/conceptual-understandings/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeConceptualUnderstandingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeConceptualUnderstanding>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeConceptualUnderstanding>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeConceptualUnderstanding>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeConceptualUnderstanding(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeConceptualUnderstandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeConceptualUnderstanding>>
>;

export type UnlikeConceptualUnderstandingMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeConceptualUnderstanding = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeConceptualUnderstanding>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeConceptualUnderstanding>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getUnlikeConceptualUnderstandingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createCommonMisconception = (
  commonMisconceptionCreateRequestDto: BodyType<CommonMisconceptionCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CommonMisconceptionResponseDto>({
    url: `/common-misconceptions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: commonMisconceptionCreateRequestDto,
    signal,
  });
};

export const getCreateCommonMisconceptionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommonMisconception>>,
    TError,
    { data: BodyType<CommonMisconceptionCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommonMisconception>>,
  TError,
  { data: BodyType<CommonMisconceptionCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommonMisconception>>,
    { data: BodyType<CommonMisconceptionCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createCommonMisconception(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommonMisconceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommonMisconception>>
>;
export type CreateCommonMisconceptionMutationBody =
  BodyType<CommonMisconceptionCreateRequestDto>;
export type CreateCommonMisconceptionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateCommonMisconception = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommonMisconception>>,
    TError,
    { data: BodyType<CommonMisconceptionCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCommonMisconception>>,
  TError,
  { data: BodyType<CommonMisconceptionCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateCommonMisconceptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateCommonMisconception = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<CommonMisconceptionResponseDto>({
    url: `/common-misconceptions/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateCommonMisconceptionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCommonMisconception>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateCommonMisconception>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateCommonMisconception>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateCommonMisconception(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateCommonMisconceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateCommonMisconception>>
>;
export type RegenerateCommonMisconceptionMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateCommonMisconceptionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateCommonMisconception = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCommonMisconception>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateCommonMisconception>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateCommonMisconceptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeCommonMisconception = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/common-misconceptions/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeCommonMisconceptionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeCommonMisconception>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeCommonMisconception>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeCommonMisconception>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeCommonMisconception(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeCommonMisconceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeCommonMisconception>>
>;

export type LikeCommonMisconceptionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeCommonMisconception = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeCommonMisconception>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeCommonMisconception>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeCommonMisconceptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeCommonMisconception = (id: number) => {
  return configureAxios<void>({
    url: `/common-misconceptions/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeCommonMisconceptionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeCommonMisconception>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeCommonMisconception>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeCommonMisconception>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeCommonMisconception(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeCommonMisconceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeCommonMisconception>>
>;

export type UnlikeCommonMisconceptionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeCommonMisconception = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeCommonMisconception>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeCommonMisconception>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeCommonMisconceptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createCollaborativeGroupWork = (
  collaborativeGroupWorkCreateRequestDto: BodyType<CollaborativeGroupWorkCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CollaborativeGroupWorkResponseDto>({
    url: `/collaborative-group-work`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: collaborativeGroupWorkCreateRequestDto,
    signal,
  });
};

export const getCreateCollaborativeGroupWorkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCollaborativeGroupWork>>,
    TError,
    { data: BodyType<CollaborativeGroupWorkCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCollaborativeGroupWork>>,
  TError,
  { data: BodyType<CollaborativeGroupWorkCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCollaborativeGroupWork>>,
    { data: BodyType<CollaborativeGroupWorkCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createCollaborativeGroupWork(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCollaborativeGroupWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCollaborativeGroupWork>>
>;
export type CreateCollaborativeGroupWorkMutationBody =
  BodyType<CollaborativeGroupWorkCreateRequestDto>;
export type CreateCollaborativeGroupWorkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateCollaborativeGroupWork = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCollaborativeGroupWork>>,
    TError,
    { data: BodyType<CollaborativeGroupWorkCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCollaborativeGroupWork>>,
  TError,
  { data: BodyType<CollaborativeGroupWorkCreateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateCollaborativeGroupWorkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateCollaborativeGroupWork = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<CollaborativeGroupWorkResponseDto>({
    url: `/collaborative-group-work/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateCollaborativeGroupWorkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCollaborativeGroupWork>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateCollaborativeGroupWork>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateCollaborativeGroupWork>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateCollaborativeGroupWork(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateCollaborativeGroupWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateCollaborativeGroupWork>>
>;
export type RegenerateCollaborativeGroupWorkMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateCollaborativeGroupWorkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateCollaborativeGroupWork = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateCollaborativeGroupWork>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateCollaborativeGroupWork>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateCollaborativeGroupWorkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeCollaborativeGroupWork = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/collaborative-group-work/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeCollaborativeGroupWorkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeCollaborativeGroupWork>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeCollaborativeGroupWork>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeCollaborativeGroupWork>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeCollaborativeGroupWork(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeCollaborativeGroupWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeCollaborativeGroupWork>>
>;

export type LikeCollaborativeGroupWorkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeCollaborativeGroupWork = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeCollaborativeGroupWork>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeCollaborativeGroupWork>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeCollaborativeGroupWorkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeCollaborativeGroupWork = (id: number) => {
  return configureAxios<void>({
    url: `/collaborative-group-work/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeCollaborativeGroupWorkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeCollaborativeGroupWork>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeCollaborativeGroupWork>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeCollaborativeGroupWork>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeCollaborativeGroupWork(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeCollaborativeGroupWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeCollaborativeGroupWork>>
>;

export type UnlikeCollaborativeGroupWorkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeCollaborativeGroupWork = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeCollaborativeGroupWork>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeCollaborativeGroupWork>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getUnlikeCollaborativeGroupWorkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createClassroomManagement = (
  classroomManagementCreateRequestDto: BodyType<ClassroomManagementCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomManagementResponseDto>({
    url: `/classroom-managements`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: classroomManagementCreateRequestDto,
    signal,
  });
};

export const getCreateClassroomManagementMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClassroomManagement>>,
    TError,
    { data: BodyType<ClassroomManagementCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClassroomManagement>>,
  TError,
  { data: BodyType<ClassroomManagementCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClassroomManagement>>,
    { data: BodyType<ClassroomManagementCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createClassroomManagement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClassroomManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClassroomManagement>>
>;
export type CreateClassroomManagementMutationBody =
  BodyType<ClassroomManagementCreateRequestDto>;
export type CreateClassroomManagementMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateClassroomManagement = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClassroomManagement>>,
    TError,
    { data: BodyType<ClassroomManagementCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClassroomManagement>>,
  TError,
  { data: BodyType<ClassroomManagementCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateClassroomManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenClassroomManagement = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomManagementResponseDto>({
    url: `/classroom-managements/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenClassroomManagementMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenClassroomManagement>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenClassroomManagement>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenClassroomManagement>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenClassroomManagement(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenClassroomManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenClassroomManagement>>
>;
export type RegenClassroomManagementMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenClassroomManagementMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenClassroomManagement = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenClassroomManagement>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenClassroomManagement>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenClassroomManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeClassroomManagement = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/classroom-managements/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeClassroomManagementMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeClassroomManagement>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeClassroomManagement>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeClassroomManagement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeClassroomManagement(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeClassroomManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeClassroomManagement>>
>;

export type LikeClassroomManagementMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeClassroomManagement = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeClassroomManagement>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeClassroomManagement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeClassroomManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeClassroomManagement = (id: number) => {
  return configureAxios<void>({
    url: `/classroom-managements/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeClassroomManagementMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeClassroomManagement>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeClassroomManagement>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeClassroomManagement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeClassroomManagement(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeClassroomManagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeClassroomManagement>>
>;

export type UnlikeClassroomManagementMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeClassroomManagement = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeClassroomManagement>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeClassroomManagement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeClassroomManagementMutationOptions(options);

  return useMutation(mutationOptions);
};

export const receiveWebhook = (
  circleWebhookRequestObject: BodyType<CircleWebhookRequestObject>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/circle-webhooks/receive`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: circleWebhookRequestObject,
    signal,
  });
};

export const getReceiveWebhookMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveWebhook>>,
    TError,
    { data: BodyType<CircleWebhookRequestObject> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiveWebhook>>,
  TError,
  { data: BodyType<CircleWebhookRequestObject> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiveWebhook>>,
    { data: BodyType<CircleWebhookRequestObject> }
  > = (props) => {
    const { data } = props ?? {};

    return receiveWebhook(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiveWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiveWebhook>>
>;
export type ReceiveWebhookMutationBody = BodyType<CircleWebhookRequestObject>;
export type ReceiveWebhookMutationError = ErrorType<BaseErrorResponseDto>;

export const useReceiveWebhook = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiveWebhook>>,
    TError,
    { data: BodyType<CircleWebhookRequestObject> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof receiveWebhook>>,
  TError,
  { data: BodyType<CircleWebhookRequestObject> },
  TContext
> => {
  const mutationOptions = getReceiveWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createChoiceBoard = (
  choiceBoardCreateRequestDto: BodyType<ChoiceBoardCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ChoiceBoardResponseDto>({
    url: `/choice-boards`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: choiceBoardCreateRequestDto,
    signal,
  });
};

export const getCreateChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChoiceBoard>>,
    TError,
    { data: BodyType<ChoiceBoardCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChoiceBoard>>,
  TError,
  { data: BodyType<ChoiceBoardCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChoiceBoard>>,
    { data: BodyType<ChoiceBoardCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createChoiceBoard(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChoiceBoard>>
>;
export type CreateChoiceBoardMutationBody =
  BodyType<ChoiceBoardCreateRequestDto>;
export type CreateChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChoiceBoard>>,
    TError,
    { data: BodyType<ChoiceBoardCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createChoiceBoard>>,
  TError,
  { data: BodyType<ChoiceBoardCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenChoiceBoard = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<ChoiceBoardResponseDto>({
    url: `/choice-boards/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenChoiceBoard>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenChoiceBoard>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenChoiceBoard>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenChoiceBoard(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenChoiceBoard>>
>;
export type RegenChoiceBoardMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useRegenChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenChoiceBoard>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenChoiceBoard>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeChoiceBoard = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/choice-boards/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeChoiceBoard>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeChoiceBoard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeChoiceBoard>>
>;

export type LikeChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeChoiceBoard = (id: number) => {
  return configureAxios<void>({
    url: `/choice-boards/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeChoiceBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeChoiceBoard>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeChoiceBoard(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeChoiceBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeChoiceBoard>>
>;

export type UnlikeChoiceBoardMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeChoiceBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeChoiceBoard>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeChoiceBoard>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeChoiceBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMessages = (
  chatId: number,
  params?: GetMessagesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatMessagesResponseDto>({
    url: `/chats/${chatId}/messages`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMessagesQueryKey = (
  chatId: number,
  params?: GetMessagesParams,
) => {
  return [`/chats/${chatId}/messages`, ...(params ? [params] : [])] as const;
};

export const getGetMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMessagesQueryKey(chatId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({
    signal,
  }) => getMessages(chatId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chatId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMessages>>
>;
export type GetMessagesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMessages<
  TData = Awaited<ReturnType<typeof getMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params: undefined | GetMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMessages<
  TData = Awaited<ReturnType<typeof getMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMessages<
  TData = Awaited<ReturnType<typeof getMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMessages<
  TData = Awaited<ReturnType<typeof getMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMessagesQueryOptions(chatId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const sendMessage = (
  chatId: number,
  createChatMessageRequestBodyDto: BodyType<CreateChatMessageRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateChatMessageResponseDto>({
    url: `/chats/${chatId}/messages`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createChatMessageRequestBodyDto,
    signal,
  });
};

export const getSendMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessage>>,
    { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> }
  > = (props) => {
    const { chatId, data } = props ?? {};

    return sendMessage(chatId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessage>>
>;
export type SendMessageMutationBody = BodyType<CreateChatMessageRequestBodyDto>;
export type SendMessageMutationError = ErrorType<BaseErrorResponseDto>;

export const useSendMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getSendMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateMessage = (chatId: number, signal?: AbortSignal) => {
  return configureAxios<GetChatResponseDto>({
    url: `/chats/${chatId}/messages/regenerate`,
    method: "POST",
    signal,
  });
};

export const getRegenerateMessageMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateMessage>>,
    TError,
    { chatId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateMessage>>,
  TError,
  { chatId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateMessage>>,
    { chatId: number }
  > = (props) => {
    const { chatId } = props ?? {};

    return regenerateMessage(chatId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateMessage>>
>;

export type RegenerateMessageMutationError = ErrorType<BaseErrorResponseDto>;

export const useRegenerateMessage = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateMessage>>,
    TError,
    { chatId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateMessage>>,
  TError,
  { chatId: number },
  TContext
> => {
  const mutationOptions = getRegenerateMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

export const discardMessageGeneration = (
  chatId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/chats/${chatId}/messages/discard-latest`,
    method: "POST",
    signal,
  });
};

export const getDiscardMessageGenerationMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardMessageGeneration>>,
    TError,
    { chatId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof discardMessageGeneration>>,
  TError,
  { chatId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof discardMessageGeneration>>,
    { chatId: number }
  > = (props) => {
    const { chatId } = props ?? {};

    return discardMessageGeneration(chatId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DiscardMessageGenerationMutationResult = NonNullable<
  Awaited<ReturnType<typeof discardMessageGeneration>>
>;

export type DiscardMessageGenerationMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDiscardMessageGeneration = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardMessageGeneration>>,
    TError,
    { chatId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof discardMessageGeneration>>,
  TError,
  { chatId: number },
  TContext
> => {
  const mutationOptions = getDiscardMessageGenerationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getMessagesOfDidactic = (
  chatId: number,
  params?: GetMessagesOfDidacticParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatMessagesResponseDto>({
    url: `/chats/${chatId}/messages/didactic`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMessagesOfDidacticQueryKey = (
  chatId: number,
  params?: GetMessagesOfDidacticParams,
) => {
  return [
    `/chats/${chatId}/messages/didactic`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMessagesOfDidacticQueryOptions = <
  TData = Awaited<ReturnType<typeof getMessagesOfDidactic>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesOfDidacticParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesOfDidactic>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMessagesOfDidacticQueryKey(chatId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMessagesOfDidactic>>
  > = ({ signal }) => getMessagesOfDidactic(chatId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!chatId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMessagesOfDidactic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMessagesOfDidacticQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMessagesOfDidactic>>
>;
export type GetMessagesOfDidacticQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMessagesOfDidactic<
  TData = Awaited<ReturnType<typeof getMessagesOfDidactic>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params: undefined | GetMessagesOfDidacticParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesOfDidactic>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesOfDidactic>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMessagesOfDidactic<
  TData = Awaited<ReturnType<typeof getMessagesOfDidactic>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesOfDidacticParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesOfDidactic>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesOfDidactic>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMessagesOfDidactic<
  TData = Awaited<ReturnType<typeof getMessagesOfDidactic>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesOfDidacticParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesOfDidactic>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMessagesOfDidactic<
  TData = Awaited<ReturnType<typeof getMessagesOfDidactic>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  chatId: number,
  params?: GetMessagesOfDidacticParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesOfDidactic>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMessagesOfDidacticQueryOptions(
    chatId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const sendMessageDidactic = (
  chatId: number,
  createChatMessageRequestBodyDto: BodyType<CreateChatMessageRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateChatMessageResponseDto>({
    url: `/chats/${chatId}/messages/didactic`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createChatMessageRequestBodyDto,
    signal,
  });
};

export const getSendMessageDidacticMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageDidactic>>,
    TError,
    { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessageDidactic>>,
  TError,
  { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessageDidactic>>,
    { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> }
  > = (props) => {
    const { chatId, data } = props ?? {};

    return sendMessageDidactic(chatId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageDidacticMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessageDidactic>>
>;
export type SendMessageDidacticMutationBody =
  BodyType<CreateChatMessageRequestBodyDto>;
export type SendMessageDidacticMutationError = ErrorType<BaseErrorResponseDto>;

export const useSendMessageDidactic = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessageDidactic>>,
    TError,
    { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessageDidactic>>,
  TError,
  { chatId: number; data: BodyType<CreateChatMessageRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getSendMessageDidacticMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createChatStudent = (
  createChatStudentRequestBodyDto: BodyType<CreateChatStudentRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateChatResponseDto>({
    url: `/chats/student`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createChatStudentRequestBodyDto,
    signal,
  });
};

export const getCreateChatStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChatStudent>>,
    TError,
    { data: BodyType<CreateChatStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChatStudent>>,
  TError,
  { data: BodyType<CreateChatStudentRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChatStudent>>,
    { data: BodyType<CreateChatStudentRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createChatStudent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChatStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChatStudent>>
>;
export type CreateChatStudentMutationBody =
  BodyType<CreateChatStudentRequestBodyDto>;
export type CreateChatStudentMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateChatStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChatStudent>>,
    TError,
    { data: BodyType<CreateChatStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createChatStudent>>,
  TError,
  { data: BodyType<CreateChatStudentRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateChatStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createExplanationStudent = (
  createExplanationStudentChatRequestBodyDto: BodyType<CreateExplanationStudentChatRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateChatResponseDto>({
    url: `/chats/student/question-explanation`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createExplanationStudentChatRequestBodyDto,
    signal,
  });
};

export const getCreateExplanationStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExplanationStudent>>,
    TError,
    { data: BodyType<CreateExplanationStudentChatRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExplanationStudent>>,
  TError,
  { data: BodyType<CreateExplanationStudentChatRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExplanationStudent>>,
    { data: BodyType<CreateExplanationStudentChatRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createExplanationStudent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExplanationStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExplanationStudent>>
>;
export type CreateExplanationStudentMutationBody =
  BodyType<CreateExplanationStudentChatRequestBodyDto>;
export type CreateExplanationStudentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateExplanationStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExplanationStudent>>,
    TError,
    { data: BodyType<CreateExplanationStudentChatRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExplanationStudent>>,
  TError,
  { data: BodyType<CreateExplanationStudentChatRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateExplanationStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createDidacticChatStudent = (
  createDidacticChatStudentRequestBodyDto: BodyType<CreateDidacticChatStudentRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateChatResponseDto>({
    url: `/chats/student/didactic`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createDidacticChatStudentRequestBodyDto,
    signal,
  });
};

export const getCreateDidacticChatStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDidacticChatStudent>>,
    TError,
    { data: BodyType<CreateDidacticChatStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDidacticChatStudent>>,
  TError,
  { data: BodyType<CreateDidacticChatStudentRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDidacticChatStudent>>,
    { data: BodyType<CreateDidacticChatStudentRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createDidacticChatStudent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDidacticChatStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDidacticChatStudent>>
>;
export type CreateDidacticChatStudentMutationBody =
  BodyType<CreateDidacticChatStudentRequestBodyDto>;
export type CreateDidacticChatStudentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateDidacticChatStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDidacticChatStudent>>,
    TError,
    { data: BodyType<CreateDidacticChatStudentRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDidacticChatStudent>>,
  TError,
  { data: BodyType<CreateDidacticChatStudentRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateDidacticChatStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getChatMessageSuggestions = (
  params: GetChatMessageSuggestionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatMessageSuggestionsResponseDto>({
    url: `/chat-message-suggestions`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetChatMessageSuggestionsQueryKey = (
  params: GetChatMessageSuggestionsParams,
) => {
  return [`/chat-message-suggestions`, ...(params ? [params] : [])] as const;
};

export const getGetChatMessageSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatMessageSuggestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetChatMessageSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessageSuggestions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChatMessageSuggestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChatMessageSuggestions>>
  > = ({ signal }) => getChatMessageSuggestions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatMessageSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetChatMessageSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatMessageSuggestions>>
>;
export type GetChatMessageSuggestionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetChatMessageSuggestions<
  TData = Awaited<ReturnType<typeof getChatMessageSuggestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetChatMessageSuggestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessageSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatMessageSuggestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChatMessageSuggestions<
  TData = Awaited<ReturnType<typeof getChatMessageSuggestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetChatMessageSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessageSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatMessageSuggestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChatMessageSuggestions<
  TData = Awaited<ReturnType<typeof getChatMessageSuggestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetChatMessageSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessageSuggestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetChatMessageSuggestions<
  TData = Awaited<ReturnType<typeof getChatMessageSuggestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetChatMessageSuggestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessageSuggestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetChatMessageSuggestionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createChatMessageSuggestion = (
  createChatMessageSuggestionRequestBodyDto: BodyType<CreateChatMessageSuggestionRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateChatMessageSuggestionResponseDto>({
    url: `/chat-message-suggestions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createChatMessageSuggestionRequestBodyDto,
    signal,
  });
};

export const getCreateChatMessageSuggestionMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChatMessageSuggestion>>,
    TError,
    { data: BodyType<CreateChatMessageSuggestionRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChatMessageSuggestion>>,
  TError,
  { data: BodyType<CreateChatMessageSuggestionRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChatMessageSuggestion>>,
    { data: BodyType<CreateChatMessageSuggestionRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createChatMessageSuggestion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChatMessageSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChatMessageSuggestion>>
>;
export type CreateChatMessageSuggestionMutationBody =
  BodyType<CreateChatMessageSuggestionRequestBodyDto>;
export type CreateChatMessageSuggestionMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateChatMessageSuggestion = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChatMessageSuggestion>>,
    TError,
    { data: BodyType<CreateChatMessageSuggestionRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createChatMessageSuggestion>>,
  TError,
  { data: BodyType<CreateChatMessageSuggestionRequestBodyDto> },
  TContext
> => {
  const mutationOptions =
    getCreateChatMessageSuggestionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createBloomsTaxonomyActivities = (
  bloomsTaxonomyActivitiesCreateRequestDto: BodyType<BloomsTaxonomyActivitiesCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<BloomsTaxonomyActivitiesResponseDto>({
    url: `/blooms-taxonomy-activities`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bloomsTaxonomyActivitiesCreateRequestDto,
    signal,
  });
};

export const getCreateBloomsTaxonomyActivitiesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBloomsTaxonomyActivities>>,
    TError,
    { data: BodyType<BloomsTaxonomyActivitiesCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBloomsTaxonomyActivities>>,
  TError,
  { data: BodyType<BloomsTaxonomyActivitiesCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBloomsTaxonomyActivities>>,
    { data: BodyType<BloomsTaxonomyActivitiesCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createBloomsTaxonomyActivities(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBloomsTaxonomyActivitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBloomsTaxonomyActivities>>
>;
export type CreateBloomsTaxonomyActivitiesMutationBody =
  BodyType<BloomsTaxonomyActivitiesCreateRequestDto>;
export type CreateBloomsTaxonomyActivitiesMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateBloomsTaxonomyActivities = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBloomsTaxonomyActivities>>,
    TError,
    { data: BodyType<BloomsTaxonomyActivitiesCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBloomsTaxonomyActivities>>,
  TError,
  { data: BodyType<BloomsTaxonomyActivitiesCreateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateBloomsTaxonomyActivitiesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenBloomsTaxonomyActivities = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<BloomsTaxonomyActivitiesResponseDto>({
    url: `/blooms-taxonomy-activities/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenBloomsTaxonomyActivitiesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenBloomsTaxonomyActivities>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenBloomsTaxonomyActivities>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenBloomsTaxonomyActivities>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenBloomsTaxonomyActivities(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenBloomsTaxonomyActivitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenBloomsTaxonomyActivities>>
>;
export type RegenBloomsTaxonomyActivitiesMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenBloomsTaxonomyActivitiesMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenBloomsTaxonomyActivities = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenBloomsTaxonomyActivities>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenBloomsTaxonomyActivities>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenBloomsTaxonomyActivitiesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeBloomsTaxonomyActivities = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/blooms-taxonomy-activities/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeBloomsTaxonomyActivitiesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeBloomsTaxonomyActivities>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeBloomsTaxonomyActivities>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeBloomsTaxonomyActivities>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeBloomsTaxonomyActivities(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeBloomsTaxonomyActivitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeBloomsTaxonomyActivities>>
>;

export type LikeBloomsTaxonomyActivitiesMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeBloomsTaxonomyActivities = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeBloomsTaxonomyActivities>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeBloomsTaxonomyActivities>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getLikeBloomsTaxonomyActivitiesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeBloomsTaxonomyActivities = (id: number) => {
  return configureAxios<void>({
    url: `/blooms-taxonomy-activities/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeBloomsTaxonomyActivitiesMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeBloomsTaxonomyActivities>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeBloomsTaxonomyActivities>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeBloomsTaxonomyActivities>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeBloomsTaxonomyActivities(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeBloomsTaxonomyActivitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeBloomsTaxonomyActivities>>
>;

export type UnlikeBloomsTaxonomyActivitiesMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeBloomsTaxonomyActivities = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeBloomsTaxonomyActivities>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeBloomsTaxonomyActivities>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getUnlikeBloomsTaxonomyActivitiesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getBlogs = (params?: GetBlogsParams, signal?: AbortSignal) => {
  return configureAxios<ListBlogPostResponseDto>({
    url: `/blogs`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBlogsQueryKey = (params?: GetBlogsParams) => {
  return [`/blogs`, ...(params ? [params] : [])] as const;
};

export const getGetBlogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlogs>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBlogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBlogs>>> = ({
    signal,
  }) => getBlogs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBlogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBlogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBlogs>>
>;
export type GetBlogsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetBlogs<
  TData = Awaited<ReturnType<typeof getBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetBlogsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlogs>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBlogs<
  TData = Awaited<ReturnType<typeof getBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBlogs>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBlogs<
  TData = Awaited<ReturnType<typeof getBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlogs>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetBlogs<
  TData = Awaited<ReturnType<typeof getBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBlogs>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetBlogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createBlog = (
  createBlogRequestBodyDto: BodyType<CreateBlogRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/blogs`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createBlogRequestBodyDto,
    signal,
  });
};

export const getCreateBlogMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBlog>>,
    TError,
    { data: BodyType<CreateBlogRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBlog>>,
  TError,
  { data: BodyType<CreateBlogRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBlog>>,
    { data: BodyType<CreateBlogRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createBlog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBlogMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBlog>>
>;
export type CreateBlogMutationBody = BodyType<CreateBlogRequestBodyDto>;
export type CreateBlogMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateBlog = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBlog>>,
    TError,
    { data: BodyType<CreateBlogRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBlog>>,
  TError,
  { data: BodyType<CreateBlogRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateBlogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeBlog = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/blogs/${id}/unlike`,
    method: "POST",
    signal,
  });
};

export const getUnlikeBlogMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeBlog>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeBlog>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeBlog>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeBlog(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeBlogMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeBlog>>
>;

export type UnlikeBlogMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeBlog = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeBlog>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeBlog>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeBlogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeBlog = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/blogs/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeBlogMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeBlog>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeBlog>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeBlog>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeBlog(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeBlogMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeBlog>>
>;

export type LikeBlogMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeBlog = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeBlog>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeBlog>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeBlogMutationOptions(options);

  return useMutation(mutationOptions);
};

export const postBlogAnswers = (
  id: number,
  blogQuizFinishRequestDto: BodyType<BlogQuizFinishRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/blogs/${id}/finish`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: blogQuizFinishRequestDto,
    signal,
  });
};

export const getPostBlogAnswersMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBlogAnswers>>,
    TError,
    { id: number; data: BodyType<BlogQuizFinishRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBlogAnswers>>,
  TError,
  { id: number; data: BodyType<BlogQuizFinishRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBlogAnswers>>,
    { id: number; data: BodyType<BlogQuizFinishRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postBlogAnswers(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBlogAnswersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBlogAnswers>>
>;
export type PostBlogAnswersMutationBody = BodyType<BlogQuizFinishRequestDto>;
export type PostBlogAnswersMutationError = ErrorType<BaseErrorResponseDto>;

export const usePostBlogAnswers = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBlogAnswers>>,
    TError,
    { id: number; data: BodyType<BlogQuizFinishRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof postBlogAnswers>>,
  TError,
  { id: number; data: BodyType<BlogQuizFinishRequestDto> },
  TContext
> => {
  const mutationOptions = getPostBlogAnswersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAudits = (params?: GetAuditsParams, signal?: AbortSignal) => {
  return configureAxios<ListAuditResponseDto>({
    url: `/audits`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAuditsQueryKey = (params?: GetAuditsParams) => {
  return [`/audits`, ...(params ? [params] : [])] as const;
};

export const getGetAuditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudits>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAudits>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuditsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAudits>>> = ({
    signal,
  }) => getAudits(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAudits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAuditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAudits>>
>;
export type GetAuditsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAudits<
  TData = Awaited<ReturnType<typeof getAudits>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAuditsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAudits>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudits>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAudits<
  TData = Awaited<ReturnType<typeof getAudits>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAudits>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudits>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAudits<
  TData = Awaited<ReturnType<typeof getAudits>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAudits>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAudits<
  TData = Awaited<ReturnType<typeof getAudits>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAudits>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAuditsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAudit = (
  createAuditRequestBodyDto: BodyType<CreateAuditRequestBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateAuditResponseDto>({
    url: `/audits`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createAuditRequestBodyDto,
    signal,
  });
};

export const getCreateAuditMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAudit>>,
    TError,
    { data: BodyType<CreateAuditRequestBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAudit>>,
  TError,
  { data: BodyType<CreateAuditRequestBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAudit>>,
    { data: BodyType<CreateAuditRequestBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createAudit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAuditMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAudit>>
>;
export type CreateAuditMutationBody = BodyType<CreateAuditRequestBodyDto>;
export type CreateAuditMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateAudit = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAudit>>,
    TError,
    { data: BodyType<CreateAuditRequestBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAudit>>,
  TError,
  { data: BodyType<CreateAuditRequestBodyDto> },
  TContext
> => {
  const mutationOptions = getCreateAuditMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createArticleGenerator = (
  articleGeneratorCreateRequestDto: BodyType<ArticleGeneratorCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<ArticleGeneratorResponseDto>({
    url: `/article-generator`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: articleGeneratorCreateRequestDto,
    signal,
  });
};

export const getCreateArticleGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createArticleGenerator>>,
    TError,
    { data: BodyType<ArticleGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createArticleGenerator>>,
  TError,
  { data: BodyType<ArticleGeneratorCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createArticleGenerator>>,
    { data: BodyType<ArticleGeneratorCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createArticleGenerator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateArticleGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createArticleGenerator>>
>;
export type CreateArticleGeneratorMutationBody =
  BodyType<ArticleGeneratorCreateRequestDto>;
export type CreateArticleGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateArticleGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createArticleGenerator>>,
    TError,
    { data: BodyType<ArticleGeneratorCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createArticleGenerator>>,
  TError,
  { data: BodyType<ArticleGeneratorCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateArticleGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateArticleGenerator = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<ArticleGeneratorResponseDto>({
    url: `/article-generator/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateArticleGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateArticleGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateArticleGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateArticleGenerator>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateArticleGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateArticleGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateArticleGenerator>>
>;
export type RegenerateArticleGeneratorMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateArticleGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateArticleGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateArticleGenerator>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateArticleGenerator>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateArticleGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeArticleGenerator = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/article-generator/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeArticleGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeArticleGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeArticleGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeArticleGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeArticleGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeArticleGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeArticleGenerator>>
>;

export type LikeArticleGeneratorMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeArticleGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeArticleGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeArticleGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeArticleGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeArticleGenerator = (id: number) => {
  return configureAxios<void>({
    url: `/article-generator/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeArticleGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeArticleGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeArticleGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeArticleGenerator>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeArticleGenerator(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeArticleGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeArticleGenerator>>
>;

export type UnlikeArticleGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeArticleGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeArticleGenerator>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeArticleGenerator>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeArticleGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createTemplateFromArticleGenerator = (
  id: number,
  articleGeneratorCreateTemplateRequestDto: BodyType<ArticleGeneratorCreateTemplateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<TemplateGenerateResponseDto>({
    url: `/article-generator/create-template/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: articleGeneratorCreateTemplateRequestDto,
    signal,
  });
};

export const getCreateTemplateFromArticleGeneratorMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplateFromArticleGenerator>>,
    TError,
    { id: number; data: BodyType<ArticleGeneratorCreateTemplateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplateFromArticleGenerator>>,
  TError,
  { id: number; data: BodyType<ArticleGeneratorCreateTemplateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTemplateFromArticleGenerator>>,
    { id: number; data: BodyType<ArticleGeneratorCreateTemplateRequestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTemplateFromArticleGenerator(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateFromArticleGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTemplateFromArticleGenerator>>
>;
export type CreateTemplateFromArticleGeneratorMutationBody =
  BodyType<ArticleGeneratorCreateTemplateRequestDto>;
export type CreateTemplateFromArticleGeneratorMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateTemplateFromArticleGenerator = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplateFromArticleGenerator>>,
    TError,
    { id: number; data: BodyType<ArticleGeneratorCreateTemplateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTemplateFromArticleGenerator>>,
  TError,
  { id: number; data: BodyType<ArticleGeneratorCreateTemplateRequestDto> },
  TContext
> => {
  const mutationOptions =
    getCreateTemplateFromArticleGeneratorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const mergeAnonymousToStudent = (
  mergeAnonymousUserToStudentBodyDto: BodyType<MergeAnonymousUserToStudentBodyDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/anonymous/student`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: mergeAnonymousUserToStudentBodyDto,
    signal,
  });
};

export const getMergeAnonymousToStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeAnonymousToStudent>>,
    TError,
    { data: BodyType<MergeAnonymousUserToStudentBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeAnonymousToStudent>>,
  TError,
  { data: BodyType<MergeAnonymousUserToStudentBodyDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeAnonymousToStudent>>,
    { data: BodyType<MergeAnonymousUserToStudentBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return mergeAnonymousToStudent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeAnonymousToStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof mergeAnonymousToStudent>>
>;
export type MergeAnonymousToStudentMutationBody =
  BodyType<MergeAnonymousUserToStudentBodyDto>;
export type MergeAnonymousToStudentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useMergeAnonymousToStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeAnonymousToStudent>>,
    TError,
    { data: BodyType<MergeAnonymousUserToStudentBodyDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof mergeAnonymousToStudent>>,
  TError,
  { data: BodyType<MergeAnonymousUserToStudentBodyDto> },
  TContext
> => {
  const mutationOptions = getMergeAnonymousToStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const markAlertAsRead = (alertId: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/alerts/lambda/${alertId}/mark-read`,
    method: "POST",
    signal,
  });
};

export const getMarkAlertAsReadMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAlertAsRead>>,
    TError,
    { alertId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAlertAsRead>>,
  TError,
  { alertId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAlertAsRead>>,
    { alertId: number }
  > = (props) => {
    const { alertId } = props ?? {};

    return markAlertAsRead(alertId);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAlertAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAlertAsRead>>
>;

export type MarkAlertAsReadMutationError = ErrorType<BaseErrorResponseDto>;

export const useMarkAlertAsRead = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAlertAsRead>>,
    TError,
    { alertId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAlertAsRead>>,
  TError,
  { alertId: number },
  TContext
> => {
  const mutationOptions = getMarkAlertAsReadMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getTextEmbedding = (
  params: GetTextEmbeddingParams,
  signal?: AbortSignal,
) => {
  return configureAxios<number[]>({
    url: `/ai/embeddings/text`,
    method: "POST",
    params,
    signal,
  });
};

export const getGetTextEmbeddingMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTextEmbedding>>,
    TError,
    { params: GetTextEmbeddingParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getTextEmbedding>>,
  TError,
  { params: GetTextEmbeddingParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getTextEmbedding>>,
    { params: GetTextEmbeddingParams }
  > = (props) => {
    const { params } = props ?? {};

    return getTextEmbedding(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetTextEmbeddingMutationResult = NonNullable<
  Awaited<ReturnType<typeof getTextEmbedding>>
>;

export type GetTextEmbeddingMutationError = ErrorType<BaseErrorResponseDto>;

export const useGetTextEmbedding = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTextEmbedding>>,
    TError,
    { params: GetTextEmbeddingParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof getTextEmbedding>>,
  TError,
  { params: GetTextEmbeddingParams },
  TContext
> => {
  const mutationOptions = getGetTextEmbeddingMutationOptions(options);

  return useMutation(mutationOptions);
};

export const searchIcons = (
  searchRequest: BodyType<SearchRequest>,
  signal?: AbortSignal,
) => {
  return configureAxios<SearchResult[]>({
    url: `/ai/embeddings/search`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: searchRequest,
    signal,
  });
};

export const getSearchIconsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchIcons>>,
    TError,
    { data: BodyType<SearchRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchIcons>>,
  TError,
  { data: BodyType<SearchRequest> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchIcons>>,
    { data: BodyType<SearchRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return searchIcons(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchIconsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchIcons>>
>;
export type SearchIconsMutationBody = BodyType<SearchRequest>;
export type SearchIconsMutationError = ErrorType<BaseErrorResponseDto>;

export const useSearchIcons = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchIcons>>,
    TError,
    { data: BodyType<SearchRequest> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchIcons>>,
  TError,
  { data: BodyType<SearchRequest> },
  TContext
> => {
  const mutationOptions = getSearchIconsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createAiSupportedTasks = (
  aiSupportedTasksCreateRequestDto: BodyType<AiSupportedTasksCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiSupportedTasksResponseDto>({
    url: `/ai-supported-tasks`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: aiSupportedTasksCreateRequestDto,
    signal,
  });
};

export const getCreateAiSupportedTasksMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiSupportedTasks>>,
    TError,
    { data: BodyType<AiSupportedTasksCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAiSupportedTasks>>,
  TError,
  { data: BodyType<AiSupportedTasksCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAiSupportedTasks>>,
    { data: BodyType<AiSupportedTasksCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createAiSupportedTasks(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAiSupportedTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAiSupportedTasks>>
>;
export type CreateAiSupportedTasksMutationBody =
  BodyType<AiSupportedTasksCreateRequestDto>;
export type CreateAiSupportedTasksMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateAiSupportedTasks = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiSupportedTasks>>,
    TError,
    { data: BodyType<AiSupportedTasksCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAiSupportedTasks>>,
  TError,
  { data: BodyType<AiSupportedTasksCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateAiSupportedTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateAiSupportedTasks = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiSupportedTasksResponseDto>({
    url: `/ai-supported-tasks/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateAiSupportedTasksMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAiSupportedTasks>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateAiSupportedTasks>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateAiSupportedTasks>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateAiSupportedTasks(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateAiSupportedTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateAiSupportedTasks>>
>;
export type RegenerateAiSupportedTasksMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateAiSupportedTasksMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateAiSupportedTasks = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAiSupportedTasks>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateAiSupportedTasks>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateAiSupportedTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeAiSupportedTasks = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/ai-supported-tasks/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeAiSupportedTasksMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiSupportedTasks>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeAiSupportedTasks>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeAiSupportedTasks>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeAiSupportedTasks(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeAiSupportedTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeAiSupportedTasks>>
>;

export type LikeAiSupportedTasksMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeAiSupportedTasks = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiSupportedTasks>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeAiSupportedTasks>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeAiSupportedTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeAiSupportedTasks = (id: number) => {
  return configureAxios<void>({
    url: `/ai-supported-tasks/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeAiSupportedTasksMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiSupportedTasks>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeAiSupportedTasks>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeAiSupportedTasks>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeAiSupportedTasks(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeAiSupportedTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeAiSupportedTasks>>
>;

export type UnlikeAiSupportedTasksMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeAiSupportedTasks = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiSupportedTasks>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeAiSupportedTasks>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeAiSupportedTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createAiResistantHomework = (
  aiResistantHomeworkCreateRequestDto: BodyType<AiResistantHomeworkCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiResistantHomeworkResponseDto>({
    url: `/ai-resistant-homework`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: aiResistantHomeworkCreateRequestDto,
    signal,
  });
};

export const getCreateAiResistantHomeworkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiResistantHomework>>,
    TError,
    { data: BodyType<AiResistantHomeworkCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAiResistantHomework>>,
  TError,
  { data: BodyType<AiResistantHomeworkCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAiResistantHomework>>,
    { data: BodyType<AiResistantHomeworkCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createAiResistantHomework(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAiResistantHomeworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAiResistantHomework>>
>;
export type CreateAiResistantHomeworkMutationBody =
  BodyType<AiResistantHomeworkCreateRequestDto>;
export type CreateAiResistantHomeworkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateAiResistantHomework = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiResistantHomework>>,
    TError,
    { data: BodyType<AiResistantHomeworkCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAiResistantHomework>>,
  TError,
  { data: BodyType<AiResistantHomeworkCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateAiResistantHomeworkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenAiResistantHomework = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiResistantHomeworkResponseDto>({
    url: `/ai-resistant-homework/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenAiResistantHomeworkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenAiResistantHomework>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenAiResistantHomework>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenAiResistantHomework>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenAiResistantHomework(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenAiResistantHomeworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenAiResistantHomework>>
>;
export type RegenAiResistantHomeworkMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenAiResistantHomeworkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenAiResistantHomework = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenAiResistantHomework>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenAiResistantHomework>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenAiResistantHomeworkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeAiResistantHomework = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/ai-resistant-homework/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeAiResistantHomeworkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiResistantHomework>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeAiResistantHomework>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeAiResistantHomework>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeAiResistantHomework(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeAiResistantHomeworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeAiResistantHomework>>
>;

export type LikeAiResistantHomeworkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeAiResistantHomework = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiResistantHomework>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeAiResistantHomework>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeAiResistantHomeworkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeAiResistantHomework = (id: number) => {
  return configureAxios<void>({
    url: `/ai-resistant-homework/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeAiResistantHomeworkMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiResistantHomework>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeAiResistantHomework>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeAiResistantHomework>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeAiResistantHomework(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeAiResistantHomeworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeAiResistantHomework>>
>;

export type UnlikeAiResistantHomeworkMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeAiResistantHomework = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiResistantHomework>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeAiResistantHomework>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeAiResistantHomeworkMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createAiAssignment = (
  aiAssignmentCreateRequestDto: BodyType<AiAssignmentCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiAssignmentResponseDto>({
    url: `/ai-assignment-designer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: aiAssignmentCreateRequestDto,
    signal,
  });
};

export const getCreateAiAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiAssignment>>,
    TError,
    { data: BodyType<AiAssignmentCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAiAssignment>>,
  TError,
  { data: BodyType<AiAssignmentCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAiAssignment>>,
    { data: BodyType<AiAssignmentCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createAiAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAiAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAiAssignment>>
>;
export type CreateAiAssignmentMutationBody =
  BodyType<AiAssignmentCreateRequestDto>;
export type CreateAiAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useCreateAiAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiAssignment>>,
    TError,
    { data: BodyType<AiAssignmentCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAiAssignment>>,
  TError,
  { data: BodyType<AiAssignmentCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateAiAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateAiAssignment = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiAssignmentResponseDto>({
    url: `/ai-assignment-designer/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateAiAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAiAssignment>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateAiAssignment>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateAiAssignment>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateAiAssignment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateAiAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateAiAssignment>>
>;
export type RegenerateAiAssignmentMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateAiAssignmentMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateAiAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAiAssignment>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateAiAssignment>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions = getRegenerateAiAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeAiAssignment = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/ai-assignment-designer/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeAiAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeAiAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeAiAssignment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeAiAssignment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeAiAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeAiAssignment>>
>;

export type LikeAiAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useLikeAiAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeAiAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeAiAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeAiAssignment = (id: number) => {
  return configureAxios<void>({
    url: `/ai-assignment-designer/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeAiAssignmentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeAiAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeAiAssignment>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeAiAssignment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeAiAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeAiAssignment>>
>;

export type UnlikeAiAssignmentMutationError = ErrorType<BaseErrorResponseDto>;

export const useUnlikeAiAssignment = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiAssignment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeAiAssignment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeAiAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const createAiAssessmentScale = (
  aiAssessmentScaleCreateRequestDto: BodyType<AiAssessmentScaleCreateRequestDto>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiAssessmentScaleResponseDto>({
    url: `/ai-assessment-scale`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: aiAssessmentScaleCreateRequestDto,
    signal,
  });
};

export const getCreateAiAssessmentScaleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiAssessmentScale>>,
    TError,
    { data: BodyType<AiAssessmentScaleCreateRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAiAssessmentScale>>,
  TError,
  { data: BodyType<AiAssessmentScaleCreateRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAiAssessmentScale>>,
    { data: BodyType<AiAssessmentScaleCreateRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createAiAssessmentScale(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAiAssessmentScaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAiAssessmentScale>>
>;
export type CreateAiAssessmentScaleMutationBody =
  BodyType<AiAssessmentScaleCreateRequestDto>;
export type CreateAiAssessmentScaleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useCreateAiAssessmentScale = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiAssessmentScale>>,
    TError,
    { data: BodyType<AiAssessmentScaleCreateRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAiAssessmentScale>>,
  TError,
  { data: BodyType<AiAssessmentScaleCreateRequestDto> },
  TContext
> => {
  const mutationOptions = getCreateAiAssessmentScaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const regenerateAiAssessmentScale = (
  id: number,
  regenTeacherToolRequestBody: BodyType<RegenTeacherToolRequestBody>,
  signal?: AbortSignal,
) => {
  return configureAxios<AiAssessmentScaleResponseDto>({
    url: `/ai-assessment-scale/${id}/regenerate`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: regenTeacherToolRequestBody,
    signal,
  });
};

export const getRegenerateAiAssessmentScaleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAiAssessmentScale>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateAiAssessmentScale>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateAiAssessmentScale>>,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateAiAssessmentScale(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateAiAssessmentScaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateAiAssessmentScale>>
>;
export type RegenerateAiAssessmentScaleMutationBody =
  BodyType<RegenTeacherToolRequestBody>;
export type RegenerateAiAssessmentScaleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRegenerateAiAssessmentScale = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAiAssessmentScale>>,
    TError,
    { id: number; data: BodyType<RegenTeacherToolRequestBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateAiAssessmentScale>>,
  TError,
  { id: number; data: BodyType<RegenTeacherToolRequestBody> },
  TContext
> => {
  const mutationOptions =
    getRegenerateAiAssessmentScaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const likeAiAssessmentScale = (id: number, signal?: AbortSignal) => {
  return configureAxios<void>({
    url: `/ai-assessment-scale/${id}/like`,
    method: "POST",
    signal,
  });
};

export const getLikeAiAssessmentScaleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiAssessmentScale>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof likeAiAssessmentScale>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof likeAiAssessmentScale>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return likeAiAssessmentScale(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LikeAiAssessmentScaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof likeAiAssessmentScale>>
>;

export type LikeAiAssessmentScaleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useLikeAiAssessmentScale = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof likeAiAssessmentScale>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof likeAiAssessmentScale>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getLikeAiAssessmentScaleMutationOptions(options);

  return useMutation(mutationOptions);
};

export const unlikeAiAssessmentScale = (id: number) => {
  return configureAxios<void>({
    url: `/ai-assessment-scale/${id}/like`,
    method: "DELETE",
  });
};

export const getUnlikeAiAssessmentScaleMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiAssessmentScale>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlikeAiAssessmentScale>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlikeAiAssessmentScale>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unlikeAiAssessmentScale(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlikeAiAssessmentScaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlikeAiAssessmentScale>>
>;

export type UnlikeAiAssessmentScaleMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useUnlikeAiAssessmentScale = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlikeAiAssessmentScale>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlikeAiAssessmentScale>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUnlikeAiAssessmentScaleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves detailed information for a specific board.
 * @summary Get Board Details
 */
export const getMadlenBoardDetails = (
  boardId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<BoardResponseDto>({
    url: `/madlen-boards/boards/${boardId}`,
    method: "GET",
    signal,
  });
};

export const getGetMadlenBoardDetailsQueryKey = (boardId: number) => {
  return [`/madlen-boards/boards/${boardId}`] as const;
};

export const getGetMadlenBoardDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMadlenBoardDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  boardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMadlenBoardDetails>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMadlenBoardDetailsQueryKey(boardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMadlenBoardDetails>>
  > = ({ signal }) => getMadlenBoardDetails(boardId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!boardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMadlenBoardDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMadlenBoardDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMadlenBoardDetails>>
>;
export type GetMadlenBoardDetailsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMadlenBoardDetails<
  TData = Awaited<ReturnType<typeof getMadlenBoardDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  boardId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMadlenBoardDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMadlenBoardDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMadlenBoardDetails<
  TData = Awaited<ReturnType<typeof getMadlenBoardDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  boardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMadlenBoardDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMadlenBoardDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMadlenBoardDetails<
  TData = Awaited<ReturnType<typeof getMadlenBoardDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  boardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMadlenBoardDetails>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Board Details
 */

export function useGetMadlenBoardDetails<
  TData = Awaited<ReturnType<typeof getMadlenBoardDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  boardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMadlenBoardDetails>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMadlenBoardDetailsQueryOptions(boardId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a board and all its associated columns and posts.
 * @summary Delete Board
 */
export const deleteMadlenBoardBoard = (boardId: number) => {
  return configureAxios<void>({
    url: `/madlen-boards/boards/${boardId}`,
    method: "DELETE",
  });
};

export const getDeleteMadlenBoardBoardMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMadlenBoardBoard>>,
    TError,
    { boardId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMadlenBoardBoard>>,
  TError,
  { boardId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMadlenBoardBoard>>,
    { boardId: number }
  > = (props) => {
    const { boardId } = props ?? {};

    return deleteMadlenBoardBoard(boardId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMadlenBoardBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMadlenBoardBoard>>
>;

export type DeleteMadlenBoardBoardMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Delete Board
 */
export const useDeleteMadlenBoardBoard = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMadlenBoardBoard>>,
    TError,
    { boardId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMadlenBoardBoard>>,
  TError,
  { boardId: number },
  TContext
> => {
  const mutationOptions = getDeleteMadlenBoardBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Partially updates a board's title or description.
 * @summary Update Board Details
 */
export const updateMadlenBoardDetails = (
  boardId: number,
  updateBoardRequestDto: BodyType<UpdateBoardRequestDto>,
) => {
  return configureAxios<BoardResponseDto>({
    url: `/madlen-boards/boards/${boardId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateBoardRequestDto,
  });
};

export const getUpdateMadlenBoardDetailsMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardDetails>>,
    TError,
    { boardId: number; data: BodyType<UpdateBoardRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMadlenBoardDetails>>,
  TError,
  { boardId: number; data: BodyType<UpdateBoardRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMadlenBoardDetails>>,
    { boardId: number; data: BodyType<UpdateBoardRequestDto> }
  > = (props) => {
    const { boardId, data } = props ?? {};

    return updateMadlenBoardDetails(boardId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMadlenBoardDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMadlenBoardDetails>>
>;
export type UpdateMadlenBoardDetailsMutationBody =
  BodyType<UpdateBoardRequestDto>;
export type UpdateMadlenBoardDetailsMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update Board Details
 */
export const useUpdateMadlenBoardDetails = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardDetails>>,
    TError,
    { boardId: number; data: BodyType<UpdateBoardRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMadlenBoardDetails>>,
  TError,
  { boardId: number; data: BodyType<UpdateBoardRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateMadlenBoardDetailsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes a specific post. Re-orders remaining posts in column if applicable.
 * @summary Delete Post
 */
export const deleteMadlenBoardPost = (boardId: number, postId: number) => {
  return configureAxios<void>({
    url: `/madlen-boards/boards/${boardId}/posts/${postId}`,
    method: "DELETE",
  });
};

export const getDeleteMadlenBoardPostMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMadlenBoardPost>>,
    TError,
    { boardId: number; postId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMadlenBoardPost>>,
  TError,
  { boardId: number; postId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMadlenBoardPost>>,
    { boardId: number; postId: number }
  > = (props) => {
    const { boardId, postId } = props ?? {};

    return deleteMadlenBoardPost(boardId, postId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMadlenBoardPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMadlenBoardPost>>
>;

export type DeleteMadlenBoardPostMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Delete Post
 */
export const useDeleteMadlenBoardPost = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMadlenBoardPost>>,
    TError,
    { boardId: number; postId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMadlenBoardPost>>,
  TError,
  { boardId: number; postId: number },
  TContext
> => {
  const mutationOptions = getDeleteMadlenBoardPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the mutable content of a post.
 * @summary Update Post Content/Details
 */
export const updateMadlenBoardPostContent = (
  boardId: number,
  postId: number,
  updatePostContentRequestDto: BodyType<UpdatePostContentRequestDto>,
) => {
  return configureAxios<PostResponseDto>({
    url: `/madlen-boards/boards/${boardId}/posts/${postId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updatePostContentRequestDto,
  });
};

export const getUpdateMadlenBoardPostContentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardPostContent>>,
    TError,
    {
      boardId: number;
      postId: number;
      data: BodyType<UpdatePostContentRequestDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMadlenBoardPostContent>>,
  TError,
  {
    boardId: number;
    postId: number;
    data: BodyType<UpdatePostContentRequestDto>;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMadlenBoardPostContent>>,
    {
      boardId: number;
      postId: number;
      data: BodyType<UpdatePostContentRequestDto>;
    }
  > = (props) => {
    const { boardId, postId, data } = props ?? {};

    return updateMadlenBoardPostContent(boardId, postId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMadlenBoardPostContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMadlenBoardPostContent>>
>;
export type UpdateMadlenBoardPostContentMutationBody =
  BodyType<UpdatePostContentRequestDto>;
export type UpdateMadlenBoardPostContentMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update Post Content/Details
 */
export const useUpdateMadlenBoardPostContent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardPostContent>>,
    TError,
    {
      boardId: number;
      postId: number;
      data: BodyType<UpdatePostContentRequestDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMadlenBoardPostContent>>,
  TError,
  {
    boardId: number;
    postId: number;
    data: BodyType<UpdatePostContentRequestDto>;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateMadlenBoardPostContentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates position (WALL) or column/order (COLUMNS).
 * @summary Update Post Position/Order (Move)
 */
export const moveMadlenBoardPost = (
  boardId: number,
  postId: number,
  movePostRequestDto: BodyType<MovePostRequestDto>,
) => {
  return configureAxios<PostResponseDto>({
    url: `/madlen-boards/boards/${boardId}/posts/${postId}/move`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: movePostRequestDto,
  });
};

export const getMoveMadlenBoardPostMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveMadlenBoardPost>>,
    TError,
    { boardId: number; postId: number; data: BodyType<MovePostRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveMadlenBoardPost>>,
  TError,
  { boardId: number; postId: number; data: BodyType<MovePostRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveMadlenBoardPost>>,
    { boardId: number; postId: number; data: BodyType<MovePostRequestDto> }
  > = (props) => {
    const { boardId, postId, data } = props ?? {};

    return moveMadlenBoardPost(boardId, postId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveMadlenBoardPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveMadlenBoardPost>>
>;
export type MoveMadlenBoardPostMutationBody = BodyType<MovePostRequestDto>;
export type MoveMadlenBoardPostMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update Post Position/Order (Move)
 */
export const useMoveMadlenBoardPost = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveMadlenBoardPost>>,
    TError,
    { boardId: number; postId: number; data: BodyType<MovePostRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof moveMadlenBoardPost>>,
  TError,
  { boardId: number; postId: number; data: BodyType<MovePostRequestDto> },
  TContext
> => {
  const mutationOptions = getMoveMadlenBoardPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes a column and its posts. Re-orders remaining columns.
 * @summary Delete Column
 */
export const deleteMadlenBoardColumn = (boardId: number, columnId: number) => {
  return configureAxios<void>({
    url: `/madlen-boards/boards/${boardId}/columns/${columnId}`,
    method: "DELETE",
  });
};

export const getDeleteMadlenBoardColumnMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMadlenBoardColumn>>,
    TError,
    { boardId: number; columnId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMadlenBoardColumn>>,
  TError,
  { boardId: number; columnId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMadlenBoardColumn>>,
    { boardId: number; columnId: number }
  > = (props) => {
    const { boardId, columnId } = props ?? {};

    return deleteMadlenBoardColumn(boardId, columnId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMadlenBoardColumnMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMadlenBoardColumn>>
>;

export type DeleteMadlenBoardColumnMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Delete Column
 */
export const useDeleteMadlenBoardColumn = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMadlenBoardColumn>>,
    TError,
    { boardId: number; columnId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMadlenBoardColumn>>,
  TError,
  { boardId: number; columnId: number },
  TContext
> => {
  const mutationOptions = getDeleteMadlenBoardColumnMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates a column's title.
 * @summary Update Column Details
 */
export const updateMadlenBoardColumn = (
  boardId: number,
  columnId: number,
  updateColumnRequestDto: BodyType<UpdateColumnRequestDto>,
) => {
  return configureAxios<ColumnResponseDto>({
    url: `/madlen-boards/boards/${boardId}/columns/${columnId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateColumnRequestDto,
  });
};

export const getUpdateMadlenBoardColumnMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardColumn>>,
    TError,
    {
      boardId: number;
      columnId: number;
      data: BodyType<UpdateColumnRequestDto>;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMadlenBoardColumn>>,
  TError,
  { boardId: number; columnId: number; data: BodyType<UpdateColumnRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMadlenBoardColumn>>,
    {
      boardId: number;
      columnId: number;
      data: BodyType<UpdateColumnRequestDto>;
    }
  > = (props) => {
    const { boardId, columnId, data } = props ?? {};

    return updateMadlenBoardColumn(boardId, columnId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMadlenBoardColumnMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMadlenBoardColumn>>
>;
export type UpdateMadlenBoardColumnMutationBody =
  BodyType<UpdateColumnRequestDto>;
export type UpdateMadlenBoardColumnMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update Column Details
 */
export const useUpdateMadlenBoardColumn = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardColumn>>,
    TError,
    {
      boardId: number;
      columnId: number;
      data: BodyType<UpdateColumnRequestDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMadlenBoardColumn>>,
  TError,
  { boardId: number; columnId: number; data: BodyType<UpdateColumnRequestDto> },
  TContext
> => {
  const mutationOptions = getUpdateMadlenBoardColumnMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the orderIndex for multiple columns on a board.
 * @summary Update Column Order
 */
export const updateMadlenBoardColumnOrder = (
  boardId: number,
  updateColumnOrderRequestDto: BodyType<UpdateColumnOrderRequestDto>,
) => {
  return configureAxios<UpdateColumnOrderResponseDto>({
    url: `/madlen-boards/boards/${boardId}/columns/order`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateColumnOrderRequestDto,
  });
};

export const getUpdateMadlenBoardColumnOrderMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardColumnOrder>>,
    TError,
    { boardId: number; data: BodyType<UpdateColumnOrderRequestDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMadlenBoardColumnOrder>>,
  TError,
  { boardId: number; data: BodyType<UpdateColumnOrderRequestDto> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMadlenBoardColumnOrder>>,
    { boardId: number; data: BodyType<UpdateColumnOrderRequestDto> }
  > = (props) => {
    const { boardId, data } = props ?? {};

    return updateMadlenBoardColumnOrder(boardId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMadlenBoardColumnOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMadlenBoardColumnOrder>>
>;
export type UpdateMadlenBoardColumnOrderMutationBody =
  BodyType<UpdateColumnOrderRequestDto>;
export type UpdateMadlenBoardColumnOrderMutationError =
  ErrorType<BaseErrorResponseDto>;

/**
 * @summary Update Column Order
 */
export const useUpdateMadlenBoardColumnOrder = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMadlenBoardColumnOrder>>,
    TError,
    { boardId: number; data: BodyType<UpdateColumnOrderRequestDto> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMadlenBoardColumnOrder>>,
  TError,
  { boardId: number; data: BodyType<UpdateColumnOrderRequestDto> },
  TContext
> => {
  const mutationOptions =
    getUpdateMadlenBoardColumnOrderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getH5p = (signal?: AbortSignal) => {
  return configureAxios<JsonNode>({
    url: `/webhooks/veyis/h5p`,
    method: "GET",
    signal,
  });
};

export const getGetH5pQueryKey = () => {
  return [`/webhooks/veyis/h5p`] as const;
};

export const getGetH5pQueryOptions = <
  TData = Awaited<ReturnType<typeof getH5p>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getH5p>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetH5pQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getH5p>>> = ({
    signal,
  }) => getH5p(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getH5p>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetH5pQueryResult = NonNullable<Awaited<ReturnType<typeof getH5p>>>;
export type GetH5pQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetH5p<
  TData = Awaited<ReturnType<typeof getH5p>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getH5p>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getH5p>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetH5p<
  TData = Awaited<ReturnType<typeof getH5p>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getH5p>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getH5p>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetH5p<
  TData = Awaited<ReturnType<typeof getH5p>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getH5p>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetH5p<
  TData = Awaited<ReturnType<typeof getH5p>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getH5p>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetH5pQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const ctr = (signal?: AbortSignal) => {
  return configureAxios<number>({
    url: `/webhooks/ctr`,
    method: "GET",
    signal,
  });
};

export const getCtrQueryKey = () => {
  return [`/webhooks/ctr`] as const;
};

export const getCtrQueryOptions = <
  TData = Awaited<ReturnType<typeof ctr>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof ctr>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCtrQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ctr>>> = ({
    signal,
  }) => ctr(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ctr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CtrQueryResult = NonNullable<Awaited<ReturnType<typeof ctr>>>;
export type CtrQueryError = ErrorType<BaseErrorResponseDto>;

export function useCtr<
  TData = Awaited<ReturnType<typeof ctr>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof ctr>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof ctr>>, TError, TData>,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCtr<
  TData = Awaited<ReturnType<typeof ctr>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof ctr>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof ctr>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCtr<
  TData = Awaited<ReturnType<typeof ctr>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof ctr>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useCtr<
  TData = Awaited<ReturnType<typeof ctr>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof ctr>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCtrQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopVocabularyLists = (
  params?: GetTopVocabularyListsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListVocabularyListResponseDto>({
    url: `/vocabulary-lists/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopVocabularyListsQueryKey = (
  params?: GetTopVocabularyListsParams,
) => {
  return [`/vocabulary-lists/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopVocabularyListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopVocabularyListsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopVocabularyLists>>
  > = ({ signal }) => getTopVocabularyLists(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopVocabularyLists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopVocabularyListsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopVocabularyLists>>
>;
export type GetTopVocabularyListsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopVocabularyLists<
  TData = Awaited<ReturnType<typeof getTopVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopVocabularyListsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVocabularyLists>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopVocabularyLists>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopVocabularyLists<
  TData = Awaited<ReturnType<typeof getTopVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVocabularyLists>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopVocabularyLists>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopVocabularyLists<
  TData = Awaited<ReturnType<typeof getTopVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopVocabularyLists<
  TData = Awaited<ReturnType<typeof getTopVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopVocabularyListsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentVocabularyLists = (
  params?: GetRecentVocabularyListsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListVocabularyListResponseDto>({
    url: `/vocabulary-lists/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentVocabularyListsQueryKey = (
  params?: GetRecentVocabularyListsParams,
) => {
  return [`/vocabulary-lists/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentVocabularyListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentVocabularyListsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentVocabularyLists>>
  > = ({ signal }) => getRecentVocabularyLists(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentVocabularyLists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentVocabularyListsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentVocabularyLists>>
>;
export type GetRecentVocabularyListsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentVocabularyLists<
  TData = Awaited<ReturnType<typeof getRecentVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentVocabularyListsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVocabularyLists>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentVocabularyLists>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentVocabularyLists<
  TData = Awaited<ReturnType<typeof getRecentVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVocabularyLists>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentVocabularyLists>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentVocabularyLists<
  TData = Awaited<ReturnType<typeof getRecentVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentVocabularyLists<
  TData = Awaited<ReturnType<typeof getRecentVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentVocabularyListsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserVocabularyLists = (
  params?: GetUserVocabularyListsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListVocabularyListResponseDto>({
    url: `/vocabulary-lists/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserVocabularyListsQueryKey = (
  params?: GetUserVocabularyListsParams,
) => {
  return [`/vocabulary-lists/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserVocabularyListsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserVocabularyListsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserVocabularyLists>>
  > = ({ signal }) => getUserVocabularyLists(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserVocabularyLists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserVocabularyListsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserVocabularyLists>>
>;
export type GetUserVocabularyListsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserVocabularyLists<
  TData = Awaited<ReturnType<typeof getUserVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserVocabularyListsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVocabularyLists>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserVocabularyLists>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserVocabularyLists<
  TData = Awaited<ReturnType<typeof getUserVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVocabularyLists>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserVocabularyLists>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserVocabularyLists<
  TData = Awaited<ReturnType<typeof getUserVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserVocabularyLists<
  TData = Awaited<ReturnType<typeof getUserVocabularyLists>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVocabularyListsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVocabularyLists>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserVocabularyListsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopVideoAvatars = (
  params?: GetTopVideoAvatarsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListVideoAvatarResponseDto>({
    url: `/video-avatar/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopVideoAvatarsQueryKey = (
  params?: GetTopVideoAvatarsParams,
) => {
  return [`/video-avatar/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopVideoAvatarsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopVideoAvatarsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopVideoAvatars>>
  > = ({ signal }) => getTopVideoAvatars(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopVideoAvatars>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopVideoAvatarsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopVideoAvatars>>
>;
export type GetTopVideoAvatarsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopVideoAvatars<
  TData = Awaited<ReturnType<typeof getTopVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopVideoAvatarsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVideoAvatars>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopVideoAvatars>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopVideoAvatars<
  TData = Awaited<ReturnType<typeof getTopVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVideoAvatars>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopVideoAvatars>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopVideoAvatars<
  TData = Awaited<ReturnType<typeof getTopVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopVideoAvatars<
  TData = Awaited<ReturnType<typeof getTopVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopVideoAvatarsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentVideoAvatars = (
  params?: GetRecentVideoAvatarsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListVideoAvatarResponseDto>({
    url: `/video-avatar/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentVideoAvatarsQueryKey = (
  params?: GetRecentVideoAvatarsParams,
) => {
  return [`/video-avatar/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentVideoAvatarsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentVideoAvatarsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentVideoAvatars>>
  > = ({ signal }) => getRecentVideoAvatars(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentVideoAvatars>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentVideoAvatarsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentVideoAvatars>>
>;
export type GetRecentVideoAvatarsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentVideoAvatars<
  TData = Awaited<ReturnType<typeof getRecentVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentVideoAvatarsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVideoAvatars>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentVideoAvatars>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentVideoAvatars<
  TData = Awaited<ReturnType<typeof getRecentVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVideoAvatars>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentVideoAvatars>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentVideoAvatars<
  TData = Awaited<ReturnType<typeof getRecentVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentVideoAvatars<
  TData = Awaited<ReturnType<typeof getRecentVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentVideoAvatarsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserVideoAvatars = (
  params?: GetUserVideoAvatarsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListVideoAvatarResponseDto>({
    url: `/video-avatar/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserVideoAvatarsQueryKey = (
  params?: GetUserVideoAvatarsParams,
) => {
  return [`/video-avatar/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserVideoAvatarsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserVideoAvatarsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserVideoAvatars>>
  > = ({ signal }) => getUserVideoAvatars(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserVideoAvatars>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserVideoAvatarsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserVideoAvatars>>
>;
export type GetUserVideoAvatarsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserVideoAvatars<
  TData = Awaited<ReturnType<typeof getUserVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserVideoAvatarsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVideoAvatars>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserVideoAvatars>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserVideoAvatars<
  TData = Awaited<ReturnType<typeof getUserVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVideoAvatars>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserVideoAvatars>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserVideoAvatars<
  TData = Awaited<ReturnType<typeof getUserVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserVideoAvatars<
  TData = Awaited<ReturnType<typeof getUserVideoAvatars>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserVideoAvatarsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserVideoAvatars>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserVideoAvatarsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAvailableVideoAvatarFaces = (signal?: AbortSignal) => {
  return configureAxios<VideoAvatarAvailableFacesResponseDto[]>({
    url: `/video-avatar/faces`,
    method: "GET",
    signal,
  });
};

export const getGetAvailableVideoAvatarFacesQueryKey = () => {
  return [`/video-avatar/faces`] as const;
};

export const getGetAvailableVideoAvatarFacesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAvailableVideoAvatarFacesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>
  > = ({ signal }) => getAvailableVideoAvatarFaces(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAvailableVideoAvatarFacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>
>;
export type GetAvailableVideoAvatarFacesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAvailableVideoAvatarFaces<
  TData = Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvailableVideoAvatarFaces<
  TData = Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableVideoAvatarFaces<
  TData = Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAvailableVideoAvatarFaces<
  TData = Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableVideoAvatarFaces>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAvailableVideoAvatarFacesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const canDoEvent = (params: CanDoEventParams, signal?: AbortSignal) => {
  return configureAxios<boolean>({
    url: `/users/subscriptions/canDo`,
    method: "GET",
    params,
    signal,
  });
};

export const getCanDoEventQueryKey = (params: CanDoEventParams) => {
  return [`/users/subscriptions/canDo`, ...(params ? [params] : [])] as const;
};

export const getCanDoEventQueryOptions = <
  TData = Awaited<ReturnType<typeof canDoEvent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDoEvent>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCanDoEventQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof canDoEvent>>> = ({
    signal,
  }) => canDoEvent(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof canDoEvent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CanDoEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof canDoEvent>>
>;
export type CanDoEventQueryError = ErrorType<BaseErrorResponseDto>;

export function useCanDoEvent<
  TData = Awaited<ReturnType<typeof canDoEvent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoEventParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDoEvent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canDoEvent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCanDoEvent<
  TData = Awaited<ReturnType<typeof canDoEvent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDoEvent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canDoEvent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCanDoEvent<
  TData = Awaited<ReturnType<typeof canDoEvent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDoEvent>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useCanDoEvent<
  TData = Awaited<ReturnType<typeof canDoEvent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDoEvent>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCanDoEventQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeachersMinuteSaved = (signal?: AbortSignal) => {
  return configureAxios<MinutesSavedResponseDto>({
    url: `/users/stats/teachers/totalMinutesSaved`,
    method: "GET",
    signal,
  });
};

export const getGetTeachersMinuteSavedQueryKey = () => {
  return [`/users/stats/teachers/totalMinutesSaved`] as const;
};

export const getGetTeachersMinuteSavedQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeachersMinuteSavedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeachersMinuteSaved>>
  > = ({ signal }) => getTeachersMinuteSaved(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeachersMinuteSavedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeachersMinuteSaved>>
>;
export type GetTeachersMinuteSavedQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeachersMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeachersMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeachersMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeachersMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeachersMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeachersMinuteSavedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentsMinuteSaved = (signal?: AbortSignal) => {
  return configureAxios<MinutesSavedResponseDto>({
    url: `/users/stats/students/totalMinutesSaved`,
    method: "GET",
    signal,
  });
};

export const getGetStudentsMinuteSavedQueryKey = () => {
  return [`/users/stats/students/totalMinutesSaved`] as const;
};

export const getGetStudentsMinuteSavedQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentsMinuteSavedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentsMinuteSaved>>
  > = ({ signal }) => getStudentsMinuteSaved(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentsMinuteSavedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentsMinuteSaved>>
>;
export type GetStudentsMinuteSavedQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudentsMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentsMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentsMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentsMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentsMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentsMinuteSavedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const canDo = (params: CanDoParams, signal?: AbortSignal) => {
  return configureAxios<boolean>({
    url: `/users/canDo`,
    method: "GET",
    params,
    signal,
  });
};

export const getCanDoQueryKey = (params: CanDoParams) => {
  return [`/users/canDo`, ...(params ? [params] : [])] as const;
};

export const getCanDoQueryOptions = <
  TData = Awaited<ReturnType<typeof canDo>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDo>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCanDoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof canDo>>> = ({
    signal,
  }) => canDo(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof canDo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CanDoQueryResult = NonNullable<Awaited<ReturnType<typeof canDo>>>;
export type CanDoQueryError = ErrorType<BaseErrorResponseDto>;

export function useCanDo<
  TData = Awaited<ReturnType<typeof canDo>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canDo>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCanDo<
  TData = Awaited<ReturnType<typeof canDo>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canDo>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCanDo<
  TData = Awaited<ReturnType<typeof canDo>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDo>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useCanDo<
  TData = Awaited<ReturnType<typeof canDo>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: CanDoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof canDo>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCanDoQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const handleFirebaseAction = (
  params: HandleFirebaseActionParams,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/users/auth/action`,
    method: "GET",
    params,
    signal,
  });
};

export const getHandleFirebaseActionQueryKey = (
  params: HandleFirebaseActionParams,
) => {
  return [`/users/auth/action`, ...(params ? [params] : [])] as const;
};

export const getHandleFirebaseActionQueryOptions = <
  TData = Awaited<ReturnType<typeof handleFirebaseAction>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: HandleFirebaseActionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handleFirebaseAction>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHandleFirebaseActionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof handleFirebaseAction>>
  > = ({ signal }) => handleFirebaseAction(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof handleFirebaseAction>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type HandleFirebaseActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof handleFirebaseAction>>
>;
export type HandleFirebaseActionQueryError = ErrorType<BaseErrorResponseDto>;

export function useHandleFirebaseAction<
  TData = Awaited<ReturnType<typeof handleFirebaseAction>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: HandleFirebaseActionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handleFirebaseAction>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof handleFirebaseAction>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useHandleFirebaseAction<
  TData = Awaited<ReturnType<typeof handleFirebaseAction>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: HandleFirebaseActionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handleFirebaseAction>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof handleFirebaseAction>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useHandleFirebaseAction<
  TData = Awaited<ReturnType<typeof handleFirebaseAction>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: HandleFirebaseActionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handleFirebaseAction>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useHandleFirebaseAction<
  TData = Awaited<ReturnType<typeof handleFirebaseAction>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: HandleFirebaseActionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof handleFirebaseAction>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getHandleFirebaseActionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopUdlChoiceBoards = (
  params?: GetTopUdlChoiceBoardsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListUdlChoiceBoardResponseDto>({
    url: `/udl-choice-board/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopUdlChoiceBoardsQueryKey = (
  params?: GetTopUdlChoiceBoardsParams,
) => {
  return [`/udl-choice-board/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopUdlChoiceBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopUdlChoiceBoardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopUdlChoiceBoards>>
  > = ({ signal }) => getTopUdlChoiceBoards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopUdlChoiceBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopUdlChoiceBoards>>
>;
export type GetTopUdlChoiceBoardsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopUdlChoiceBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopUdlChoiceBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentUdlChoiceBoards = (
  params?: GetRecentUdlChoiceBoardsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListUdlChoiceBoardResponseDto>({
    url: `/udl-choice-board/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentUdlChoiceBoardsQueryKey = (
  params?: GetRecentUdlChoiceBoardsParams,
) => {
  return [`/udl-choice-board/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentUdlChoiceBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentUdlChoiceBoardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>
  > = ({ signal }) => getRecentUdlChoiceBoards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentUdlChoiceBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>
>;
export type GetRecentUdlChoiceBoardsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentUdlChoiceBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentUdlChoiceBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserUdlChoiceBoards = (
  params?: GetUserUdlChoiceBoardsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListUdlChoiceBoardResponseDto>({
    url: `/udl-choice-board/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserUdlChoiceBoardsQueryKey = (
  params?: GetUserUdlChoiceBoardsParams,
) => {
  return [`/udl-choice-board/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserUdlChoiceBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserUdlChoiceBoardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserUdlChoiceBoards>>
  > = ({ signal }) => getUserUdlChoiceBoards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserUdlChoiceBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserUdlChoiceBoards>>
>;
export type GetUserUdlChoiceBoardsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserUdlChoiceBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserUdlChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserUdlChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUdlChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserUdlChoiceBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUbdExpertPlannerService = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<UbdExpertPlannerResponseDto>({
    url: `/ubd-expert-planner/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetUbdExpertPlannerServiceQueryKey = (id: number) => {
  return [`/ubd-expert-planner/${id}`] as const;
};

export const getGetUbdExpertPlannerServiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUbdExpertPlannerServiceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUbdExpertPlannerService>>
  > = ({ signal }) => getUbdExpertPlannerService(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUbdExpertPlannerServiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUbdExpertPlannerService>>
>;
export type GetUbdExpertPlannerServiceQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUbdExpertPlannerService<
  TData = Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUbdExpertPlannerService<
  TData = Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUbdExpertPlannerService<
  TData = Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUbdExpertPlannerService<
  TData = Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUbdExpertPlannerService>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUbdExpertPlannerServiceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTranslations = (signal?: AbortSignal) => {
  return configureAxios<BaseTranslationDto[]>({
    url: `/translation/keys`,
    method: "GET",
    signal,
  });
};

export const getGetTranslationsQueryKey = () => {
  return [`/translation/keys`] as const;
};

export const getGetTranslationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslations>>> = ({
    signal,
  }) => getTranslations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranslations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTranslationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranslations>>
>;
export type GetTranslationsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTranslations>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTranslations>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTranslations<
  TData = Awaited<ReturnType<typeof getTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTranslationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTranslation = (key: string, signal?: AbortSignal) => {
  return configureAxios<BaseTranslationDto>({
    url: `/translation/keys/${key}`,
    method: "GET",
    signal,
  });
};

export const getGetTranslationQueryKey = (key: string) => {
  return [`/translation/keys/${key}`] as const;
};

export const getGetTranslationQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslation>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslation>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTranslationQueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslation>>> = ({
    signal,
  }) => getTranslation(key, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!key,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranslation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTranslationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranslation>>
>;
export type GetTranslationQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTranslation<
  TData = Awaited<ReturnType<typeof getTranslation>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslation>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTranslation<
  TData = Awaited<ReturnType<typeof getTranslation>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranslation>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTranslation<
  TData = Awaited<ReturnType<typeof getTranslation>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslation>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTranslation<
  TData = Awaited<ReturnType<typeof getTranslation>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranslation>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTranslationQueryOptions(key, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTranslationGroups = (signal?: AbortSignal) => {
  return configureAxios<string[]>({
    url: `/translation/groups`,
    method: "GET",
    signal,
  });
};

export const getGetTranslationGroupsQueryKey = () => {
  return [`/translation/groups`] as const;
};

export const getGetTranslationGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranslationGroups>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTranslationGroups>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTranslationGroupsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTranslationGroups>>
  > = ({ signal }) => getTranslationGroups(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranslationGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTranslationGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranslationGroups>>
>;
export type GetTranslationGroupsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTranslationGroups<
  TData = Awaited<ReturnType<typeof getTranslationGroups>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTranslationGroups>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTranslationGroups>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTranslationGroups<
  TData = Awaited<ReturnType<typeof getTranslationGroups>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTranslationGroups>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTranslationGroups>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTranslationGroups<
  TData = Awaited<ReturnType<typeof getTranslationGroups>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTranslationGroups>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTranslationGroups<
  TData = Awaited<ReturnType<typeof getTranslationGroups>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTranslationGroups>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTranslationGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGroupTranslations = (
  groupName: string,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseTranslationDto[]>({
    url: `/translation/groups/${groupName}`,
    method: "GET",
    signal,
  });
};

export const getGetGroupTranslationsQueryKey = (groupName: string) => {
  return [`/translation/groups/${groupName}`] as const;
};

export const getGetGroupTranslationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGroupTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  groupName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGroupTranslations>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGroupTranslationsQueryKey(groupName);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGroupTranslations>>
  > = ({ signal }) => getGroupTranslations(groupName, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!groupName,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGroupTranslations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGroupTranslationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGroupTranslations>>
>;
export type GetGroupTranslationsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetGroupTranslations<
  TData = Awaited<ReturnType<typeof getGroupTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  groupName: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGroupTranslations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupTranslations>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGroupTranslations<
  TData = Awaited<ReturnType<typeof getGroupTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  groupName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGroupTranslations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupTranslations>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGroupTranslations<
  TData = Awaited<ReturnType<typeof getGroupTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  groupName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGroupTranslations>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetGroupTranslations<
  TData = Awaited<ReturnType<typeof getGroupTranslations>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  groupName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGroupTranslations>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetGroupTranslationsQueryOptions(groupName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopTransferActivities = (
  params?: GetTopTransferActivitiesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTransferActivityResponseDto>({
    url: `/transfer-activity/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopTransferActivitiesQueryKey = (
  params?: GetTopTransferActivitiesParams,
) => {
  return [`/transfer-activity/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopTransferActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTransferActivities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopTransferActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopTransferActivities>>
  > = ({ signal }) => getTopTransferActivities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopTransferActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopTransferActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopTransferActivities>>
>;
export type GetTopTransferActivitiesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopTransferActivities<
  TData = Awaited<ReturnType<typeof getTopTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopTransferActivitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTransferActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopTransferActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopTransferActivities<
  TData = Awaited<ReturnType<typeof getTopTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTransferActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopTransferActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopTransferActivities<
  TData = Awaited<ReturnType<typeof getTopTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTransferActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopTransferActivities<
  TData = Awaited<ReturnType<typeof getTopTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTransferActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopTransferActivitiesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentTransferActivities = (
  params?: GetRecentTransferActivitiesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTransferActivityResponseDto>({
    url: `/transfer-activity/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentTransferActivitiesQueryKey = (
  params?: GetRecentTransferActivitiesParams,
) => {
  return [`/transfer-activity/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentTransferActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTransferActivities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentTransferActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentTransferActivities>>
  > = ({ signal }) => getRecentTransferActivities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentTransferActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentTransferActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentTransferActivities>>
>;
export type GetRecentTransferActivitiesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentTransferActivities<
  TData = Awaited<ReturnType<typeof getRecentTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentTransferActivitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTransferActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentTransferActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentTransferActivities<
  TData = Awaited<ReturnType<typeof getRecentTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTransferActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentTransferActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentTransferActivities<
  TData = Awaited<ReturnType<typeof getRecentTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTransferActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentTransferActivities<
  TData = Awaited<ReturnType<typeof getRecentTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTransferActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentTransferActivitiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserTransferActivities = (
  params?: GetUserTransferActivitiesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTransferActivityResponseDto>({
    url: `/transfer-activity/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserTransferActivitiesQueryKey = (
  params?: GetUserTransferActivitiesParams,
) => {
  return [`/transfer-activity/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserTransferActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTransferActivities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserTransferActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserTransferActivities>>
  > = ({ signal }) => getUserTransferActivities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserTransferActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserTransferActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserTransferActivities>>
>;
export type GetUserTransferActivitiesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserTransferActivities<
  TData = Awaited<ReturnType<typeof getUserTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserTransferActivitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTransferActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTransferActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserTransferActivities<
  TData = Awaited<ReturnType<typeof getUserTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTransferActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTransferActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserTransferActivities<
  TData = Awaited<ReturnType<typeof getUserTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTransferActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserTransferActivities<
  TData = Awaited<ReturnType<typeof getUserTransferActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTransferActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTransferActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserTransferActivitiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopics = (params?: GetTopicsParams, signal?: AbortSignal) => {
  return configureAxios<TopicListResponseDto>({
    url: `/topics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopicsQueryKey = (params?: GetTopicsParams) => {
  return [`/topics`, ...(params ? [params] : [])] as const;
};

export const getGetTopicsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopicsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopics>>> = ({
    signal,
  }) => getTopics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopicsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopics>>
>;
export type GetTopicsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopicsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopics<
  TData = Awaited<ReturnType<typeof getTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopicsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopTextLevelers = (
  params?: GetTopTextLevelersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTextLevelerResponseDto>({
    url: `/text-levelers/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopTextLevelersQueryKey = (
  params?: GetTopTextLevelersParams,
) => {
  return [`/text-levelers/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopTextLevelersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTextLevelers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopTextLevelersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopTextLevelers>>
  > = ({ signal }) => getTopTextLevelers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopTextLevelers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopTextLevelersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopTextLevelers>>
>;
export type GetTopTextLevelersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopTextLevelers<
  TData = Awaited<ReturnType<typeof getTopTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopTextLevelersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTextLevelers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopTextLevelers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopTextLevelers<
  TData = Awaited<ReturnType<typeof getTopTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTextLevelers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopTextLevelers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopTextLevelers<
  TData = Awaited<ReturnType<typeof getTopTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTextLevelers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopTextLevelers<
  TData = Awaited<ReturnType<typeof getTopTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopTextLevelers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopTextLevelersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentTextLevelers = (
  params?: GetRecentTextLevelersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTextLevelerResponseDto>({
    url: `/text-levelers/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentTextLevelersQueryKey = (
  params?: GetRecentTextLevelersParams,
) => {
  return [`/text-levelers/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentTextLevelersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTextLevelers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentTextLevelersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentTextLevelers>>
  > = ({ signal }) => getRecentTextLevelers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentTextLevelers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentTextLevelersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentTextLevelers>>
>;
export type GetRecentTextLevelersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentTextLevelers<
  TData = Awaited<ReturnType<typeof getRecentTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentTextLevelersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTextLevelers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentTextLevelers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentTextLevelers<
  TData = Awaited<ReturnType<typeof getRecentTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTextLevelers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentTextLevelers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentTextLevelers<
  TData = Awaited<ReturnType<typeof getRecentTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTextLevelers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentTextLevelers<
  TData = Awaited<ReturnType<typeof getRecentTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentTextLevelers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentTextLevelersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserTextLevelers = (
  params?: GetUserTextLevelersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTextLevelerResponseDto>({
    url: `/text-levelers/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserTextLevelersQueryKey = (
  params?: GetUserTextLevelersParams,
) => {
  return [`/text-levelers/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserTextLevelersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTextLevelers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserTextLevelersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserTextLevelers>>
  > = ({ signal }) => getUserTextLevelers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserTextLevelers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserTextLevelersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserTextLevelers>>
>;
export type GetUserTextLevelersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserTextLevelers<
  TData = Awaited<ReturnType<typeof getUserTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserTextLevelersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTextLevelers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTextLevelers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserTextLevelers<
  TData = Awaited<ReturnType<typeof getUserTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTextLevelers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTextLevelers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserTextLevelers<
  TData = Awaited<ReturnType<typeof getUserTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTextLevelers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserTextLevelers<
  TData = Awaited<ReturnType<typeof getUserTextLevelers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserTextLevelersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTextLevelers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserTextLevelersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTedYearlyLessonPlannersAdmin = (
  params?: GetTedYearlyLessonPlannersAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TedYearlyLessonPlannerResponseDto[]>({
    url: `/ted-yearly-lesson-planner/admin`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTedYearlyLessonPlannersAdminQueryKey = (
  params?: GetTedYearlyLessonPlannersAdminParams,
) => {
  return [
    `/ted-yearly-lesson-planner/admin`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTedYearlyLessonPlannersAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTedYearlyLessonPlannersAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>
  > = ({ signal }) => getTedYearlyLessonPlannersAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTedYearlyLessonPlannersAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>
>;
export type GetTedYearlyLessonPlannersAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTedYearlyLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTedYearlyLessonPlannersAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTedYearlyLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTedYearlyLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTedYearlyLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedYearlyLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedYearlyLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTedYearlyLessonPlannersAdminQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTedLessonPlannersAdmin = (
  params?: GetTedLessonPlannersAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TedLessonPlannerResponseDto[]>({
    url: `/ted-lesson-planner/admin`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTedLessonPlannersAdminQueryKey = (
  params?: GetTedLessonPlannersAdminParams,
) => {
  return [`/ted-lesson-planner/admin`, ...(params ? [params] : [])] as const;
};

export const getGetTedLessonPlannersAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTedLessonPlannersAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>
  > = ({ signal }) => getTedLessonPlannersAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTedLessonPlannersAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>
>;
export type GetTedLessonPlannersAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTedLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTedLessonPlannersAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTedLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTedLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTedLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTedLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTedLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTedLessonPlannersAdminQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentsGenericFiltered = (
  params?: GetStudentsGenericFilteredParams,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentResponseDto[]>({
    url: `/teachers/students`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStudentsGenericFilteredQueryKey = (
  params?: GetStudentsGenericFilteredParams,
) => {
  return [`/teachers/students`, ...(params ? [params] : [])] as const;
};

export const getGetStudentsGenericFilteredQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentsGenericFilteredQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentsGenericFiltered>>
  > = ({ signal }) => getStudentsGenericFiltered(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentsGenericFilteredQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentsGenericFiltered>>
>;
export type GetStudentsGenericFilteredQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentsGenericFiltered<
  TData = Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetStudentsGenericFilteredParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentsGenericFiltered<
  TData = Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentsGenericFiltered<
  TData = Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentsGenericFiltered<
  TData = Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFiltered>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentsGenericFilteredQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentsOfStudentFromTeacher = (
  studentId: number,
  params?: GetAssignmentsOfStudentFromTeacherParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListStudentAssignmentsResponseDto>({
    url: `/teachers/students/${studentId}/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentsOfStudentFromTeacherQueryKey = (
  studentId: number,
  params?: GetAssignmentsOfStudentFromTeacherParams,
) => {
  return [
    `/teachers/students/${studentId}/assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentsOfStudentFromTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssignmentsOfStudentFromTeacherQueryKey(studentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>
  > = ({ signal }) =>
    getAssignmentsOfStudentFromTeacher(studentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentsOfStudentFromTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>
>;
export type GetAssignmentsOfStudentFromTeacherQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentsOfStudentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params: undefined | GetAssignmentsOfStudentFromTeacherParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentsOfStudentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentsOfStudentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentsOfStudentFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentsOfStudentFromTeacherQueryOptions(
    studentId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get assignment detail of student including questions and answers etc.
 * @summary Get assignment of student
 */
export const getStudentAssignmentDetailFromTeacher = (
  studentId: number,
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentAssignmentDetailTeacherPerspectiveResponseDto>({
    url: `/teachers/students/${studentId}/assignments/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetStudentAssignmentDetailFromTeacherQueryKey = (
  studentId: number,
  assignmentId: number,
) => {
  return [
    `/teachers/students/${studentId}/assignments/${assignmentId}`,
  ] as const;
};

export const getGetStudentAssignmentDetailFromTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentAssignmentDetailFromTeacherQueryKey(studentId, assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>
  > = ({ signal }) =>
    getStudentAssignmentDetailFromTeacher(studentId, assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(studentId && assignmentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentAssignmentDetailFromTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>
>;
export type GetStudentAssignmentDetailFromTeacherQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentAssignmentDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentAssignmentDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentAssignmentDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assignment of student
 */

export function useGetStudentAssignmentDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentAssignmentDetailFromTeacherQueryOptions(
    studentId,
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentsWithIds = (
  params?: GetStudentsWithIdsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentResponseDto[]>({
    url: `/teachers/students/ids`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStudentsWithIdsQueryKey = (
  params?: GetStudentsWithIdsParams,
) => {
  return [`/teachers/students/ids`, ...(params ? [params] : [])] as const;
};

export const getGetStudentsWithIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentsWithIds>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsWithIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsWithIds>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentsWithIdsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentsWithIds>>
  > = ({ signal }) => getStudentsWithIds(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentsWithIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentsWithIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentsWithIds>>
>;
export type GetStudentsWithIdsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudentsWithIds<
  TData = Awaited<ReturnType<typeof getStudentsWithIds>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetStudentsWithIdsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsWithIds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsWithIds>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentsWithIds<
  TData = Awaited<ReturnType<typeof getStudentsWithIds>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsWithIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsWithIds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsWithIds>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentsWithIds<
  TData = Awaited<ReturnType<typeof getStudentsWithIds>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsWithIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsWithIds>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentsWithIds<
  TData = Awaited<ReturnType<typeof getStudentsWithIds>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsWithIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsWithIds>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentsWithIdsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeacherMinuteSaved = (signal?: AbortSignal) => {
  return configureAxios<MinutesSavedResponseDto>({
    url: `/teachers/stats/totalMinutesSaved`,
    method: "GET",
    signal,
  });
};

export const getGetTeacherMinuteSavedQueryKey = () => {
  return [`/teachers/stats/totalMinutesSaved`] as const;
};

export const getGetTeacherMinuteSavedQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeacherMinuteSavedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherMinuteSaved>>
  > = ({ signal }) => getTeacherMinuteSaved(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherMinuteSavedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherMinuteSaved>>
>;
export type GetTeacherMinuteSavedQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherMinuteSaved<
  TData = Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeacherMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherMinuteSavedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get general statistics of student
 */
export const getStudentAssignmentsStatistics = (
  studentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentAssignmentStatisticsResponseDto>({
    url: `/teachers/statistics/students/${studentId}/assignments`,
    method: "GET",
    signal,
  });
};

export const getGetStudentAssignmentsStatisticsQueryKey = (
  studentId: number,
) => {
  return [`/teachers/statistics/students/${studentId}/assignments`] as const;
};

export const getGetStudentAssignmentsStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentAssignmentsStatisticsQueryKey(studentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>
  > = ({ signal }) => getStudentAssignmentsStatistics(studentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentAssignmentsStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>
>;
export type GetStudentAssignmentsStatisticsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get general statistics of student
 */

export function useGetStudentAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentAssignmentsStatisticsQueryOptions(
    studentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get weekly analysis of students of this classroom.
 * @summary Get classrooms dashboard
 */
export const getClassroomWeeklyAnalysis = (
  classroomId: number,
  params?: GetClassroomWeeklyAnalysisParams,
  signal?: AbortSignal,
) => {
  return configureAxios<WeeklyAnalysisResponseDto[]>({
    url: `/teachers/statistics/classrooms/${classroomId}/weekly_analysis`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomWeeklyAnalysisQueryKey = (
  classroomId: number,
  params?: GetClassroomWeeklyAnalysisParams,
) => {
  return [
    `/teachers/statistics/classrooms/${classroomId}/weekly_analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomWeeklyAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomWeeklyAnalysisQueryKey(classroomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>
  > = ({ signal }) => getClassroomWeeklyAnalysis(classroomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomWeeklyAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>
>;
export type GetClassroomWeeklyAnalysisQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params: undefined | GetClassroomWeeklyAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classrooms dashboard
 */

export function useGetClassroomWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWeeklyAnalysis>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomWeeklyAnalysisQueryOptions(
    classroomId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get general student statistics
 */
export const getClassroomStudentsStatistics = (
  classroomId: number,
  params?: GetClassroomStudentsStatisticsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomStudentStatisticsResponseDto>({
    url: `/teachers/statistics/classrooms/${classroomId}/students`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomStudentsStatisticsQueryKey = (
  classroomId: number,
  params?: GetClassroomStudentsStatisticsParams,
) => {
  return [
    `/teachers/statistics/classrooms/${classroomId}/students`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomStudentsStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomStudentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomStudentsStatisticsQueryKey(classroomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomStudentsStatistics>>
  > = ({ signal }) =>
    getClassroomStudentsStatistics(classroomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomStudentsStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomStudentsStatistics>>
>;
export type GetClassroomStudentsStatisticsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomStudentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params: undefined | GetClassroomStudentsStatisticsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomStudentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomStudentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomStudentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomStudentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get general student statistics
 */

export function useGetClassroomStudentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomStudentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomStudentsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomStudentsStatisticsQueryOptions(
    classroomId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get classroom dashboard content of a teacher.
 * @summary Get classrooms dashboard
 */
export const getClassroomDashboard = (
  classroomId: number,
  params?: GetClassroomDashboardParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomDashboardResponseDto>({
    url: `/teachers/statistics/classrooms/${classroomId}/dashboard`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomDashboardQueryKey = (
  classroomId: number,
  params?: GetClassroomDashboardParams,
) => {
  return [
    `/teachers/statistics/classrooms/${classroomId}/dashboard`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomDashboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomDashboardQueryKey(classroomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomDashboard>>
  > = ({ signal }) => getClassroomDashboard(classroomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomDashboard>>
>;
export type GetClassroomDashboardQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassroomDashboard<
  TData = Awaited<ReturnType<typeof getClassroomDashboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params: undefined | GetClassroomDashboardParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomDashboard>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomDashboard<
  TData = Awaited<ReturnType<typeof getClassroomDashboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomDashboard>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomDashboard<
  TData = Awaited<ReturnType<typeof getClassroomDashboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classrooms dashboard
 */

export function useGetClassroomDashboard<
  TData = Awaited<ReturnType<typeof getClassroomDashboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomDashboardQueryOptions(
    classroomId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get general assignment statistics
 */
export const getClassroomAssignmentsStatistics = (
  classroomId: number,
  params?: GetClassroomAssignmentsStatisticsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomAssignmentStatisticsResponseDto>({
    url: `/teachers/statistics/classrooms/${classroomId}/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomAssignmentsStatisticsQueryKey = (
  classroomId: number,
  params?: GetClassroomAssignmentsStatisticsParams,
) => {
  return [
    `/teachers/statistics/classrooms/${classroomId}/assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomAssignmentsStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomAssignmentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomAssignmentsStatisticsQueryKey(classroomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>
  > = ({ signal }) =>
    getClassroomAssignmentsStatistics(classroomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomAssignmentsStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>
>;
export type GetClassroomAssignmentsStatisticsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params: undefined | GetClassroomAssignmentsStatisticsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomAssignmentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomAssignmentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get general assignment statistics
 */

export function useGetClassroomAssignmentsStatistics<
  TData = Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomAssignmentsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAssignmentsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomAssignmentsStatisticsQueryOptions(
    classroomId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get classroom analytics of a teacher.
 * @summary Get classroom analytics
 */
export const getClassroomAnalytics = (
  classId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomAnalyticsResponseDto>({
    url: `/teachers/statistics/classrooms/${classId}/analytics`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomAnalyticsQueryKey = (classId: number) => {
  return [`/teachers/statistics/classrooms/${classId}/analytics`] as const;
};

export const getGetClassroomAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAnalytics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassroomAnalyticsQueryKey(classId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomAnalytics>>
  > = ({ signal }) => getClassroomAnalytics(classId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomAnalytics>>
>;
export type GetClassroomAnalyticsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassroomAnalytics<
  TData = Awaited<ReturnType<typeof getClassroomAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAnalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomAnalytics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomAnalytics<
  TData = Awaited<ReturnType<typeof getClassroomAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAnalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomAnalytics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomAnalytics<
  TData = Awaited<ReturnType<typeof getClassroomAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAnalytics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classroom analytics
 */

export function useGetClassroomAnalytics<
  TData = Awaited<ReturnType<typeof getClassroomAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomAnalytics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomAnalyticsQueryOptions(classId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get weekly analysis of students of.
 * @summary Get weekly analysis of student
 */
export const getStudentWeeklyAnalysis = (
  studentId: number,
  params?: GetStudentWeeklyAnalysisParams,
  signal?: AbortSignal,
) => {
  return configureAxios<WeeklyAnalysisResponseDto[]>({
    url: `/teachers/statistics/classrooms/weekly_analysis/${studentId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStudentWeeklyAnalysisQueryKey = (
  studentId: number,
  params?: GetStudentWeeklyAnalysisParams,
) => {
  return [
    `/teachers/statistics/classrooms/weekly_analysis/${studentId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStudentWeeklyAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetStudentWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentWeeklyAnalysisQueryKey(studentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>
  > = ({ signal }) => getStudentWeeklyAnalysis(studentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentWeeklyAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>
>;
export type GetStudentWeeklyAnalysisQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params: undefined | GetStudentWeeklyAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetStudentWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetStudentWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get weekly analysis of student
 */

export function useGetStudentWeeklyAnalysis<
  TData = Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetStudentWeeklyAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentWeeklyAnalysis>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentWeeklyAnalysisQueryOptions(
    studentId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get assignment statistics
 */
export const getAssignmentStatistics = (
  assignmentId: number,
  params?: GetAssignmentStatisticsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<AssignmentStatisticsResponseDto>({
    url: `/teachers/statistics/assignments/${assignmentId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentStatisticsQueryKey = (
  assignmentId: number,
  params?: GetAssignmentStatisticsParams,
) => {
  return [
    `/teachers/statistics/assignments/${assignmentId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetAssignmentStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStatistics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssignmentStatisticsQueryKey(assignmentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentStatistics>>
  > = ({ signal }) => getAssignmentStatistics(assignmentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentStatistics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentStatistics>>
>;
export type GetAssignmentStatisticsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentStatistics<
  TData = Awaited<ReturnType<typeof getAssignmentStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params: undefined | GetAssignmentStatisticsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentStatistics<
  TData = Awaited<ReturnType<typeof getAssignmentStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetAssignmentStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentStatistics<
  TData = Awaited<ReturnType<typeof getAssignmentStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetAssignmentStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assignment statistics
 */

export function useGetAssignmentStatistics<
  TData = Awaited<ReturnType<typeof getAssignmentStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetAssignmentStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentStatisticsQueryOptions(
    assignmentId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get assignment analytics of a teacher.
 * @summary Get assignment analytics
 */
export const getAssignmentAnalytics = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<AssignmentAnalyticsResponseDto>({
    url: `/teachers/statistics/assignments/${assignmentId}/analytics`,
    method: "GET",
    signal,
  });
};

export const getGetAssignmentAnalyticsQueryKey = (assignmentId: number) => {
  return [
    `/teachers/statistics/assignments/${assignmentId}/analytics`,
  ] as const;
};

export const getGetAssignmentAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAnalytics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentAnalyticsQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentAnalytics>>
  > = ({ signal }) => getAssignmentAnalytics(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentAnalytics>>
>;
export type GetAssignmentAnalyticsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentAnalytics<
  TData = Awaited<ReturnType<typeof getAssignmentAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAnalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentAnalytics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentAnalytics<
  TData = Awaited<ReturnType<typeof getAssignmentAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAnalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentAnalytics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentAnalytics<
  TData = Awaited<ReturnType<typeof getAssignmentAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAnalytics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assignment analytics
 */

export function useGetAssignmentAnalytics<
  TData = Awaited<ReturnType<typeof getAssignmentAnalytics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAnalytics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentAnalyticsQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeacherProfile = (
  userId: number,
  params?: GetTeacherProfileParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherProfileResponseDto>({
    url: `/teachers/profile/${userId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherProfileQueryKey = (
  userId: number,
  params?: GetTeacherProfileParams,
) => {
  return [`/teachers/profile/${userId}`, ...(params ? [params] : [])] as const;
};

export const getGetTeacherProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherProfile>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  userId: number,
  params?: GetTeacherProfileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherProfile>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherProfileQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherProfile>>
  > = ({ signal }) => getTeacherProfile(userId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherProfile>>
>;
export type GetTeacherProfileQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherProfile<
  TData = Awaited<ReturnType<typeof getTeacherProfile>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  userId: number,
  params: undefined | GetTeacherProfileParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherProfile>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherProfile<
  TData = Awaited<ReturnType<typeof getTeacherProfile>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  userId: number,
  params?: GetTeacherProfileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherProfile>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherProfile<
  TData = Awaited<ReturnType<typeof getTeacherProfile>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  userId: number,
  params?: GetTeacherProfileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherProfile>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherProfile<
  TData = Awaited<ReturnType<typeof getTeacherProfile>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  userId: number,
  params?: GetTeacherProfileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherProfile>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherProfileQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLoggedInTeacher = (signal?: AbortSignal) => {
  return configureAxios<TeacherResponseDto>({
    url: `/teachers/me`,
    method: "GET",
    signal,
  });
};

export const getGetLoggedInTeacherQueryKey = () => {
  return [`/teachers/me`] as const;
};

export const getGetLoggedInTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoggedInTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInTeacher>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoggedInTeacherQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoggedInTeacher>>
  > = ({ signal }) => getLoggedInTeacher(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoggedInTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLoggedInTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoggedInTeacher>>
>;
export type GetLoggedInTeacherQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLoggedInTeacher<
  TData = Awaited<ReturnType<typeof getLoggedInTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInTeacher>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedInTeacher>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLoggedInTeacher<
  TData = Awaited<ReturnType<typeof getLoggedInTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInTeacher>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedInTeacher>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLoggedInTeacher<
  TData = Awaited<ReturnType<typeof getLoggedInTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInTeacher>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLoggedInTeacher<
  TData = Awaited<ReturnType<typeof getLoggedInTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInTeacher>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLoggedInTeacherQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all documents with pagination and filtering
 */
export const listFiles = (params?: ListFilesParams, signal?: AbortSignal) => {
  return configureAxios<ListTeacherDocumentResponseDto>({
    url: `/teachers/documents`,
    method: "GET",
    params,
    signal,
  });
};

export const getListFilesQueryKey = (params?: ListFilesParams) => {
  return [`/teachers/documents`, ...(params ? [params] : [])] as const;
};

export const getListFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFiles>>> = ({
    signal,
  }) => listFiles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFiles>>
>;
export type ListFilesQueryError = ErrorType<BaseErrorResponseDto>;

export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | ListFilesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFiles>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFiles>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all documents with pagination and filtering
 */

export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: ListFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListFilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get single document
 */
export const getTeacherDocument = (id: number, signal?: AbortSignal) => {
  return configureAxios<TeacherDocumentResponseDto>({
    url: `/teachers/documents/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTeacherDocumentQueryKey = (id: number) => {
  return [`/teachers/documents/${id}`] as const;
};

export const getGetTeacherDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDocument>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeacherDocumentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherDocument>>
  > = ({ signal }) => getTeacherDocument(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherDocument>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherDocumentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherDocument>>
>;
export type GetTeacherDocumentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherDocument<
  TData = Awaited<ReturnType<typeof getTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherDocument>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherDocument<
  TData = Awaited<ReturnType<typeof getTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherDocument>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherDocument<
  TData = Awaited<ReturnType<typeof getTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDocument>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get single document
 */

export function useGetTeacherDocument<
  TData = Awaited<ReturnType<typeof getTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDocument>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherDocumentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a document
 */
export const deleteFile = (id: number) => {
  return configureAxios<void>({
    url: `/teachers/documents/${id}`,
    method: "DELETE",
  });
};

export const getDeleteFileMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFile>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteFile(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFile>>
>;

export type DeleteFileMutationError = ErrorType<BaseErrorResponseDto>;

/**
 * @summary Delete a document
 */
export const useDeleteFile = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteFileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Insert Youtube or Vimeo or any downloadable video URL or any downloadable mp3 url
 */
export const saveYoutubeVimeoUrlAsTeacherDocument = (
  params: SaveYoutubeVimeoUrlAsTeacherDocumentParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherDocumentResponseDto>({
    url: `/teachers/documents/saveVideoUrl`,
    method: "GET",
    params,
    signal,
  });
};

export const getSaveYoutubeVimeoUrlAsTeacherDocumentQueryKey = (
  params: SaveYoutubeVimeoUrlAsTeacherDocumentParams,
) => {
  return [
    `/teachers/documents/saveVideoUrl`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSaveYoutubeVimeoUrlAsTeacherDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: SaveYoutubeVimeoUrlAsTeacherDocumentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSaveYoutubeVimeoUrlAsTeacherDocumentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>
  > = ({ signal }) => saveYoutubeVimeoUrlAsTeacherDocument(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SaveYoutubeVimeoUrlAsTeacherDocumentQueryResult = NonNullable<
  Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>
>;
export type SaveYoutubeVimeoUrlAsTeacherDocumentQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useSaveYoutubeVimeoUrlAsTeacherDocument<
  TData = Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: SaveYoutubeVimeoUrlAsTeacherDocumentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSaveYoutubeVimeoUrlAsTeacherDocument<
  TData = Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: SaveYoutubeVimeoUrlAsTeacherDocumentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSaveYoutubeVimeoUrlAsTeacherDocument<
  TData = Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: SaveYoutubeVimeoUrlAsTeacherDocumentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Insert Youtube or Vimeo or any downloadable video URL or any downloadable mp3 url
 */

export function useSaveYoutubeVimeoUrlAsTeacherDocument<
  TData = Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: SaveYoutubeVimeoUrlAsTeacherDocumentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof saveYoutubeVimeoUrlAsTeacherDocument>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSaveYoutubeVimeoUrlAsTeacherDocumentQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generate a presigned URL for uploading a file and save to db
 */
export const generatePresignedUrl = (
  params: GeneratePresignedUrlParams,
  signal?: AbortSignal,
) => {
  return configureAxios<CreateTeacherDocumentResponseDto>({
    url: `/teachers/documents/generatePresignedUrl`,
    method: "GET",
    params,
    signal,
  });
};

export const getGeneratePresignedUrlQueryKey = (
  params: GeneratePresignedUrlParams,
) => {
  return [
    `/teachers/documents/generatePresignedUrl`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGeneratePresignedUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof generatePresignedUrl>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrl>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGeneratePresignedUrlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof generatePresignedUrl>>
  > = ({ signal }) => generatePresignedUrl(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof generatePresignedUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GeneratePresignedUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof generatePresignedUrl>>
>;
export type GeneratePresignedUrlQueryError = ErrorType<BaseErrorResponseDto>;

export function useGeneratePresignedUrl<
  TData = Awaited<ReturnType<typeof generatePresignedUrl>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePresignedUrl>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGeneratePresignedUrl<
  TData = Awaited<ReturnType<typeof generatePresignedUrl>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePresignedUrl>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGeneratePresignedUrl<
  TData = Awaited<ReturnType<typeof generatePresignedUrl>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrl>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Generate a presigned URL for uploading a file and save to db
 */

export function useGeneratePresignedUrl<
  TData = Awaited<ReturnType<typeof generatePresignedUrl>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrl>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGeneratePresignedUrlQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generate a presigned URL for uploading a file
 */
export const generatePresignedUrlOnly = (
  params: GeneratePresignedUrlOnlyParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PresignedUrlResponseDto>({
    url: `/teachers/documents/generateOnlyPresignedUrl`,
    method: "GET",
    params,
    signal,
  });
};

export const getGeneratePresignedUrlOnlyQueryKey = (
  params: GeneratePresignedUrlOnlyParams,
) => {
  return [
    `/teachers/documents/generateOnlyPresignedUrl`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGeneratePresignedUrlOnlyQueryOptions = <
  TData = Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlOnlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGeneratePresignedUrlOnlyQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof generatePresignedUrlOnly>>
  > = ({ signal }) => generatePresignedUrlOnly(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GeneratePresignedUrlOnlyQueryResult = NonNullable<
  Awaited<ReturnType<typeof generatePresignedUrlOnly>>
>;
export type GeneratePresignedUrlOnlyQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGeneratePresignedUrlOnly<
  TData = Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlOnlyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGeneratePresignedUrlOnly<
  TData = Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlOnlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGeneratePresignedUrlOnly<
  TData = Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlOnlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Generate a presigned URL for uploading a file
 */

export function useGeneratePresignedUrlOnly<
  TData = Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GeneratePresignedUrlOnlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generatePresignedUrlOnly>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGeneratePresignedUrlOnlyQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassroomWithoutDetailFromTeacher = (
  classroomId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomWithoutStudentDetailResponseDto>({
    url: `/teachers/classrooms/${classroomId}`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomWithoutDetailFromTeacherQueryKey = (
  classroomId: number,
) => {
  return [`/teachers/classrooms/${classroomId}`] as const;
};

export const getGetClassroomWithoutDetailFromTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomWithoutDetailFromTeacherQueryKey(classroomId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>
  > = ({ signal }) => getClassroomWithoutDetailFromTeacher(classroomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomWithoutDetailFromTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>
>;
export type GetClassroomWithoutDetailFromTeacherQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomWithoutDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomWithoutDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomWithoutDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomWithoutDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithoutDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomWithoutDetailFromTeacherQueryOptions(
    classroomId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteClassroom = (classroomId: number) => {
  return configureAxios<void>({
    url: `/teachers/classrooms/${classroomId}`,
    method: "DELETE",
  });
};

export const getDeleteClassroomMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClassroom>>,
    TError,
    { classroomId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClassroom>>,
  TError,
  { classroomId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClassroom>>,
    { classroomId: number }
  > = (props) => {
    const { classroomId } = props ?? {};

    return deleteClassroom(classroomId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClassroomMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClassroom>>
>;

export type DeleteClassroomMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteClassroom = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClassroom>>,
    TError,
    { classroomId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClassroom>>,
  TError,
  { classroomId: number },
  TContext
> => {
  const mutationOptions = getDeleteClassroomMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getClassroomWithDetailFromTeacher = (
  classroomId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomWithStudentDetailResponseDto>({
    url: `/teachers/classrooms/${classroomId}/detail`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomWithDetailFromTeacherQueryKey = (
  classroomId: number,
) => {
  return [`/teachers/classrooms/${classroomId}/detail`] as const;
};

export const getGetClassroomWithDetailFromTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomWithDetailFromTeacherQueryKey(classroomId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>
  > = ({ signal }) => getClassroomWithDetailFromTeacher(classroomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomWithDetailFromTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>
>;
export type GetClassroomWithDetailFromTeacherQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomWithDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomWithDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomWithDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomWithDetailFromTeacher<
  TData = Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomWithDetailFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomWithDetailFromTeacherQueryOptions(
    classroomId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get classroom dashboard content of a teacher.
 * @summary Get classrooms dashboard
 */
export const getClassroomDashboard1 = (
  classroomId: number,
  params?: GetClassroomDashboard1Params,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomDashboardResponseDto>({
    url: `/teachers/classrooms/${classroomId}/dashboard`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomDashboard1QueryKey = (
  classroomId: number,
  params?: GetClassroomDashboard1Params,
) => {
  return [
    `/teachers/classrooms/${classroomId}/dashboard`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomDashboard1QueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomDashboard1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboard1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard1>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomDashboard1QueryKey(classroomId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomDashboard1>>
  > = ({ signal }) => getClassroomDashboard1(classroomId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomDashboard1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomDashboard1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomDashboard1>>
>;
export type GetClassroomDashboard1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassroomDashboard1<
  TData = Awaited<ReturnType<typeof getClassroomDashboard1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params: undefined | GetClassroomDashboard1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomDashboard1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomDashboard1<
  TData = Awaited<ReturnType<typeof getClassroomDashboard1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboard1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomDashboard1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomDashboard1<
  TData = Awaited<ReturnType<typeof getClassroomDashboard1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboard1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classrooms dashboard
 */

export function useGetClassroomDashboard1<
  TData = Awaited<ReturnType<typeof getClassroomDashboard1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  params?: GetClassroomDashboard1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomDashboard1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomDashboard1QueryOptions(
    classroomId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassroomInfoAsTeacherForAssignViewPage = (
  classroomId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomForAssignViewResponseDto>({
    url: `/teachers/classrooms/for-assign-view/${classroomId}`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomInfoAsTeacherForAssignViewPageQueryKey = (
  classroomId: number,
) => {
  return [`/teachers/classrooms/for-assign-view/${classroomId}`] as const;
};

export const getGetClassroomInfoAsTeacherForAssignViewPageQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomInfoAsTeacherForAssignViewPageQueryKey(classroomId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>
  > = ({ signal }) =>
    getClassroomInfoAsTeacherForAssignViewPage(classroomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomInfoAsTeacherForAssignViewPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>
>;
export type GetClassroomInfoAsTeacherForAssignViewPageQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomInfoAsTeacherForAssignViewPage<
  TData = Awaited<
    ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomInfoAsTeacherForAssignViewPage<
  TData = Awaited<
    ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomInfoAsTeacherForAssignViewPage<
  TData = Awaited<
    ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomInfoAsTeacherForAssignViewPage<
  TData = Awaited<
    ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomInfoAsTeacherForAssignViewPage>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetClassroomInfoAsTeacherForAssignViewPageQueryOptions(
      classroomId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get classrooms of teacher. You can filter with respect to grade and courseType. Does not contain students and their assignments.
 * @summary Get classrooms detailed
 */
export const getClassroomsDetailed = (
  params?: GetClassroomsDetailedParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomWithStudentDetailResponseDto[]>({
    url: `/teachers/classrooms/detail`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomsDetailedQueryKey = (
  params?: GetClassroomsDetailedParams,
) => {
  return [`/teachers/classrooms/detail`, ...(params ? [params] : [])] as const;
};

export const getGetClassroomsDetailedQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomsDetailed>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailed>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassroomsDetailedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomsDetailed>>
  > = ({ signal }) => getClassroomsDetailed(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomsDetailed>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomsDetailedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomsDetailed>>
>;
export type GetClassroomsDetailedQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassroomsDetailed<
  TData = Awaited<ReturnType<typeof getClassroomsDetailed>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetClassroomsDetailedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomsDetailed>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomsDetailed<
  TData = Awaited<ReturnType<typeof getClassroomsDetailed>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomsDetailed>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomsDetailed<
  TData = Awaited<ReturnType<typeof getClassroomsDetailed>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailed>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classrooms detailed
 */

export function useGetClassroomsDetailed<
  TData = Awaited<ReturnType<typeof getClassroomsDetailed>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailed>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomsDetailedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentsFromTeacher = (
  params?: GetAssignmentsFromTeacherParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedBaseAssignmentsResponseDto>({
    url: `/teachers/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentsFromTeacherQueryKey = (
  params?: GetAssignmentsFromTeacherParams,
) => {
  return [`/teachers/assignments`, ...(params ? [params] : [])] as const;
};

export const getGetAssignmentsFromTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentsFromTeacherQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentsFromTeacher>>
  > = ({ signal }) => getAssignmentsFromTeacher(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentsFromTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentsFromTeacher>>
>;
export type GetAssignmentsFromTeacherQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentsFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAssignmentsFromTeacherParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentsFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentsFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentsFromTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsFromTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentsFromTeacherQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const previewAssignmentFromTeacher = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/teachers/assignments/${assignmentId}/preview`,
    method: "GET",
    signal,
  });
};

export const getPreviewAssignmentFromTeacherQueryKey = (
  assignmentId: number,
) => {
  return [`/teachers/assignments/${assignmentId}/preview`] as const;
};

export const getPreviewAssignmentFromTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPreviewAssignmentFromTeacherQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof previewAssignmentFromTeacher>>
  > = ({ signal }) => previewAssignmentFromTeacher(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PreviewAssignmentFromTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewAssignmentFromTeacher>>
>;
export type PreviewAssignmentFromTeacherQueryError =
  ErrorType<BaseErrorResponseDto>;

export function usePreviewAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePreviewAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePreviewAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function usePreviewAssignmentFromTeacher<
  TData = Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof previewAssignmentFromTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPreviewAssignmentFromTeacherQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get finished open ended questions of assignment
 * @summary Get finished open ended questions of assignment
 */
export const getFinishedOpenEndedQuestionsOfAssignment = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherReviewPageDto>({
    url: `/teachers/assignments/${assignmentId}/finished-open-ended`,
    method: "GET",
    signal,
  });
};

export const getGetFinishedOpenEndedQuestionsOfAssignmentQueryKey = (
  assignmentId: number,
) => {
  return [`/teachers/assignments/${assignmentId}/finished-open-ended`] as const;
};

export const getGetFinishedOpenEndedQuestionsOfAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFinishedOpenEndedQuestionsOfAssignmentQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>
  > = ({ signal }) =>
    getFinishedOpenEndedQuestionsOfAssignment(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFinishedOpenEndedQuestionsOfAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>
>;
export type GetFinishedOpenEndedQuestionsOfAssignmentQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetFinishedOpenEndedQuestionsOfAssignment<
  TData = Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFinishedOpenEndedQuestionsOfAssignment<
  TData = Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFinishedOpenEndedQuestionsOfAssignment<
  TData = Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get finished open ended questions of assignment
 */

export function useGetFinishedOpenEndedQuestionsOfAssignment<
  TData = Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFinishedOpenEndedQuestionsOfAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFinishedOpenEndedQuestionsOfAssignmentQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get list of students assigned to an assignment with their assignment status and progress
 * @summary Get assigned students of an assignment
 */
export const getAssignmentStudents = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentAssignmentSummaryDto[]>({
    url: `/teachers/assignment-students/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetAssignmentStudentsQueryKey = (assignmentId: number) => {
  return [`/teachers/assignment-students/${assignmentId}`] as const;
};

export const getGetAssignmentStudentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStudents>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentStudentsQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentStudents>>
  > = ({ signal }) => getAssignmentStudents(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentStudents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentStudents>>
>;
export type GetAssignmentStudentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentStudents<
  TData = Awaited<ReturnType<typeof getAssignmentStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStudents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentStudents>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentStudents<
  TData = Awaited<ReturnType<typeof getAssignmentStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStudents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentStudents>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentStudents<
  TData = Awaited<ReturnType<typeof getAssignmentStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStudents>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assigned students of an assignment
 */

export function useGetAssignmentStudents<
  TData = Awaited<ReturnType<typeof getAssignmentStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentStudents>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentStudentsQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSuperToolById = (id: number, signal?: AbortSignal) => {
  return configureAxios<SuperToolResponseDto>({
    url: `/teacher-tools/super-tool/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSuperToolByIdQueryKey = (id: number) => {
  return [`/teacher-tools/super-tool/${id}`] as const;
};

export const getGetSuperToolByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperToolById>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperToolById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuperToolByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperToolById>>
  > = ({ signal }) => getSuperToolById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperToolById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSuperToolByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperToolById>>
>;
export type GetSuperToolByIdQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSuperToolById<
  TData = Awaited<ReturnType<typeof getSuperToolById>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperToolById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperToolById>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSuperToolById<
  TData = Awaited<ReturnType<typeof getSuperToolById>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperToolById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperToolById>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSuperToolById<
  TData = Awaited<ReturnType<typeof getSuperToolById>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperToolById>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSuperToolById<
  TData = Awaited<ReturnType<typeof getSuperToolById>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperToolById>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSuperToolByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteSuperTool = (id: number) => {
  return configureAxios<void>({
    url: `/teacher-tools/super-tool/${id}`,
    method: "DELETE",
  });
};

export const getDeleteSuperToolMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperTool>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperTool>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperTool>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSuperTool(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSuperToolMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperTool>>
>;

export type DeleteSuperToolMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteSuperTool = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperTool>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperTool>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteSuperToolMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSharedTool = (sharedUuid: string, signal?: AbortSignal) => {
  return configureAxios<GetSharedTool200>({
    url: `/teacher-tools/shared/${sharedUuid}`,
    method: "GET",
    signal,
  });
};

export const getGetSharedToolQueryKey = (sharedUuid: string) => {
  return [`/teacher-tools/shared/${sharedUuid}`] as const;
};

export const getGetSharedToolQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedTool>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  sharedUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedTool>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSharedToolQueryKey(sharedUuid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedTool>>> = ({
    signal,
  }) => getSharedTool(sharedUuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!sharedUuid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedTool>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSharedToolQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedTool>>
>;
export type GetSharedToolQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSharedTool<
  TData = Awaited<ReturnType<typeof getSharedTool>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  sharedUuid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedTool>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedTool>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSharedTool<
  TData = Awaited<ReturnType<typeof getSharedTool>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  sharedUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedTool>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedTool>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSharedTool<
  TData = Awaited<ReturnType<typeof getSharedTool>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  sharedUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedTool>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSharedTool<
  TData = Awaited<ReturnType<typeof getSharedTool>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  sharedUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedTool>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSharedToolQueryOptions(sharedUuid, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeacherToolChat = (id: number, signal?: AbortSignal) => {
  return configureAxios<TeacherToolChatResponseDto>({
    url: `/teacher-tool-chat/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTeacherToolChatQueryKey = (id: number) => {
  return [`/teacher-tool-chat/${id}`] as const;
};

export const getGetTeacherToolChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherToolChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChat>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeacherToolChatQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherToolChat>>
  > = ({ signal }) => getTeacherToolChat(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherToolChat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherToolChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherToolChat>>
>;
export type GetTeacherToolChatQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherToolChat<
  TData = Awaited<ReturnType<typeof getTeacherToolChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherToolChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherToolChat<
  TData = Awaited<ReturnType<typeof getTeacherToolChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherToolChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherToolChat<
  TData = Awaited<ReturnType<typeof getTeacherToolChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherToolChat<
  TData = Awaited<ReturnType<typeof getTeacherToolChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherToolChatQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteTeacherToolChat = (id: number) => {
  return configureAxios<void>({
    url: `/teacher-tool-chat/${id}`,
    method: "DELETE",
  });
};

export const getDeleteTeacherToolChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeacherToolChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeacherToolChat>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeacherToolChat>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTeacherToolChat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeacherToolChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeacherToolChat>>
>;

export type DeleteTeacherToolChatMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteTeacherToolChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeacherToolChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTeacherToolChat>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteTeacherToolChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSpokenDialogue = (id: number, signal?: AbortSignal) => {
  return configureAxios<SpokenDialogueResponseDto>({
    url: `/swann-spoken-dialogue/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetSpokenDialogueQueryKey = (id: number) => {
  return [`/swann-spoken-dialogue/${id}`] as const;
};

export const getGetSpokenDialogueQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpokenDialogue>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSpokenDialogue>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSpokenDialogueQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSpokenDialogue>>
  > = ({ signal }) => getSpokenDialogue(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpokenDialogue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSpokenDialogueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpokenDialogue>>
>;
export type GetSpokenDialogueQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSpokenDialogue<
  TData = Awaited<ReturnType<typeof getSpokenDialogue>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSpokenDialogue>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpokenDialogue>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSpokenDialogue<
  TData = Awaited<ReturnType<typeof getSpokenDialogue>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSpokenDialogue>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpokenDialogue>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSpokenDialogue<
  TData = Awaited<ReturnType<typeof getSpokenDialogue>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSpokenDialogue>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSpokenDialogue<
  TData = Awaited<ReturnType<typeof getSpokenDialogue>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSpokenDialogue>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSpokenDialogueQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentFromStudents = (
  params?: GetAssignmentFromStudentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListStudentAssignmentViewDto>({
    url: `/swann-pronunciation/student/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentFromStudentsQueryKey = (
  params?: GetAssignmentFromStudentsParams,
) => {
  return [
    `/swann-pronunciation/student/assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentFromStudentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentFromStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentFromStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromStudents>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentFromStudentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentFromStudents>>
  > = ({ signal }) => getAssignmentFromStudents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentFromStudents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentFromStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentFromStudents>>
>;
export type GetAssignmentFromStudentsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentFromStudents<
  TData = Awaited<ReturnType<typeof getAssignmentFromStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAssignmentFromStudentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromStudents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentFromStudents>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentFromStudents<
  TData = Awaited<ReturnType<typeof getAssignmentFromStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentFromStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromStudents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentFromStudents>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentFromStudents<
  TData = Awaited<ReturnType<typeof getAssignmentFromStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentFromStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromStudents>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentFromStudents<
  TData = Awaited<ReturnType<typeof getAssignmentFromStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentFromStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromStudents>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentFromStudentsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPronunciationAssignment = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentAssignmentViewDto>({
    url: `/swann-pronunciation/student/assignments/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPronunciationAssignmentQueryKey = (id: number) => {
  return [`/swann-pronunciation/student/assignments/${id}`] as const;
};

export const getGetPronunciationAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getPronunciationAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPronunciationAssignment>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPronunciationAssignmentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPronunciationAssignment>>
  > = ({ signal }) => getPronunciationAssignment(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPronunciationAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPronunciationAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPronunciationAssignment>>
>;
export type GetPronunciationAssignmentQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetPronunciationAssignment<
  TData = Awaited<ReturnType<typeof getPronunciationAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPronunciationAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPronunciationAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPronunciationAssignment<
  TData = Awaited<ReturnType<typeof getPronunciationAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPronunciationAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPronunciationAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPronunciationAssignment<
  TData = Awaited<ReturnType<typeof getPronunciationAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPronunciationAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPronunciationAssignment<
  TData = Awaited<ReturnType<typeof getPronunciationAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPronunciationAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPronunciationAssignmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPublicAssignment = (code: string, signal?: AbortSignal) => {
  return configureAxios<PublicAssignmentViewDto>({
    url: `/swann-pronunciation/public/${code}`,
    method: "GET",
    signal,
  });
};

export const getGetPublicAssignmentQueryKey = (code: string) => {
  return [`/swann-pronunciation/public/${code}`] as const;
};

export const getGetPublicAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssignment>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicAssignmentQueryKey(code);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPublicAssignment>>
  > = ({ signal }) => getPublicAssignment(code, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPublicAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicAssignment>>
>;
export type GetPublicAssignmentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetPublicAssignment<
  TData = Awaited<ReturnType<typeof getPublicAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  code: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPublicAssignment<
  TData = Awaited<ReturnType<typeof getPublicAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPublicAssignment<
  TData = Awaited<ReturnType<typeof getPublicAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPublicAssignment<
  TData = Awaited<ReturnType<typeof getPublicAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPublicAssignmentQueryOptions(code, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignment = (id: number, signal?: AbortSignal) => {
  return configureAxios<PronunciationAssignmentResponseDto>({
    url: `/swann-pronunciation/assignments/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAssignmentQueryKey = (id: number) => {
  return [`/swann-pronunciation/assignments/${id}`] as const;
};

export const getGetAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssignmentQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignment>>> = ({
    signal,
  }) => getAssignment(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignment>>
>;
export type GetAssignmentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignment<
  TData = Awaited<ReturnType<typeof getAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignment<
  TData = Awaited<ReturnType<typeof getAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignment<
  TData = Awaited<ReturnType<typeof getAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignment<
  TData = Awaited<ReturnType<typeof getAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignment>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMyAssignments = (
  params?: GetMyAssignmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListPronunciationAssignmentResponseDto>({
    url: `/swann-pronunciation/assignments/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMyAssignmentsQueryKey = (
  params?: GetMyAssignmentsParams,
) => {
  return [
    `/swann-pronunciation/assignments/me`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMyAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssignments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyAssignments>>
  > = ({ signal }) => getMyAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyAssignments>>
>;
export type GetMyAssignmentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMyAssignments<
  TData = Awaited<ReturnType<typeof getMyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMyAssignmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyAssignments<
  TData = Awaited<ReturnType<typeof getMyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyAssignments<
  TData = Awaited<ReturnType<typeof getMyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMyAssignments<
  TData = Awaited<ReturnType<typeof getMyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopSummarizers = (
  params?: GetTopSummarizersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSummarizerResponseDto>({
    url: `/summarizers/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopSummarizersQueryKey = (
  params?: GetTopSummarizersParams,
) => {
  return [`/summarizers/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopSummarizersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSummarizers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopSummarizersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopSummarizers>>
  > = ({ signal }) => getTopSummarizers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopSummarizers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopSummarizersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopSummarizers>>
>;
export type GetTopSummarizersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopSummarizers<
  TData = Awaited<ReturnType<typeof getTopSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopSummarizersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSummarizers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopSummarizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopSummarizers<
  TData = Awaited<ReturnType<typeof getTopSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSummarizers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopSummarizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopSummarizers<
  TData = Awaited<ReturnType<typeof getTopSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSummarizers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopSummarizers<
  TData = Awaited<ReturnType<typeof getTopSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSummarizers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopSummarizersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentSummarizers = (
  params?: GetRecentSummarizersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSummarizerResponseDto>({
    url: `/summarizers/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentSummarizersQueryKey = (
  params?: GetRecentSummarizersParams,
) => {
  return [`/summarizers/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentSummarizersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentSummarizers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentSummarizersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentSummarizers>>
  > = ({ signal }) => getRecentSummarizers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentSummarizers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentSummarizersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentSummarizers>>
>;
export type GetRecentSummarizersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentSummarizers<
  TData = Awaited<ReturnType<typeof getRecentSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentSummarizersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentSummarizers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentSummarizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentSummarizers<
  TData = Awaited<ReturnType<typeof getRecentSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentSummarizers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentSummarizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentSummarizers<
  TData = Awaited<ReturnType<typeof getRecentSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentSummarizers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentSummarizers<
  TData = Awaited<ReturnType<typeof getRecentSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentSummarizers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentSummarizersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserSummarizers = (
  params?: GetUserSummarizersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSummarizerResponseDto>({
    url: `/summarizers/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserSummarizersQueryKey = (
  params?: GetUserSummarizersParams,
) => {
  return [`/summarizers/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserSummarizersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSummarizers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserSummarizersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserSummarizers>>
  > = ({ signal }) => getUserSummarizers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSummarizers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserSummarizersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserSummarizers>>
>;
export type GetUserSummarizersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserSummarizers<
  TData = Awaited<ReturnType<typeof getUserSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserSummarizersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSummarizers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSummarizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserSummarizers<
  TData = Awaited<ReturnType<typeof getUserSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSummarizers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSummarizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSummarizers<
  TData = Awaited<ReturnType<typeof getUserSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSummarizers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserSummarizers<
  TData = Awaited<ReturnType<typeof getUserSummarizers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserSummarizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserSummarizers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserSummarizersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const streamEvents = (signal?: AbortSignal) => {
  return configureAxios<ServerSentEventString[]>({
    url: `/students/streamsse`,
    method: "GET",
    signal,
  });
};

export const getStreamEventsQueryKey = () => {
  return [`/students/streamsse`] as const;
};

export const getStreamEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamEventsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamEvents>>> = ({
    signal,
  }) => streamEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamEvents>>
>;
export type StreamEventsQueryError = ErrorType<BaseErrorResponseDto>;

export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof streamEvents>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof streamEvents>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamEventsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentMinuteSaved = (signal?: AbortSignal) => {
  return configureAxios<MinutesSavedResponseDto>({
    url: `/students/stats/totalMinutesSaved`,
    method: "GET",
    signal,
  });
};

export const getGetStudentMinuteSavedQueryKey = () => {
  return [`/students/stats/totalMinutesSaved`] as const;
};

export const getGetStudentMinuteSavedQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentMinuteSaved>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentMinuteSavedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentMinuteSaved>>
  > = ({ signal }) => getStudentMinuteSaved(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentMinuteSaved>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentMinuteSavedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentMinuteSaved>>
>;
export type GetStudentMinuteSavedQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudentMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStudentMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentMinuteSaved>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStudentMinuteSaved>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentMinuteSaved<
  TData = Awaited<ReturnType<typeof getStudentMinuteSaved>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentMinuteSaved>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentMinuteSavedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuotas = (signal?: AbortSignal) => {
  return configureAxios<JsonNode>({
    url: `/students/quotas`,
    method: "GET",
    signal,
  });
};

export const getGetQuotasQueryKey = () => {
  return [`/students/quotas`] as const;
};

export const getGetQuotasQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuotas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getQuotas>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuotasQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotas>>> = ({
    signal,
  }) => getQuotas(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuotas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuotasQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuotas>>
>;
export type GetQuotasQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetQuotas<
  TData = Awaited<ReturnType<typeof getQuotas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getQuotas>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getQuotas>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuotas<
  TData = Awaited<ReturnType<typeof getQuotas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getQuotas>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getQuotas>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuotas<
  TData = Awaited<ReturnType<typeof getQuotas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getQuotas>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuotas<
  TData = Awaited<ReturnType<typeof getQuotas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getQuotas>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuotasQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLoggedinStudent = (signal?: AbortSignal) => {
  return configureAxios<StudentResponseDto>({
    url: `/students/me`,
    method: "GET",
    signal,
  });
};

export const getGetLoggedinStudentQueryKey = () => {
  return [`/students/me`] as const;
};

export const getGetLoggedinStudentQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoggedinStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinStudent>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoggedinStudentQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoggedinStudent>>
  > = ({ signal }) => getLoggedinStudent(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoggedinStudent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLoggedinStudentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoggedinStudent>>
>;
export type GetLoggedinStudentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLoggedinStudent<
  TData = Awaited<ReturnType<typeof getLoggedinStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinStudent>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedinStudent>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLoggedinStudent<
  TData = Awaited<ReturnType<typeof getLoggedinStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinStudent>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedinStudent>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLoggedinStudent<
  TData = Awaited<ReturnType<typeof getLoggedinStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinStudent>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLoggedinStudent<
  TData = Awaited<ReturnType<typeof getLoggedinStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedinStudent>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLoggedinStudentQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLeaderboard = (signal?: AbortSignal) => {
  return configureAxios<LeaderboardDTO>({
    url: `/students/leaderboard`,
    method: "GET",
    signal,
  });
};

export const getGetLeaderboardQueryKey = () => {
  return [`/students/leaderboard`] as const;
};

export const getGetLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeaderboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeaderboard>>> = ({
    signal,
  }) => getLeaderboard(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeaderboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeaderboard>>
>;
export type GetLeaderboardQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLeaderboard<
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLeaderboard>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeaderboard<
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLeaderboard>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeaderboard<
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLeaderboard<
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLeaderboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLeaderboardV2 = (signal?: AbortSignal) => {
  return configureAxios<LeaderboardV2DTO>({
    url: `/students/leaderboard/v2`,
    method: "GET",
    signal,
  });
};

export const getGetLeaderboardV2QueryKey = () => {
  return [`/students/leaderboard/v2`] as const;
};

export const getGetLeaderboardV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getLeaderboardV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboardV2>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeaderboardV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLeaderboardV2>>
  > = ({ signal }) => getLeaderboardV2(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeaderboardV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLeaderboardV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeaderboardV2>>
>;
export type GetLeaderboardV2QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLeaderboardV2<
  TData = Awaited<ReturnType<typeof getLeaderboardV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboardV2>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLeaderboardV2>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeaderboardV2<
  TData = Awaited<ReturnType<typeof getLeaderboardV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboardV2>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLeaderboardV2>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeaderboardV2<
  TData = Awaited<ReturnType<typeof getLeaderboardV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboardV2>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLeaderboardV2<
  TData = Awaited<ReturnType<typeof getLeaderboardV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLeaderboardV2>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLeaderboardV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentsOfStudentFromStudent = (
  params?: GetAssignmentsOfStudentFromStudentParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListStudentAssignmentsResponseDto>({
    url: `/students/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentsOfStudentFromStudentQueryKey = (
  params?: GetAssignmentsOfStudentFromStudentParams,
) => {
  return [`/students/assignments`, ...(params ? [params] : [])] as const;
};

export const getGetAssignmentsOfStudentFromStudentQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsOfStudentFromStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssignmentsOfStudentFromStudentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>
  > = ({ signal }) => getAssignmentsOfStudentFromStudent(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentsOfStudentFromStudentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>
>;
export type GetAssignmentsOfStudentFromStudentQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentsOfStudentFromStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAssignmentsOfStudentFromStudentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentsOfStudentFromStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsOfStudentFromStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentsOfStudentFromStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsOfStudentFromStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentsOfStudentFromStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsOfStudentFromStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudentFromStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentsOfStudentFromStudentQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get explanation of question for student
 * @summary Get explanation of question
 */
export const getAnswerFeedback = (
  assignmentId: number,
  questionId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<GetAnswerFeedback200>({
    url: `/students/assignments/${assignmentId}/${questionId}/explanation`,
    method: "GET",
    signal,
  });
};

export const getGetAnswerFeedbackQueryKey = (
  assignmentId: number,
  questionId: number,
) => {
  return [
    `/students/assignments/${assignmentId}/${questionId}/explanation`,
  ] as const;
};

export const getGetAnswerFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnswerFeedback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAnswerFeedbackQueryKey(assignmentId, questionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnswerFeedback>>
  > = ({ signal }) => getAnswerFeedback(assignmentId, questionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(assignmentId && questionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnswerFeedback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAnswerFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnswerFeedback>>
>;
export type GetAnswerFeedbackQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAnswerFeedback<
  TData = Awaited<ReturnType<typeof getAnswerFeedback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnswerFeedback>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAnswerFeedback<
  TData = Awaited<ReturnType<typeof getAnswerFeedback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnswerFeedback>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAnswerFeedback<
  TData = Awaited<ReturnType<typeof getAnswerFeedback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get explanation of question
 */

export function useGetAnswerFeedback<
  TData = Awaited<ReturnType<typeof getAnswerFeedback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAnswerFeedbackQueryOptions(
    assignmentId,
    questionId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get assignment info during quiz.
 * @summary Get assignment of student
 */
export const getStudentAssignmentDuringQuizFromStudent = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<AssignmentDuringQuizStudentPerspectiveResponseDto>({
    url: `/students/assignments/${assignmentId}/during-quiz`,
    method: "GET",
    signal,
  });
};

export const getGetStudentAssignmentDuringQuizFromStudentQueryKey = (
  assignmentId: number,
) => {
  return [`/students/assignments/${assignmentId}/during-quiz`] as const;
};

export const getGetStudentAssignmentDuringQuizFromStudentQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentAssignmentDuringQuizFromStudentQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>
  > = ({ signal }) =>
    getStudentAssignmentDuringQuizFromStudent(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentAssignmentDuringQuizFromStudentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>
>;
export type GetStudentAssignmentDuringQuizFromStudentQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentAssignmentDuringQuizFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentAssignmentDuringQuizFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentAssignmentDuringQuizFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assignment of student
 */

export function useGetStudentAssignmentDuringQuizFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDuringQuizFromStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentAssignmentDuringQuizFromStudentQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get assignment detail of student including questions and answers etc.
 * @summary Get assignment of student
 */
export const getStudentAssignmentDetailFromStudent = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentAssignmentDetailStudentPerspectiveResponseDto>({
    url: `/students/assignments/${assignmentId}/detail`,
    method: "GET",
    signal,
  });
};

export const getGetStudentAssignmentDetailFromStudentQueryKey = (
  assignmentId: number,
) => {
  return [`/students/assignments/${assignmentId}/detail`] as const;
};

export const getGetStudentAssignmentDetailFromStudentQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentAssignmentDetailFromStudentQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>
  > = ({ signal }) =>
    getStudentAssignmentDetailFromStudent(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentAssignmentDetailFromStudentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>
>;
export type GetStudentAssignmentDetailFromStudentQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentAssignmentDetailFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentAssignmentDetailFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentAssignmentDetailFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assignment of student
 */

export function useGetStudentAssignmentDetailFromStudent<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetailFromStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentAssignmentDetailFromStudentQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get paginated list of student tasks including assignments, interactive materials, podcasts, and pronunciation assignments.
 * @summary Get unified tasks
 */
export const getUnifiedTasks = (
  params?: GetUnifiedTasksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<GroupedUnifiedTaskResponseDto>({
    url: `/student/unified-tasks`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUnifiedTasksQueryKey = (params?: GetUnifiedTasksParams) => {
  return [`/student/unified-tasks`, ...(params ? [params] : [])] as const;
};

export const getGetUnifiedTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnifiedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnifiedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnifiedTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUnifiedTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnifiedTasks>>> = ({
    signal,
  }) => getUnifiedTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnifiedTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUnifiedTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnifiedTasks>>
>;
export type GetUnifiedTasksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUnifiedTasks<
  TData = Awaited<ReturnType<typeof getUnifiedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUnifiedTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnifiedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnifiedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUnifiedTasks<
  TData = Awaited<ReturnType<typeof getUnifiedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnifiedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnifiedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnifiedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUnifiedTasks<
  TData = Awaited<ReturnType<typeof getUnifiedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnifiedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnifiedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get unified tasks
 */

export function useGetUnifiedTasks<
  TData = Awaited<ReturnType<typeof getUnifiedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnifiedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnifiedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUnifiedTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeacherAssignedInteractiveMaterials = (
  params?: GetTeacherAssignedInteractiveMaterialsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentInteractiveMaterialResponseDto[]>({
    url: `/student-interactive-materials/teacher`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherAssignedInteractiveMaterialsQueryKey = (
  params?: GetTeacherAssignedInteractiveMaterialsParams,
) => {
  return [
    `/student-interactive-materials/teacher`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeacherAssignedInteractiveMaterialsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherAssignedInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTeacherAssignedInteractiveMaterialsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>
  > = ({ signal }) => getTeacherAssignedInteractiveMaterials(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherAssignedInteractiveMaterialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>
>;
export type GetTeacherAssignedInteractiveMaterialsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTeacherAssignedInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeacherAssignedInteractiveMaterialsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherAssignedInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherAssignedInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherAssignedInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherAssignedInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherAssignedInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherAssignedInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherAssignedInteractiveMaterialsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentInteractiveMaterials = (
  studentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentInteractiveMaterialResponseDto[]>({
    url: `/student-interactive-materials/student/${studentId}`,
    method: "GET",
    signal,
  });
};

export const getGetStudentInteractiveMaterialsQueryKey = (
  studentId: number,
) => {
  return [`/student-interactive-materials/student/${studentId}`] as const;
};

export const getGetStudentInteractiveMaterialsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentInteractiveMaterialsQueryKey(studentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentInteractiveMaterials>>
  > = ({ signal }) => getStudentInteractiveMaterials(studentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentInteractiveMaterialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentInteractiveMaterials>>
>;
export type GetStudentInteractiveMaterialsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentInteractiveMaterialsQueryOptions(
    studentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentInteractiveMaterialDetail = (
  studentId: number,
  interactiveMaterialId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentInteractiveMaterialDetailResponseDto>({
    url: `/student-interactive-materials/student/${studentId}/interactive-material/${interactiveMaterialId}`,
    method: "GET",
    signal,
  });
};

export const getGetStudentInteractiveMaterialDetailQueryKey = (
  studentId: number,
  interactiveMaterialId: number,
) => {
  return [
    `/student-interactive-materials/student/${studentId}/interactive-material/${interactiveMaterialId}`,
  ] as const;
};

export const getGetStudentInteractiveMaterialDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  interactiveMaterialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentInteractiveMaterialDetailQueryKey(
      studentId,
      interactiveMaterialId,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>
  > = ({ signal }) =>
    getStudentInteractiveMaterialDetail(
      studentId,
      interactiveMaterialId,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(studentId && interactiveMaterialId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentInteractiveMaterialDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>
>;
export type GetStudentInteractiveMaterialDetailQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentInteractiveMaterialDetail<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  interactiveMaterialId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentInteractiveMaterialDetail<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  interactiveMaterialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentInteractiveMaterialDetail<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  interactiveMaterialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentInteractiveMaterialDetail<
  TData = Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  interactiveMaterialId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentInteractiveMaterialDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentInteractiveMaterialDetailQueryOptions(
    studentId,
    interactiveMaterialId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFiles = (params: GetFilesParams, signal?: AbortSignal) => {
  return configureAxios<BaseStaticQuestionAnswerResponseDto>({
    url: `/static-question-answers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFilesQueryKey = (params: GetFilesParams) => {
  return [`/static-question-answers`, ...(params ? [params] : [])] as const;
};

export const getGetFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiles>>> = ({
    signal,
  }) => getFiles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiles>>
>;
export type GetFilesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetFiles<
  TData = Awaited<ReturnType<typeof getFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetFilesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiles>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFiles<
  TData = Awaited<ReturnType<typeof getFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiles>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFiles<
  TData = Awaited<ReturnType<typeof getFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFiles<
  TData = Awaited<ReturnType<typeof getFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAvailableCourses = (signal?: AbortSignal) => {
  return configureAxios<GetAvailableCourses200Item[]>({
    url: `/static-question-answers/available-courses`,
    method: "GET",
    signal,
  });
};

export const getGetAvailableCoursesQueryKey = () => {
  return [`/static-question-answers/available-courses`] as const;
};

export const getGetAvailableCoursesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableCourses>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableCoursesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailableCourses>>
  > = ({ signal }) => getAvailableCourses(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableCourses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAvailableCoursesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableCourses>>
>;
export type GetAvailableCoursesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAvailableCourses<
  TData = Awaited<ReturnType<typeof getAvailableCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableCourses>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAvailableCourses>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvailableCourses<
  TData = Awaited<ReturnType<typeof getAvailableCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableCourses>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAvailableCourses>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableCourses<
  TData = Awaited<ReturnType<typeof getAvailableCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableCourses>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAvailableCourses<
  TData = Awaited<ReturnType<typeof getAvailableCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableCourses>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAvailableCoursesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const handleUserInfoRequest = (signal?: AbortSignal) => {
  return configureAxios<HandleUserInfoRequest200>({
    url: `/sso/circle/userinfo`,
    method: "GET",
    signal,
  });
};

export const getHandleUserInfoRequestQueryKey = () => {
  return [`/sso/circle/userinfo`] as const;
};

export const getHandleUserInfoRequestQueryOptions = <
  TData = Awaited<ReturnType<typeof handleUserInfoRequest>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof handleUserInfoRequest>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHandleUserInfoRequestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof handleUserInfoRequest>>
  > = ({ signal }) => handleUserInfoRequest(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof handleUserInfoRequest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type HandleUserInfoRequestQueryResult = NonNullable<
  Awaited<ReturnType<typeof handleUserInfoRequest>>
>;
export type HandleUserInfoRequestQueryError = ErrorType<BaseErrorResponseDto>;

export function useHandleUserInfoRequest<
  TData = Awaited<ReturnType<typeof handleUserInfoRequest>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof handleUserInfoRequest>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof handleUserInfoRequest>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useHandleUserInfoRequest<
  TData = Awaited<ReturnType<typeof handleUserInfoRequest>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof handleUserInfoRequest>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof handleUserInfoRequest>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useHandleUserInfoRequest<
  TData = Awaited<ReturnType<typeof handleUserInfoRequest>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof handleUserInfoRequest>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useHandleUserInfoRequest<
  TData = Awaited<ReturnType<typeof handleUserInfoRequest>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof handleUserInfoRequest>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getHandleUserInfoRequestQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopSketchGenerator = (
  params?: GetTopSketchGeneratorParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSketchGeneratorResponseDto>({
    url: `/sketch-generator/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopSketchGeneratorQueryKey = (
  params?: GetTopSketchGeneratorParams,
) => {
  return [`/sketch-generator/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopSketchGeneratorQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSketchGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSketchGenerator>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopSketchGeneratorQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopSketchGenerator>>
  > = ({ signal }) => getTopSketchGenerator(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopSketchGenerator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopSketchGeneratorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopSketchGenerator>>
>;
export type GetTopSketchGeneratorQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopSketchGenerator<
  TData = Awaited<ReturnType<typeof getTopSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopSketchGeneratorParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSketchGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopSketchGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopSketchGenerator<
  TData = Awaited<ReturnType<typeof getTopSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSketchGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSketchGenerator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopSketchGenerator>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopSketchGenerator<
  TData = Awaited<ReturnType<typeof getTopSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSketchGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSketchGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopSketchGenerator<
  TData = Awaited<ReturnType<typeof getTopSketchGenerator>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopSketchGeneratorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopSketchGenerator>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopSketchGeneratorQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSketchGenerator1 = (
  params?: GetSketchGenerator1Params,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSketchGeneratorResponseDto>({
    url: `/sketch-generator/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSketchGenerator1QueryKey = (
  params?: GetSketchGenerator1Params,
) => {
  return [`/sketch-generator/recent`, ...(params ? [params] : [])] as const;
};

export const getGetSketchGenerator1QueryOptions = <
  TData = Awaited<ReturnType<typeof getSketchGenerator1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGenerator1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator1>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSketchGenerator1QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSketchGenerator1>>
  > = ({ signal }) => getSketchGenerator1(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSketchGenerator1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSketchGenerator1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getSketchGenerator1>>
>;
export type GetSketchGenerator1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSketchGenerator1<
  TData = Awaited<ReturnType<typeof getSketchGenerator1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetSketchGenerator1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSketchGenerator1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSketchGenerator1<
  TData = Awaited<ReturnType<typeof getSketchGenerator1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGenerator1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSketchGenerator1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSketchGenerator1<
  TData = Awaited<ReturnType<typeof getSketchGenerator1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGenerator1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSketchGenerator1<
  TData = Awaited<ReturnType<typeof getSketchGenerator1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGenerator1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerator1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSketchGenerator1QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSketchGenerators = (
  params?: GetSketchGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListSketchGeneratorResponseDto>({
    url: `/sketch-generator/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSketchGeneratorsQueryKey = (
  params?: GetSketchGeneratorsParams,
) => {
  return [`/sketch-generator/me`, ...(params ? [params] : [])] as const;
};

export const getGetSketchGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSketchGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSketchGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSketchGenerators>>
  > = ({ signal }) => getSketchGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSketchGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSketchGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSketchGenerators>>
>;
export type GetSketchGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetSketchGenerators<
  TData = Awaited<ReturnType<typeof getSketchGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetSketchGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSketchGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSketchGenerators<
  TData = Awaited<ReturnType<typeof getSketchGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSketchGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSketchGenerators<
  TData = Awaited<ReturnType<typeof getSketchGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSketchGenerators<
  TData = Awaited<ReturnType<typeof getSketchGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetSketchGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSketchGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSketchGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopRubricGenerators = (
  params?: GetTopRubricGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListRubricGeneratorResponseDto>({
    url: `/rubric-generator/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopRubricGeneratorsQueryKey = (
  params?: GetTopRubricGeneratorsParams,
) => {
  return [`/rubric-generator/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopRubricGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopRubricGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopRubricGenerators>>
  > = ({ signal }) => getTopRubricGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopRubricGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopRubricGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopRubricGenerators>>
>;
export type GetTopRubricGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopRubricGenerators<
  TData = Awaited<ReturnType<typeof getTopRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopRubricGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRubricGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopRubricGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopRubricGenerators<
  TData = Awaited<ReturnType<typeof getTopRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRubricGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopRubricGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopRubricGenerators<
  TData = Awaited<ReturnType<typeof getTopRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopRubricGenerators<
  TData = Awaited<ReturnType<typeof getTopRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopRubricGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentRubricGenerators = (
  params?: GetRecentRubricGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListRubricGeneratorResponseDto>({
    url: `/rubric-generator/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentRubricGeneratorsQueryKey = (
  params?: GetRecentRubricGeneratorsParams,
) => {
  return [`/rubric-generator/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentRubricGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentRubricGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentRubricGenerators>>
  > = ({ signal }) => getRecentRubricGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentRubricGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentRubricGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentRubricGenerators>>
>;
export type GetRecentRubricGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentRubricGenerators<
  TData = Awaited<ReturnType<typeof getRecentRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentRubricGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRubricGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentRubricGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentRubricGenerators<
  TData = Awaited<ReturnType<typeof getRecentRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRubricGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentRubricGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentRubricGenerators<
  TData = Awaited<ReturnType<typeof getRecentRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentRubricGenerators<
  TData = Awaited<ReturnType<typeof getRecentRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentRubricGeneratorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserRubricGenerators = (
  params?: GetUserRubricGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListRubricGeneratorResponseDto>({
    url: `/rubric-generator/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserRubricGeneratorsQueryKey = (
  params?: GetUserRubricGeneratorsParams,
) => {
  return [`/rubric-generator/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserRubricGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserRubricGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserRubricGenerators>>
  > = ({ signal }) => getUserRubricGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserRubricGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserRubricGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserRubricGenerators>>
>;
export type GetUserRubricGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserRubricGenerators<
  TData = Awaited<ReturnType<typeof getUserRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserRubricGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRubricGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserRubricGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserRubricGenerators<
  TData = Awaited<ReturnType<typeof getUserRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRubricGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserRubricGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserRubricGenerators<
  TData = Awaited<ReturnType<typeof getUserRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserRubricGenerators<
  TData = Awaited<ReturnType<typeof getUserRubricGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRubricGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRubricGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserRubricGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopRealWorldConnections = (
  params?: GetTopRealWorldConnectionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListRealWorldConnectionResponseDto>({
    url: `/real-world-connections/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopRealWorldConnectionsQueryKey = (
  params?: GetTopRealWorldConnectionsParams,
) => {
  return [`/real-world-connections/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopRealWorldConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopRealWorldConnectionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopRealWorldConnections>>
  > = ({ signal }) => getTopRealWorldConnections(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopRealWorldConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopRealWorldConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopRealWorldConnections>>
>;
export type GetTopRealWorldConnectionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopRealWorldConnections<
  TData = Awaited<ReturnType<typeof getTopRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopRealWorldConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRealWorldConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopRealWorldConnections>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopRealWorldConnections<
  TData = Awaited<ReturnType<typeof getTopRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRealWorldConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopRealWorldConnections>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopRealWorldConnections<
  TData = Awaited<ReturnType<typeof getTopRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopRealWorldConnections<
  TData = Awaited<ReturnType<typeof getTopRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopRealWorldConnectionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentRealWorldConnections = (
  params?: GetRecentRealWorldConnectionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListRealWorldConnectionResponseDto>({
    url: `/real-world-connections/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentRealWorldConnectionsQueryKey = (
  params?: GetRecentRealWorldConnectionsParams,
) => {
  return [
    `/real-world-connections/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentRealWorldConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentRealWorldConnectionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentRealWorldConnections>>
  > = ({ signal }) => getRecentRealWorldConnections(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentRealWorldConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentRealWorldConnections>>
>;
export type GetRecentRealWorldConnectionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentRealWorldConnections<
  TData = Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentRealWorldConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentRealWorldConnections<
  TData = Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentRealWorldConnections<
  TData = Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentRealWorldConnections<
  TData = Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentRealWorldConnectionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserRealWorldConnections = (
  params?: GetUserRealWorldConnectionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListRealWorldConnectionResponseDto>({
    url: `/real-world-connections/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserRealWorldConnectionsQueryKey = (
  params?: GetUserRealWorldConnectionsParams,
) => {
  return [`/real-world-connections/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserRealWorldConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserRealWorldConnectionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserRealWorldConnections>>
  > = ({ signal }) => getUserRealWorldConnections(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserRealWorldConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserRealWorldConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserRealWorldConnections>>
>;
export type GetUserRealWorldConnectionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserRealWorldConnections<
  TData = Awaited<ReturnType<typeof getUserRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserRealWorldConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRealWorldConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserRealWorldConnections>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserRealWorldConnections<
  TData = Awaited<ReturnType<typeof getUserRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRealWorldConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserRealWorldConnections>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserRealWorldConnections<
  TData = Awaited<ReturnType<typeof getUserRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserRealWorldConnections<
  TData = Awaited<ReturnType<typeof getUserRealWorldConnections>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserRealWorldConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserRealWorldConnections>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserRealWorldConnectionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const exportQuestionSolverV2 = (
  id: number,
  params?: ExportQuestionSolverV2Params,
  signal?: AbortSignal,
) => {
  return configureAxios<GetQuestionSolverResponseDtoV2>({
    url: `/question-solver/v2/${id}/export`,
    method: "GET",
    params,
    signal,
  });
};

export const getExportQuestionSolverV2QueryKey = (
  id: number,
  params?: ExportQuestionSolverV2Params,
) => {
  return [
    `/question-solver/v2/${id}/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExportQuestionSolverV2QueryOptions = <
  TData = Awaited<ReturnType<typeof exportQuestionSolverV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: ExportQuestionSolverV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportQuestionSolverV2>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportQuestionSolverV2QueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportQuestionSolverV2>>
  > = ({ signal }) => exportQuestionSolverV2(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportQuestionSolverV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExportQuestionSolverV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof exportQuestionSolverV2>>
>;
export type ExportQuestionSolverV2QueryError = ErrorType<BaseErrorResponseDto>;

export function useExportQuestionSolverV2<
  TData = Awaited<ReturnType<typeof exportQuestionSolverV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | ExportQuestionSolverV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportQuestionSolverV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportQuestionSolverV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportQuestionSolverV2<
  TData = Awaited<ReturnType<typeof exportQuestionSolverV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: ExportQuestionSolverV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportQuestionSolverV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportQuestionSolverV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportQuestionSolverV2<
  TData = Awaited<ReturnType<typeof exportQuestionSolverV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: ExportQuestionSolverV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportQuestionSolverV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useExportQuestionSolverV2<
  TData = Awaited<ReturnType<typeof exportQuestionSolverV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: ExportQuestionSolverV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportQuestionSolverV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getExportQuestionSolverV2QueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuestionsWithFileSystemV2 = (
  params?: GetQuestionsWithFileSystemV2Params,
  signal?: AbortSignal,
) => {
  return configureAxios<QuestionFileNodeDtoV2>({
    url: `/question-solver/v2/filesystem`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetQuestionsWithFileSystemV2QueryKey = (
  params?: GetQuestionsWithFileSystemV2Params,
) => {
  return [
    `/question-solver/v2/filesystem`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetQuestionsWithFileSystemV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionsWithFileSystemV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionsWithFileSystemV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>
  > = ({ signal }) => getQuestionsWithFileSystemV2(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionsWithFileSystemV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>
>;
export type GetQuestionsWithFileSystemV2QueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetQuestionsWithFileSystemV2<
  TData = Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetQuestionsWithFileSystemV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionsWithFileSystemV2<
  TData = Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionsWithFileSystemV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionsWithFileSystemV2<
  TData = Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionsWithFileSystemV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionsWithFileSystemV2<
  TData = Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionsWithFileSystemV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionsWithFileSystemV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionsWithFileSystemV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuestionRegen = (questionId: number, signal?: AbortSignal) => {
  return configureAxios<QuestionRegenResponseDto[]>({
    url: `/question-regen/${questionId}`,
    method: "GET",
    signal,
  });
};

export const getGetQuestionRegenQueryKey = (questionId: number) => {
  return [`/question-regen/${questionId}`] as const;
};

export const getGetQuestionRegenQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionRegen>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegen>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionRegenQueryKey(questionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionRegen>>
  > = ({ signal }) => getQuestionRegen(questionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!questionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionRegen>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionRegenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionRegen>>
>;
export type GetQuestionRegenQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetQuestionRegen<
  TData = Awaited<ReturnType<typeof getQuestionRegen>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  questionId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegen>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionRegen>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionRegen<
  TData = Awaited<ReturnType<typeof getQuestionRegen>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegen>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionRegen>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionRegen<
  TData = Awaited<ReturnType<typeof getQuestionRegen>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegen>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionRegen<
  TData = Awaited<ReturnType<typeof getQuestionRegen>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegen>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionRegenQueryOptions(questionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuestionRegenWithRegenId = (
  regenId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<QuestionRegenResponseDto>({
    url: `/question-regen/with-regen-id/${regenId}`,
    method: "GET",
    signal,
  });
};

export const getGetQuestionRegenWithRegenIdQueryKey = (regenId: number) => {
  return [`/question-regen/with-regen-id/${regenId}`] as const;
};

export const getGetQuestionRegenWithRegenIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  regenId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionRegenWithRegenIdQueryKey(regenId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>
  > = ({ signal }) => getQuestionRegenWithRegenId(regenId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!regenId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionRegenWithRegenIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>
>;
export type GetQuestionRegenWithRegenIdQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetQuestionRegenWithRegenId<
  TData = Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  regenId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionRegenWithRegenId<
  TData = Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  regenId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionRegenWithRegenId<
  TData = Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  regenId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionRegenWithRegenId<
  TData = Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  regenId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegenWithRegenId>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionRegenWithRegenIdQueryOptions(
    regenId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuestionRegensByAssignmentId = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<QuestionRegenResponseDto[]>({
    url: `/question-regen/assignment/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetQuestionRegensByAssignmentIdQueryKey = (
  assignmentId: number,
) => {
  return [`/question-regen/assignment/${assignmentId}`] as const;
};

export const getGetQuestionRegensByAssignmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetQuestionRegensByAssignmentIdQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>
  > = ({ signal }) => getQuestionRegensByAssignmentId(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionRegensByAssignmentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>
>;
export type GetQuestionRegensByAssignmentIdQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetQuestionRegensByAssignmentId<
  TData = Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionRegensByAssignmentId<
  TData = Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionRegensByAssignmentId<
  TData = Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionRegensByAssignmentId<
  TData = Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionRegensByAssignmentId>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionRegensByAssignmentIdQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve all unique tags used by the user across their question helpers
 * @summary Get all available tags for the authenticated user
 */
export const getUserTags = (signal?: AbortSignal) => {
  return configureAxios<QuestionHelperTagsResponseDto>({
    url: `/question-helper/tags`,
    method: "GET",
    signal,
  });
};

export const getGetUserTagsQueryKey = () => {
  return [`/question-helper/tags`] as const;
};

export const getGetUserTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserTags>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserTags>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserTags>>> = ({
    signal,
  }) => getUserTags(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserTags>>
>;
export type GetUserTagsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserTags<
  TData = Awaited<ReturnType<typeof getUserTags>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserTags>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserTags>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserTags<
  TData = Awaited<ReturnType<typeof getUserTags>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserTags>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserTags>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserTags<
  TData = Awaited<ReturnType<typeof getUserTags>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserTags>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all available tags for the authenticated user
 */

export function useGetUserTags<
  TData = Awaited<ReturnType<typeof getUserTags>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserTags>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopProjectBasedLearnings = (
  params?: GetTopProjectBasedLearningsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListProjectBasedLearningResponseDto>({
    url: `/project-based-learning/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopProjectBasedLearningsQueryKey = (
  params?: GetTopProjectBasedLearningsParams,
) => {
  return [`/project-based-learning/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopProjectBasedLearningsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopProjectBasedLearningsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopProjectBasedLearnings>>
  > = ({ signal }) => getTopProjectBasedLearnings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopProjectBasedLearningsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopProjectBasedLearnings>>
>;
export type GetTopProjectBasedLearningsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopProjectBasedLearningsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopProjectBasedLearningsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentProjectBasedLearnings = (
  params?: GetRecentProjectBasedLearningsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListProjectBasedLearningResponseDto>({
    url: `/project-based-learning/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentProjectBasedLearningsQueryKey = (
  params?: GetRecentProjectBasedLearningsParams,
) => {
  return [
    `/project-based-learning/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentProjectBasedLearningsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentProjectBasedLearningsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>
  > = ({ signal }) => getRecentProjectBasedLearnings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentProjectBasedLearningsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>
>;
export type GetRecentProjectBasedLearningsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentProjectBasedLearningsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentProjectBasedLearningsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserProjectBasedLearnings = (
  params?: GetUserProjectBasedLearningsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListProjectBasedLearningResponseDto>({
    url: `/project-based-learning/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserProjectBasedLearningsQueryKey = (
  params?: GetUserProjectBasedLearningsParams,
) => {
  return [`/project-based-learning/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserProjectBasedLearningsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserProjectBasedLearningsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserProjectBasedLearnings>>
  > = ({ signal }) => getUserProjectBasedLearnings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserProjectBasedLearningsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserProjectBasedLearnings>>
>;
export type GetUserProjectBasedLearningsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserProjectBasedLearningsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserProjectBasedLearnings<
  TData = Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserProjectBasedLearningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserProjectBasedLearnings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserProjectBasedLearningsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopPodcasts = (
  params?: GetTopPodcastsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListPodcastResponseDto>({
    url: `/podcasts/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopPodcastsQueryKey = (params?: GetTopPodcastsParams) => {
  return [`/podcasts/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopPodcastsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopPodcasts>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopPodcastsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopPodcasts>>> = ({
    signal,
  }) => getTopPodcasts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopPodcasts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopPodcastsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopPodcasts>>
>;
export type GetTopPodcastsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopPodcasts<
  TData = Awaited<ReturnType<typeof getTopPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopPodcastsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopPodcasts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopPodcasts<
  TData = Awaited<ReturnType<typeof getTopPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopPodcasts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopPodcasts<
  TData = Awaited<ReturnType<typeof getTopPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopPodcasts>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopPodcasts<
  TData = Awaited<ReturnType<typeof getTopPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopPodcasts>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopPodcastsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentPodcasts = (signal?: AbortSignal) => {
  return configureAxios<StudentPodcastResponseDto[]>({
    url: `/podcasts/students`,
    method: "GET",
    signal,
  });
};

export const getGetStudentPodcastsQueryKey = () => {
  return [`/podcasts/students`] as const;
};

export const getGetStudentPodcastsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentPodcasts>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentPodcastsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentPodcasts>>
  > = ({ signal }) => getStudentPodcasts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentPodcasts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentPodcastsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentPodcasts>>
>;
export type GetStudentPodcastsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudentPodcasts<
  TData = Awaited<ReturnType<typeof getStudentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentPodcasts>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStudentPodcasts>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentPodcasts<
  TData = Awaited<ReturnType<typeof getStudentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentPodcasts>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStudentPodcasts>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentPodcasts<
  TData = Awaited<ReturnType<typeof getStudentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentPodcasts>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentPodcasts<
  TData = Awaited<ReturnType<typeof getStudentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStudentPodcasts>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentPodcastsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentPodcast = (id: number, signal?: AbortSignal) => {
  return configureAxios<StudentPodcastResponseDto>({
    url: `/podcasts/students/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetStudentPodcastQueryKey = (id: number) => {
  return [`/podcasts/students/${id}`] as const;
};

export const getGetStudentPodcastQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentPodcast>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentPodcastQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentPodcast>>
  > = ({ signal }) => getStudentPodcast(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentPodcast>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentPodcastQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentPodcast>>
>;
export type GetStudentPodcastQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudentPodcast<
  TData = Awaited<ReturnType<typeof getStudentPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentPodcast>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentPodcast>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentPodcast<
  TData = Awaited<ReturnType<typeof getStudentPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentPodcast>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentPodcast>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentPodcast<
  TData = Awaited<ReturnType<typeof getStudentPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentPodcast>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentPodcast<
  TData = Awaited<ReturnType<typeof getStudentPodcast>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentPodcast>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentPodcastQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeacherAssignedPodcasts = (
  id: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentPodcastResponseDto[]>({
    url: `/podcasts/students/${id}/assigned`,
    method: "GET",
    signal,
  });
};

export const getGetTeacherAssignedPodcastsQueryKey = (id: number) => {
  return [`/podcasts/students/${id}/assigned`] as const;
};

export const getGetTeacherAssignedPodcastsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherAssignedPodcastsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>
  > = ({ signal }) => getTeacherAssignedPodcasts(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherAssignedPodcastsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>
>;
export type GetTeacherAssignedPodcastsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTeacherAssignedPodcasts<
  TData = Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherAssignedPodcasts<
  TData = Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherAssignedPodcasts<
  TData = Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherAssignedPodcasts<
  TData = Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherAssignedPodcasts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherAssignedPodcastsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentPodcasts = (
  params?: GetRecentPodcastsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListPodcastResponseDto>({
    url: `/podcasts/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentPodcastsQueryKey = (
  params?: GetRecentPodcastsParams,
) => {
  return [`/podcasts/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentPodcastsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPodcasts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentPodcastsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentPodcasts>>
  > = ({ signal }) => getRecentPodcasts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentPodcasts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentPodcastsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentPodcasts>>
>;
export type GetRecentPodcastsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentPodcasts<
  TData = Awaited<ReturnType<typeof getRecentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentPodcastsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPodcasts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentPodcasts<
  TData = Awaited<ReturnType<typeof getRecentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPodcasts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentPodcasts<
  TData = Awaited<ReturnType<typeof getRecentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPodcasts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentPodcasts<
  TData = Awaited<ReturnType<typeof getRecentPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPodcasts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentPodcastsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserPodcasts = (
  params?: GetUserPodcastsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListPodcastResponseDto>({
    url: `/podcasts/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserPodcastsQueryKey = (params?: GetUserPodcastsParams) => {
  return [`/podcasts/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserPodcastsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPodcasts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserPodcastsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPodcasts>>> = ({
    signal,
  }) => getUserPodcasts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPodcasts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserPodcastsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPodcasts>>
>;
export type GetUserPodcastsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserPodcasts<
  TData = Awaited<ReturnType<typeof getUserPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserPodcastsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPodcasts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserPodcasts<
  TData = Awaited<ReturnType<typeof getUserPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPodcasts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPodcasts>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserPodcasts<
  TData = Awaited<ReturnType<typeof getUserPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPodcasts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserPodcasts<
  TData = Awaited<ReturnType<typeof getUserPodcasts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPodcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPodcasts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserPodcastsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopPerformanceTasks = (
  params?: GetTopPerformanceTasksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListPerformanceTaskResponseDto>({
    url: `/performance-task/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopPerformanceTasksQueryKey = (
  params?: GetTopPerformanceTasksParams,
) => {
  return [`/performance-task/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopPerformanceTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopPerformanceTasksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopPerformanceTasks>>
  > = ({ signal }) => getTopPerformanceTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopPerformanceTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopPerformanceTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopPerformanceTasks>>
>;
export type GetTopPerformanceTasksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopPerformanceTasks<
  TData = Awaited<ReturnType<typeof getTopPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopPerformanceTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformanceTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPerformanceTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopPerformanceTasks<
  TData = Awaited<ReturnType<typeof getTopPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformanceTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPerformanceTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopPerformanceTasks<
  TData = Awaited<ReturnType<typeof getTopPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopPerformanceTasks<
  TData = Awaited<ReturnType<typeof getTopPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopPerformanceTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentPerformanceTasks = (
  params?: GetRecentPerformanceTasksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListPerformanceTaskResponseDto>({
    url: `/performance-task/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentPerformanceTasksQueryKey = (
  params?: GetRecentPerformanceTasksParams,
) => {
  return [`/performance-task/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentPerformanceTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentPerformanceTasksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentPerformanceTasks>>
  > = ({ signal }) => getRecentPerformanceTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentPerformanceTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentPerformanceTasks>>
>;
export type GetRecentPerformanceTasksQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentPerformanceTasks<
  TData = Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentPerformanceTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentPerformanceTasks<
  TData = Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentPerformanceTasks<
  TData = Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentPerformanceTasks<
  TData = Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentPerformanceTasksQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserPerformanceTasks = (
  params?: GetUserPerformanceTasksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListPerformanceTaskResponseDto>({
    url: `/performance-task/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserPerformanceTasksQueryKey = (
  params?: GetUserPerformanceTasksParams,
) => {
  return [`/performance-task/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserPerformanceTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserPerformanceTasksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPerformanceTasks>>
  > = ({ signal }) => getUserPerformanceTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPerformanceTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserPerformanceTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPerformanceTasks>>
>;
export type GetUserPerformanceTasksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserPerformanceTasks<
  TData = Awaited<ReturnType<typeof getUserPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserPerformanceTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPerformanceTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPerformanceTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserPerformanceTasks<
  TData = Awaited<ReturnType<typeof getUserPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPerformanceTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPerformanceTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserPerformanceTasks<
  TData = Awaited<ReturnType<typeof getUserPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserPerformanceTasks<
  TData = Awaited<ReturnType<typeof getUserPerformanceTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserPerformanceTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPerformanceTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserPerformanceTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentPdfStatus = (id: number, signal?: AbortSignal) => {
  return configureAxios<PdfStatusResponseItem>({
    url: `/pdf-renderer/assignments/${id}/status`,
    method: "GET",
    signal,
  });
};

export const getGetAssignmentPdfStatusQueryKey = (id: number) => {
  return [`/pdf-renderer/assignments/${id}/status`] as const;
};

export const getGetAssignmentPdfStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentPdfStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentPdfStatus>>
  > = ({ signal }) => getAssignmentPdfStatus(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentPdfStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentPdfStatus>>
>;
export type GetAssignmentPdfStatusQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentPdfStatus<
  TData = Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentPdfStatus<
  TData = Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentPdfStatus<
  TData = Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentPdfStatus<
  TData = Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentPdfStatus>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentPdfStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentAsJSON = (
  id: number,
  params?: GetAssignmentAsJSONParams,
  signal?: AbortSignal,
) => {
  return configureAxios<HomeworkAssignmentPdfCreateRequestItem>({
    url: `/pdf-renderer/assignments/${id}/json`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentAsJSONQueryKey = (
  id: number,
  params?: GetAssignmentAsJSONParams,
) => {
  return [
    `/pdf-renderer/assignments/${id}/json`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentAsJSONQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentAsJSON>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentAsJSONParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAsJSON>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentAsJSONQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentAsJSON>>
  > = ({ signal }) => getAssignmentAsJSON(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentAsJSON>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentAsJSONQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentAsJSON>>
>;
export type GetAssignmentAsJSONQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentAsJSON<
  TData = Awaited<ReturnType<typeof getAssignmentAsJSON>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | GetAssignmentAsJSONParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAsJSON>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentAsJSON>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentAsJSON<
  TData = Awaited<ReturnType<typeof getAssignmentAsJSON>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentAsJSONParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAsJSON>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentAsJSON>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentAsJSON<
  TData = Awaited<ReturnType<typeof getAssignmentAsJSON>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentAsJSONParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAsJSON>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentAsJSON<
  TData = Awaited<ReturnType<typeof getAssignmentAsJSON>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentAsJSONParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentAsJSON>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentAsJSONQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOrganizationAdmins = (
  params?: GetOrganizationAdminsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedOrganizationAdminResponseDto>({
    url: `/organization-admin`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOrganizationAdminsQueryKey = (
  params?: GetOrganizationAdminsParams,
) => {
  return [`/organization-admin`, ...(params ? [params] : [])] as const;
};

export const getGetOrganizationAdminsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationAdmins>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetOrganizationAdminsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmins>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationAdminsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationAdmins>>
  > = ({ signal }) => getOrganizationAdmins(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationAdmins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrganizationAdminsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationAdmins>>
>;
export type GetOrganizationAdminsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetOrganizationAdmins<
  TData = Awaited<ReturnType<typeof getOrganizationAdmins>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetOrganizationAdminsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmins>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAdmins>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizationAdmins<
  TData = Awaited<ReturnType<typeof getOrganizationAdmins>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetOrganizationAdminsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmins>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAdmins>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationAdmins<
  TData = Awaited<ReturnType<typeof getOrganizationAdmins>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetOrganizationAdminsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmins>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetOrganizationAdmins<
  TData = Awaited<ReturnType<typeof getOrganizationAdmins>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetOrganizationAdminsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmins>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrganizationAdminsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOrganizationAdmin = (
  organizationAdminId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<OrganizationAdminResponseDto>({
    url: `/organization-admin/${organizationAdminId}`,
    method: "GET",
    signal,
  });
};

export const getGetOrganizationAdminQueryKey = (
  organizationAdminId: number,
) => {
  return [`/organization-admin/${organizationAdminId}`] as const;
};

export const getGetOrganizationAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  organizationAdminId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOrganizationAdminQueryKey(organizationAdminId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationAdmin>>
  > = ({ signal }) => getOrganizationAdmin(organizationAdminId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationAdminId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrganizationAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationAdmin>>
>;
export type GetOrganizationAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  organizationAdminId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  organizationAdminId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  organizationAdminId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  organizationAdminId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizationAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrganizationAdminQueryOptions(
    organizationAdminId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentDetail = (
  id: number,
  params?: GetStudentDetailParams,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentDetailResponseDto>({
    url: `/organization-admin/${id}/detail`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStudentDetailQueryKey = (
  id: number,
  params?: GetStudentDetailParams,
) => {
  return [
    `/organization-admin/${id}/detail`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStudentDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetStudentDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetail>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentDetailQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentDetail>>
  > = ({ signal }) => getStudentDetail(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentDetail>>
>;
export type GetStudentDetailQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudentDetail<
  TData = Awaited<ReturnType<typeof getStudentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | GetStudentDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentDetail<
  TData = Awaited<ReturnType<typeof getStudentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetStudentDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentDetail<
  TData = Awaited<ReturnType<typeof getStudentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetStudentDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentDetail<
  TData = Awaited<ReturnType<typeof getStudentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetStudentDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentDetailQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get assignment detail of student including questions and answers etc.
 * @summary Get assignment of student
 */
export const getStudentAssignmentDetail = (
  id: number,
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<GetStudentAssignmentDetailResponseDto>({
    url: `/organization-admin/${id}/assignments/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetStudentAssignmentDetailQueryKey = (
  id: number,
  assignmentId: number,
) => {
  return [`/organization-admin/${id}/assignments/${assignmentId}`] as const;
};

export const getGetStudentAssignmentDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentAssignmentDetailQueryKey(id, assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentAssignmentDetail>>
  > = ({ signal }) => getStudentAssignmentDetail(id, assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(id && assignmentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentAssignmentDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentAssignmentDetail>>
>;
export type GetStudentAssignmentDetailQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentAssignmentDetail<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentAssignmentDetail<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentAssignmentDetail<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assignment of student
 */

export function useGetStudentAssignmentDetail<
  TData = Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentAssignmentDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentAssignmentDetailQueryOptions(
    id,
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Tool usage aggregated by course and tool type
 */
export const getToolUsage = (signal?: AbortSignal) => {
  return configureAxios<ToolUsageByCourseDto[]>({
    url: `/organization-admin/v2/tool-usage`,
    method: "GET",
    signal,
  });
};

export const getGetToolUsageQueryKey = () => {
  return [`/organization-admin/v2/tool-usage`] as const;
};

export const getGetToolUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getToolUsage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getToolUsage>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetToolUsageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getToolUsage>>> = ({
    signal,
  }) => getToolUsage(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getToolUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetToolUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getToolUsage>>
>;
export type GetToolUsageQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetToolUsage<
  TData = Awaited<ReturnType<typeof getToolUsage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getToolUsage>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getToolUsage>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetToolUsage<
  TData = Awaited<ReturnType<typeof getToolUsage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getToolUsage>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getToolUsage>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetToolUsage<
  TData = Awaited<ReturnType<typeof getToolUsage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getToolUsage>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Tool usage aggregated by course and tool type
 */

export function useGetToolUsage<
  TData = Awaited<ReturnType<typeof getToolUsage>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getToolUsage>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetToolUsageQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Teachers table
 */
export const getTeachers = (
  params?: GetTeachersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PageTeacherTableRowDto>({
    url: `/organization-admin/v2/teachers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeachersQueryKey = (params?: GetTeachersParams) => {
  return [
    `/organization-admin/v2/teachers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeachersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeachersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeachers>>> = ({
    signal,
  }) => getTeachers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeachers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeachersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeachers>>
>;
export type GetTeachersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeachers<
  TData = Awaited<ReturnType<typeof getTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeachersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeachers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeachers<
  TData = Awaited<ReturnType<typeof getTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeachers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeachers<
  TData = Awaited<ReturnType<typeof getTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Teachers table
 */

export function useGetTeachers<
  TData = Awaited<ReturnType<typeof getTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeachers>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeachersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Teacher details with per-tool usage counts and last used
 */
export const getTeacherDetails = (teacherId: number, signal?: AbortSignal) => {
  return configureAxios<TeacherDetailsDto>({
    url: `/organization-admin/v2/teachers/${teacherId}/details`,
    method: "GET",
    signal,
  });
};

export const getGetTeacherDetailsQueryKey = (teacherId: number) => {
  return [`/organization-admin/v2/teachers/${teacherId}/details`] as const;
};

export const getGetTeacherDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  teacherId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetails>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherDetailsQueryKey(teacherId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherDetails>>
  > = ({ signal }) => getTeacherDetails(teacherId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!teacherId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherDetails>>
>;
export type GetTeacherDetailsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherDetails<
  TData = Awaited<ReturnType<typeof getTeacherDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  teacherId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherDetails<
  TData = Awaited<ReturnType<typeof getTeacherDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  teacherId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherDetails<
  TData = Awaited<ReturnType<typeof getTeacherDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  teacherId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetails>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Teacher details with per-tool usage counts and last used
 */

export function useGetTeacherDetails<
  TData = Awaited<ReturnType<typeof getTeacherDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  teacherId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetails>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherDetailsQueryOptions(teacherId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Students table
 */
export const getStudents = (
  params?: GetStudentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PageStudentTableRowDto>({
    url: `/organization-admin/v2/students`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStudentsQueryKey = (params?: GetStudentsParams) => {
  return [
    `/organization-admin/v2/students`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStudentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudents>>> = ({
    signal,
  }) => getStudents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudents>>
>;
export type GetStudentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudents<
  TData = Awaited<ReturnType<typeof getStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetStudentsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudents>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudents<
  TData = Awaited<ReturnType<typeof getStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudents>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudents<
  TData = Awaited<ReturnType<typeof getStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Students table
 */

export function useGetStudents<
  TData = Awaited<ReturnType<typeof getStudents>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Student details with assignments and interactive materials analytics
 */
export const getStudentDetails = (studentId: number, signal?: AbortSignal) => {
  return configureAxios<StudentDetailsDto>({
    url: `/organization-admin/v2/students/${studentId}/details`,
    method: "GET",
    signal,
  });
};

export const getGetStudentDetailsQueryKey = (studentId: number) => {
  return [`/organization-admin/v2/students/${studentId}/details`] as const;
};

export const getGetStudentDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetails>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentDetailsQueryKey(studentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentDetails>>
  > = ({ signal }) => getStudentDetails(studentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentDetails>>
>;
export type GetStudentDetailsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudentDetails<
  TData = Awaited<ReturnType<typeof getStudentDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentDetails<
  TData = Awaited<ReturnType<typeof getStudentDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentDetails<
  TData = Awaited<ReturnType<typeof getStudentDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetails>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Student details with assignments and interactive materials analytics
 */

export function useGetStudentDetails<
  TData = Awaited<ReturnType<typeof getStudentDetails>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentDetails>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentDetailsQueryOptions(studentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generic KPIs for school
 */
export const getGeneric = (signal?: AbortSignal) => {
  return configureAxios<GenericDataDto>({
    url: `/organization-admin/v2/generic-data`,
    method: "GET",
    signal,
  });
};

export const getGetGenericQueryKey = () => {
  return [`/organization-admin/v2/generic-data`] as const;
};

export const getGetGenericQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneric>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGeneric>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGenericQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneric>>> = ({
    signal,
  }) => getGeneric(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneric>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGenericQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneric>>
>;
export type GetGenericQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetGeneric<
  TData = Awaited<ReturnType<typeof getGeneric>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGeneric>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGeneric>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGeneric<
  TData = Awaited<ReturnType<typeof getGeneric>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGeneric>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGeneric>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGeneric<
  TData = Awaited<ReturnType<typeof getGeneric>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGeneric>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Generic KPIs for school
 */

export function useGetGeneric<
  TData = Awaited<ReturnType<typeof getGeneric>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getGeneric>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetGenericQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeacher = (id: number, signal?: AbortSignal) => {
  return configureAxios<TeacherResponseDto>({
    url: `/organization-admin/teachers/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTeacherQueryKey = (id: number) => {
  return [`/organization-admin/teachers/${id}`] as const;
};

export const getGetTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeacherQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeacher>>> = ({
    signal,
  }) => getTeacher(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacher>>
>;
export type GetTeacherQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacher<
  TData = Awaited<ReturnType<typeof getTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacher<
  TData = Awaited<ReturnType<typeof getTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacher<
  TData = Awaited<ReturnType<typeof getTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacher<
  TData = Awaited<ReturnType<typeof getTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeacherDetail = (
  id: number,
  params?: GetTeacherDetailParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherDetailResponseDto>({
    url: `/organization-admin/teachers/${id}/detail`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherDetailQueryKey = (
  id: number,
  params?: GetTeacherDetailParams,
) => {
  return [
    `/organization-admin/teachers/${id}/detail`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeacherDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetTeacherDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetail>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherDetailQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherDetail>>
  > = ({ signal }) => getTeacherDetail(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherDetail>>
>;
export type GetTeacherDetailQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherDetail<
  TData = Awaited<ReturnType<typeof getTeacherDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | GetTeacherDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherDetail<
  TData = Awaited<ReturnType<typeof getTeacherDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetTeacherDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherDetail<
  TData = Awaited<ReturnType<typeof getTeacherDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetTeacherDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeacherDetail<
  TData = Awaited<ReturnType<typeof getTeacherDetail>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetTeacherDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherDetail>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherDetailQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentsOfTeacher = (
  id: number,
  params?: GetAssignmentsOfTeacherParams,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseAssignmentResponseDto[]>({
    url: `/organization-admin/teachers/${id}/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentsOfTeacherQueryKey = (
  id: number,
  params?: GetAssignmentsOfTeacherParams,
) => {
  return [
    `/organization-admin/teachers/${id}/assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentsOfTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentsOfTeacherQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentsOfTeacher>>
  > = ({ signal }) => getAssignmentsOfTeacher(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentsOfTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentsOfTeacher>>
>;
export type GetAssignmentsOfTeacherQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentsOfTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | GetAssignmentsOfTeacherParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentsOfTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentsOfTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentsOfTeacher<
  TData = Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfTeacherParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfTeacher>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentsOfTeacherQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeachersWithFiltersForAdminApp = (
  params: GetTeachersWithFiltersForAdminAppParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedTeacherResponseDto>({
    url: `/organization-admin/teachers-with-filters`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeachersWithFiltersForAdminAppQueryKey = (
  params: GetTeachersWithFiltersForAdminAppParams,
) => {
  return [
    `/organization-admin/teachers-with-filters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeachersWithFiltersForAdminAppQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetTeachersWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTeachersWithFiltersForAdminAppQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>
  > = ({ signal }) => getTeachersWithFiltersForAdminApp(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeachersWithFiltersForAdminAppQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>
>;
export type GetTeachersWithFiltersForAdminAppQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTeachersWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetTeachersWithFiltersForAdminAppParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeachersWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetTeachersWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeachersWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetTeachersWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeachersWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetTeachersWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeachersWithFiltersForAdminApp>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeachersWithFiltersForAdminAppQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudent = (studentId: number, signal?: AbortSignal) => {
  return configureAxios<StudentResponseDto>({
    url: `/organization-admin/students/${studentId}`,
    method: "GET",
    signal,
  });
};

export const getGetStudentQueryKey = (studentId: number) => {
  return [`/organization-admin/students/${studentId}`] as const;
};

export const getGetStudentQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudentQueryKey(studentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudent>>> = ({
    signal,
  }) => getStudent(studentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudent>>
>;
export type GetStudentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudent<
  TData = Awaited<ReturnType<typeof getStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudent<
  TData = Awaited<ReturnType<typeof getStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudent<
  TData = Awaited<ReturnType<typeof getStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudent<
  TData = Awaited<ReturnType<typeof getStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentQueryOptions(studentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentsOfStudentFromOrganizationAdmin = (
  studentId: number,
  params?: GetAssignmentsOfStudentFromOrganizationAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListStudentAssignmentsResponseDto>({
    url: `/organization-admin/students/${studentId}/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentsOfStudentFromOrganizationAdminQueryKey = (
  studentId: number,
  params?: GetAssignmentsOfStudentFromOrganizationAdminParams,
) => {
  return [
    `/organization-admin/students/${studentId}/assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentsOfStudentFromOrganizationAdminQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromOrganizationAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssignmentsOfStudentFromOrganizationAdminQueryKey(studentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>>
  > = ({ signal }) =>
    getAssignmentsOfStudentFromOrganizationAdmin(studentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!studentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentsOfStudentFromOrganizationAdminQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>>
  >;
export type GetAssignmentsOfStudentFromOrganizationAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentsOfStudentFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params: undefined | GetAssignmentsOfStudentFromOrganizationAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentsOfStudentFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromOrganizationAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentsOfStudentFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromOrganizationAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentsOfStudentFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  params?: GetAssignmentsOfStudentFromOrganizationAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAssignmentsOfStudentFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAssignmentsOfStudentFromOrganizationAdminQueryOptions(
      studentId,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get assignment detail of student including questions and answers etc.
 * @summary Get assignment of student
 */
export const getStudentAssignmentDetailFromOrganizationAdmin = (
  studentId: number,
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<StudentAssignmentDetailTeacherPerspectiveResponseDto>({
    url: `/organization-admin/students/${studentId}/assignments/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetStudentAssignmentDetailFromOrganizationAdminQueryKey = (
  studentId: number,
  assignmentId: number,
) => {
  return [
    `/organization-admin/students/${studentId}/assignments/${assignmentId}`,
  ] as const;
};

export const getGetStudentAssignmentDetailFromOrganizationAdminQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentAssignmentDetailFromOrganizationAdminQueryKey(
      studentId,
      assignmentId,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>>
  > = ({ signal }) =>
    getStudentAssignmentDetailFromOrganizationAdmin(
      studentId,
      assignmentId,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(studentId && assignmentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentAssignmentDetailFromOrganizationAdminQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>>
  >;
export type GetStudentAssignmentDetailFromOrganizationAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentAssignmentDetailFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentAssignmentDetailFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
          >,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentAssignmentDetailFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get assignment of student
 */

export function useGetStudentAssignmentDetailFromOrganizationAdmin<
  TData = Awaited<
    ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
  >,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  studentId: number,
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getStudentAssignmentDetailFromOrganizationAdmin>
        >,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetStudentAssignmentDetailFromOrganizationAdminQueryOptions(
      studentId,
      assignmentId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentsOfStudent = (
  id: number,
  params?: GetAssignmentsOfStudentParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListStudentAssignmentsResponseDto>({
    url: `/organization-admin/students/${id}/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentsOfStudentQueryKey = (
  id: number,
  params?: GetAssignmentsOfStudentParams,
) => {
  return [
    `/organization-admin/students/${id}/assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentsOfStudentQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssignmentsOfStudentQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentsOfStudent>>
  > = ({ signal }) => getAssignmentsOfStudent(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentsOfStudentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentsOfStudent>>
>;
export type GetAssignmentsOfStudentQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentsOfStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | GetAssignmentsOfStudentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentsOfStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentsOfStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentsOfStudent<
  TData = Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetAssignmentsOfStudentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentsOfStudent>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentsOfStudentQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentsGenericFilteredAdmin = (
  params?: GetStudentsGenericFilteredAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PageStudentResponseDto>({
    url: `/organization-admin/students/generic`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStudentsGenericFilteredAdminQueryKey = (
  params?: GetStudentsGenericFilteredAdminParams,
) => {
  return [
    `/organization-admin/students/generic`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStudentsGenericFilteredAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStudentsGenericFilteredAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>
  > = ({ signal }) => getStudentsGenericFilteredAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentsGenericFilteredAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>
>;
export type GetStudentsGenericFilteredAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentsGenericFilteredAdmin<
  TData = Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetStudentsGenericFilteredAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentsGenericFilteredAdmin<
  TData = Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentsGenericFilteredAdmin<
  TData = Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentsGenericFilteredAdmin<
  TData = Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetStudentsGenericFilteredAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsGenericFilteredAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentsGenericFilteredAdminQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudentsFilteredForAdminApp = (
  params: GetStudentsFilteredForAdminAppParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PageStudentResponseDto>({
    url: `/organization-admin/students-with-filters`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStudentsFilteredForAdminAppQueryKey = (
  params: GetStudentsFilteredForAdminAppParams,
) => {
  return [
    `/organization-admin/students-with-filters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStudentsFilteredForAdminAppQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetStudentsFilteredForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudentsFilteredForAdminAppQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>
  > = ({ signal }) => getStudentsFilteredForAdminApp(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudentsFilteredForAdminAppQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>
>;
export type GetStudentsFilteredForAdminAppQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetStudentsFilteredForAdminApp<
  TData = Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetStudentsFilteredForAdminAppParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudentsFilteredForAdminApp<
  TData = Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetStudentsFilteredForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudentsFilteredForAdminApp<
  TData = Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetStudentsFilteredForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudentsFilteredForAdminApp<
  TData = Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetStudentsFilteredForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudentsFilteredForAdminApp>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudentsFilteredForAdminAppQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserGradeDistribution = (
  params?: GetUserGradeDistributionParams,
  signal?: AbortSignal,
) => {
  return configureAxios<UserGradeDistributionDto[]>({
    url: `/organization-admin/statistics/users/grade-distribution`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserGradeDistributionQueryKey = (
  params?: GetUserGradeDistributionParams,
) => {
  return [
    `/organization-admin/statistics/users/grade-distribution`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserGradeDistributionQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserGradeDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserGradeDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserGradeDistribution>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserGradeDistributionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserGradeDistribution>>
  > = ({ signal }) => getUserGradeDistribution(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserGradeDistribution>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserGradeDistributionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserGradeDistribution>>
>;
export type GetUserGradeDistributionQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserGradeDistribution<
  TData = Awaited<ReturnType<typeof getUserGradeDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserGradeDistributionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserGradeDistribution>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGradeDistribution>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserGradeDistribution<
  TData = Awaited<ReturnType<typeof getUserGradeDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserGradeDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserGradeDistribution>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGradeDistribution>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserGradeDistribution<
  TData = Awaited<ReturnType<typeof getUserGradeDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserGradeDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserGradeDistribution>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserGradeDistribution<
  TData = Awaited<ReturnType<typeof getUserGradeDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserGradeDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserGradeDistribution>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserGradeDistributionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getActiveUserMetrics = (
  params?: GetActiveUserMetricsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ActiveStudentMetrics>({
    url: `/organization-admin/statistics/users/active-metrics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetActiveUserMetricsQueryKey = (
  params?: GetActiveUserMetricsParams,
) => {
  return [
    `/organization-admin/statistics/users/active-metrics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetActiveUserMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveUserMetrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetActiveUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveUserMetrics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActiveUserMetricsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveUserMetrics>>
  > = ({ signal }) => getActiveUserMetrics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveUserMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetActiveUserMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveUserMetrics>>
>;
export type GetActiveUserMetricsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetActiveUserMetrics<
  TData = Awaited<ReturnType<typeof getActiveUserMetrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetActiveUserMetricsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveUserMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveUserMetrics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetActiveUserMetrics<
  TData = Awaited<ReturnType<typeof getActiveUserMetrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetActiveUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveUserMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveUserMetrics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveUserMetrics<
  TData = Awaited<ReturnType<typeof getActiveUserMetrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetActiveUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveUserMetrics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetActiveUserMetrics<
  TData = Awaited<ReturnType<typeof getActiveUserMetrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetActiveUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveUserMetrics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetActiveUserMetricsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const getToolCountPerUserCount = (
  params?: GetToolCountPerUserCountParams,
  signal?: AbortSignal,
) => {
  return configureAxios<UserTeacherToolUsageMetrics[]>({
    url: `/organization-admin/statistics/teacher-tools/user-teacher-tool-usage`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetToolCountPerUserCountQueryKey = (
  params?: GetToolCountPerUserCountParams,
) => {
  return [
    `/organization-admin/statistics/teacher-tools/user-teacher-tool-usage`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetToolCountPerUserCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getToolCountPerUserCount>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerUserCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerUserCount>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetToolCountPerUserCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getToolCountPerUserCount>>
  > = ({ signal }) => getToolCountPerUserCount(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getToolCountPerUserCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetToolCountPerUserCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getToolCountPerUserCount>>
>;
export type GetToolCountPerUserCountQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetToolCountPerUserCount<
  TData = Awaited<ReturnType<typeof getToolCountPerUserCount>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetToolCountPerUserCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerUserCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolCountPerUserCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetToolCountPerUserCount<
  TData = Awaited<ReturnType<typeof getToolCountPerUserCount>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerUserCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerUserCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolCountPerUserCount>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetToolCountPerUserCount<
  TData = Awaited<ReturnType<typeof getToolCountPerUserCount>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerUserCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerUserCount>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useGetToolCountPerUserCount<
  TData = Awaited<ReturnType<typeof getToolCountPerUserCount>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerUserCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerUserCount>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetToolCountPerUserCountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns tool usage counts for users filtered by school using the inferred school type
 * @summary Get tool usage counts for specific users by school
 */
export const getToolUsageCountsForSpecificUsers = (
  params?: GetToolUsageCountsForSpecificUsersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ToolUsageMetric[]>({
    url: `/organization-admin/statistics/teacher-tools/tool-usage-by-school`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetToolUsageCountsForSpecificUsersQueryKey = (
  params?: GetToolUsageCountsForSpecificUsersParams,
) => {
  return [
    `/organization-admin/statistics/teacher-tools/tool-usage-by-school`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetToolUsageCountsForSpecificUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolUsageCountsForSpecificUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetToolUsageCountsForSpecificUsersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>
  > = ({ signal }) => getToolUsageCountsForSpecificUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetToolUsageCountsForSpecificUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>
>;
export type GetToolUsageCountsForSpecificUsersQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetToolUsageCountsForSpecificUsers<
  TData = Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetToolUsageCountsForSpecificUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetToolUsageCountsForSpecificUsers<
  TData = Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolUsageCountsForSpecificUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetToolUsageCountsForSpecificUsers<
  TData = Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolUsageCountsForSpecificUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get tool usage counts for specific users by school
 */

export function useGetToolUsageCountsForSpecificUsers<
  TData = Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolUsageCountsForSpecificUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolUsageCountsForSpecificUsers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetToolUsageCountsForSpecificUsersQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const getToolCountPerType = (
  params?: GetToolCountPerTypeParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherToolPerToolTypeMetrics[]>({
    url: `/organization-admin/statistics/teacher-tools/teacher-tool-type-metrics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetToolCountPerTypeQueryKey = (
  params?: GetToolCountPerTypeParams,
) => {
  return [
    `/organization-admin/statistics/teacher-tools/teacher-tool-type-metrics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetToolCountPerTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getToolCountPerType>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerType>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetToolCountPerTypeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getToolCountPerType>>
  > = ({ signal }) => getToolCountPerType(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getToolCountPerType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetToolCountPerTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getToolCountPerType>>
>;
export type GetToolCountPerTypeQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetToolCountPerType<
  TData = Awaited<ReturnType<typeof getToolCountPerType>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetToolCountPerTypeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerType>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolCountPerType>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetToolCountPerType<
  TData = Awaited<ReturnType<typeof getToolCountPerType>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerType>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolCountPerType>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetToolCountPerType<
  TData = Awaited<ReturnType<typeof getToolCountPerType>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerType>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useGetToolCountPerType<
  TData = Awaited<ReturnType<typeof getToolCountPerType>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerType>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetToolCountPerTypeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 */
export const getToolCountPerGrade = (
  params?: GetToolCountPerGradeParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherToolPerGradeMetrics[]>({
    url: `/organization-admin/statistics/teacher-tools/teacher-tool-grade-metrics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetToolCountPerGradeQueryKey = (
  params?: GetToolCountPerGradeParams,
) => {
  return [
    `/organization-admin/statistics/teacher-tools/teacher-tool-grade-metrics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetToolCountPerGradeQueryOptions = <
  TData = Awaited<ReturnType<typeof getToolCountPerGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerGrade>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetToolCountPerGradeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getToolCountPerGrade>>
  > = ({ signal }) => getToolCountPerGrade(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getToolCountPerGrade>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetToolCountPerGradeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getToolCountPerGrade>>
>;
export type GetToolCountPerGradeQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetToolCountPerGrade<
  TData = Awaited<ReturnType<typeof getToolCountPerGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetToolCountPerGradeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerGrade>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolCountPerGrade>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetToolCountPerGrade<
  TData = Awaited<ReturnType<typeof getToolCountPerGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerGrade>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToolCountPerGrade>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetToolCountPerGrade<
  TData = Awaited<ReturnType<typeof getToolCountPerGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerGrade>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 */

export function useGetToolCountPerGrade<
  TData = Awaited<ReturnType<typeof getToolCountPerGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetToolCountPerGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getToolCountPerGrade>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetToolCountPerGradeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get comprehensive statistics for Teacher Tools
 */
export const getTeacherToolsStatistics = (
  params?: GetTeacherToolsStatisticsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherToolsStatisticsResponseDto>({
    url: `/organization-admin/statistics/teacher-tools/statistics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherToolsStatisticsQueryKey = (
  params?: GetTeacherToolsStatisticsParams,
) => {
  return [
    `/organization-admin/statistics/teacher-tools/statistics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeacherToolsStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherToolsStatisticsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherToolsStatistics>>
  > = ({ signal }) => getTeacherToolsStatistics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherToolsStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherToolsStatistics>>
>;
export type GetTeacherToolsStatisticsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTeacherToolsStatistics<
  TData = Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeacherToolsStatisticsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherToolsStatistics<
  TData = Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherToolsStatistics<
  TData = Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get comprehensive statistics for Teacher Tools
 */

export function useGetTeacherToolsStatistics<
  TData = Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherToolsStatisticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherToolsStatistics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherToolsStatisticsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a user's top 4 grades based on their teacher tool usage within a specified time period
 * @summary Get user top 4 grades by tool usage
 */
export const getUserTop4Grades = (
  params: GetUserTop4GradesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<UserTopGradeDto[]>({
    url: `/organization-admin/statistics/teacher-activity/user-top-grades`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserTop4GradesQueryKey = (
  params: GetUserTop4GradesParams,
) => {
  return [
    `/organization-admin/statistics/teacher-activity/user-top-grades`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserTop4GradesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserTop4Grades>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetUserTop4GradesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTop4Grades>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserTop4GradesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserTop4Grades>>
  > = ({ signal }) => getUserTop4Grades(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserTop4Grades>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserTop4GradesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserTop4Grades>>
>;
export type GetUserTop4GradesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserTop4Grades<
  TData = Awaited<ReturnType<typeof getUserTop4Grades>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetUserTop4GradesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTop4Grades>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTop4Grades>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserTop4Grades<
  TData = Awaited<ReturnType<typeof getUserTop4Grades>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetUserTop4GradesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTop4Grades>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTop4Grades>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserTop4Grades<
  TData = Awaited<ReturnType<typeof getUserTop4Grades>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetUserTop4GradesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTop4Grades>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user top 4 grades by tool usage
 */

export function useGetUserTop4Grades<
  TData = Awaited<ReturnType<typeof getUserTop4Grades>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetUserTop4GradesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTop4Grades>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserTop4GradesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns daily count of unique active teachers for each day within a specified time range
 * @summary Get daily active teachers
 */
export const getDailyActiveTeachers = (
  params?: GetDailyActiveTeachersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<DailyActiveTeacherDto[]>({
    url: `/organization-admin/statistics/teacher-activity/daily-active-teachers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDailyActiveTeachersQueryKey = (
  params?: GetDailyActiveTeachersParams,
) => {
  return [
    `/organization-admin/statistics/teacher-activity/daily-active-teachers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDailyActiveTeachersQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyActiveTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyActiveTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyActiveTeachers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyActiveTeachersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyActiveTeachers>>
  > = ({ signal }) => getDailyActiveTeachers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyActiveTeachers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDailyActiveTeachersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyActiveTeachers>>
>;
export type GetDailyActiveTeachersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDailyActiveTeachers<
  TData = Awaited<ReturnType<typeof getDailyActiveTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetDailyActiveTeachersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyActiveTeachers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyActiveTeachers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDailyActiveTeachers<
  TData = Awaited<ReturnType<typeof getDailyActiveTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyActiveTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyActiveTeachers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyActiveTeachers>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDailyActiveTeachers<
  TData = Awaited<ReturnType<typeof getDailyActiveTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyActiveTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyActiveTeachers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get daily active teachers
 */

export function useGetDailyActiveTeachers<
  TData = Awaited<ReturnType<typeof getDailyActiveTeachers>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyActiveTeachersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyActiveTeachers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDailyActiveTeachersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns most active teachers within a specified time range with their activity counts and last activity time
 * @summary Get teacher activity summary
 */
export const getTeacherActivitySummary = (
  params?: GetTeacherActivitySummaryParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherActivitySummaryDto[]>({
    url: `/organization-admin/statistics/teacher-activity/activity-summary`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherActivitySummaryQueryKey = (
  params?: GetTeacherActivitySummaryParams,
) => {
  return [
    `/organization-admin/statistics/teacher-activity/activity-summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeacherActivitySummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherActivitySummary>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivitySummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherActivitySummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherActivitySummary>>
  > = ({ signal }) => getTeacherActivitySummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherActivitySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherActivitySummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherActivitySummary>>
>;
export type GetTeacherActivitySummaryQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTeacherActivitySummary<
  TData = Awaited<ReturnType<typeof getTeacherActivitySummary>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeacherActivitySummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivitySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherActivitySummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherActivitySummary<
  TData = Awaited<ReturnType<typeof getTeacherActivitySummary>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivitySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherActivitySummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherActivitySummary<
  TData = Awaited<ReturnType<typeof getTeacherActivitySummary>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivitySummary>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get teacher activity summary
 */

export function useGetTeacherActivitySummary<
  TData = Awaited<ReturnType<typeof getTeacherActivitySummary>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivitySummary>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherActivitySummaryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns detailed activity log for teachers within a specified time range including activity types and timestamps
 * @summary Get detailed teacher activity log
 */
export const getTeacherActivityLog = (
  params?: GetTeacherActivityLogParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TeacherActivityLogDto[]>({
    url: `/organization-admin/statistics/teacher-activity/activity-log`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTeacherActivityLogQueryKey = (
  params?: GetTeacherActivityLogParams,
) => {
  return [
    `/organization-admin/statistics/teacher-activity/activity-log`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTeacherActivityLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeacherActivityLog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivityLog>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeacherActivityLogQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeacherActivityLog>>
  > = ({ signal }) => getTeacherActivityLog(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeacherActivityLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeacherActivityLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeacherActivityLog>>
>;
export type GetTeacherActivityLogQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTeacherActivityLog<
  TData = Awaited<ReturnType<typeof getTeacherActivityLog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTeacherActivityLogParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivityLog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherActivityLog>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeacherActivityLog<
  TData = Awaited<ReturnType<typeof getTeacherActivityLog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivityLog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherActivityLog>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeacherActivityLog<
  TData = Awaited<ReturnType<typeof getTeacherActivityLog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivityLog>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get detailed teacher activity log
 */

export function useGetTeacherActivityLog<
  TData = Awaited<ReturnType<typeof getTeacherActivityLog>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTeacherActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeacherActivityLog>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeacherActivityLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuestionSolverCourseDistribution = (
  params?: GetQuestionSolverCourseDistributionParams,
  signal?: AbortSignal,
) => {
  return configureAxios<QuestionSolverCourseDistributionDto[]>({
    url: `/organization-admin/statistics/question-solver/course-distribution`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetQuestionSolverCourseDistributionQueryKey = (
  params?: GetQuestionSolverCourseDistributionParams,
) => {
  return [
    `/organization-admin/statistics/question-solver/course-distribution`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetQuestionSolverCourseDistributionQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverCourseDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetQuestionSolverCourseDistributionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>
  > = ({ signal }) => getQuestionSolverCourseDistribution(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionSolverCourseDistributionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>
>;
export type GetQuestionSolverCourseDistributionQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetQuestionSolverCourseDistribution<
  TData = Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetQuestionSolverCourseDistributionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionSolverCourseDistribution<
  TData = Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverCourseDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionSolverCourseDistribution<
  TData = Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverCourseDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionSolverCourseDistribution<
  TData = Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverCourseDistributionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverCourseDistribution>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionSolverCourseDistributionQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMessagesAverages = (
  params?: GetMessagesAveragesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<AverageMessageCountPerChat[]>({
    url: `/organization-admin/statistics/messages/average`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMessagesAveragesQueryKey = (
  params?: GetMessagesAveragesParams,
) => {
  return [
    `/organization-admin/statistics/messages/average`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMessagesAveragesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMessagesAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAverages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMessagesAveragesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMessagesAverages>>
  > = ({ signal }) => getMessagesAverages(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMessagesAverages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMessagesAveragesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMessagesAverages>>
>;
export type GetMessagesAveragesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMessagesAverages<
  TData = Awaited<ReturnType<typeof getMessagesAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMessagesAveragesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAverages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesAverages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMessagesAverages<
  TData = Awaited<ReturnType<typeof getMessagesAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAverages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesAverages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMessagesAverages<
  TData = Awaited<ReturnType<typeof getMessagesAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAverages>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMessagesAverages<
  TData = Awaited<ReturnType<typeof getMessagesAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAverages>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMessagesAveragesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMessageCountPerChat = (
  params?: GetMessageCountPerChatParams,
  signal?: AbortSignal,
) => {
  return configureAxios<MessageCountDistributionOfChats[]>({
    url: `/organization-admin/statistics/chats/msg-count-distribution`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMessageCountPerChatQueryKey = (
  params?: GetMessageCountPerChatParams,
) => {
  return [
    `/organization-admin/statistics/chats/msg-count-distribution`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMessageCountPerChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getMessageCountPerChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChat>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMessageCountPerChatQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMessageCountPerChat>>
  > = ({ signal }) => getMessageCountPerChat(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMessageCountPerChat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMessageCountPerChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMessageCountPerChat>>
>;
export type GetMessageCountPerChatQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMessageCountPerChat<
  TData = Awaited<ReturnType<typeof getMessageCountPerChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMessageCountPerChatParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessageCountPerChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMessageCountPerChat<
  TData = Awaited<ReturnType<typeof getMessageCountPerChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessageCountPerChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMessageCountPerChat<
  TData = Awaited<ReturnType<typeof getMessageCountPerChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMessageCountPerChat<
  TData = Awaited<ReturnType<typeof getMessageCountPerChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMessageCountPerChatQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMessageCountPerChatPerCourse = (
  params?: GetMessageCountPerChatPerCourseParams,
  signal?: AbortSignal,
) => {
  return configureAxios<MessageCountDistributionOfChatsPerCourse[]>({
    url: `/organization-admin/statistics/chats/msg-count-distribution-per-course`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMessageCountPerChatPerCourseQueryKey = (
  params?: GetMessageCountPerChatPerCourseParams,
) => {
  return [
    `/organization-admin/statistics/chats/msg-count-distribution-per-course`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMessageCountPerChatPerCourseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatPerCourseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMessageCountPerChatPerCourseQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>
  > = ({ signal }) => getMessageCountPerChatPerCourse(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMessageCountPerChatPerCourseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>
>;
export type GetMessageCountPerChatPerCourseQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetMessageCountPerChatPerCourse<
  TData = Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMessageCountPerChatPerCourseParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMessageCountPerChatPerCourse<
  TData = Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatPerCourseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMessageCountPerChatPerCourse<
  TData = Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatPerCourseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMessageCountPerChatPerCourse<
  TData = Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessageCountPerChatPerCourseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessageCountPerChatPerCourse>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMessageCountPerChatPerCourseQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCourseGradeDistributionOfChats = (
  params?: GetCourseGradeDistributionOfChatsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ChatsCourseGradeDistributionDto[]>({
    url: `/organization-admin/statistics/chats/course-grade-distribution`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCourseGradeDistributionOfChatsQueryKey = (
  params?: GetCourseGradeDistributionOfChatsParams,
) => {
  return [
    `/organization-admin/statistics/chats/course-grade-distribution`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCourseGradeDistributionOfChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetCourseGradeDistributionOfChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCourseGradeDistributionOfChatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>
  > = ({ signal }) => getCourseGradeDistributionOfChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCourseGradeDistributionOfChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>
>;
export type GetCourseGradeDistributionOfChatsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetCourseGradeDistributionOfChats<
  TData = Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetCourseGradeDistributionOfChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCourseGradeDistributionOfChats<
  TData = Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetCourseGradeDistributionOfChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCourseGradeDistributionOfChats<
  TData = Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetCourseGradeDistributionOfChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetCourseGradeDistributionOfChats<
  TData = Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetCourseGradeDistributionOfChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCourseGradeDistributionOfChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCourseGradeDistributionOfChatsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentCountByCourseTypeAndGrade = (
  params?: GetAssignmentCountByCourseTypeAndGradeParams,
  signal?: AbortSignal,
) => {
  return configureAxios<AssignmentCountByCourseTypeAndGrade[]>({
    url: `/organization-admin/statistics/assignments/count-grade-course`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentCountByCourseTypeAndGradeQueryKey = (
  params?: GetAssignmentCountByCourseTypeAndGradeParams,
) => {
  return [
    `/organization-admin/statistics/assignments/count-grade-course`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentCountByCourseTypeAndGradeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentCountByCourseTypeAndGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssignmentCountByCourseTypeAndGradeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>
  > = ({ signal }) => getAssignmentCountByCourseTypeAndGrade(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentCountByCourseTypeAndGradeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>
>;
export type GetAssignmentCountByCourseTypeAndGradeQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentCountByCourseTypeAndGrade<
  TData = Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAssignmentCountByCourseTypeAndGradeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentCountByCourseTypeAndGrade<
  TData = Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentCountByCourseTypeAndGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentCountByCourseTypeAndGrade<
  TData = Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentCountByCourseTypeAndGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentCountByCourseTypeAndGrade<
  TData = Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentCountByCourseTypeAndGradeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentCountByCourseTypeAndGrade>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentCountByCourseTypeAndGradeQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuestionSolverResponsesV2 = (
  params?: GetQuestionSolverResponsesV2Params,
  signal?: AbortSignal,
) => {
  return configureAxios<ListQuestionSolverV2ResponseDto>({
    url: `/organization-admin/question-solver-responses`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetQuestionSolverResponsesV2QueryKey = (
  params?: GetQuestionSolverResponsesV2Params,
) => {
  return [
    `/organization-admin/question-solver-responses`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetQuestionSolverResponsesV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverResponsesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionSolverResponsesV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>
  > = ({ signal }) => getQuestionSolverResponsesV2(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionSolverResponsesV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>
>;
export type GetQuestionSolverResponsesV2QueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetQuestionSolverResponsesV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetQuestionSolverResponsesV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionSolverResponsesV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverResponsesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionSolverResponsesV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverResponsesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionSolverResponsesV2<
  TData = Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverResponsesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverResponsesV2>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionSolverResponsesV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLoggedInAdmin = (signal?: AbortSignal) => {
  return configureAxios<OrganizationAdminResponseDto>({
    url: `/organization-admin/me`,
    method: "GET",
    signal,
  });
};

export const getGetLoggedInAdminQueryKey = () => {
  return [`/organization-admin/me`] as const;
};

export const getGetLoggedInAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoggedInAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoggedInAdmin>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoggedInAdminQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoggedInAdmin>>
  > = ({ signal }) => getLoggedInAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoggedInAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLoggedInAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoggedInAdmin>>
>;
export type GetLoggedInAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLoggedInAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoggedInAdmin>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedInAdmin>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLoggedInAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoggedInAdmin>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedInAdmin>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLoggedInAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoggedInAdmin>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLoggedInAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoggedInAdmin>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLoggedInAdminQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLessonPlannersAdmin = (
  params?: GetLessonPlannersAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListLessonPlannerV2ResponseDto>({
    url: `/organization-admin/lesson-planners`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetLessonPlannersAdminQueryKey = (
  params?: GetLessonPlannersAdminParams,
) => {
  return [
    `/organization-admin/lesson-planners`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetLessonPlannersAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLessonPlannersAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLessonPlannersAdmin>>
  > = ({ signal }) => getLessonPlannersAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLessonPlannersAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLessonPlannersAdmin>>
>;
export type GetLessonPlannersAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetLessonPlannersAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLessonPlannersAdmin<
  TData = Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLessonPlannersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLessonPlannersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLessonPlannersAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getInteractiveMaterials = (
  params?: GetInteractiveMaterialsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListInteractiveMaterialResponseDto>({
    url: `/organization-admin/interactive-materials`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetInteractiveMaterialsQueryKey = (
  params?: GetInteractiveMaterialsParams,
) => {
  return [
    `/organization-admin/interactive-materials`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInteractiveMaterialsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInteractiveMaterialsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInteractiveMaterials>>
  > = ({ signal }) => getInteractiveMaterials(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInteractiveMaterials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetInteractiveMaterialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInteractiveMaterials>>
>;
export type GetInteractiveMaterialsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetInteractiveMaterialsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInteractiveMaterials>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetInteractiveMaterials<
  TData = Awaited<ReturnType<typeof getInteractiveMaterials>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetInteractiveMaterialsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterials>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetInteractiveMaterialsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAdminAppFilters = (
  params: GetAdminAppFiltersParams,
  signal?: AbortSignal,
) => {
  return configureAxios<FilterResponseDto>({
    url: `/organization-admin/filters`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAdminAppFiltersQueryKey = (
  params: GetAdminAppFiltersParams,
) => {
  return [`/organization-admin/filters`, ...(params ? [params] : [])] as const;
};

export const getGetAdminAppFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminAppFilters>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetAdminAppFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminAppFilters>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminAppFiltersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminAppFilters>>
  > = ({ signal }) => getAdminAppFilters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAppFilters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAdminAppFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminAppFilters>>
>;
export type GetAdminAppFiltersQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAdminAppFilters<
  TData = Awaited<ReturnType<typeof getAdminAppFilters>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetAdminAppFiltersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminAppFilters>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAppFilters>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAdminAppFilters<
  TData = Awaited<ReturnType<typeof getAdminAppFilters>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetAdminAppFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminAppFilters>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAppFilters>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminAppFilters<
  TData = Awaited<ReturnType<typeof getAdminAppFilters>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetAdminAppFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminAppFilters>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAdminAppFilters<
  TData = Awaited<ReturnType<typeof getAdminAppFilters>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetAdminAppFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminAppFilters>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAdminAppFiltersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getEssayGradersAdmin = (
  params?: GetEssayGradersAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListEssayGradingSubSingleResultDto>({
    url: `/organization-admin/essay-graders`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetEssayGradersAdminQueryKey = (
  params?: GetEssayGradersAdminParams,
) => {
  return [
    `/organization-admin/essay-graders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEssayGradersAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getEssayGradersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGradersAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEssayGradersAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEssayGradersAdmin>>
  > = ({ signal }) => getEssayGradersAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEssayGradersAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEssayGradersAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEssayGradersAdmin>>
>;
export type GetEssayGradersAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetEssayGradersAdmin<
  TData = Awaited<ReturnType<typeof getEssayGradersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetEssayGradersAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGradersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayGradersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEssayGradersAdmin<
  TData = Awaited<ReturnType<typeof getEssayGradersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGradersAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayGradersAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEssayGradersAdmin<
  TData = Awaited<ReturnType<typeof getEssayGradersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGradersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetEssayGradersAdmin<
  TData = Awaited<ReturnType<typeof getEssayGradersAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetEssayGradersAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEssayGradersAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEssayGradersAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDashboardData = (
  params: GetDashboardDataParams,
  signal?: AbortSignal,
) => {
  return configureAxios<DashboardDto>({
    url: `/organization-admin/dashboard`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDashboardDataQueryKey = (params: GetDashboardDataParams) => {
  return [
    `/organization-admin/dashboard`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDashboardDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardData>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDashboardDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardData>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardDataQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardData>>
  > = ({ signal }) => getDashboardData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDashboardDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardData>>
>;
export type GetDashboardDataQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDashboardData<
  TData = Awaited<ReturnType<typeof getDashboardData>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDashboardDataParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardData>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardData>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDashboardData<
  TData = Awaited<ReturnType<typeof getDashboardData>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDashboardDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardData>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardData>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardData<
  TData = Awaited<ReturnType<typeof getDashboardData>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDashboardDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardData>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDashboardData<
  TData = Awaited<ReturnType<typeof getDashboardData>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDashboardDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardData>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDashboardDataQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDailyAssignments = (
  params?: GetDailyAssignmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<DailyAssignmentsResponseDto[]>({
    url: `/organization-admin/daily-assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDailyAssignmentsQueryKey = (
  params?: GetDailyAssignmentsParams,
) => {
  return [
    `/organization-admin/daily-assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDailyAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyAssignments>>
  > = ({ signal }) => getDailyAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDailyAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyAssignments>>
>;
export type GetDailyAssignmentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDailyAssignments<
  TData = Awaited<ReturnType<typeof getDailyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetDailyAssignmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDailyAssignments<
  TData = Awaited<ReturnType<typeof getDailyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDailyAssignments<
  TData = Awaited<ReturnType<typeof getDailyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDailyAssignments<
  TData = Awaited<ReturnType<typeof getDailyAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDailyAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDailyAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassroomFromOrganizationAdmin = (
  classroomId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<ClassroomWithoutStudentDetailResponseDto>({
    url: `/organization-admin/classrooms/${classroomId}`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomFromOrganizationAdminQueryKey = (
  classroomId: number,
) => {
  return [`/organization-admin/classrooms/${classroomId}`] as const;
};

export const getGetClassroomFromOrganizationAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomFromOrganizationAdminQueryKey(classroomId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>
  > = ({ signal }) => getClassroomFromOrganizationAdmin(classroomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomFromOrganizationAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>
>;
export type GetClassroomFromOrganizationAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomFromOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomFromOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomFromOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomFromOrganizationAdmin<
  TData = Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomFromOrganizationAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomFromOrganizationAdminQueryOptions(
    classroomId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get classrooms of organization. You can filter with respect to grade and courseType. Does not contain students and their assignments.
 * @summary Get classrooms detailed
 */
export const getClassroomsDetailedAdmin = (
  params?: GetClassroomsDetailedAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedClassroomResponseDto>({
    url: `/organization-admin/classrooms/detail`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomsDetailedAdminQueryKey = (
  params?: GetClassroomsDetailedAdminParams,
) => {
  return [
    `/organization-admin/classrooms/detail`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomsDetailedAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassroomsDetailedAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>
  > = ({ signal }) => getClassroomsDetailedAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomsDetailedAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>
>;
export type GetClassroomsDetailedAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomsDetailedAdmin<
  TData = Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetClassroomsDetailedAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomsDetailedAdmin<
  TData = Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomsDetailedAdmin<
  TData = Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classrooms detailed
 */

export function useGetClassroomsDetailedAdmin<
  TData = Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetClassroomsDetailedAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsDetailedAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomsDetailedAdminQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get classrooms of organization. You can filter with respect to grade and courseType. Does not contain students and their assignments.
 * @summary Get classrooms
 */
export const getClassroomsWithFiltersForAdminApp = (
  params: GetClassroomsWithFiltersForAdminAppParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedClassroomResponseDto>({
    url: `/organization-admin/classrooms-with-filters`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetClassroomsWithFiltersForAdminAppQueryKey = (
  params: GetClassroomsWithFiltersForAdminAppParams,
) => {
  return [
    `/organization-admin/classrooms-with-filters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassroomsWithFiltersForAdminAppQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetClassroomsWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassroomsWithFiltersForAdminAppQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>
  > = ({ signal }) => getClassroomsWithFiltersForAdminApp(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomsWithFiltersForAdminAppQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>
>;
export type GetClassroomsWithFiltersForAdminAppQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetClassroomsWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetClassroomsWithFiltersForAdminAppParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomsWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetClassroomsWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomsWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetClassroomsWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get classrooms
 */

export function useGetClassroomsWithFiltersForAdminApp<
  TData = Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetClassroomsWithFiltersForAdminAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassroomsWithFiltersForAdminApp>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomsWithFiltersForAdminAppQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getChatsAdmin = (
  params?: GetChatsAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatResponseDto>({
    url: `/organization-admin/chats`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetChatsAdminQueryKey = (params?: GetChatsAdminParams) => {
  return [`/organization-admin/chats`, ...(params ? [params] : [])] as const;
};

export const getGetChatsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatsAdmin>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatsAdminQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatsAdmin>>> = ({
    signal,
  }) => getChatsAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetChatsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatsAdmin>>
>;
export type GetChatsAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetChatsAdmin<
  TData = Awaited<ReturnType<typeof getChatsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetChatsAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatsAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatsAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChatsAdmin<
  TData = Awaited<ReturnType<typeof getChatsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatsAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatsAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChatsAdmin<
  TData = Awaited<ReturnType<typeof getChatsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatsAdmin>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetChatsAdmin<
  TData = Awaited<ReturnType<typeof getChatsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatsAdmin>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetChatsAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMessagesAdmin = (
  params?: GetMessagesAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatMessagesResponseDto>({
    url: `/organization-admin/chats/messages`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMessagesAdminQueryKey = (
  params?: GetMessagesAdminParams,
) => {
  return [
    `/organization-admin/chats/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMessagesAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getMessagesAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMessagesAdminQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMessagesAdmin>>
  > = ({ signal }) => getMessagesAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMessagesAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMessagesAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMessagesAdmin>>
>;
export type GetMessagesAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMessagesAdmin<
  TData = Awaited<ReturnType<typeof getMessagesAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMessagesAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMessagesAdmin<
  TData = Awaited<ReturnType<typeof getMessagesAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMessagesAdmin<
  TData = Awaited<ReturnType<typeof getMessagesAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMessagesAdmin<
  TData = Awaited<ReturnType<typeof getMessagesAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMessagesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMessagesAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMessagesAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const countChatsWithMessagesGreaterThanN = (
  params?: CountChatsWithMessagesGreaterThanNParams,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseChatDto[]>({
    url: `/organization-admin/chats/count`,
    method: "GET",
    params,
    signal,
  });
};

export const getCountChatsWithMessagesGreaterThanNQueryKey = (
  params?: CountChatsWithMessagesGreaterThanNParams,
) => {
  return [
    `/organization-admin/chats/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountChatsWithMessagesGreaterThanNQueryOptions = <
  TData = Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: CountChatsWithMessagesGreaterThanNParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountChatsWithMessagesGreaterThanNQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>
  > = ({ signal }) => countChatsWithMessagesGreaterThanN(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CountChatsWithMessagesGreaterThanNQueryResult = NonNullable<
  Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>
>;
export type CountChatsWithMessagesGreaterThanNQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useCountChatsWithMessagesGreaterThanN<
  TData = Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | CountChatsWithMessagesGreaterThanNParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCountChatsWithMessagesGreaterThanN<
  TData = Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: CountChatsWithMessagesGreaterThanNParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCountChatsWithMessagesGreaterThanN<
  TData = Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: CountChatsWithMessagesGreaterThanNParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useCountChatsWithMessagesGreaterThanN<
  TData = Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: CountChatsWithMessagesGreaterThanNParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countChatsWithMessagesGreaterThanN>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCountChatsWithMessagesGreaterThanNQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignments = (
  params?: GetAssignmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedBaseAssignmentsResponseDto>({
    url: `/organization-admin/assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssignmentsQueryKey = (params?: GetAssignmentsParams) => {
  return [
    `/organization-admin/assignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignments>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssignmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignments>>> = ({
    signal,
  }) => getAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignments>>
>;
export type GetAssignmentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAssignments<
  TData = Awaited<ReturnType<typeof getAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAssignmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignments<
  TData = Awaited<ReturnType<typeof getAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignments<
  TData = Awaited<ReturnType<typeof getAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignments>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignments<
  TData = Awaited<ReturnType<typeof getAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssignments>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAssignmentFromOrgAdmin = (
  assignmentId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<BaseAssignmentResponseDto>({
    url: `/organization-admin/assignments/${assignmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetAssignmentFromOrgAdminQueryKey = (assignmentId: number) => {
  return [`/organization-admin/assignments/${assignmentId}`] as const;
};

export const getGetAssignmentFromOrgAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssignmentFromOrgAdminQueryKey(assignmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>
  > = ({ signal }) => getAssignmentFromOrgAdmin(assignmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAssignmentFromOrgAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>
>;
export type GetAssignmentFromOrgAdminQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAssignmentFromOrgAdmin<
  TData = Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAssignmentFromOrgAdmin<
  TData = Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAssignmentFromOrgAdmin<
  TData = Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAssignmentFromOrgAdmin<
  TData = Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssignmentFromOrgAdmin>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAssignmentFromOrgAdminQueryOptions(
    assignmentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteAssignmentsFromOrganizationAdmin = (
  assignmentId: number,
) => {
  return configureAxios<void>({
    url: `/organization-admin/assignments/${assignmentId}`,
    method: "DELETE",
  });
};

export const getDeleteAssignmentsFromOrganizationAdminMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssignmentsFromOrganizationAdmin>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAssignmentsFromOrganizationAdmin>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAssignmentsFromOrganizationAdmin>>,
    { assignmentId: number }
  > = (props) => {
    const { assignmentId } = props ?? {};

    return deleteAssignmentsFromOrganizationAdmin(assignmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssignmentsFromOrganizationAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssignmentsFromOrganizationAdmin>>
>;

export type DeleteAssignmentsFromOrganizationAdminMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useDeleteAssignmentsFromOrganizationAdmin = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssignmentsFromOrganizationAdmin>>,
    TError,
    { assignmentId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAssignmentsFromOrganizationAdmin>>,
  TError,
  { assignmentId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteAssignmentsFromOrganizationAdminMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getOrganization = (orgId: number, signal?: AbortSignal) => {
  return configureAxios<BaseOrganizationDTO>({
    url: `/org/${orgId}`,
    method: "GET",
    signal,
  });
};

export const getGetOrganizationQueryKey = (orgId: number) => {
  return [`/org/${orgId}`] as const;
};

export const getGetOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
    signal,
  }) => getOrganization(orgId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!orgId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  orgId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrganizationQueryOptions(orgId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all notifications for the user
 * @summary Get Notifications
 */
export const getNotifications = (
  params?: GetNotificationsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListNotificationsResponseDto>({
    url: `/notifications`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetNotificationsQueryKey = (
  params?: GetNotificationsParams,
) => {
  return [`/notifications`, ...(params ? [params] : [])] as const;
};

export const getGetNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotifications>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotifications>>
  > = ({ signal }) => getNotifications(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotifications>>
>;
export type GetNotificationsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetNotificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotifications>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Notifications
 */

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotifications>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all unread notifications for the user
 * @summary Get unread Notifications
 */
export const getUnreadNotifications = (
  params?: GetUnreadNotificationsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListNotificationsResponseDto>({
    url: `/notifications/unread`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUnreadNotificationsQueryKey = (
  params?: GetUnreadNotificationsParams,
) => {
  return [`/notifications/unread`, ...(params ? [params] : [])] as const;
};

export const getGetUnreadNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnreadNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnreadNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnreadNotifications>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUnreadNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUnreadNotifications>>
  > = ({ signal }) => getUnreadNotifications(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnreadNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUnreadNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnreadNotifications>>
>;
export type GetUnreadNotificationsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUnreadNotifications<
  TData = Awaited<ReturnType<typeof getUnreadNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUnreadNotificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnreadNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadNotifications>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUnreadNotifications<
  TData = Awaited<ReturnType<typeof getUnreadNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnreadNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnreadNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadNotifications>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUnreadNotifications<
  TData = Awaited<ReturnType<typeof getUnreadNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnreadNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnreadNotifications>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get unread Notifications
 */

export function useGetUnreadNotifications<
  TData = Awaited<ReturnType<typeof getUnreadNotifications>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUnreadNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnreadNotifications>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUnreadNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopMindmapGenerators = (
  params?: GetTopMindmapGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListMindmapGeneratorResponseDto>({
    url: `/mindmap-generator/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopMindmapGeneratorsQueryKey = (
  params?: GetTopMindmapGeneratorsParams,
) => {
  return [`/mindmap-generator/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopMindmapGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopMindmapGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopMindmapGenerators>>
  > = ({ signal }) => getTopMindmapGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopMindmapGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopMindmapGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopMindmapGenerators>>
>;
export type GetTopMindmapGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopMindmapGenerators<
  TData = Awaited<ReturnType<typeof getTopMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopMindmapGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopMindmapGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopMindmapGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopMindmapGenerators<
  TData = Awaited<ReturnType<typeof getTopMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopMindmapGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopMindmapGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopMindmapGenerators<
  TData = Awaited<ReturnType<typeof getTopMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopMindmapGenerators<
  TData = Awaited<ReturnType<typeof getTopMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopMindmapGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentMindmapGenerators = (
  params?: GetRecentMindmapGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListMindmapGeneratorResponseDto>({
    url: `/mindmap-generator/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentMindmapGeneratorsQueryKey = (
  params?: GetRecentMindmapGeneratorsParams,
) => {
  return [`/mindmap-generator/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentMindmapGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentMindmapGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentMindmapGenerators>>
  > = ({ signal }) => getRecentMindmapGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentMindmapGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentMindmapGenerators>>
>;
export type GetRecentMindmapGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentMindmapGenerators<
  TData = Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentMindmapGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentMindmapGenerators<
  TData = Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentMindmapGenerators<
  TData = Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentMindmapGenerators<
  TData = Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentMindmapGeneratorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserMindmapGenerators = (
  params?: GetUserMindmapGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListMindmapGeneratorResponseDto>({
    url: `/mindmap-generator/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserMindmapGeneratorsQueryKey = (
  params?: GetUserMindmapGeneratorsParams,
) => {
  return [`/mindmap-generator/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserMindmapGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserMindmapGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserMindmapGenerators>>
  > = ({ signal }) => getUserMindmapGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserMindmapGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserMindmapGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserMindmapGenerators>>
>;
export type GetUserMindmapGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserMindmapGenerators<
  TData = Awaited<ReturnType<typeof getUserMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserMindmapGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserMindmapGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMindmapGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserMindmapGenerators<
  TData = Awaited<ReturnType<typeof getUserMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserMindmapGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMindmapGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserMindmapGenerators<
  TData = Awaited<ReturnType<typeof getUserMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserMindmapGenerators<
  TData = Awaited<ReturnType<typeof getUserMindmapGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserMindmapGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserMindmapGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserMindmapGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTokenUsages = (
  params?: GetTokenUsagesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTokenUsageDetailedResponseDto>({
    url: `/madlen-admin/token-usages`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTokenUsagesQueryKey = (params?: GetTokenUsagesParams) => {
  return [`/madlen-admin/token-usages`, ...(params ? [params] : [])] as const;
};

export const getGetTokenUsagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTokenUsages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTokenUsages>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTokenUsagesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTokenUsages>>> = ({
    signal,
  }) => getTokenUsages(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTokenUsages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTokenUsagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTokenUsages>>
>;
export type GetTokenUsagesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTokenUsages<
  TData = Awaited<ReturnType<typeof getTokenUsages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTokenUsagesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTokenUsages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTokenUsages<
  TData = Awaited<ReturnType<typeof getTokenUsages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTokenUsages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTokenUsages<
  TData = Awaited<ReturnType<typeof getTokenUsages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTokenUsages>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTokenUsages<
  TData = Awaited<ReturnType<typeof getTokenUsages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTokenUsages>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTokenUsagesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTokenUsagesPerUser = (
  params?: GetTokenUsagesPerUserParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTokenUsagePerUserResponseDto>({
    url: `/madlen-admin/token-usages/per-user`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTokenUsagesPerUserQueryKey = (
  params?: GetTokenUsagesPerUserParams,
) => {
  return [
    `/madlen-admin/token-usages/per-user`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTokenUsagesPerUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesPerUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTokenUsagesPerUserQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTokenUsagesPerUser>>
  > = ({ signal }) => getTokenUsagesPerUser(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTokenUsagesPerUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTokenUsagesPerUser>>
>;
export type GetTokenUsagesPerUserQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTokenUsagesPerUser<
  TData = Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTokenUsagesPerUserParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTokenUsagesPerUser<
  TData = Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesPerUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTokenUsagesPerUser<
  TData = Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesPerUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTokenUsagesPerUser<
  TData = Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsagesPerUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsagesPerUser>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTokenUsagesPerUserQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTokenUsageAverages = (
  params?: GetTokenUsageAveragesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<TokenUsageAverage>({
    url: `/madlen-admin/token-usages/average`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTokenUsageAveragesQueryKey = (
  params?: GetTokenUsageAveragesParams,
) => {
  return [
    `/madlen-admin/token-usages/average`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTokenUsageAveragesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTokenUsageAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsageAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsageAverages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTokenUsageAveragesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTokenUsageAverages>>
  > = ({ signal }) => getTokenUsageAverages(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTokenUsageAverages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTokenUsageAveragesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTokenUsageAverages>>
>;
export type GetTokenUsageAveragesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTokenUsageAverages<
  TData = Awaited<ReturnType<typeof getTokenUsageAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTokenUsageAveragesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsageAverages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsageAverages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTokenUsageAverages<
  TData = Awaited<ReturnType<typeof getTokenUsageAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsageAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsageAverages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsageAverages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTokenUsageAverages<
  TData = Awaited<ReturnType<typeof getTokenUsageAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsageAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsageAverages>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTokenUsageAverages<
  TData = Awaited<ReturnType<typeof getTokenUsageAverages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTokenUsageAveragesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTokenUsageAverages>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTokenUsageAveragesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLoggedInMadlenAdmin = (signal?: AbortSignal) => {
  return configureAxios<MadlenAdminResponseDto>({
    url: `/madlen-admin/me`,
    method: "GET",
    signal,
  });
};

export const getGetLoggedInMadlenAdminQueryKey = () => {
  return [`/madlen-admin/me`] as const;
};

export const getGetLoggedInMadlenAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLoggedInMadlenAdminQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>
  > = ({ signal }) => getLoggedInMadlenAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLoggedInMadlenAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>
>;
export type GetLoggedInMadlenAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLoggedInMadlenAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLoggedInMadlenAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLoggedInMadlenAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLoggedInMadlenAdmin<
  TData = Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInMadlenAdmin>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLoggedInMadlenAdminQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDailyStreaks = (signal?: AbortSignal) => {
  return configureAxios<DailyStreakResponseDto[]>({
    url: `/madlen-admin/daily-streak`,
    method: "GET",
    signal,
  });
};

export const getGetDailyStreaksQueryKey = () => {
  return [`/madlen-admin/daily-streak`] as const;
};

export const getGetDailyStreaksQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyStreaks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDailyStreaks>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDailyStreaksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyStreaks>>> = ({
    signal,
  }) => getDailyStreaks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyStreaks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDailyStreaksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyStreaks>>
>;
export type GetDailyStreaksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDailyStreaks<
  TData = Awaited<ReturnType<typeof getDailyStreaks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDailyStreaks>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getDailyStreaks>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDailyStreaks<
  TData = Awaited<ReturnType<typeof getDailyStreaks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDailyStreaks>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getDailyStreaks>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDailyStreaks<
  TData = Awaited<ReturnType<typeof getDailyStreaks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDailyStreaks>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDailyStreaks<
  TData = Awaited<ReturnType<typeof getDailyStreaks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDailyStreaks>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDailyStreaksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDailyStreak = (id: number, signal?: AbortSignal) => {
  return configureAxios<DailyStreak>({
    url: `/madlen-admin/daily-streak/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetDailyStreakQueryKey = (id: number) => {
  return [`/madlen-admin/daily-streak/${id}`] as const;
};

export const getGetDailyStreakQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyStreak>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDailyStreak>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDailyStreakQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyStreak>>> = ({
    signal,
  }) => getDailyStreak(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyStreak>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDailyStreakQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyStreak>>
>;
export type GetDailyStreakQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDailyStreak<
  TData = Awaited<ReturnType<typeof getDailyStreak>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDailyStreak>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyStreak>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDailyStreak<
  TData = Awaited<ReturnType<typeof getDailyStreak>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDailyStreak>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyStreak>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDailyStreak<
  TData = Awaited<ReturnType<typeof getDailyStreak>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDailyStreak>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDailyStreak<
  TData = Awaited<ReturnType<typeof getDailyStreak>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDailyStreak>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDailyStreakQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMaarifLearningOutcomes = (
  params?: GetMaarifLearningOutcomesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<MaarifLearningOutcomesPerOutcomePerExplanationResponseDto>(
    { url: `/maarif-learning-outcomes`, method: "GET", params, signal },
  );
};

export const getGetMaarifLearningOutcomesQueryKey = (
  params?: GetMaarifLearningOutcomesParams,
) => {
  return [`/maarif-learning-outcomes`, ...(params ? [params] : [])] as const;
};

export const getGetMaarifLearningOutcomesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMaarifLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMaarifLearningOutcomesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMaarifLearningOutcomes>>
  > = ({ signal }) => getMaarifLearningOutcomes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMaarifLearningOutcomesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMaarifLearningOutcomes>>
>;
export type GetMaarifLearningOutcomesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetMaarifLearningOutcomes<
  TData = Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMaarifLearningOutcomesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMaarifLearningOutcomes<
  TData = Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMaarifLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMaarifLearningOutcomes<
  TData = Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMaarifLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMaarifLearningOutcomes<
  TData = Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMaarifLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMaarifLearningOutcomes>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMaarifLearningOutcomesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopLessonHooks = (
  params?: GetTopLessonHooksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListLessonHookResponseDto>({
    url: `/lesson-hooks/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopLessonHooksQueryKey = (
  params?: GetTopLessonHooksParams,
) => {
  return [`/lesson-hooks/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopLessonHooksQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopLessonHooks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopLessonHooksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopLessonHooks>>
  > = ({ signal }) => getTopLessonHooks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopLessonHooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopLessonHooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopLessonHooks>>
>;
export type GetTopLessonHooksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopLessonHooks<
  TData = Awaited<ReturnType<typeof getTopLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopLessonHooksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopLessonHooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopLessonHooks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopLessonHooks<
  TData = Awaited<ReturnType<typeof getTopLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopLessonHooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopLessonHooks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopLessonHooks<
  TData = Awaited<ReturnType<typeof getTopLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopLessonHooks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopLessonHooks<
  TData = Awaited<ReturnType<typeof getTopLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopLessonHooks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopLessonHooksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentLessonHooks = (
  params?: GetRecentLessonHooksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListLessonHookResponseDto>({
    url: `/lesson-hooks/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentLessonHooksQueryKey = (
  params?: GetRecentLessonHooksParams,
) => {
  return [`/lesson-hooks/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentLessonHooksQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentLessonHooks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentLessonHooksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentLessonHooks>>
  > = ({ signal }) => getRecentLessonHooks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentLessonHooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentLessonHooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentLessonHooks>>
>;
export type GetRecentLessonHooksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentLessonHooks<
  TData = Awaited<ReturnType<typeof getRecentLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentLessonHooksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentLessonHooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentLessonHooks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentLessonHooks<
  TData = Awaited<ReturnType<typeof getRecentLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentLessonHooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentLessonHooks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentLessonHooks<
  TData = Awaited<ReturnType<typeof getRecentLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentLessonHooks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentLessonHooks<
  TData = Awaited<ReturnType<typeof getRecentLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentLessonHooks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentLessonHooksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserLessonHooks = (
  params?: GetUserLessonHooksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListLessonHookResponseDto>({
    url: `/lesson-hooks/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserLessonHooksQueryKey = (
  params?: GetUserLessonHooksParams,
) => {
  return [`/lesson-hooks/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserLessonHooksQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLessonHooks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserLessonHooksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserLessonHooks>>
  > = ({ signal }) => getUserLessonHooks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserLessonHooks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserLessonHooksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserLessonHooks>>
>;
export type GetUserLessonHooksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserLessonHooks<
  TData = Awaited<ReturnType<typeof getUserLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserLessonHooksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLessonHooks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLessonHooks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserLessonHooks<
  TData = Awaited<ReturnType<typeof getUserLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLessonHooks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLessonHooks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserLessonHooks<
  TData = Awaited<ReturnType<typeof getUserLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLessonHooks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserLessonHooks<
  TData = Awaited<ReturnType<typeof getUserLessonHooks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserLessonHooksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserLessonHooks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserLessonHooksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLearningOutcomes = (
  params?: GetLearningOutcomesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<LearningOutcomesPerOutcomePerExplanationResponseDto>({
    url: `/learning-outcomes`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetLearningOutcomesQueryKey = (
  params?: GetLearningOutcomesParams,
) => {
  return [`/learning-outcomes`, ...(params ? [params] : [])] as const;
};

export const getGetLearningOutcomesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLearningOutcomes>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLearningOutcomesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLearningOutcomes>>
  > = ({ signal }) => getLearningOutcomes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLearningOutcomes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLearningOutcomesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLearningOutcomes>>
>;
export type GetLearningOutcomesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetLearningOutcomes<
  TData = Awaited<ReturnType<typeof getLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetLearningOutcomesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLearningOutcomes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearningOutcomes>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLearningOutcomes<
  TData = Awaited<ReturnType<typeof getLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLearningOutcomes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearningOutcomes>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLearningOutcomes<
  TData = Awaited<ReturnType<typeof getLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLearningOutcomes>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLearningOutcomes<
  TData = Awaited<ReturnType<typeof getLearningOutcomes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetLearningOutcomesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLearningOutcomes>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLearningOutcomesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getInteractiveMaterial1 = (id: number, signal?: AbortSignal) => {
  return configureAxios<InteractiveMaterialResponseDto>({
    url: `/interactive-materials/v2/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetInteractiveMaterial1QueryKey = (id: number) => {
  return [`/interactive-materials/v2/${id}`] as const;
};

export const getGetInteractiveMaterial1QueryOptions = <
  TData = Awaited<ReturnType<typeof getInteractiveMaterial1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial1>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInteractiveMaterial1QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInteractiveMaterial1>>
  > = ({ signal }) => getInteractiveMaterial1(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInteractiveMaterial1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetInteractiveMaterial1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getInteractiveMaterial1>>
>;
export type GetInteractiveMaterial1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetInteractiveMaterial1<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInteractiveMaterial1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInteractiveMaterial1<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInteractiveMaterial1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInteractiveMaterial1<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetInteractiveMaterial1<
  TData = Awaited<ReturnType<typeof getInteractiveMaterial1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInteractiveMaterial1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetInteractiveMaterial1QueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopImageGenerators = (
  params?: GetTopImageGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListImageGeneratorResponseDto>({
    url: `/image-generators/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopImageGeneratorsQueryKey = (
  params?: GetTopImageGeneratorsParams,
) => {
  return [`/image-generators/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopImageGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopImageGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopImageGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopImageGenerators>>
  > = ({ signal }) => getTopImageGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopImageGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopImageGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopImageGenerators>>
>;
export type GetTopImageGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopImageGenerators<
  TData = Awaited<ReturnType<typeof getTopImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopImageGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopImageGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopImageGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopImageGenerators<
  TData = Awaited<ReturnType<typeof getTopImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopImageGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopImageGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopImageGenerators<
  TData = Awaited<ReturnType<typeof getTopImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopImageGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopImageGenerators<
  TData = Awaited<ReturnType<typeof getTopImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopImageGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopImageGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentImageGenerators = (
  params?: GetRecentImageGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListImageGeneratorResponseDto>({
    url: `/image-generators/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentImageGeneratorsQueryKey = (
  params?: GetRecentImageGeneratorsParams,
) => {
  return [`/image-generators/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentImageGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentImageGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentImageGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentImageGenerators>>
  > = ({ signal }) => getRecentImageGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentImageGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentImageGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentImageGenerators>>
>;
export type GetRecentImageGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentImageGenerators<
  TData = Awaited<ReturnType<typeof getRecentImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentImageGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentImageGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentImageGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentImageGenerators<
  TData = Awaited<ReturnType<typeof getRecentImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentImageGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentImageGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentImageGenerators<
  TData = Awaited<ReturnType<typeof getRecentImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentImageGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentImageGenerators<
  TData = Awaited<ReturnType<typeof getRecentImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentImageGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentImageGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserImageGenerators = (
  params?: GetUserImageGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListImageGeneratorResponseDto>({
    url: `/image-generators/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserImageGeneratorsQueryKey = (
  params?: GetUserImageGeneratorsParams,
) => {
  return [`/image-generators/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserImageGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserImageGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserImageGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserImageGenerators>>
  > = ({ signal }) => getUserImageGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserImageGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserImageGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserImageGenerators>>
>;
export type GetUserImageGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserImageGenerators<
  TData = Awaited<ReturnType<typeof getUserImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserImageGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserImageGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserImageGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserImageGenerators<
  TData = Awaited<ReturnType<typeof getUserImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserImageGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserImageGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserImageGenerators<
  TData = Awaited<ReturnType<typeof getUserImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserImageGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserImageGenerators<
  TData = Awaited<ReturnType<typeof getUserImageGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserImageGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserImageGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserImageGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopHomeworkIdeas = (
  params?: GetTopHomeworkIdeasParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListHomeworkIdeaResponseDto>({
    url: `/homework-ideas/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopHomeworkIdeasQueryKey = (
  params?: GetTopHomeworkIdeasParams,
) => {
  return [`/homework-ideas/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopHomeworkIdeasQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopHomeworkIdeasQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopHomeworkIdeas>>
  > = ({ signal }) => getTopHomeworkIdeas(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopHomeworkIdeasQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopHomeworkIdeas>>
>;
export type GetTopHomeworkIdeasQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopHomeworkIdeasParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopHomeworkIdeasQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentHomeworkIdeas = (
  params?: GetRecentHomeworkIdeasParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListHomeworkIdeaResponseDto>({
    url: `/homework-ideas/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentHomeworkIdeasQueryKey = (
  params?: GetRecentHomeworkIdeasParams,
) => {
  return [`/homework-ideas/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentHomeworkIdeasQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentHomeworkIdeasQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentHomeworkIdeas>>
  > = ({ signal }) => getRecentHomeworkIdeas(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentHomeworkIdeasQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentHomeworkIdeas>>
>;
export type GetRecentHomeworkIdeasQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentHomeworkIdeasParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentHomeworkIdeasQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserHomeworkIdeas = (
  params?: GetUserHomeworkIdeasParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListHomeworkIdeaResponseDto>({
    url: `/homework-ideas/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserHomeworkIdeasQueryKey = (
  params?: GetUserHomeworkIdeasParams,
) => {
  return [`/homework-ideas/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserHomeworkIdeasQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserHomeworkIdeasQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserHomeworkIdeas>>
  > = ({ signal }) => getUserHomeworkIdeas(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserHomeworkIdeasQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserHomeworkIdeas>>
>;
export type GetUserHomeworkIdeasQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserHomeworkIdeasParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserHomeworkIdeas<
  TData = Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserHomeworkIdeasParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserHomeworkIdeas>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserHomeworkIdeasQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getScopes = (signal?: AbortSignal) => {
  return configureAxios<GetGoogleScopesResponseDto>({
    url: `/google/scopes`,
    method: "GET",
    signal,
  });
};

export const getGetScopesQueryKey = () => {
  return [`/google/scopes`] as const;
};

export const getGetScopesQueryOptions = <
  TData = Awaited<ReturnType<typeof getScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScopesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScopes>>> = ({
    signal,
  }) => getScopes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getScopes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetScopesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getScopes>>
>;
export type GetScopesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetScopes<
  TData = Awaited<ReturnType<typeof getScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getScopes>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetScopes<
  TData = Awaited<ReturnType<typeof getScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getScopes>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetScopes<
  TData = Awaited<ReturnType<typeof getScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetScopes<
  TData = Awaited<ReturnType<typeof getScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetScopesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const oauth2callback = (
  params: Oauth2callbackParams,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/google/oauth2callback`,
    method: "GET",
    params,
    signal,
  });
};

export const getOauth2callbackQueryKey = (params: Oauth2callbackParams) => {
  return [`/google/oauth2callback`, ...(params ? [params] : [])] as const;
};

export const getOauth2callbackQueryOptions = <
  TData = Awaited<ReturnType<typeof oauth2callback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: Oauth2callbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof oauth2callback>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOauth2callbackQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof oauth2callback>>> = ({
    signal,
  }) => oauth2callback(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof oauth2callback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type Oauth2callbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof oauth2callback>>
>;
export type Oauth2callbackQueryError = ErrorType<BaseErrorResponseDto>;

export function useOauth2callback<
  TData = Awaited<ReturnType<typeof oauth2callback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: Oauth2callbackParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof oauth2callback>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oauth2callback>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useOauth2callback<
  TData = Awaited<ReturnType<typeof oauth2callback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: Oauth2callbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof oauth2callback>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oauth2callback>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOauth2callback<
  TData = Awaited<ReturnType<typeof oauth2callback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: Oauth2callbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof oauth2callback>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useOauth2callback<
  TData = Awaited<ReturnType<typeof oauth2callback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: Oauth2callbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof oauth2callback>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getOauth2callbackQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFilesUsingGoogleClassroom = (
  googleClassroomId: string,
  signal?: AbortSignal,
) => {
  return configureAxios<PostFilesMetadataResponseDto[]>({
    url: `/google/classroom/${googleClassroomId}/files-metadata/google-classroom`,
    method: "GET",
    signal,
  });
};

export const getGetFilesUsingGoogleClassroomQueryKey = (
  googleClassroomId: string,
) => {
  return [
    `/google/classroom/${googleClassroomId}/files-metadata/google-classroom`,
  ] as const;
};

export const getGetFilesUsingGoogleClassroomQueryOptions = <
  TData = Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  googleClassroomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFilesUsingGoogleClassroomQueryKey(googleClassroomId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>
  > = ({ signal }) => getFilesUsingGoogleClassroom(googleClassroomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!googleClassroomId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFilesUsingGoogleClassroomQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>
>;
export type GetFilesUsingGoogleClassroomQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetFilesUsingGoogleClassroom<
  TData = Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  googleClassroomId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFilesUsingGoogleClassroom<
  TData = Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  googleClassroomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFilesUsingGoogleClassroom<
  TData = Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  googleClassroomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFilesUsingGoogleClassroom<
  TData = Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  googleClassroomId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFilesUsingGoogleClassroom>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFilesUsingGoogleClassroomQueryOptions(
    googleClassroomId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFiles1 = (classroomId: number, signal?: AbortSignal) => {
  return configureAxios<PostFilesMetadataResponseDto[]>({
    url: `/google/classroom/${classroomId}/files-metadata`,
    method: "GET",
    signal,
  });
};

export const getGetFiles1QueryKey = (classroomId: number) => {
  return [`/google/classroom/${classroomId}/files-metadata`] as const;
};

export const getGetFiles1QueryOptions = <
  TData = Awaited<ReturnType<typeof getFiles1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles1>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFiles1QueryKey(classroomId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiles1>>> = ({
    signal,
  }) => getFiles1(classroomId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classroomId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFiles1>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetFiles1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiles1>>
>;
export type GetFiles1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetFiles1<
  TData = Awaited<ReturnType<typeof getFiles1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiles1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFiles1<
  TData = Awaited<ReturnType<typeof getFiles1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiles1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFiles1<
  TData = Awaited<ReturnType<typeof getFiles1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFiles1<
  TData = Awaited<ReturnType<typeof getFiles1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classroomId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiles1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFiles1QueryOptions(classroomId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassroomScopes = (signal?: AbortSignal) => {
  return configureAxios<string[]>({
    url: `/google/classroom/scopes`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomScopesQueryKey = () => {
  return [`/google/classroom/scopes`] as const;
};

export const getGetClassroomScopesQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomScopes>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClassroomScopesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomScopes>>
  > = ({ signal }) => getClassroomScopes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomScopes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomScopesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomScopes>>
>;
export type GetClassroomScopesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassroomScopes<
  TData = Awaited<ReturnType<typeof getClassroomScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomScopes>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getClassroomScopes>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomScopes<
  TData = Awaited<ReturnType<typeof getClassroomScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomScopes>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getClassroomScopes>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomScopes<
  TData = Awaited<ReturnType<typeof getClassroomScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomScopes>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomScopes<
  TData = Awaited<ReturnType<typeof getClassroomScopes>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomScopes>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomScopesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getVideosFromGoogleDrive = (
  params?: GetVideosFromGoogleDriveParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedDriveFilesResponseDto>({
    url: `/google/classroom/drive-videos-metadata`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetVideosFromGoogleDriveQueryKey = (
  params?: GetVideosFromGoogleDriveParams,
) => {
  return [
    `/google/classroom/drive-videos-metadata`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetVideosFromGoogleDriveQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVideosFromGoogleDriveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVideosFromGoogleDrive>>
  > = ({ signal }) => getVideosFromGoogleDrive(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVideosFromGoogleDriveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVideosFromGoogleDrive>>
>;
export type GetVideosFromGoogleDriveQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetVideosFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetVideosFromGoogleDriveParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVideosFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVideosFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetVideosFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosFromGoogleDrive>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVideosFromGoogleDriveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getVideosAndPdfFromGoogleDrive = (
  params?: GetVideosAndPdfFromGoogleDriveParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedDriveFilesResponseDto>({
    url: `/google/classroom/drive-pdf-videos-metadata`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetVideosAndPdfFromGoogleDriveQueryKey = (
  params?: GetVideosAndPdfFromGoogleDriveParams,
) => {
  return [
    `/google/classroom/drive-pdf-videos-metadata`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetVideosAndPdfFromGoogleDriveQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosAndPdfFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVideosAndPdfFromGoogleDriveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>
  > = ({ signal }) => getVideosAndPdfFromGoogleDrive(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVideosAndPdfFromGoogleDriveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>
>;
export type GetVideosAndPdfFromGoogleDriveQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetVideosAndPdfFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetVideosAndPdfFromGoogleDriveParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVideosAndPdfFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosAndPdfFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVideosAndPdfFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosAndPdfFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetVideosAndPdfFromGoogleDrive<
  TData = Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetVideosAndPdfFromGoogleDriveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosAndPdfFromGoogleDrive>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVideosAndPdfFromGoogleDriveQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDriveFiles = (
  params?: GetDriveFilesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<PaginatedDriveFilesResponseDto>({
    url: `/google/classroom/drive-files-metadata`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDriveFilesQueryKey = (params?: GetDriveFilesParams) => {
  return [
    `/google/classroom/drive-files-metadata`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDriveFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDriveFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDriveFiles>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDriveFilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriveFiles>>> = ({
    signal,
  }) => getDriveFiles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDriveFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDriveFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDriveFiles>>
>;
export type GetDriveFilesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDriveFiles<
  TData = Awaited<ReturnType<typeof getDriveFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetDriveFilesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDriveFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveFiles>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDriveFiles<
  TData = Awaited<ReturnType<typeof getDriveFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDriveFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriveFiles>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDriveFiles<
  TData = Awaited<ReturnType<typeof getDriveFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDriveFiles>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDriveFiles<
  TData = Awaited<ReturnType<typeof getDriveFiles>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDriveFiles>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDriveFilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassroomCourses = (signal?: AbortSignal) => {
  return configureAxios<GetCoursesResponseDto>({
    url: `/google/classroom/courses`,
    method: "GET",
    signal,
  });
};

export const getGetClassroomCoursesQueryKey = () => {
  return [`/google/classroom/courses`] as const;
};

export const getGetClassroomCoursesQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassroomCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomCourses>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClassroomCoursesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassroomCourses>>
  > = ({ signal }) => getClassroomCourses(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassroomCourses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassroomCoursesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassroomCourses>>
>;
export type GetClassroomCoursesQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassroomCourses<
  TData = Awaited<ReturnType<typeof getClassroomCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomCourses>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getClassroomCourses>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassroomCourses<
  TData = Awaited<ReturnType<typeof getClassroomCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomCourses>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getClassroomCourses>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassroomCourses<
  TData = Awaited<ReturnType<typeof getClassroomCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomCourses>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassroomCourses<
  TData = Awaited<ReturnType<typeof getClassroomCourses>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassroomCourses>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassroomCoursesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopics1 = (courseId: string, signal?: AbortSignal) => {
  return configureAxios<GetTopicsResponseDto>({
    url: `/google/classroom/courses/${courseId}/topics`,
    method: "GET",
    signal,
  });
};

export const getGetTopics1QueryKey = (courseId: string) => {
  return [`/google/classroom/courses/${courseId}/topics`] as const;
};

export const getGetTopics1QueryOptions = <
  TData = Awaited<ReturnType<typeof getTopics1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics1>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopics1QueryKey(courseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopics1>>> = ({
    signal,
  }) => getTopics1(courseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!courseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopics1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopics1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopics1>>
>;
export type GetTopics1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopics1<
  TData = Awaited<ReturnType<typeof getTopics1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopics1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopics1<
  TData = Awaited<ReturnType<typeof getTopics1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopics1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopics1<
  TData = Awaited<ReturnType<typeof getTopics1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopics1<
  TData = Awaited<ReturnType<typeof getTopics1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTopics1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopics1QueryOptions(courseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudents1 = (courseId: string, signal?: AbortSignal) => {
  return configureAxios<GetStudentsResponseDto>({
    url: `/google/classroom/courses/${courseId}/students`,
    method: "GET",
    signal,
  });
};

export const getGetStudents1QueryKey = (courseId: string) => {
  return [`/google/classroom/courses/${courseId}/students`] as const;
};

export const getGetStudents1QueryOptions = <
  TData = Awaited<ReturnType<typeof getStudents1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents1>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStudents1QueryKey(courseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudents1>>> = ({
    signal,
  }) => getStudents1(courseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!courseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudents1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStudents1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudents1>>
>;
export type GetStudents1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetStudents1<
  TData = Awaited<ReturnType<typeof getStudents1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudents1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStudents1<
  TData = Awaited<ReturnType<typeof getStudents1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudents1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStudents1<
  TData = Awaited<ReturnType<typeof getStudents1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStudents1<
  TData = Awaited<ReturnType<typeof getStudents1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  courseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStudents1>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStudents1QueryOptions(courseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopFormativeAssessments = (
  params?: GetTopFormativeAssessmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListFormativeAssessmentResponseDto>({
    url: `/formative-assessment/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopFormativeAssessmentsQueryKey = (
  params?: GetTopFormativeAssessmentsParams,
) => {
  return [`/formative-assessment/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopFormativeAssessmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopFormativeAssessmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopFormativeAssessments>>
  > = ({ signal }) => getTopFormativeAssessments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopFormativeAssessments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopFormativeAssessmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopFormativeAssessments>>
>;
export type GetTopFormativeAssessmentsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopFormativeAssessments<
  TData = Awaited<ReturnType<typeof getTopFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopFormativeAssessmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopFormativeAssessments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopFormativeAssessments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopFormativeAssessments<
  TData = Awaited<ReturnType<typeof getTopFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopFormativeAssessments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopFormativeAssessments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopFormativeAssessments<
  TData = Awaited<ReturnType<typeof getTopFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopFormativeAssessments<
  TData = Awaited<ReturnType<typeof getTopFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopFormativeAssessmentsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentFormativeAssessments = (
  params?: GetRecentFormativeAssessmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListFormativeAssessmentResponseDto>({
    url: `/formative-assessment/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentFormativeAssessmentsQueryKey = (
  params?: GetRecentFormativeAssessmentsParams,
) => {
  return [`/formative-assessment/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentFormativeAssessmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentFormativeAssessmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentFormativeAssessments>>
  > = ({ signal }) => getRecentFormativeAssessments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentFormativeAssessmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentFormativeAssessments>>
>;
export type GetRecentFormativeAssessmentsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentFormativeAssessments<
  TData = Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentFormativeAssessmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentFormativeAssessments<
  TData = Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentFormativeAssessments<
  TData = Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentFormativeAssessments<
  TData = Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentFormativeAssessmentsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserFormativeAssessments = (
  params?: GetUserFormativeAssessmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListFormativeAssessmentResponseDto>({
    url: `/formative-assessment/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserFormativeAssessmentsQueryKey = (
  params?: GetUserFormativeAssessmentsParams,
) => {
  return [`/formative-assessment/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserFormativeAssessmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserFormativeAssessmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserFormativeAssessments>>
  > = ({ signal }) => getUserFormativeAssessments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserFormativeAssessments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserFormativeAssessmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserFormativeAssessments>>
>;
export type GetUserFormativeAssessmentsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserFormativeAssessments<
  TData = Awaited<ReturnType<typeof getUserFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserFormativeAssessmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserFormativeAssessments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFormativeAssessments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserFormativeAssessments<
  TData = Awaited<ReturnType<typeof getUserFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserFormativeAssessments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFormativeAssessments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserFormativeAssessments<
  TData = Awaited<ReturnType<typeof getUserFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserFormativeAssessments<
  TData = Awaited<ReturnType<typeof getUserFormativeAssessments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserFormativeAssessmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserFormativeAssessments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserFormativeAssessmentsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getNode = (nodeId: number, signal?: AbortSignal) => {
  return configureAxios<BaseFileNodeDto>({
    url: `/filenodes/${nodeId}`,
    method: "GET",
    signal,
  });
};

export const getGetNodeQueryKey = (nodeId: number) => {
  return [`/filenodes/${nodeId}`] as const;
};

export const getGetNodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  nodeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNodeQueryKey(nodeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNode>>> = ({
    signal,
  }) => getNode(nodeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!nodeId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetNodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNode>>
>;
export type GetNodeQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  nodeId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNode>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  nodeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNode>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  nodeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetNode<
  TData = Awaited<ReturnType<typeof getNode>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  nodeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNode>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetNodeQueryOptions(nodeId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteNode = (nodeId: number) => {
  return configureAxios<void>({
    url: `/filenodes/${nodeId}`,
    method: "DELETE",
  });
};

export const getDeleteNodeMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNode>>,
    TError,
    { nodeId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNode>>,
  TError,
  { nodeId: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNode>>,
    { nodeId: number }
  > = (props) => {
    const { nodeId } = props ?? {};

    return deleteNode(nodeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNode>>
>;

export type DeleteNodeMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteNode = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNode>>,
    TError,
    { nodeId: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNode>>,
  TError,
  { nodeId: number },
  TContext
> => {
  const mutationOptions = getDeleteNodeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getFavouriteChatMessages = (
  params?: GetFavouriteChatMessagesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatMessagesResponseDto>({
    url: `/favourites/messages`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFavouriteChatMessagesQueryKey = (
  params?: GetFavouriteChatMessagesParams,
) => {
  return [`/favourites/messages`, ...(params ? [params] : [])] as const;
};

export const getGetFavouriteChatMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavouriteChatMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFavouriteChatMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFavouriteChatMessages>>
  > = ({ signal }) => getFavouriteChatMessages(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavouriteChatMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFavouriteChatMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavouriteChatMessages>>
>;
export type GetFavouriteChatMessagesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetFavouriteChatMessages<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetFavouriteChatMessagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChatMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFavouriteChatMessages<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChatMessages>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFavouriteChatMessages<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessages>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFavouriteChatMessages<
  TData = Awaited<ReturnType<typeof getFavouriteChatMessages>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatMessagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChatMessages>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFavouriteChatMessagesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFavouriteChats = (
  params?: GetFavouriteChatsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatResponseDto>({
    url: `/favourites/chats`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFavouriteChatsQueryKey = (
  params?: GetFavouriteChatsParams,
) => {
  return [`/favourites/chats`, ...(params ? [params] : [])] as const;
};

export const getGetFavouriteChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavouriteChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChats>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFavouriteChatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFavouriteChats>>
  > = ({ signal }) => getFavouriteChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavouriteChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFavouriteChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavouriteChats>>
>;
export type GetFavouriteChatsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetFavouriteChats<
  TData = Awaited<ReturnType<typeof getFavouriteChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetFavouriteChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFavouriteChats<
  TData = Awaited<ReturnType<typeof getFavouriteChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavouriteChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFavouriteChats<
  TData = Awaited<ReturnType<typeof getFavouriteChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFavouriteChats<
  TData = Awaited<ReturnType<typeof getFavouriteChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetFavouriteChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFavouriteChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFavouriteChatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopExitTicketGenerators = (
  params?: GetTopExitTicketGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListExitTicketGeneratorResponseDto>({
    url: `/exit-ticket-generator/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopExitTicketGeneratorsQueryKey = (
  params?: GetTopExitTicketGeneratorsParams,
) => {
  return [`/exit-ticket-generator/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopExitTicketGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopExitTicketGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopExitTicketGenerators>>
  > = ({ signal }) => getTopExitTicketGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopExitTicketGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopExitTicketGenerators>>
>;
export type GetTopExitTicketGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopExitTicketGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopExitTicketGeneratorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentExitTicketGenerators = (
  params?: GetRecentExitTicketGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListExitTicketGeneratorResponseDto>({
    url: `/exit-ticket-generator/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentExitTicketGeneratorsQueryKey = (
  params?: GetRecentExitTicketGeneratorsParams,
) => {
  return [
    `/exit-ticket-generator/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentExitTicketGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentExitTicketGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentExitTicketGenerators>>
  > = ({ signal }) => getRecentExitTicketGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentExitTicketGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentExitTicketGenerators>>
>;
export type GetRecentExitTicketGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentExitTicketGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentExitTicketGeneratorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserExitTicketGenerators = (
  params?: GetUserExitTicketGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListExitTicketGeneratorResponseDto>({
    url: `/exit-ticket-generator/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserExitTicketGeneratorsQueryKey = (
  params?: GetUserExitTicketGeneratorsParams,
) => {
  return [`/exit-ticket-generator/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserExitTicketGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserExitTicketGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserExitTicketGenerators>>
  > = ({ signal }) => getUserExitTicketGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserExitTicketGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserExitTicketGenerators>>
>;
export type GetUserExitTicketGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserExitTicketGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserExitTicketGenerators<
  TData = Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserExitTicketGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserExitTicketGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserExitTicketGeneratorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopEssentialQuestions = (
  params?: GetTopEssentialQuestionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListEssentialQuestionsResponseDto>({
    url: `/essential-questions/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopEssentialQuestionsQueryKey = (
  params?: GetTopEssentialQuestionsParams,
) => {
  return [`/essential-questions/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopEssentialQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopEssentialQuestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopEssentialQuestions>>
  > = ({ signal }) => getTopEssentialQuestions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopEssentialQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopEssentialQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopEssentialQuestions>>
>;
export type GetTopEssentialQuestionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopEssentialQuestions<
  TData = Awaited<ReturnType<typeof getTopEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopEssentialQuestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopEssentialQuestions<
  TData = Awaited<ReturnType<typeof getTopEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopEssentialQuestions<
  TData = Awaited<ReturnType<typeof getTopEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopEssentialQuestions<
  TData = Awaited<ReturnType<typeof getTopEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopEssentialQuestionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentEssentialQuestions = (
  params?: GetRecentEssentialQuestionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListEssentialQuestionsResponseDto>({
    url: `/essential-questions/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentEssentialQuestionsQueryKey = (
  params?: GetRecentEssentialQuestionsParams,
) => {
  return [`/essential-questions/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentEssentialQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentEssentialQuestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentEssentialQuestions>>
  > = ({ signal }) => getRecentEssentialQuestions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentEssentialQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentEssentialQuestions>>
>;
export type GetRecentEssentialQuestionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentEssentialQuestions<
  TData = Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentEssentialQuestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentEssentialQuestions<
  TData = Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentEssentialQuestions<
  TData = Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentEssentialQuestions<
  TData = Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentEssentialQuestionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserEssentialQuestions = (
  params?: GetUserEssentialQuestionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListEssentialQuestionsResponseDto>({
    url: `/essential-questions/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserEssentialQuestionsQueryKey = (
  params?: GetUserEssentialQuestionsParams,
) => {
  return [`/essential-questions/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserEssentialQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserEssentialQuestionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserEssentialQuestions>>
  > = ({ signal }) => getUserEssentialQuestions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserEssentialQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserEssentialQuestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserEssentialQuestions>>
>;
export type GetUserEssentialQuestionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserEssentialQuestions<
  TData = Awaited<ReturnType<typeof getUserEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserEssentialQuestionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserEssentialQuestions<
  TData = Awaited<ReturnType<typeof getUserEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEssentialQuestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEssentialQuestions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserEssentialQuestions<
  TData = Awaited<ReturnType<typeof getUserEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserEssentialQuestions<
  TData = Awaited<ReturnType<typeof getUserEssentialQuestions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserEssentialQuestionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserEssentialQuestions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserEssentialQuestionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all my essay submissions
 */
export const getMySubmissions = (
  params?: GetMySubmissionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListStudentEssaySubmissionResponseDto>({
    url: `/essay-submissions/my-submissions`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMySubmissionsQueryKey = (
  params?: GetMySubmissionsParams,
) => {
  return [
    `/essay-submissions/my-submissions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMySubmissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMySubmissions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySubmissions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMySubmissionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMySubmissions>>
  > = ({ signal }) => getMySubmissions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMySubmissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMySubmissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMySubmissions>>
>;
export type GetMySubmissionsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMySubmissions<
  TData = Awaited<ReturnType<typeof getMySubmissions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMySubmissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMySubmissions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMySubmissions<
  TData = Awaited<ReturnType<typeof getMySubmissions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMySubmissions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMySubmissions<
  TData = Awaited<ReturnType<typeof getMySubmissions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySubmissions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all my essay submissions
 */

export function useGetMySubmissions<
  TData = Awaited<ReturnType<typeof getMySubmissions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySubmissions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMySubmissionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all submissions for assignment (Teacher only)
 */
export const getSubmissionsForAssignment = (
  assignmentId: number,
  params?: GetSubmissionsForAssignmentParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListStudentEssaySubmissionResponseDto>({
    url: `/essay-submissions/assignments/${assignmentId}/all`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSubmissionsForAssignmentQueryKey = (
  assignmentId: number,
  params?: GetSubmissionsForAssignmentParams,
) => {
  return [
    `/essay-submissions/assignments/${assignmentId}/all`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSubmissionsForAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetSubmissionsForAssignmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSubmissionsForAssignmentQueryKey(assignmentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubmissionsForAssignment>>
  > = ({ signal }) => getSubmissionsForAssignment(assignmentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assignmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSubmissionsForAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubmissionsForAssignment>>
>;
export type GetSubmissionsForAssignmentQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetSubmissionsForAssignment<
  TData = Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params: undefined | GetSubmissionsForAssignmentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSubmissionsForAssignment<
  TData = Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetSubmissionsForAssignmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSubmissionsForAssignment<
  TData = Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetSubmissionsForAssignmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all submissions for assignment (Teacher only)
 */

export function useGetSubmissionsForAssignment<
  TData = Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  params?: GetSubmissionsForAssignmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionsForAssignment>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSubmissionsForAssignmentQueryOptions(
    assignmentId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getEssayGrader = (id: number, signal?: AbortSignal) => {
  return configureAxios<EssayGradingResultDto>({
    url: `/essay-grader/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetEssayGraderQueryKey = (id: number) => {
  return [`/essay-grader/${id}`] as const;
};

export const getGetEssayGraderQueryOptions = <
  TData = Awaited<ReturnType<typeof getEssayGrader>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEssayGrader>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEssayGraderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEssayGrader>>> = ({
    signal,
  }) => getEssayGrader(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEssayGrader>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEssayGraderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEssayGrader>>
>;
export type GetEssayGraderQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetEssayGrader<
  TData = Awaited<ReturnType<typeof getEssayGrader>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEssayGrader>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayGrader>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEssayGrader<
  TData = Awaited<ReturnType<typeof getEssayGrader>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEssayGrader>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEssayGrader>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEssayGrader<
  TData = Awaited<ReturnType<typeof getEssayGrader>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEssayGrader>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetEssayGrader<
  TData = Awaited<ReturnType<typeof getEssayGrader>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEssayGrader>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEssayGraderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteEssayGrader = (id: number) => {
  return configureAxios<void>({ url: `/essay-grader/${id}`, method: "DELETE" });
};

export const getDeleteEssayGraderMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEssayGrader>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEssayGrader>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEssayGrader>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteEssayGrader(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEssayGraderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEssayGrader>>
>;

export type DeleteEssayGraderMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteEssayGrader = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEssayGrader>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEssayGrader>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteEssayGraderMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAvailableRubrics = (
  params?: GetAvailableRubricsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListTeacherDocumentResponseDto>({
    url: `/essay-grader/rubrics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAvailableRubricsQueryKey = (
  params?: GetAvailableRubricsParams,
) => {
  return [`/essay-grader/rubrics`, ...(params ? [params] : [])] as const;
};

export const getGetAvailableRubricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableRubrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAvailableRubricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableRubrics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAvailableRubricsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailableRubrics>>
  > = ({ signal }) => getAvailableRubrics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableRubrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAvailableRubricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableRubrics>>
>;
export type GetAvailableRubricsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAvailableRubrics<
  TData = Awaited<ReturnType<typeof getAvailableRubrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAvailableRubricsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableRubrics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableRubrics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvailableRubrics<
  TData = Awaited<ReturnType<typeof getAvailableRubrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAvailableRubricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableRubrics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableRubrics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableRubrics<
  TData = Awaited<ReturnType<typeof getAvailableRubrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAvailableRubricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableRubrics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAvailableRubrics<
  TData = Awaited<ReturnType<typeof getAvailableRubrics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAvailableRubricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableRubrics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAvailableRubricsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const elbHealth = (signal?: AbortSignal) => {
  return configureAxios<string>({ url: `/elb-health`, method: "GET", signal });
};

export const getElbHealthQueryKey = () => {
  return [`/elb-health`] as const;
};

export const getElbHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof elbHealth>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof elbHealth>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getElbHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof elbHealth>>> = ({
    signal,
  }) => elbHealth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof elbHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ElbHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof elbHealth>>
>;
export type ElbHealthQueryError = ErrorType<BaseErrorResponseDto>;

export function useElbHealth<
  TData = Awaited<ReturnType<typeof elbHealth>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof elbHealth>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof elbHealth>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useElbHealth<
  TData = Awaited<ReturnType<typeof elbHealth>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof elbHealth>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof elbHealth>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useElbHealth<
  TData = Awaited<ReturnType<typeof elbHealth>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof elbHealth>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useElbHealth<
  TData = Awaited<ReturnType<typeof elbHealth>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof elbHealth>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getElbHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const handleCallback = (
  params?: HandleCallbackParams,
  signal?: AbortSignal,
) => {
  return configureAxios<void>({
    url: `/edlink/oauth/callback`,
    method: "GET",
    params,
    signal,
  });
};

export const getHandleCallbackQueryKey = (params?: HandleCallbackParams) => {
  return [`/edlink/oauth/callback`, ...(params ? [params] : [])] as const;
};

export const getHandleCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof handleCallback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: HandleCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof handleCallback>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHandleCallbackQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof handleCallback>>> = ({
    signal,
  }) => handleCallback(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof handleCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type HandleCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof handleCallback>>
>;
export type HandleCallbackQueryError = ErrorType<BaseErrorResponseDto>;

export function useHandleCallback<
  TData = Awaited<ReturnType<typeof handleCallback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | HandleCallbackParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof handleCallback>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof handleCallback>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useHandleCallback<
  TData = Awaited<ReturnType<typeof handleCallback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: HandleCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof handleCallback>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof handleCallback>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useHandleCallback<
  TData = Awaited<ReturnType<typeof handleCallback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: HandleCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof handleCallback>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useHandleCallback<
  TData = Awaited<ReturnType<typeof handleCallback>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: HandleCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof handleCallback>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getHandleCallbackQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClassesOfTeacher = (signal?: AbortSignal) => {
  return configureAxios<EdlinkClassroomResponseDto[]>({
    url: `/edlink/classes`,
    method: "GET",
    signal,
  });
};

export const getGetClassesOfTeacherQueryKey = () => {
  return [`/edlink/classes`] as const;
};

export const getGetClassesOfTeacherQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassesOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassesOfTeacher>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClassesOfTeacherQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassesOfTeacher>>
  > = ({ signal }) => getClassesOfTeacher(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassesOfTeacher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetClassesOfTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassesOfTeacher>>
>;
export type GetClassesOfTeacherQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClassesOfTeacher<
  TData = Awaited<ReturnType<typeof getClassesOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassesOfTeacher>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getClassesOfTeacher>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClassesOfTeacher<
  TData = Awaited<ReturnType<typeof getClassesOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassesOfTeacher>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getClassesOfTeacher>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClassesOfTeacher<
  TData = Awaited<ReturnType<typeof getClassesOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassesOfTeacher>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClassesOfTeacher<
  TData = Awaited<ReturnType<typeof getClassesOfTeacher>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getClassesOfTeacher>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassesOfTeacherQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getClass = (classId: string, signal?: AbortSignal) => {
  return configureAxios<EdlinkClassroomResponseDto>({
    url: `/edlink/classes/${classId}`,
    method: "GET",
    signal,
  });
};

export const getGetClassQueryKey = (classId: string) => {
  return [`/edlink/classes/${classId}`] as const;
};

export const getGetClassQueryOptions = <
  TData = Awaited<ReturnType<typeof getClass>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClass>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClassQueryKey(classId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClass>>> = ({
    signal,
  }) => getClass(classId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!classId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getClass>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetClassQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClass>>
>;
export type GetClassQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetClass<
  TData = Awaited<ReturnType<typeof getClass>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClass>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClass>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetClass<
  TData = Awaited<ReturnType<typeof getClass>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClass>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClass>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetClass<
  TData = Awaited<ReturnType<typeof getClass>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClass>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetClass<
  TData = Awaited<ReturnType<typeof getClass>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClass>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetClassQueryOptions(classId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDidacticTopics = (
  params?: GetDidacticTopicsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<DidacticTopicResponseDto[]>({
    url: `/didactic-topics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDidacticTopicsQueryKey = (
  params?: GetDidacticTopicsParams,
) => {
  return [`/didactic-topics`, ...(params ? [params] : [])] as const;
};

export const getGetDidacticTopicsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDidacticTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticTopics>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDidacticTopicsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDidacticTopics>>
  > = ({ signal }) => getDidacticTopics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDidacticTopics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDidacticTopicsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDidacticTopics>>
>;
export type GetDidacticTopicsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDidacticTopics<
  TData = Awaited<ReturnType<typeof getDidacticTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetDidacticTopicsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticTopics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDidacticTopics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDidacticTopics<
  TData = Awaited<ReturnType<typeof getDidacticTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticTopics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDidacticTopics>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDidacticTopics<
  TData = Awaited<ReturnType<typeof getDidacticTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticTopics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDidacticTopics<
  TData = Awaited<ReturnType<typeof getDidacticTopics>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticTopicsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticTopics>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDidacticTopicsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDailyAssignments1 = (
  params: GetDailyAssignments1Params,
  signal?: AbortSignal,
) => {
  return configureAxios<DailyAssignmentsResponseDto[]>({
    url: `/daily-assignments`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDailyAssignments1QueryKey = (
  params: GetDailyAssignments1Params,
) => {
  return [`/daily-assignments`, ...(params ? [params] : [])] as const;
};

export const getGetDailyAssignments1QueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyAssignments1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDailyAssignments1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments1>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyAssignments1QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyAssignments1>>
  > = ({ signal }) => getDailyAssignments1(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyAssignments1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDailyAssignments1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyAssignments1>>
>;
export type GetDailyAssignments1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDailyAssignments1<
  TData = Awaited<ReturnType<typeof getDailyAssignments1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDailyAssignments1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyAssignments1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDailyAssignments1<
  TData = Awaited<ReturnType<typeof getDailyAssignments1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDailyAssignments1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyAssignments1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDailyAssignments1<
  TData = Awaited<ReturnType<typeof getDailyAssignments1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDailyAssignments1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDailyAssignments1<
  TData = Awaited<ReturnType<typeof getDailyAssignments1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: GetDailyAssignments1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyAssignments1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDailyAssignments1QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopConceptualUnderstandings = (
  params?: GetTopConceptualUnderstandingsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListConceptualUnderstandingResponseDto>({
    url: `/conceptual-understandings/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopConceptualUnderstandingsQueryKey = (
  params?: GetTopConceptualUnderstandingsParams,
) => {
  return [
    `/conceptual-understandings/top`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTopConceptualUnderstandingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopConceptualUnderstandingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopConceptualUnderstandings>>
  > = ({ signal }) => getTopConceptualUnderstandings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopConceptualUnderstandingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopConceptualUnderstandings>>
>;
export type GetTopConceptualUnderstandingsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopConceptualUnderstandingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopConceptualUnderstandingsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentConceptualUnderstandings = (
  params?: GetRecentConceptualUnderstandingsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListConceptualUnderstandingResponseDto>({
    url: `/conceptual-understandings/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentConceptualUnderstandingsQueryKey = (
  params?: GetRecentConceptualUnderstandingsParams,
) => {
  return [
    `/conceptual-understandings/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentConceptualUnderstandingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRecentConceptualUnderstandingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>
  > = ({ signal }) => getRecentConceptualUnderstandings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentConceptualUnderstandingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>
>;
export type GetRecentConceptualUnderstandingsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentConceptualUnderstandingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentConceptualUnderstandingsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserConceptualUnderstandings = (
  params?: GetUserConceptualUnderstandingsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListConceptualUnderstandingResponseDto>({
    url: `/conceptual-understandings/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserConceptualUnderstandingsQueryKey = (
  params?: GetUserConceptualUnderstandingsParams,
) => {
  return [
    `/conceptual-understandings/me`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserConceptualUnderstandingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserConceptualUnderstandingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserConceptualUnderstandings>>
  > = ({ signal }) => getUserConceptualUnderstandings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserConceptualUnderstandingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserConceptualUnderstandings>>
>;
export type GetUserConceptualUnderstandingsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserConceptualUnderstandingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserConceptualUnderstandings<
  TData = Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserConceptualUnderstandingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserConceptualUnderstandings>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserConceptualUnderstandingsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopCommonMisconceptions = (
  params?: GetTopCommonMisconceptionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListCommonMisconceptionResponseDto>({
    url: `/common-misconceptions/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopCommonMisconceptionsQueryKey = (
  params?: GetTopCommonMisconceptionsParams,
) => {
  return [`/common-misconceptions/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopCommonMisconceptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopCommonMisconceptionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopCommonMisconceptions>>
  > = ({ signal }) => getTopCommonMisconceptions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopCommonMisconceptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopCommonMisconceptions>>
>;
export type GetTopCommonMisconceptionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopCommonMisconceptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopCommonMisconceptionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentCommonMisconceptions = (
  params?: GetRecentCommonMisconceptionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListCommonMisconceptionResponseDto>({
    url: `/common-misconceptions/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentCommonMisconceptionsQueryKey = (
  params?: GetRecentCommonMisconceptionsParams,
) => {
  return [
    `/common-misconceptions/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentCommonMisconceptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentCommonMisconceptionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentCommonMisconceptions>>
  > = ({ signal }) => getRecentCommonMisconceptions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentCommonMisconceptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentCommonMisconceptions>>
>;
export type GetRecentCommonMisconceptionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentCommonMisconceptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentCommonMisconceptionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserCommonMisconceptions = (
  params?: GetUserCommonMisconceptionsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListCommonMisconceptionResponseDto>({
    url: `/common-misconceptions/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserCommonMisconceptionsQueryKey = (
  params?: GetUserCommonMisconceptionsParams,
) => {
  return [`/common-misconceptions/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserCommonMisconceptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserCommonMisconceptionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserCommonMisconceptions>>
  > = ({ signal }) => getUserCommonMisconceptions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserCommonMisconceptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserCommonMisconceptions>>
>;
export type GetUserCommonMisconceptionsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserCommonMisconceptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserCommonMisconceptions<
  TData = Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCommonMisconceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCommonMisconceptions>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserCommonMisconceptionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopCollaborativeGroupWorks = (
  params?: GetTopCollaborativeGroupWorksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListCollaborativeGroupWorkResponseDto>({
    url: `/collaborative-group-work/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopCollaborativeGroupWorksQueryKey = (
  params?: GetTopCollaborativeGroupWorksParams,
) => {
  return [
    `/collaborative-group-work/top`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTopCollaborativeGroupWorksQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopCollaborativeGroupWorksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>
  > = ({ signal }) => getTopCollaborativeGroupWorks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopCollaborativeGroupWorksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>
>;
export type GetTopCollaborativeGroupWorksQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopCollaborativeGroupWorksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopCollaborativeGroupWorksQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentCollaborativeGroupWorks = (
  params?: GetRecentCollaborativeGroupWorksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListCollaborativeGroupWorkResponseDto>({
    url: `/collaborative-group-work/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentCollaborativeGroupWorksQueryKey = (
  params?: GetRecentCollaborativeGroupWorksParams,
) => {
  return [
    `/collaborative-group-work/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentCollaborativeGroupWorksQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRecentCollaborativeGroupWorksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>
  > = ({ signal }) => getRecentCollaborativeGroupWorks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentCollaborativeGroupWorksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>
>;
export type GetRecentCollaborativeGroupWorksQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentCollaborativeGroupWorksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentCollaborativeGroupWorksQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserCollaborativeGroupWorks = (
  params?: GetUserCollaborativeGroupWorksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListCollaborativeGroupWorkResponseDto>({
    url: `/collaborative-group-work/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserCollaborativeGroupWorksQueryKey = (
  params?: GetUserCollaborativeGroupWorksParams,
) => {
  return [`/collaborative-group-work/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserCollaborativeGroupWorksQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserCollaborativeGroupWorksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>
  > = ({ signal }) => getUserCollaborativeGroupWorks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserCollaborativeGroupWorksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>
>;
export type GetUserCollaborativeGroupWorksQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserCollaborativeGroupWorksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserCollaborativeGroupWorks<
  TData = Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserCollaborativeGroupWorksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserCollaborativeGroupWorks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserCollaborativeGroupWorksQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopClassroomManagements = (
  params?: GetTopClassroomManagementsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListClassroomManagementResponseDto>({
    url: `/classroom-managements/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopClassroomManagementsQueryKey = (
  params?: GetTopClassroomManagementsParams,
) => {
  return [`/classroom-managements/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopClassroomManagementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopClassroomManagementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopClassroomManagements>>
  > = ({ signal }) => getTopClassroomManagements(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopClassroomManagements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopClassroomManagementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopClassroomManagements>>
>;
export type GetTopClassroomManagementsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopClassroomManagements<
  TData = Awaited<ReturnType<typeof getTopClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopClassroomManagementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopClassroomManagements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopClassroomManagements>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopClassroomManagements<
  TData = Awaited<ReturnType<typeof getTopClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopClassroomManagements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopClassroomManagements>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopClassroomManagements<
  TData = Awaited<ReturnType<typeof getTopClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopClassroomManagements<
  TData = Awaited<ReturnType<typeof getTopClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopClassroomManagementsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentClassroomManagements = (
  params?: GetRecentClassroomManagementsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListClassroomManagementResponseDto>({
    url: `/classroom-managements/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentClassroomManagementsQueryKey = (
  params?: GetRecentClassroomManagementsParams,
) => {
  return [
    `/classroom-managements/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentClassroomManagementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentClassroomManagementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentClassroomManagements>>
  > = ({ signal }) => getRecentClassroomManagements(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentClassroomManagements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentClassroomManagementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentClassroomManagements>>
>;
export type GetRecentClassroomManagementsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentClassroomManagements<
  TData = Awaited<ReturnType<typeof getRecentClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentClassroomManagementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentClassroomManagements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentClassroomManagements>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentClassroomManagements<
  TData = Awaited<ReturnType<typeof getRecentClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentClassroomManagements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentClassroomManagements>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentClassroomManagements<
  TData = Awaited<ReturnType<typeof getRecentClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentClassroomManagements<
  TData = Awaited<ReturnType<typeof getRecentClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentClassroomManagementsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserClassroomManagements = (
  params?: GetUserClassroomManagementsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListClassroomManagementResponseDto>({
    url: `/classroom-managements/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserClassroomManagementsQueryKey = (
  params?: GetUserClassroomManagementsParams,
) => {
  return [`/classroom-managements/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserClassroomManagementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserClassroomManagementsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserClassroomManagements>>
  > = ({ signal }) => getUserClassroomManagements(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserClassroomManagements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserClassroomManagementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserClassroomManagements>>
>;
export type GetUserClassroomManagementsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserClassroomManagements<
  TData = Awaited<ReturnType<typeof getUserClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserClassroomManagementsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserClassroomManagements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserClassroomManagements>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserClassroomManagements<
  TData = Awaited<ReturnType<typeof getUserClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserClassroomManagements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserClassroomManagements>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserClassroomManagements<
  TData = Awaited<ReturnType<typeof getUserClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserClassroomManagements<
  TData = Awaited<ReturnType<typeof getUserClassroomManagements>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserClassroomManagementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserClassroomManagements>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserClassroomManagementsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopChoiceBoards = (
  params?: GetTopChoiceBoardsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChoiceBoardResponseDto>({
    url: `/choice-boards/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopChoiceBoardsQueryKey = (
  params?: GetTopChoiceBoardsParams,
) => {
  return [`/choice-boards/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopChoiceBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopChoiceBoardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopChoiceBoards>>
  > = ({ signal }) => getTopChoiceBoards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopChoiceBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopChoiceBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopChoiceBoards>>
>;
export type GetTopChoiceBoardsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopChoiceBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopChoiceBoards<
  TData = Awaited<ReturnType<typeof getTopChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopChoiceBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentChoiceBoards = (
  params?: GetRecentChoiceBoardsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChoiceBoardResponseDto>({
    url: `/choice-boards/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentChoiceBoardsQueryKey = (
  params?: GetRecentChoiceBoardsParams,
) => {
  return [`/choice-boards/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentChoiceBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentChoiceBoardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentChoiceBoards>>
  > = ({ signal }) => getRecentChoiceBoards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentChoiceBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentChoiceBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentChoiceBoards>>
>;
export type GetRecentChoiceBoardsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentChoiceBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentChoiceBoards<
  TData = Awaited<ReturnType<typeof getRecentChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentChoiceBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserChoiceBoards = (
  params?: GetUserChoiceBoardsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChoiceBoardResponseDto>({
    url: `/choice-boards/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserChoiceBoardsQueryKey = (
  params?: GetUserChoiceBoardsParams,
) => {
  return [`/choice-boards/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserChoiceBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserChoiceBoardsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserChoiceBoards>>
  > = ({ signal }) => getUserChoiceBoards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserChoiceBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserChoiceBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserChoiceBoards>>
>;
export type GetUserChoiceBoardsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserChoiceBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserChoiceBoards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserChoiceBoards>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserChoiceBoards<
  TData = Awaited<ReturnType<typeof getUserChoiceBoards>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserChoiceBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserChoiceBoards>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserChoiceBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getChats = (params?: GetChatsParams, signal?: AbortSignal) => {
  return configureAxios<ListChatResponseDto>({
    url: `/chats`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetChatsQueryKey = (params?: GetChatsParams) => {
  return [`/chats`, ...(params ? [params] : [])] as const;
};

export const getGetChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChats>>> = ({
    signal,
  }) => getChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChats>>
>;
export type GetChatsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetChats<
  TData = Awaited<ReturnType<typeof getChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChats<
  TData = Awaited<ReturnType<typeof getChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChats<
  TData = Awaited<ReturnType<typeof getChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetChats<
  TData = Awaited<ReturnType<typeof getChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetChatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuestionSolverChats = (
  params?: GetQuestionSolverChatsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatResponseDto>({
    url: `/chats/question-solver`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetQuestionSolverChatsQueryKey = (
  params?: GetQuestionSolverChatsParams,
) => {
  return [`/chats/question-solver`, ...(params ? [params] : [])] as const;
};

export const getGetQuestionSolverChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionSolverChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverChats>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionSolverChatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionSolverChats>>
  > = ({ signal }) => getQuestionSolverChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionSolverChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuestionSolverChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionSolverChats>>
>;
export type GetQuestionSolverChatsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetQuestionSolverChats<
  TData = Awaited<ReturnType<typeof getQuestionSolverChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetQuestionSolverChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverChats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuestionSolverChats<
  TData = Awaited<ReturnType<typeof getQuestionSolverChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverChats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionSolverChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuestionSolverChats<
  TData = Awaited<ReturnType<typeof getQuestionSolverChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuestionSolverChats<
  TData = Awaited<ReturnType<typeof getQuestionSolverChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetQuestionSolverChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionSolverChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuestionSolverChatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDidacticChats = (
  params?: GetDidacticChatsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatResponseDto>({
    url: `/chats/didactic`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDidacticChatsQueryKey = (
  params?: GetDidacticChatsParams,
) => {
  return [`/chats/didactic`, ...(params ? [params] : [])] as const;
};

export const getGetDidacticChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDidacticChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChats>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDidacticChatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDidacticChats>>
  > = ({ signal }) => getDidacticChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDidacticChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDidacticChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDidacticChats>>
>;
export type GetDidacticChatsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDidacticChats<
  TData = Awaited<ReturnType<typeof getDidacticChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetDidacticChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDidacticChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDidacticChats<
  TData = Awaited<ReturnType<typeof getDidacticChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDidacticChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDidacticChats<
  TData = Awaited<ReturnType<typeof getDidacticChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDidacticChats<
  TData = Awaited<ReturnType<typeof getDidacticChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetDidacticChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChats>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDidacticChatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDidacticChat = (
  id: number,
  params?: GetDidacticChatParams,
  signal?: AbortSignal,
) => {
  return configureAxios<GetChatResponseDto>({
    url: `/chats/didactic/${id}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetDidacticChatQueryKey = (
  id: number,
  params?: GetDidacticChatParams,
) => {
  return [`/chats/didactic/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetDidacticChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getDidacticChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetDidacticChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChat>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDidacticChatQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDidacticChat>>> = ({
    signal,
  }) => getDidacticChat(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDidacticChat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDidacticChatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDidacticChat>>
>;
export type GetDidacticChatQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetDidacticChat<
  TData = Awaited<ReturnType<typeof getDidacticChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params: undefined | GetDidacticChatParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDidacticChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDidacticChat<
  TData = Awaited<ReturnType<typeof getDidacticChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetDidacticChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDidacticChat>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDidacticChat<
  TData = Awaited<ReturnType<typeof getDidacticChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetDidacticChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDidacticChat<
  TData = Awaited<ReturnType<typeof getDidacticChat>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  id: number,
  params?: GetDidacticChatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDidacticChat>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDidacticChatQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteDidacticChat = (id: number) => {
  return configureAxios<void>({
    url: `/chats/didactic/${id}`,
    method: "DELETE",
  });
};

export const getDeleteDidacticChatMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDidacticChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDidacticChat>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDidacticChat>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDidacticChat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDidacticChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDidacticChat>>
>;

export type DeleteDidacticChatMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteDidacticChat = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDidacticChat>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDidacticChat>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteDidacticChatMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getAllChats = (
  params?: GetAllChatsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListChatResponseDto>({
    url: `/chats/all`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAllChatsQueryKey = (params?: GetAllChatsParams) => {
  return [`/chats/all`, ...(params ? [params] : [])] as const;
};

export const getGetAllChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllChats>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllChatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllChats>>> = ({
    signal,
  }) => getAllChats(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllChats>>
>;
export type GetAllChatsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAllChats<
  TData = Awaited<ReturnType<typeof getAllChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAllChatsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllChats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllChats<
  TData = Awaited<ReturnType<typeof getAllChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllChats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllChats>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllChats<
  TData = Awaited<ReturnType<typeof getAllChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllChats>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAllChats<
  TData = Awaited<ReturnType<typeof getAllChats>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllChats>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllChatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAllChatsWithFileSystem = (
  params?: GetAllChatsWithFileSystemParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ChatFileNodeDto>({
    url: `/chats/all/filesystem`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAllChatsWithFileSystemQueryKey = (
  params?: GetAllChatsWithFileSystemParams,
) => {
  return [`/chats/all/filesystem`, ...(params ? [params] : [])] as const;
};

export const getGetAllChatsWithFileSystemQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsWithFileSystemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllChatsWithFileSystemQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllChatsWithFileSystem>>
  > = ({ signal }) => getAllChatsWithFileSystem(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllChatsWithFileSystemQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllChatsWithFileSystem>>
>;
export type GetAllChatsWithFileSystemQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetAllChatsWithFileSystem<
  TData = Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAllChatsWithFileSystemParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllChatsWithFileSystem<
  TData = Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsWithFileSystemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllChatsWithFileSystem<
  TData = Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsWithFileSystemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAllChatsWithFileSystem<
  TData = Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAllChatsWithFileSystemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllChatsWithFileSystem>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllChatsWithFileSystemQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopBloomsTaxonomyActivities = (
  params?: GetTopBloomsTaxonomyActivitiesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListBloomsTaxonomyActivitiesResponseDto>({
    url: `/blooms-taxonomy-activities/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopBloomsTaxonomyActivitiesQueryKey = (
  params?: GetTopBloomsTaxonomyActivitiesParams,
) => {
  return [
    `/blooms-taxonomy-activities/top`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTopBloomsTaxonomyActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopBloomsTaxonomyActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>
  > = ({ signal }) => getTopBloomsTaxonomyActivities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopBloomsTaxonomyActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>
>;
export type GetTopBloomsTaxonomyActivitiesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopBloomsTaxonomyActivitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopBloomsTaxonomyActivitiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentBloomsTaxonomyActivities = (
  params?: GetRecentBloomsTaxonomyActivitiesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListBloomsTaxonomyActivitiesResponseDto>({
    url: `/blooms-taxonomy-activities/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentBloomsTaxonomyActivitiesQueryKey = (
  params?: GetRecentBloomsTaxonomyActivitiesParams,
) => {
  return [
    `/blooms-taxonomy-activities/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentBloomsTaxonomyActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRecentBloomsTaxonomyActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>
  > = ({ signal }) => getRecentBloomsTaxonomyActivities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentBloomsTaxonomyActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>
>;
export type GetRecentBloomsTaxonomyActivitiesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentBloomsTaxonomyActivitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentBloomsTaxonomyActivitiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserBloomsTaxonomyActivities = (
  params?: GetUserBloomsTaxonomyActivitiesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListBloomsTaxonomyActivitiesResponseDto>({
    url: `/blooms-taxonomy-activities/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserBloomsTaxonomyActivitiesQueryKey = (
  params?: GetUserBloomsTaxonomyActivitiesParams,
) => {
  return [
    `/blooms-taxonomy-activities/me`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserBloomsTaxonomyActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserBloomsTaxonomyActivitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>
  > = ({ signal }) => getUserBloomsTaxonomyActivities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserBloomsTaxonomyActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>
>;
export type GetUserBloomsTaxonomyActivitiesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserBloomsTaxonomyActivitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserBloomsTaxonomyActivities<
  TData = Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserBloomsTaxonomyActivitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBloomsTaxonomyActivities>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserBloomsTaxonomyActivitiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTodayBlogs = (signal?: AbortSignal) => {
  return configureAxios<ListBlogPostResponseDto>({
    url: `/blogs/today`,
    method: "GET",
    signal,
  });
};

export const getGetTodayBlogsQueryKey = () => {
  return [`/blogs/today`] as const;
};

export const getGetTodayBlogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTodayBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTodayBlogs>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTodayBlogsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTodayBlogs>>> = ({
    signal,
  }) => getTodayBlogs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTodayBlogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTodayBlogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTodayBlogs>>
>;
export type GetTodayBlogsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTodayBlogs<
  TData = Awaited<ReturnType<typeof getTodayBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTodayBlogs>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTodayBlogs>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTodayBlogs<
  TData = Awaited<ReturnType<typeof getTodayBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTodayBlogs>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTodayBlogs>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTodayBlogs<
  TData = Awaited<ReturnType<typeof getTodayBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTodayBlogs>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTodayBlogs<
  TData = Awaited<ReturnType<typeof getTodayBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTodayBlogs>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTodayBlogsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMostSeenBlogs = (
  params?: GetMostSeenBlogsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListBlogPostResponseDto>({
    url: `/blogs/most-seen`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMostSeenBlogsQueryKey = (
  params?: GetMostSeenBlogsParams,
) => {
  return [`/blogs/most-seen`, ...(params ? [params] : [])] as const;
};

export const getGetMostSeenBlogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMostSeenBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMostSeenBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMostSeenBlogs>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMostSeenBlogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMostSeenBlogs>>
  > = ({ signal }) => getMostSeenBlogs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMostSeenBlogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMostSeenBlogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMostSeenBlogs>>
>;
export type GetMostSeenBlogsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetMostSeenBlogs<
  TData = Awaited<ReturnType<typeof getMostSeenBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetMostSeenBlogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMostSeenBlogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMostSeenBlogs>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMostSeenBlogs<
  TData = Awaited<ReturnType<typeof getMostSeenBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMostSeenBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMostSeenBlogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMostSeenBlogs>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMostSeenBlogs<
  TData = Awaited<ReturnType<typeof getMostSeenBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMostSeenBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMostSeenBlogs>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMostSeenBlogs<
  TData = Awaited<ReturnType<typeof getMostSeenBlogs>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetMostSeenBlogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMostSeenBlogs>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMostSeenBlogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAuditsAdmin = (
  params?: GetAuditsAdminParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAuditResponseDto>({
    url: `/audits/admin`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAuditsAdminQueryKey = (params?: GetAuditsAdminParams) => {
  return [`/audits/admin`, ...(params ? [params] : [])] as const;
};

export const getGetAuditsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuditsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditsAdmin>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuditsAdminQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditsAdmin>>> = ({
    signal,
  }) => getAuditsAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuditsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAuditsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuditsAdmin>>
>;
export type GetAuditsAdminQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAuditsAdmin<
  TData = Awaited<ReturnType<typeof getAuditsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetAuditsAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditsAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditsAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAuditsAdmin<
  TData = Awaited<ReturnType<typeof getAuditsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditsAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditsAdmin>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAuditsAdmin<
  TData = Awaited<ReturnType<typeof getAuditsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditsAdmin>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAuditsAdmin<
  TData = Awaited<ReturnType<typeof getAuditsAdmin>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetAuditsAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditsAdmin>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAuditsAdminQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get explanation of question for student
 * @summary Get explanation of question
 */
export const getAnswerFeedback1 = (
  assignmentId: number,
  questionId: number,
  signal?: AbortSignal,
) => {
  return configureAxios<GetAnswerFeedback1200>({
    url: `/assignments/${assignmentId}/questions/${questionId}/explanation`,
    method: "GET",
    signal,
  });
};

export const getGetAnswerFeedback1QueryKey = (
  assignmentId: number,
  questionId: number,
) => {
  return [
    `/assignments/${assignmentId}/questions/${questionId}/explanation`,
  ] as const;
};

export const getGetAnswerFeedback1QueryOptions = <
  TData = Awaited<ReturnType<typeof getAnswerFeedback1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback1>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAnswerFeedback1QueryKey(assignmentId, questionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnswerFeedback1>>
  > = ({ signal }) => getAnswerFeedback1(assignmentId, questionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(assignmentId && questionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnswerFeedback1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAnswerFeedback1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnswerFeedback1>>
>;
export type GetAnswerFeedback1QueryError = ErrorType<BaseErrorResponseDto>;

export function useGetAnswerFeedback1<
  TData = Awaited<ReturnType<typeof getAnswerFeedback1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnswerFeedback1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAnswerFeedback1<
  TData = Awaited<ReturnType<typeof getAnswerFeedback1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnswerFeedback1>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAnswerFeedback1<
  TData = Awaited<ReturnType<typeof getAnswerFeedback1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get explanation of question
 */

export function useGetAnswerFeedback1<
  TData = Awaited<ReturnType<typeof getAnswerFeedback1>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  assignmentId: number,
  questionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswerFeedback1>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAnswerFeedback1QueryOptions(
    assignmentId,
    questionId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopArticleGenerators = (
  params?: GetTopArticleGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListArticleGeneratorResponseDto>({
    url: `/article-generator/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopArticleGeneratorsQueryKey = (
  params?: GetTopArticleGeneratorsParams,
) => {
  return [`/article-generator/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopArticleGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopArticleGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopArticleGenerators>>
  > = ({ signal }) => getTopArticleGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopArticleGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopArticleGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopArticleGenerators>>
>;
export type GetTopArticleGeneratorsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopArticleGenerators<
  TData = Awaited<ReturnType<typeof getTopArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopArticleGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopArticleGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopArticleGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopArticleGenerators<
  TData = Awaited<ReturnType<typeof getTopArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopArticleGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopArticleGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopArticleGenerators<
  TData = Awaited<ReturnType<typeof getTopArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopArticleGenerators<
  TData = Awaited<ReturnType<typeof getTopArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopArticleGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentArticleGenerators = (
  params?: GetRecentArticleGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListArticleGeneratorResponseDto>({
    url: `/article-generator/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentArticleGeneratorsQueryKey = (
  params?: GetRecentArticleGeneratorsParams,
) => {
  return [`/article-generator/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentArticleGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentArticleGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentArticleGenerators>>
  > = ({ signal }) => getRecentArticleGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentArticleGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentArticleGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentArticleGenerators>>
>;
export type GetRecentArticleGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentArticleGenerators<
  TData = Awaited<ReturnType<typeof getRecentArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentArticleGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentArticleGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentArticleGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentArticleGenerators<
  TData = Awaited<ReturnType<typeof getRecentArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentArticleGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentArticleGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentArticleGenerators<
  TData = Awaited<ReturnType<typeof getRecentArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentArticleGenerators<
  TData = Awaited<ReturnType<typeof getRecentArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentArticleGeneratorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserArticleGenerators = (
  params?: GetUserArticleGeneratorsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListArticleGeneratorResponseDto>({
    url: `/article-generator/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserArticleGeneratorsQueryKey = (
  params?: GetUserArticleGeneratorsParams,
) => {
  return [`/article-generator/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserArticleGeneratorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserArticleGeneratorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserArticleGenerators>>
  > = ({ signal }) => getUserArticleGenerators(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserArticleGenerators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserArticleGeneratorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserArticleGenerators>>
>;
export type GetUserArticleGeneratorsQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserArticleGenerators<
  TData = Awaited<ReturnType<typeof getUserArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserArticleGeneratorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserArticleGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserArticleGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserArticleGenerators<
  TData = Awaited<ReturnType<typeof getUserArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserArticleGenerators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserArticleGenerators>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserArticleGenerators<
  TData = Awaited<ReturnType<typeof getUserArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserArticleGenerators<
  TData = Awaited<ReturnType<typeof getUserArticleGenerators>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserArticleGeneratorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserArticleGenerators>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserArticleGeneratorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUnreadAlerts = (signal?: AbortSignal) => {
  return configureAxios<LambdaAlertEntity[]>({
    url: `/alerts/lambda`,
    method: "GET",
    signal,
  });
};

export const getGetUnreadAlertsQueryKey = () => {
  return [`/alerts/lambda`] as const;
};

export const getGetUnreadAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnreadAlerts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUnreadAlerts>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUnreadAlertsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadAlerts>>> = ({
    signal,
  }) => getUnreadAlerts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnreadAlerts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUnreadAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnreadAlerts>>
>;
export type GetUnreadAlertsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUnreadAlerts<
  TData = Awaited<ReturnType<typeof getUnreadAlerts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUnreadAlerts>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUnreadAlerts>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUnreadAlerts<
  TData = Awaited<ReturnType<typeof getUnreadAlerts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUnreadAlerts>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUnreadAlerts>>,
        TError,
        TData
      >,
      "initialData"
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUnreadAlerts<
  TData = Awaited<ReturnType<typeof getUnreadAlerts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUnreadAlerts>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUnreadAlerts<
  TData = Awaited<ReturnType<typeof getUnreadAlerts>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUnreadAlerts>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUnreadAlertsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopAiSupportedTasks = (
  params?: GetTopAiSupportedTasksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiSupportedTasksResponseDto>({
    url: `/ai-supported-tasks/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopAiSupportedTasksQueryKey = (
  params?: GetTopAiSupportedTasksParams,
) => {
  return [`/ai-supported-tasks/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopAiSupportedTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopAiSupportedTasksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopAiSupportedTasks>>
  > = ({ signal }) => getTopAiSupportedTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopAiSupportedTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopAiSupportedTasks>>
>;
export type GetTopAiSupportedTasksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopAiSupportedTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopAiSupportedTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentAiSupportedTasks = (
  params?: GetRecentAiSupportedTasksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiSupportedTasksResponseDto>({
    url: `/ai-supported-tasks/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentAiSupportedTasksQueryKey = (
  params?: GetRecentAiSupportedTasksParams,
) => {
  return [`/ai-supported-tasks/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentAiSupportedTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentAiSupportedTasksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentAiSupportedTasks>>
  > = ({ signal }) => getRecentAiSupportedTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentAiSupportedTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentAiSupportedTasks>>
>;
export type GetRecentAiSupportedTasksQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentAiSupportedTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentAiSupportedTasksQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserAiSupportedTasks = (
  params?: GetUserAiSupportedTasksParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiSupportedTasksResponseDto>({
    url: `/ai-supported-tasks/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserAiSupportedTasksQueryKey = (
  params?: GetUserAiSupportedTasksParams,
) => {
  return [`/ai-supported-tasks/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserAiSupportedTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserAiSupportedTasksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserAiSupportedTasks>>
  > = ({ signal }) => getUserAiSupportedTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserAiSupportedTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserAiSupportedTasks>>
>;
export type GetUserAiSupportedTasksQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserAiSupportedTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserAiSupportedTasks<
  TData = Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiSupportedTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiSupportedTasks>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserAiSupportedTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopAiResistantHomework = (
  params?: GetTopAiResistantHomeworkParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiResistantHomeworkResponseDto>({
    url: `/ai-resistant-homework/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopAiResistantHomeworkQueryKey = (
  params?: GetTopAiResistantHomeworkParams,
) => {
  return [`/ai-resistant-homework/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopAiResistantHomeworkQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopAiResistantHomeworkQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopAiResistantHomework>>
  > = ({ signal }) => getTopAiResistantHomework(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopAiResistantHomework>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopAiResistantHomeworkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopAiResistantHomework>>
>;
export type GetTopAiResistantHomeworkQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopAiResistantHomework<
  TData = Awaited<ReturnType<typeof getTopAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopAiResistantHomeworkParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopAiResistantHomework<
  TData = Awaited<ReturnType<typeof getTopAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopAiResistantHomework<
  TData = Awaited<ReturnType<typeof getTopAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopAiResistantHomework<
  TData = Awaited<ReturnType<typeof getTopAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopAiResistantHomeworkQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentAiResistantHomework = (
  params?: GetRecentAiResistantHomeworkParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiResistantHomeworkResponseDto>({
    url: `/ai-resistant-homework/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentAiResistantHomeworkQueryKey = (
  params?: GetRecentAiResistantHomeworkParams,
) => {
  return [
    `/ai-resistant-homework/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentAiResistantHomeworkQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentAiResistantHomeworkQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentAiResistantHomework>>
  > = ({ signal }) => getRecentAiResistantHomework(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentAiResistantHomeworkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentAiResistantHomework>>
>;
export type GetRecentAiResistantHomeworkQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentAiResistantHomework<
  TData = Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentAiResistantHomeworkParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentAiResistantHomework<
  TData = Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentAiResistantHomework<
  TData = Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentAiResistantHomework<
  TData = Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentAiResistantHomeworkQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserAiResistantHomework = (
  params?: GetUserAiResistantHomeworkParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiResistantHomeworkResponseDto>({
    url: `/ai-resistant-homework/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserAiResistantHomeworkQueryKey = (
  params?: GetUserAiResistantHomeworkParams,
) => {
  return [`/ai-resistant-homework/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserAiResistantHomeworkQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserAiResistantHomeworkQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserAiResistantHomework>>
  > = ({ signal }) => getUserAiResistantHomework(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAiResistantHomework>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserAiResistantHomeworkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserAiResistantHomework>>
>;
export type GetUserAiResistantHomeworkQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserAiResistantHomework<
  TData = Awaited<ReturnType<typeof getUserAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserAiResistantHomeworkParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserAiResistantHomework<
  TData = Awaited<ReturnType<typeof getUserAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiResistantHomework>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiResistantHomework>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserAiResistantHomework<
  TData = Awaited<ReturnType<typeof getUserAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserAiResistantHomework<
  TData = Awaited<ReturnType<typeof getUserAiResistantHomework>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiResistantHomeworkParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiResistantHomework>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserAiResistantHomeworkQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopAiAssignments = (
  params?: GetTopAiAssignmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiAssignmentResponseDto>({
    url: `/ai-assignment-designer/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopAiAssignmentsQueryKey = (
  params?: GetTopAiAssignmentsParams,
) => {
  return [`/ai-assignment-designer/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopAiAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssignments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopAiAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopAiAssignments>>
  > = ({ signal }) => getTopAiAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopAiAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopAiAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopAiAssignments>>
>;
export type GetTopAiAssignmentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetTopAiAssignments<
  TData = Awaited<ReturnType<typeof getTopAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopAiAssignmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopAiAssignments<
  TData = Awaited<ReturnType<typeof getTopAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopAiAssignments<
  TData = Awaited<ReturnType<typeof getTopAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopAiAssignments<
  TData = Awaited<ReturnType<typeof getTopAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopAiAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentAiAssignments = (
  params?: GetRecentAiAssignmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiAssignmentResponseDto>({
    url: `/ai-assignment-designer/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentAiAssignmentsQueryKey = (
  params?: GetRecentAiAssignmentsParams,
) => {
  return [
    `/ai-assignment-designer/recent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecentAiAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssignments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentAiAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentAiAssignments>>
  > = ({ signal }) => getRecentAiAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentAiAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentAiAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentAiAssignments>>
>;
export type GetRecentAiAssignmentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetRecentAiAssignments<
  TData = Awaited<ReturnType<typeof getRecentAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentAiAssignmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentAiAssignments<
  TData = Awaited<ReturnType<typeof getRecentAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentAiAssignments<
  TData = Awaited<ReturnType<typeof getRecentAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentAiAssignments<
  TData = Awaited<ReturnType<typeof getRecentAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentAiAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserAiAssignments = (
  params?: GetUserAiAssignmentsParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiAssignmentResponseDto>({
    url: `/ai-assignment-designer/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserAiAssignmentsQueryKey = (
  params?: GetUserAiAssignmentsParams,
) => {
  return [`/ai-assignment-designer/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserAiAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssignments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserAiAssignmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserAiAssignments>>
  > = ({ signal }) => getUserAiAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAiAssignments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserAiAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserAiAssignments>>
>;
export type GetUserAiAssignmentsQueryError = ErrorType<BaseErrorResponseDto>;

export function useGetUserAiAssignments<
  TData = Awaited<ReturnType<typeof getUserAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserAiAssignmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserAiAssignments<
  TData = Awaited<ReturnType<typeof getUserAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssignments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiAssignments>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserAiAssignments<
  TData = Awaited<ReturnType<typeof getUserAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserAiAssignments<
  TData = Awaited<ReturnType<typeof getUserAiAssignments>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssignmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssignments>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserAiAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopAiAssessmentScales = (
  params?: GetTopAiAssessmentScalesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiAssessmentScaleResponseDto>({
    url: `/ai-assessment-scale/top`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTopAiAssessmentScalesQueryKey = (
  params?: GetTopAiAssessmentScalesParams,
) => {
  return [`/ai-assessment-scale/top`, ...(params ? [params] : [])] as const;
};

export const getGetTopAiAssessmentScalesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopAiAssessmentScalesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopAiAssessmentScales>>
  > = ({ signal }) => getTopAiAssessmentScales(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopAiAssessmentScalesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopAiAssessmentScales>>
>;
export type GetTopAiAssessmentScalesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetTopAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetTopAiAssessmentScalesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetTopAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopAiAssessmentScalesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getRecentAiAssessmentScales = (
  params?: GetRecentAiAssessmentScalesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiAssessmentScaleResponseDto>({
    url: `/ai-assessment-scale/recent`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetRecentAiAssessmentScalesQueryKey = (
  params?: GetRecentAiAssessmentScalesParams,
) => {
  return [`/ai-assessment-scale/recent`, ...(params ? [params] : [])] as const;
};

export const getGetRecentAiAssessmentScalesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentAiAssessmentScalesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentAiAssessmentScales>>
  > = ({ signal }) => getRecentAiAssessmentScales(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRecentAiAssessmentScalesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentAiAssessmentScales>>
>;
export type GetRecentAiAssessmentScalesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetRecentAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetRecentAiAssessmentScalesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecentAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecentAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetRecentAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetRecentAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecentAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRecentAiAssessmentScalesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserAiAssessmentScales = (
  params?: GetUserAiAssessmentScalesParams,
  signal?: AbortSignal,
) => {
  return configureAxios<ListAiAssessmentScaleResponseDto>({
    url: `/ai-assessment-scale/me`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetUserAiAssessmentScalesQueryKey = (
  params?: GetUserAiAssessmentScalesParams,
) => {
  return [`/ai-assessment-scale/me`, ...(params ? [params] : [])] as const;
};

export const getGetUserAiAssessmentScalesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserAiAssessmentScalesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserAiAssessmentScales>>
  > = ({ signal }) => getUserAiAssessmentScales(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserAiAssessmentScalesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserAiAssessmentScales>>
>;
export type GetUserAiAssessmentScalesQueryError =
  ErrorType<BaseErrorResponseDto>;

export function useGetUserAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params: undefined | GetUserAiAssessmentScalesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
          TError,
          TData
        >,
        "initialData"
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserAiAssessmentScales<
  TData = Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
  TError = ErrorType<BaseErrorResponseDto>,
>(
  params?: GetUserAiAssessmentScalesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserAiAssessmentScales>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserAiAssessmentScalesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteUser = () => {
  return configureAxios<void>({ url: `/users`, method: "DELETE" });
};

export const getDeleteUserMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    void
  > = () => {
    return deleteUser();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteUser = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeStudentsFromClassroomInTeacherController = (
  classroomId: number,
  addRemoveStudentsToFromClassroomRequestBodyDto: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>,
) => {
  return configureAxios<RemoveStudentsFromClassroomInTeacherController200>({
    url: `/teachers/classrooms/${classroomId}/students`,
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    data: addRemoveStudentsToFromClassroomRequestBodyDto,
  });
};

export const getRemoveStudentsFromClassroomInTeacherControllerMutationOptions =
  <TError = ErrorType<BaseErrorResponseDto>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeStudentsFromClassroomInTeacherController>
      >,
      TError,
      {
        classroomId: number;
        data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof removeStudentsFromClassroomInTeacherController>>,
    TError,
    {
      classroomId: number;
      data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof removeStudentsFromClassroomInTeacherController>
      >,
      {
        classroomId: number;
        data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
      }
    > = (props) => {
      const { classroomId, data } = props ?? {};

      return removeStudentsFromClassroomInTeacherController(classroomId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveStudentsFromClassroomInTeacherControllerMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeStudentsFromClassroomInTeacherController>>
  >;
export type RemoveStudentsFromClassroomInTeacherControllerMutationBody =
  BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
export type RemoveStudentsFromClassroomInTeacherControllerMutationError =
  ErrorType<BaseErrorResponseDto>;

export const useRemoveStudentsFromClassroomInTeacherController = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStudentsFromClassroomInTeacherController>>,
    TError,
    {
      classroomId: number;
      data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeStudentsFromClassroomInTeacherController>>,
  TError,
  {
    classroomId: number;
    data: BodyType<AddRemoveStudentsToFromClassroomRequestBodyDto>;
  },
  TContext
> => {
  const mutationOptions =
    getRemoveStudentsFromClassroomInTeacherControllerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const removeStudent = () => {
  return configureAxios<void>({ url: `/students`, method: "DELETE" });
};

export const getRemoveStudentMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStudent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeStudent>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeStudent>>,
    void
  > = () => {
    return removeStudent();
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeStudent>>
>;

export type RemoveStudentMutationError = ErrorType<BaseErrorResponseDto>;

export const useRemoveStudent = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStudent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeStudent>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getRemoveStudentMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteQuestionRegen = (id: number) => {
  return configureAxios<void>({
    url: `/question-regen/${id}`,
    method: "DELETE",
  });
};

export const getDeleteQuestionRegenMutationOptions = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuestionRegen>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteQuestionRegen>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteQuestionRegen>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteQuestionRegen(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteQuestionRegenMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteQuestionRegen>>
>;

export type DeleteQuestionRegenMutationError = ErrorType<BaseErrorResponseDto>;

export const useDeleteQuestionRegen = <
  TError = ErrorType<BaseErrorResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuestionRegen>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteQuestionRegen>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteQuestionRegenMutationOptions(options);

  return useMutation(mutationOptions);
};
